import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  EvidenceCustomDataFieldsDynamicZoneInput: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Long: { input: any; output: any; }
  TaskTypeDataFieldsDynamicZoneInput: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AddDataCollectorToProjectInput = {
  dataCollectorId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};

export type Analytic = {
  __typename?: 'Analytic';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  default_dashboard?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AnalyticEntity = {
  __typename?: 'AnalyticEntity';
  attributes?: Maybe<Analytic>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type AnalyticEntityResponse = {
  __typename?: 'AnalyticEntityResponse';
  data?: Maybe<AnalyticEntity>;
};

export type AnalyticInput = {
  default_dashboard?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AverageMetirc = {
  __typename?: 'AverageMetirc';
  dod: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  wow: Scalars['Float']['output'];
};

export type BaoleaderPayload = {
  __typename?: 'BaoleaderPayload';
  baoleader?: Maybe<UsersPermissionsUserEntity>;
};

export type BaoriderCommunityMetrics = {
  __typename?: 'BaoriderCommunityMetrics';
  activeMembers: Scalars['Int']['output'];
  community?: Maybe<Community>;
  completedProjects: Scalars['Int']['output'];
  completedTasks: Scalars['Int']['output'];
};

export type BaoriderPayload = {
  __typename?: 'BaoriderPayload';
  baorider?: Maybe<UsersPermissionsUserEntity>;
};

export type BaoriderTaskMetrics = {
  __typename?: 'BaoriderTaskMetrics';
  availableTasks: Scalars['Int']['output'];
  completedTasks: Scalars['Int']['output'];
  currentProject?: Maybe<ProjectSet>;
  currentTask?: Maybe<TaskEntity>;
};

export type BaoverifierApp = {
  __typename?: 'BaoverifierApp';
  appVersion?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Enum_Baoverifierapp_Status>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BaoverifierAppEntity = {
  __typename?: 'BaoverifierAppEntity';
  attributes?: Maybe<BaoverifierApp>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type BaoverifierAppEntityResponse = {
  __typename?: 'BaoverifierAppEntityResponse';
  data?: Maybe<BaoverifierAppEntity>;
};

export type BaoverifierAppInput = {
  appVersion?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Enum_Baoverifierapp_Status>;
};

export type BooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  contains?: InputMaybe<Scalars['Boolean']['input']>;
  containsi?: InputMaybe<Scalars['Boolean']['input']>;
  endsWith?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  eqi?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nei?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BooleanFilterInput>;
  notContains?: InputMaybe<Scalars['Boolean']['input']>;
  notContainsi?: InputMaybe<Scalars['Boolean']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  startsWith?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CardPayload = {
  __typename?: 'CardPayload';
  brand?: Maybe<Scalars['String']['output']>;
  exp_month?: Maybe<Scalars['Int']['output']>;
  exp_year?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
};

export type Category = {
  __typename?: 'Category';
  ER_ID?: Maybe<Scalars['String']['output']>;
  company?: Maybe<CompanyEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  featureImage?: Maybe<UploadFileEntityResponse>;
  onlyEmployeesVerify?: Maybe<Scalars['Boolean']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Enum_Category_Status>;
  task_types?: Maybe<TaskTypeRelationResponseCollection>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CategoryTask_TypesArgs = {
  filters?: InputMaybe<TaskTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CategoryEntity = {
  __typename?: 'CategoryEntity';
  attributes?: Maybe<Category>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CategoryEntityResponse = {
  __typename?: 'CategoryEntityResponse';
  data?: Maybe<CategoryEntity>;
};

export type CategoryEntityResponseCollection = {
  __typename?: 'CategoryEntityResponseCollection';
  data: Array<CategoryEntity>;
  meta: ResponseCollectionMeta;
};

export type CategoryFiltersInput = {
  ER_ID?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<CategoryFiltersInput>>>;
  company?: InputMaybe<CompanyFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<CategoryFiltersInput>;
  onlyEmployeesVerify?: InputMaybe<BooleanFilterInput>;
  or?: InputMaybe<Array<InputMaybe<CategoryFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  task_types?: InputMaybe<TaskTypeFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CategoryInput = {
  ER_ID?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  featureImage?: InputMaybe<Scalars['ID']['input']>;
  onlyEmployeesVerify?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Enum_Category_Status>;
  task_types?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryRelationResponseCollection = {
  __typename?: 'CategoryRelationResponseCollection';
  data: Array<CategoryEntity>;
};

export type CategorySet = {
  __typename?: 'CategorySet';
  id: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type CategorysWithCount = {
  __typename?: 'CategorysWithCount';
  categories?: Maybe<Array<Maybe<CategoryEntity>>>;
  count?: Maybe<Scalars['Int']['output']>;
};

export type ChartData = {
  __typename?: 'ChartData';
  key: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type CodeValid = {
  __typename?: 'CodeValid';
  code?: Maybe<Scalars['String']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type Community = {
  __typename?: 'Community';
  baoleader?: Maybe<UsersPermissionsUserEntityResponse>;
  chief_name?: Maybe<Scalars['String']['output']>;
  community_members?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  featured_image?: Maybe<UploadFileEntityResponse>;
  location?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Enum_Community_Type>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CommunityCommunity_MembersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CommunityEntity = {
  __typename?: 'CommunityEntity';
  attributes?: Maybe<Community>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CommunityEntityResponse = {
  __typename?: 'CommunityEntityResponse';
  data?: Maybe<CommunityEntity>;
};

export type CommunityEntityResponseCollection = {
  __typename?: 'CommunityEntityResponseCollection';
  data: Array<CommunityEntity>;
  meta: ResponseCollectionMeta;
};

export type CommunityFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CommunityFiltersInput>>>;
  baoleader?: InputMaybe<UsersPermissionsUserFiltersInput>;
  chief_name?: InputMaybe<StringFilterInput>;
  community_members?: InputMaybe<UsersPermissionsUserFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  location?: InputMaybe<JsonFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CommunityFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CommunityFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CommunityInput = {
  baoleader?: InputMaybe<Scalars['ID']['input']>;
  chief_name?: InputMaybe<Scalars['String']['input']>;
  community_members?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  featured_image?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Enum_Community_Type>;
};

export type CommunityMembersPayload = {
  __typename?: 'CommunityMembersPayload';
  member?: Maybe<UsersPermissionsUserEntity>;
};

export type Company = {
  __typename?: 'Company';
  affiliates?: Maybe<Scalars['JSON']['output']>;
  categories?: Maybe<CategoryRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  data_lists?: Maybe<DataListRelationResponseCollection>;
  default_dashboard?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id_number?: Maybe<Scalars['String']['output']>;
  matabase_group_ID?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  onboardingInformation?: Maybe<Scalars['JSON']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  pin_registration?: Maybe<Scalars['String']['output']>;
  projects?: Maybe<ProjectRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Enum_Company_Status>;
  subscription?: Maybe<SubscriptionEntityResponse>;
  team_members?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  wildlife_association_number?: Maybe<Scalars['String']['output']>;
};


export type CompanyCategoriesArgs = {
  filters?: InputMaybe<CategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CompanyData_ListsArgs = {
  filters?: InputMaybe<DataListFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CompanyProjectsArgs = {
  filters?: InputMaybe<ProjectFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CompanyTeam_MembersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CompanyEntity = {
  __typename?: 'CompanyEntity';
  attributes?: Maybe<Company>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CompanyEntityResponse = {
  __typename?: 'CompanyEntityResponse';
  data?: Maybe<CompanyEntity>;
};

export type CompanyEntityResponseCollection = {
  __typename?: 'CompanyEntityResponseCollection';
  data: Array<CompanyEntity>;
  meta: ResponseCollectionMeta;
};

export type CompanyFiltersInput = {
  affiliates?: InputMaybe<JsonFilterInput>;
  and?: InputMaybe<Array<InputMaybe<CompanyFiltersInput>>>;
  categories?: InputMaybe<CategoryFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  customerId?: InputMaybe<StringFilterInput>;
  data_lists?: InputMaybe<DataListFiltersInput>;
  default_dashboard?: InputMaybe<StringFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  id_number?: InputMaybe<StringFilterInput>;
  matabase_group_ID?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CompanyFiltersInput>;
  onboardingInformation?: InputMaybe<JsonFilterInput>;
  or?: InputMaybe<Array<InputMaybe<CompanyFiltersInput>>>;
  paymentMethod?: InputMaybe<StringFilterInput>;
  pin_registration?: InputMaybe<StringFilterInput>;
  projects?: InputMaybe<ProjectFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  subscription?: InputMaybe<SubscriptionFiltersInput>;
  team_members?: InputMaybe<UsersPermissionsUserFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  website?: InputMaybe<StringFilterInput>;
  wildlife_association_number?: InputMaybe<StringFilterInput>;
};

export type CompanyInput = {
  affiliates?: InputMaybe<Scalars['JSON']['input']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  data_lists?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  default_dashboard?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id_number?: InputMaybe<Scalars['String']['input']>;
  matabase_group_ID?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onboardingInformation?: InputMaybe<Scalars['JSON']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  pin_registration?: InputMaybe<Scalars['String']['input']>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Enum_Company_Status>;
  subscription?: InputMaybe<Scalars['ID']['input']>;
  team_members?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  website?: InputMaybe<Scalars['String']['input']>;
  wildlife_association_number?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyRelationResponseCollection = {
  __typename?: 'CompanyRelationResponseCollection';
  data: Array<CompanyEntity>;
};

export type ComponentComboFieldOption = {
  __typename?: 'ComponentComboFieldOption';
  id: Scalars['ID']['output'];
  option?: Maybe<Scalars['String']['output']>;
};

export type ComponentComboFieldOptionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentComboFieldOptionFiltersInput>>>;
  not?: InputMaybe<ComponentComboFieldOptionFiltersInput>;
  option?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentComboFieldOptionFiltersInput>>>;
};

export type ComponentComboFieldOptionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  option?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentCustomDataFieldsCheckbox = {
  __typename?: 'ComponentCustomDataFieldsCheckbox';
  id: Scalars['ID']['output'];
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  option?: Maybe<Array<Maybe<ComponentComboFieldOption>>>;
};


export type ComponentCustomDataFieldsCheckboxOptionArgs = {
  filters?: InputMaybe<ComponentComboFieldOptionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentCustomDataFieldsDataList = {
  __typename?: 'ComponentCustomDataFieldsDataList';
  id: Scalars['ID']['output'];
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  listId: Scalars['String']['output'];
  option?: Maybe<Array<Maybe<ComponentComboFieldOption>>>;
};


export type ComponentCustomDataFieldsDataListOptionArgs = {
  filters?: InputMaybe<ComponentComboFieldOptionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentCustomDataFieldsDateTimeField = {
  __typename?: 'ComponentCustomDataFieldsDateTimeField';
  datetime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type ComponentCustomDataFieldsEmailField = {
  __typename?: 'ComponentCustomDataFieldsEmailField';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type ComponentCustomDataFieldsImageField = {
  __typename?: 'ComponentCustomDataFieldsImageField';
  id: Scalars['ID']['output'];
  imageUrls?: Maybe<Scalars['JSON']['output']>;
  images?: Maybe<UploadFileRelationResponseCollection>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  upload_state?: Maybe<Enum_Componentcustomdatafieldsimagefield_Upload_State>;
};


export type ComponentCustomDataFieldsImageFieldImagesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentCustomDataFieldsMetricsSpecific = {
  __typename?: 'ComponentCustomDataFieldsMetricsSpecific';
  id: Scalars['ID']['output'];
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Long']['output']>;
  metric?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['Long']['output']>;
  number_value?: Maybe<Scalars['String']['output']>;
};

export type ComponentCustomDataFieldsNumberDropDown = {
  __typename?: 'ComponentCustomDataFieldsNumberDropDown';
  id: Scalars['ID']['output'];
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Long']['output']>;
  min?: Maybe<Scalars['Long']['output']>;
  value?: Maybe<Scalars['Long']['output']>;
};

export type ComponentCustomDataFieldsNumberField = {
  __typename?: 'ComponentCustomDataFieldsNumberField';
  id: Scalars['ID']['output'];
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Long']['output']>;
  min?: Maybe<Scalars['Long']['output']>;
  number_field_value?: Maybe<Scalars['String']['output']>;
};

export type ComponentCustomDataFieldsNumberRange = {
  __typename?: 'ComponentCustomDataFieldsNumberRange';
  id: Scalars['ID']['output'];
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Long']['output']>;
  min?: Maybe<Scalars['Long']['output']>;
};

export type ComponentCustomDataFieldsPercentage = {
  __typename?: 'ComponentCustomDataFieldsPercentage';
  id: Scalars['ID']['output'];
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Long']['output']>;
};

export type ComponentCustomDataFieldsPhoneNumberField = {
  __typename?: 'ComponentCustomDataFieldsPhoneNumberField';
  id: Scalars['ID']['output'];
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type ComponentCustomDataFieldsRadio = {
  __typename?: 'ComponentCustomDataFieldsRadio';
  id: Scalars['ID']['output'];
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  option?: Maybe<Array<Maybe<ComponentComboFieldOption>>>;
};


export type ComponentCustomDataFieldsRadioOptionArgs = {
  filters?: InputMaybe<ComponentComboFieldOptionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentCustomDataFieldsRating = {
  __typename?: 'ComponentCustomDataFieldsRating';
  id: Scalars['ID']['output'];
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  number_of_stars?: Maybe<Scalars['Long']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
};

export type ComponentCustomDataFieldsSelect = {
  __typename?: 'ComponentCustomDataFieldsSelect';
  id: Scalars['ID']['output'];
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  option?: Maybe<Array<Maybe<ComponentComboFieldOption>>>;
};


export type ComponentCustomDataFieldsSelectOptionArgs = {
  filters?: InputMaybe<ComponentComboFieldOptionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentCustomDataFieldsText = {
  __typename?: 'ComponentCustomDataFieldsText';
  id: Scalars['ID']['output'];
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  text_value?: Maybe<Scalars['String']['output']>;
};

export type ComponentFaqFaq = {
  __typename?: 'ComponentFaqFaq';
  answer?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Enum_Componentfaqfaq_Category>;
  id: Scalars['ID']['output'];
  page?: Maybe<Enum_Componentfaqfaq_Page>;
  question?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<ComponentComboFieldOption>>>;
};


export type ComponentFaqFaqTagsArgs = {
  filters?: InputMaybe<ComponentComboFieldOptionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentFaqFaqFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentFaqFaqFiltersInput>>>;
  answer?: InputMaybe<StringFilterInput>;
  category?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentFaqFaqFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentFaqFaqFiltersInput>>>;
  page?: InputMaybe<StringFilterInput>;
  question?: InputMaybe<StringFilterInput>;
  tags?: InputMaybe<ComponentComboFieldOptionFiltersInput>;
};

export type ComponentFaqFaqInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Enum_Componentfaqfaq_Category>;
  id?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Enum_Componentfaqfaq_Page>;
  question?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<ComponentComboFieldOptionInput>>>;
};

export type ComponentPricePlansPlans = {
  __typename?: 'ComponentPricePlansPlans';
  id: Scalars['ID']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  priceId?: Maybe<Scalars['String']['output']>;
  recurring?: Maybe<Enum_Componentpriceplansplans_Recurring>;
};

export type ComponentProductFeaturePlanFeature = {
  __typename?: 'ComponentProductFeaturePlanFeature';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isHighlighted?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

export type ComponentProductFeaturePlanFeatureFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentProductFeaturePlanFeatureFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  isHighlighted?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentProductFeaturePlanFeatureFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentProductFeaturePlanFeatureFiltersInput>>>;
  sortOrder?: InputMaybe<IntFilterInput>;
};

export type ComponentProductFeaturePlanFeatureInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isHighlighted?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type ComponentProductFeatureProductFeature = {
  __typename?: 'ComponentProductFeatureProductFeature';
  baoriders_allowed?: Maybe<Scalars['Int']['output']>;
  cost_per_baorider?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  price?: Maybe<Scalars['Long']['output']>;
  price_usd?: Maybe<Scalars['Long']['output']>;
  price_zar?: Maybe<Scalars['Long']['output']>;
  recurring?: Maybe<Enum_Componentproductfeatureproductfeature_Recurring>;
  support_hours?: Maybe<Scalars['Float']['output']>;
};

export type ComponentProductFeatureProductFeatureFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentProductFeatureProductFeatureFiltersInput>>>;
  baoriders_allowed?: InputMaybe<IntFilterInput>;
  cost_per_baorider?: InputMaybe<FloatFilterInput>;
  not?: InputMaybe<ComponentProductFeatureProductFeatureFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentProductFeatureProductFeatureFiltersInput>>>;
  price?: InputMaybe<LongFilterInput>;
  price_usd?: InputMaybe<LongFilterInput>;
  price_zar?: InputMaybe<LongFilterInput>;
  recurring?: InputMaybe<StringFilterInput>;
  support_hours?: InputMaybe<FloatFilterInput>;
};

export type ComponentProductFeatureProductFeatureInput = {
  baoriders_allowed?: InputMaybe<Scalars['Int']['input']>;
  cost_per_baorider?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  price?: InputMaybe<Scalars['Long']['input']>;
  price_usd?: InputMaybe<Scalars['Long']['input']>;
  price_zar?: InputMaybe<Scalars['Long']['input']>;
  recurring?: InputMaybe<Enum_Componentproductfeatureproductfeature_Recurring>;
  support_hours?: InputMaybe<Scalars['Float']['input']>;
};

export type ComponentTrainingVideoTrainingVideo = {
  __typename?: 'ComponentTrainingVideoTrainingVideo';
  category?: Maybe<Enum_Componenttrainingvideotrainingvideo_Category>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  page?: Maybe<Enum_Componenttrainingvideotrainingvideo_Page>;
  tags?: Maybe<Array<Maybe<ComponentComboFieldOption>>>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};


export type ComponentTrainingVideoTrainingVideoTagsArgs = {
  filters?: InputMaybe<ComponentComboFieldOptionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentTrainingVideoTrainingVideoFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentTrainingVideoTrainingVideoFiltersInput>>>;
  category?: InputMaybe<StringFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentTrainingVideoTrainingVideoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentTrainingVideoTrainingVideoFiltersInput>>>;
  page?: InputMaybe<StringFilterInput>;
  tags?: InputMaybe<ComponentComboFieldOptionFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type ComponentTrainingVideoTrainingVideoInput = {
  category?: InputMaybe<Enum_Componenttrainingvideotrainingvideo_Category>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Enum_Componenttrainingvideotrainingvideo_Page>;
  tags?: InputMaybe<Array<InputMaybe<ComponentComboFieldOptionInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBaoleaderInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  role: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateBaoriderInput = {
  community: Scalars['ID']['input'];
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  idNumber?: InputMaybe<Scalars['String']['input']>;
  isVerifier?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  projects?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateCommunityMembersInput = {
  community: Scalars['ID']['input'];
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  idNumber?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type CreateNewSubscriptionInput = {
  collectionMethod: Scalars['String']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  plan: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  recurring: Scalars['String']['input'];
};

export type CustomDataLabel = {
  __typename?: 'CustomDataLabel';
  baoleader?: Maybe<UsersPermissionsUserEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  is_default?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  options?: Maybe<ProjectDataLabelTypeOptionRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  task_type?: Maybe<TaskTypeEntityResponse>;
  type?: Maybe<DataLabelTypeEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CustomDataLabelOptionsArgs = {
  filters?: InputMaybe<ProjectDataLabelTypeOptionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CustomDataLabelEntity = {
  __typename?: 'CustomDataLabelEntity';
  attributes?: Maybe<CustomDataLabel>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CustomDataLabelEntityResponse = {
  __typename?: 'CustomDataLabelEntityResponse';
  data?: Maybe<CustomDataLabelEntity>;
};

export type CustomDataLabelEntityResponseCollection = {
  __typename?: 'CustomDataLabelEntityResponseCollection';
  data: Array<CustomDataLabelEntity>;
  meta: ResponseCollectionMeta;
};

export type CustomDataLabelFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CustomDataLabelFiltersInput>>>;
  baoleader?: InputMaybe<UsersPermissionsUserFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  is_default?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CustomDataLabelFiltersInput>;
  options?: InputMaybe<ProjectDataLabelTypeOptionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CustomDataLabelFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  task_type?: InputMaybe<TaskTypeFiltersInput>;
  type?: InputMaybe<DataLabelTypeFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CustomDataLabelInput = {
  baoleader?: InputMaybe<Scalars['ID']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  task_type?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['ID']['input']>;
};

export type CustomDataLabelRelationResponseCollection = {
  __typename?: 'CustomDataLabelRelationResponseCollection';
  data: Array<CustomDataLabelEntity>;
};

export type DataLabelType = {
  __typename?: 'DataLabelType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  has_options?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DataLabelTypeEntity = {
  __typename?: 'DataLabelTypeEntity';
  attributes?: Maybe<DataLabelType>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type DataLabelTypeEntityResponse = {
  __typename?: 'DataLabelTypeEntityResponse';
  data?: Maybe<DataLabelTypeEntity>;
};

export type DataLabelTypeEntityResponseCollection = {
  __typename?: 'DataLabelTypeEntityResponseCollection';
  data: Array<DataLabelTypeEntity>;
  meta: ResponseCollectionMeta;
};

export type DataLabelTypeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<DataLabelTypeFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  has_options?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<DataLabelTypeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<DataLabelTypeFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type DataLabelTypeInput = {
  has_options?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DataList = {
  __typename?: 'DataList';
  company?: Maybe<CompanyEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  data_list_options?: Maybe<DataListOptionRelationResponseCollection>;
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Enum_Datalist_Status>;
  updateKey?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type DataListData_List_OptionsArgs = {
  filters?: InputMaybe<DataListOptionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DataListEntity = {
  __typename?: 'DataListEntity';
  attributes?: Maybe<DataList>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type DataListEntityResponse = {
  __typename?: 'DataListEntityResponse';
  data?: Maybe<DataListEntity>;
};

export type DataListEntityResponseCollection = {
  __typename?: 'DataListEntityResponseCollection';
  data: Array<DataListEntity>;
  meta: ResponseCollectionMeta;
};

export type DataListFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<DataListFiltersInput>>>;
  company?: InputMaybe<CompanyFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  data_list_options?: InputMaybe<DataListOptionFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<DataListFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<DataListFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  updateKey?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type DataListInput = {
  company?: InputMaybe<Scalars['ID']['input']>;
  data_list_options?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Enum_Datalist_Status>;
  updateKey?: InputMaybe<Scalars['String']['input']>;
};

export type DataListOption = {
  __typename?: 'DataListOption';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  data_list?: Maybe<DataListEntityResponse>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Enum_Datalistoption_Status>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value: Scalars['String']['output'];
};

export type DataListOptionEntity = {
  __typename?: 'DataListOptionEntity';
  attributes?: Maybe<DataListOption>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type DataListOptionEntityResponse = {
  __typename?: 'DataListOptionEntityResponse';
  data?: Maybe<DataListOptionEntity>;
};

export type DataListOptionEntityResponseCollection = {
  __typename?: 'DataListOptionEntityResponseCollection';
  data: Array<DataListOptionEntity>;
  meta: ResponseCollectionMeta;
};

export type DataListOptionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<DataListOptionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  data_list?: InputMaybe<DataListFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<DataListOptionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<DataListOptionFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  value?: InputMaybe<StringFilterInput>;
};

export type DataListOptionInput = {
  data_list?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Enum_Datalistoption_Status>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type DataListOptionRelationResponseCollection = {
  __typename?: 'DataListOptionRelationResponseCollection';
  data: Array<DataListOptionEntity>;
};

export type DataListOptionWithCount = {
  __typename?: 'DataListOptionWithCount';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<DataListOptionEntity>>>;
};

export type DataListRelationResponseCollection = {
  __typename?: 'DataListRelationResponseCollection';
  data: Array<DataListEntity>;
};

export type DateFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  contains?: InputMaybe<Scalars['Date']['input']>;
  containsi?: InputMaybe<Scalars['Date']['input']>;
  endsWith?: InputMaybe<Scalars['Date']['input']>;
  eq?: InputMaybe<Scalars['Date']['input']>;
  eqi?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nei?: InputMaybe<Scalars['Date']['input']>;
  not?: InputMaybe<DateFilterInput>;
  notContains?: InputMaybe<Scalars['Date']['input']>;
  notContainsi?: InputMaybe<Scalars['Date']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  startsWith?: InputMaybe<Scalars['Date']['input']>;
};

export type DateRangeInput = {
  end?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};

export type DateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  contains?: InputMaybe<Scalars['DateTime']['input']>;
  containsi?: InputMaybe<Scalars['DateTime']['input']>;
  endsWith?: InputMaybe<Scalars['DateTime']['input']>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  eqi?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  ne?: InputMaybe<Scalars['DateTime']['input']>;
  nei?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeFilterInput>;
  notContains?: InputMaybe<Scalars['DateTime']['input']>;
  notContainsi?: InputMaybe<Scalars['DateTime']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  startsWith?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeliveryReportCounts = {
  __typename?: 'DeliveryReportCounts';
  failed: Scalars['Int']['output'];
  notSent: Scalars['Int']['output'];
  received: Scalars['Int']['output'];
  sent: Scalars['Int']['output'];
};

export enum Enum_Baoverifierapp_Status {
  Active = 'active',
  Inactive = 'inactive'
}

export enum Enum_Category_Status {
  Active = 'active',
  Inactive = 'inactive'
}

export enum Enum_Community_Type {
  Community = 'Community',
  Team = 'Team',
  Volunteers = 'Volunteers'
}

export enum Enum_Company_Status {
  Active = 'active',
  Inactive = 'inactive'
}

export enum Enum_Componentcustomdatafieldsimagefield_Upload_State {
  Done = 'done',
  InProgress = 'in_progress'
}

export enum Enum_Componentfaqfaq_Category {
  Admin = 'Admin',
  DataCollector = 'Data_Collector',
  WelcomeToBaotree = 'Welcome_to_Baotree'
}

export enum Enum_Componentfaqfaq_Page {
  DataCollectors = 'Data_Collectors',
  GroupsGuide = 'Groups_Guide',
  Help = 'Help',
  Onboarding = 'Onboarding',
  ProjectsHowTo = 'Projects_How_To',
  Settings = 'Settings',
  TaskBuilder_101 = 'Task_Builder_101',
  TasksFeed = 'Tasks_Feed'
}

export enum Enum_Componentpriceplansplans_Recurring {
  Month = 'month',
  Year = 'year'
}

export enum Enum_Componentproductfeatureproductfeature_Recurring {
  Month = 'month',
  Year = 'year'
}

export enum Enum_Componenttrainingvideotrainingvideo_Category {
  Admin = 'Admin',
  DataCollector = 'Data_Collector',
  WelcomeToBaotree = 'Welcome_to_Baotree'
}

export enum Enum_Componenttrainingvideotrainingvideo_Page {
  DataCollectors = 'Data_Collectors',
  GroupsGuide = 'Groups_Guide',
  Help = 'Help',
  Onboarding = 'Onboarding',
  ProjectsHowTo = 'Projects_How_To',
  Settings = 'Settings',
  TaskBuilder_101 = 'Task_Builder_101',
  TasksFeed = 'Tasks_Feed'
}

export enum Enum_Datalistoption_Status {
  Active = 'active',
  Inactive = 'inactive'
}

export enum Enum_Datalist_Status {
  Active = 'active',
  Inactive = 'inactive'
}

export enum Enum_Evidence_Upload_State {
  Done = 'done',
  InProgress = 'in_progress'
}

export enum Enum_Featurecoupon_Feature {
  Analytics = 'analytics'
}

export enum Enum_Featureunlock_Feature {
  Analytics = 'analytics'
}

export enum Enum_Insightreport_Status {
  Draft = 'draft',
  Published = 'published'
}

export enum Enum_Notification_Recur {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  None = 'NONE',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export enum Enum_Notification_Status {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Done = 'DONE',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  Info = 'INFO',
  Received = 'RECEIVED',
  Sent = 'SENT'
}

export enum Enum_Notification_Type {
  EarlyWarning = 'EARLY_WARNING',
  General = 'GENERAL',
  MoreInfoRequested = 'MORE_INFO_REQUESTED',
  Reminder = 'REMINDER',
  ReminderAlert = 'REMINDER_ALERT'
}

export enum Enum_Project_Partners {
  Ftt = 'FTT'
}

export enum Enum_Project_Status {
  Archived = 'ARCHIVED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS'
}

export enum Enum_Pushnotificationstatus_Status {
  Failed = 'FAILED',
  Received = 'RECEIVED',
  Sent = 'SENT'
}

export enum Enum_Request_Status {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export enum Enum_Scheduledcronjob_Jobtype {
  DcInactivity = 'DC_INACTIVITY',
  DcLastTaskReported = 'DC_LAST_TASK_REPORTED',
  DcWeeklyActivities = 'DC_WEEKLY_ACTIVITIES',
  Login = 'LOGIN'
}

export enum Enum_Scheduledcronjob_Status {
  Done = 'DONE',
  Error = 'ERROR',
  Pending = 'PENDING'
}

export enum Enum_Schedulednotification_Priority {
  Default = 'DEFAULT',
  High = 'HIGH',
  Low = 'LOW',
  Max = 'MAX'
}

export enum Enum_Schedulednotification_Recur {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  None = 'NONE',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export enum Enum_Schedulednotification_Status {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export enum Enum_Subscription_Collection_Method {
  ChargeAutomatically = 'charge_automatically',
  SendInvoice = 'send_invoice'
}

export enum Enum_Subscription_Currency {
  Gbp = 'gbp',
  Usd = 'usd',
  Zar = 'zar'
}

export enum Enum_Subscription_Recurring {
  Month = 'month',
  Year = 'year'
}

export enum Enum_Subscription_Status {
  Active = 'active',
  Canceled = 'canceled',
  Incomplete = 'incomplete',
  IncompleteExpired = 'incomplete_expired',
  PastDue = 'past_due',
  Trialing = 'trialing',
  Unpaid = 'unpaid'
}

export enum Enum_Taskdefinition_Status {
  Active = 'active',
  Deactivated = 'deactivated',
  Old = 'old'
}

export enum Enum_Tasktype_Status {
  Active = 'active',
  Deactivated = 'deactivated',
  Drafted = 'drafted',
  Old = 'old'
}

export enum Enum_Task_Status {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  MoreInfoRequested = 'MORE_INFO_REQUESTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Reported = 'REPORTED'
}

export enum Enum_Task_Task_Origin {
  Baoleader = 'BAOLEADER',
  Baoverifier = 'BAOVERIFIER',
  CommunityMember = 'COMMUNITY_MEMBER',
  DataCollector = 'DATA_COLLECTOR',
  Desktop = 'DESKTOP',
  Leader = 'LEADER'
}

export enum Enum_Userspermissionsuser_Gender {
  Female = 'Female',
  Male = 'Male',
  Other = 'Other',
  PreferNotToSay = 'Prefer_not_to_say'
}

export enum Enum_Userspermissionsuser_Onboarding {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS'
}

export enum Enum_Userspermissionsuser_Status {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Inactive = 'INACTIVE',
  RequestPending = 'REQUEST_PENDING'
}

export enum Enum_Video_Category {
  Baorider = 'baorider',
  Community = 'community',
  General = 'general',
  Project = 'project',
  Request = 'request',
  Task = 'task'
}

export type EmailOtp = {
  __typename?: 'EmailOtp';
  attempts?: Maybe<Scalars['Int']['output']>;
  consumedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  lastSentAt?: Maybe<Scalars['DateTime']['output']>;
  sendCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EmailOtpEntity = {
  __typename?: 'EmailOtpEntity';
  attributes?: Maybe<EmailOtp>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type EmailOtpEntityResponse = {
  __typename?: 'EmailOtpEntityResponse';
  data?: Maybe<EmailOtpEntity>;
};

export type EmailOtpEntityResponseCollection = {
  __typename?: 'EmailOtpEntityResponseCollection';
  data: Array<EmailOtpEntity>;
  meta: ResponseCollectionMeta;
};

export type EmailOtpFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<EmailOtpFiltersInput>>>;
  attempts?: InputMaybe<IntFilterInput>;
  codeHash?: InputMaybe<StringFilterInput>;
  consumedAt?: InputMaybe<DateTimeFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  expiresAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  lastSentAt?: InputMaybe<DateTimeFilterInput>;
  not?: InputMaybe<EmailOtpFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<EmailOtpFiltersInput>>>;
  sendCount?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  verified?: InputMaybe<BooleanFilterInput>;
  verifiedAt?: InputMaybe<DateTimeFilterInput>;
};

export type EmailOtpInput = {
  attempts?: InputMaybe<Scalars['Int']['input']>;
  codeHash?: InputMaybe<Scalars['String']['input']>;
  consumedAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  sendCount?: InputMaybe<Scalars['Int']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  verifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Error = {
  __typename?: 'Error';
  code: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type Evidence = {
  __typename?: 'Evidence';
  accuracy?: Maybe<Scalars['Float']['output']>;
  baorider?: Maybe<UsersPermissionsUserEntityResponse>;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  connectivity?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  custom_data_fields?: Maybe<Array<Maybe<EvidenceCustomDataFieldsDynamicZone>>>;
  data_field_values?: Maybe<TaskDataLabelValueRelationResponseCollection>;
  latitude?: Maybe<Scalars['Float']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  photos?: Maybe<UploadFileRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  requestedInfo?: Maybe<Scalars['String']['output']>;
  task?: Maybe<TaskEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  upload_state?: Maybe<Enum_Evidence_Upload_State>;
};


export type EvidenceData_Field_ValuesArgs = {
  filters?: InputMaybe<TaskDataLabelValueFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type EvidencePhotosArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EvidenceCustomDataFieldsDynamicZone = ComponentCustomDataFieldsCheckbox | ComponentCustomDataFieldsDataList | ComponentCustomDataFieldsDateTimeField | ComponentCustomDataFieldsEmailField | ComponentCustomDataFieldsImageField | ComponentCustomDataFieldsMetricsSpecific | ComponentCustomDataFieldsNumberDropDown | ComponentCustomDataFieldsNumberField | ComponentCustomDataFieldsNumberRange | ComponentCustomDataFieldsPercentage | ComponentCustomDataFieldsPhoneNumberField | ComponentCustomDataFieldsRadio | ComponentCustomDataFieldsRating | ComponentCustomDataFieldsSelect | ComponentCustomDataFieldsText | Error;

export type EvidenceEntity = {
  __typename?: 'EvidenceEntity';
  attributes?: Maybe<Evidence>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type EvidenceEntityResponse = {
  __typename?: 'EvidenceEntityResponse';
  data?: Maybe<EvidenceEntity>;
};

export type EvidenceEntityResponseCollection = {
  __typename?: 'EvidenceEntityResponseCollection';
  data: Array<EvidenceEntity>;
  meta: ResponseCollectionMeta;
};

export type EvidenceFiltersInput = {
  accuracy?: InputMaybe<FloatFilterInput>;
  and?: InputMaybe<Array<InputMaybe<EvidenceFiltersInput>>>;
  baorider?: InputMaybe<UsersPermissionsUserFiltersInput>;
  cancellationReason?: InputMaybe<StringFilterInput>;
  connectivity?: InputMaybe<JsonFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  data_field_values?: InputMaybe<TaskDataLabelValueFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  latitude?: InputMaybe<FloatFilterInput>;
  location?: InputMaybe<StringFilterInput>;
  longitude?: InputMaybe<FloatFilterInput>;
  not?: InputMaybe<EvidenceFiltersInput>;
  notes?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<EvidenceFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  requestedInfo?: InputMaybe<StringFilterInput>;
  task?: InputMaybe<TaskFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  upload_state?: InputMaybe<StringFilterInput>;
};

export type EvidenceInput = {
  accuracy?: InputMaybe<Scalars['Float']['input']>;
  baorider?: InputMaybe<Scalars['ID']['input']>;
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  connectivity?: InputMaybe<Scalars['JSON']['input']>;
  custom_data_fields?: InputMaybe<Array<Scalars['EvidenceCustomDataFieldsDynamicZoneInput']['input']>>;
  data_field_values?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  photos?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  requestedInfo?: InputMaybe<Scalars['String']['input']>;
  task?: InputMaybe<Scalars['ID']['input']>;
  upload_state?: InputMaybe<Enum_Evidence_Upload_State>;
};

export type EvidenceInputType = {
  dataLabelValuesArr?: InputMaybe<Scalars['JSON']['input']>;
  input?: InputMaybe<EvidenceInput>;
  taskOfflineId?: InputMaybe<Scalars['String']['input']>;
};

export type EvidenceRelationResponseCollection = {
  __typename?: 'EvidenceRelationResponseCollection';
  data: Array<EvidenceEntity>;
};

export type FeatureAccessPayload = {
  __typename?: 'FeatureAccessPayload';
  /**
   * When a time-limited grant ends — a coupon's expiry, or the manual-plan
   * cutoff. Null when access is not time-limited.
   */
  accessEndsAt?: Maybe<Scalars['DateTime']['output']>;
  feature?: Maybe<Scalars['String']['output']>;
  hasAccess?: Maybe<Scalars['Boolean']['output']>;
  isManual?: Maybe<Scalars['Boolean']['output']>;
  migrationDeadline?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Whether the account should be prompted to move onto an automated
   * (Stripe-billed) plan. True for every manual account, coupon or not.
   */
  requiresMigration?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether the client should run the manual-plan countdown. False for
   * coupon holders, who are deliberately keeping access.
   */
  showCountdown?: Maybe<Scalars['Boolean']['output']>;
  /** Why access is (or is not) granted: 'coupon', 'manual_grace', 'plan' or 'none'. */
  source?: Maybe<Scalars['String']['output']>;
};

export type FeatureCoupon = {
  __typename?: 'FeatureCoupon';
  code: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  durationDays: Scalars['Int']['output'];
  feature: Enum_Featurecoupon_Feature;
  feature_unlocks?: Maybe<FeatureUnlockRelationResponseCollection>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  maxRedemptions?: Maybe<Scalars['Int']['output']>;
  redemptionCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  validUntil?: Maybe<Scalars['DateTime']['output']>;
};


export type FeatureCouponFeature_UnlocksArgs = {
  filters?: InputMaybe<FeatureUnlockFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FeatureCouponEntity = {
  __typename?: 'FeatureCouponEntity';
  attributes?: Maybe<FeatureCoupon>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type FeatureCouponEntityResponse = {
  __typename?: 'FeatureCouponEntityResponse';
  data?: Maybe<FeatureCouponEntity>;
};

export type FeatureCouponEntityResponseCollection = {
  __typename?: 'FeatureCouponEntityResponseCollection';
  data: Array<FeatureCouponEntity>;
  meta: ResponseCollectionMeta;
};

export type FeatureCouponFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<FeatureCouponFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  durationDays?: InputMaybe<IntFilterInput>;
  feature?: InputMaybe<StringFilterInput>;
  feature_unlocks?: InputMaybe<FeatureUnlockFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  isActive?: InputMaybe<BooleanFilterInput>;
  maxRedemptions?: InputMaybe<IntFilterInput>;
  not?: InputMaybe<FeatureCouponFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<FeatureCouponFiltersInput>>>;
  redemptionCount?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  validUntil?: InputMaybe<DateTimeFilterInput>;
};

export type FeatureCouponInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  durationDays?: InputMaybe<Scalars['Int']['input']>;
  feature?: InputMaybe<Enum_Featurecoupon_Feature>;
  feature_unlocks?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  maxRedemptions?: InputMaybe<Scalars['Int']['input']>;
  redemptionCount?: InputMaybe<Scalars['Int']['input']>;
  validUntil?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FeatureUnlock = {
  __typename?: 'FeatureUnlock';
  company?: Maybe<CompanyEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt: Scalars['DateTime']['output'];
  feature: Enum_Featureunlock_Feature;
  feature_coupon?: Maybe<FeatureCouponEntityResponse>;
  redeemedBy?: Maybe<UsersPermissionsUserEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FeatureUnlockEntity = {
  __typename?: 'FeatureUnlockEntity';
  attributes?: Maybe<FeatureUnlock>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type FeatureUnlockEntityResponse = {
  __typename?: 'FeatureUnlockEntityResponse';
  data?: Maybe<FeatureUnlockEntity>;
};

export type FeatureUnlockEntityResponseCollection = {
  __typename?: 'FeatureUnlockEntityResponseCollection';
  data: Array<FeatureUnlockEntity>;
  meta: ResponseCollectionMeta;
};

export type FeatureUnlockFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<FeatureUnlockFiltersInput>>>;
  company?: InputMaybe<CompanyFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  expiresAt?: InputMaybe<DateTimeFilterInput>;
  feature?: InputMaybe<StringFilterInput>;
  feature_coupon?: InputMaybe<FeatureCouponFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<FeatureUnlockFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<FeatureUnlockFiltersInput>>>;
  redeemedBy?: InputMaybe<UsersPermissionsUserFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type FeatureUnlockInput = {
  company?: InputMaybe<Scalars['ID']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  feature?: InputMaybe<Enum_Featureunlock_Feature>;
  feature_coupon?: InputMaybe<Scalars['ID']['input']>;
  redeemedBy?: InputMaybe<Scalars['ID']['input']>;
};

export type FeatureUnlockPayload = {
  __typename?: 'FeatureUnlockPayload';
  active?: Maybe<Scalars['Boolean']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  feature?: Maybe<Scalars['String']['output']>;
};

export type FeatureUnlockRelationResponseCollection = {
  __typename?: 'FeatureUnlockRelationResponseCollection';
  data: Array<FeatureUnlockEntity>;
};

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contains?: InputMaybe<Scalars['Float']['input']>;
  containsi?: InputMaybe<Scalars['Float']['input']>;
  endsWith?: InputMaybe<Scalars['Float']['input']>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  eqi?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nei?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<FloatFilterInput>;
  notContains?: InputMaybe<Scalars['Float']['input']>;
  notContainsi?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  startsWith?: InputMaybe<Scalars['Float']['input']>;
};

export type FreeTrialPayload = {
  __typename?: 'FreeTrialPayload';
  billingRequired?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['ID']['output']>;
  trialEndsAt?: Maybe<Scalars['DateTime']['output']>;
  trialStartsAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GenericMorph = Analytic | BaoverifierApp | Category | Community | Company | ComponentComboFieldOption | ComponentCustomDataFieldsCheckbox | ComponentCustomDataFieldsDataList | ComponentCustomDataFieldsDateTimeField | ComponentCustomDataFieldsEmailField | ComponentCustomDataFieldsImageField | ComponentCustomDataFieldsMetricsSpecific | ComponentCustomDataFieldsNumberDropDown | ComponentCustomDataFieldsNumberField | ComponentCustomDataFieldsNumberRange | ComponentCustomDataFieldsPercentage | ComponentCustomDataFieldsPhoneNumberField | ComponentCustomDataFieldsRadio | ComponentCustomDataFieldsRating | ComponentCustomDataFieldsSelect | ComponentCustomDataFieldsText | ComponentFaqFaq | ComponentPricePlansPlans | ComponentProductFeaturePlanFeature | ComponentProductFeatureProductFeature | ComponentTrainingVideoTrainingVideo | CustomDataLabel | DataLabelType | DataList | DataListOption | EmailOtp | Evidence | FeatureCoupon | FeatureUnlock | I18NLocale | InsightReport | Notification | ProductPlan | Project | ProjectDataLabelTypeOption | Request | ScheduledCronEmailStatus | ScheduledCronJob | ScheduledNotification | Subscription | Task | TaskDataLabelValue | TaskDefinition | TaskType | TermsAndCondition | TrainingVideo | UnSdg | UploadFile | UploadFolder | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsUser | Video;

export type I18NLocale = {
  __typename?: 'I18NLocale';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type I18NLocaleEntity = {
  __typename?: 'I18NLocaleEntity';
  attributes?: Maybe<I18NLocale>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type I18NLocaleEntityResponse = {
  __typename?: 'I18NLocaleEntityResponse';
  data?: Maybe<I18NLocaleEntity>;
};

export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  data: Array<I18NLocaleEntity>;
  meta: ResponseCollectionMeta;
};

export type I18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<I18NLocaleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  containsi?: InputMaybe<Scalars['ID']['input']>;
  endsWith?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  eqi?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  nei?: InputMaybe<Scalars['ID']['input']>;
  not?: InputMaybe<IdFilterInput>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
  notContainsi?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startsWith?: InputMaybe<Scalars['ID']['input']>;
};

export type InsightAiMessageInput = {
  content: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

export type InsightAiResponse = {
  __typename?: 'InsightAIResponse';
  message?: Maybe<Scalars['String']['output']>;
  reportPlan?: Maybe<Scalars['JSON']['output']>;
  suggestedChartType?: Maybe<Scalars['String']['output']>;
  suggestedColumns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  suggestions?: Maybe<Array<Maybe<InsightAiSuggestion>>>;
};

export type InsightAiSuggestion = {
  __typename?: 'InsightAISuggestion';
  label?: Maybe<Scalars['String']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
};

export type InsightAgentFilterInput = {
  column: Scalars['String']['input'];
  operator: Scalars['String']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type InsightAgentReportInput = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  chartType: Scalars['String']['input'];
  dateRange?: InputMaybe<DateRangeInput>;
  dateSource?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<InsightAgentFilterInput>>;
  name: Scalars['String']['input'];
  previewOnly?: InputMaybe<Scalars['Boolean']['input']>;
  selectedColumns: Array<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  taskDefinitionIds: Array<Scalars['ID']['input']>;
  timeSeries?: InputMaybe<Scalars['String']['input']>;
};

export type InsightAgentReportResult = {
  __typename?: 'InsightAgentReportResult';
  preview: Scalars['JSON']['output'];
  report?: Maybe<InsightReportEntity>;
  warnings: Array<Scalars['String']['output']>;
};

export type InsightColumn = {
  __typename?: 'InsightColumn';
  isFromOlderVersion?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  taskTypeId?: Maybe<Scalars['String']['output']>;
  taskTypeName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type InsightReport = {
  __typename?: 'InsightReport';
  company?: Maybe<CompanyEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  created_by_user?: Maybe<UsersPermissionsUserEntityResponse>;
  description?: Maybe<Scalars['String']['output']>;
  /** Chart count, types and a first-chart thumbnail — what the reports list draws. */
  graphSummary?: Maybe<Scalars['JSON']['output']>;
  graphs?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  status?: Maybe<Enum_Insightreport_Status>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type InsightReportCustomInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  graphs?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type InsightReportEntity = {
  __typename?: 'InsightReportEntity';
  attributes?: Maybe<InsightReport>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type InsightReportEntityResponse = {
  __typename?: 'InsightReportEntityResponse';
  data?: Maybe<InsightReportEntity>;
};

export type InsightReportEntityResponseCollection = {
  __typename?: 'InsightReportEntityResponseCollection';
  data: Array<InsightReportEntity>;
  meta: ResponseCollectionMeta;
};

export type InsightReportFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<InsightReportFiltersInput>>>;
  company?: InputMaybe<CompanyFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  created_by_user?: InputMaybe<UsersPermissionsUserFiltersInput>;
  description?: InputMaybe<StringFilterInput>;
  graphs?: InputMaybe<JsonFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<InsightReportFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<InsightReportFiltersInput>>>;
  status?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type InsightReportInput = {
  company?: InputMaybe<Scalars['ID']['input']>;
  created_by_user?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  graphs?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Enum_Insightreport_Status>;
};

export type InsightTaskData = {
  __typename?: 'InsightTaskData';
  aggregatedData?: Maybe<Scalars['JSON']['output']>;
  columns?: Maybe<Array<Maybe<InsightColumn>>>;
  dateInfo?: Maybe<Scalars['JSON']['output']>;
  rows?: Maybe<Scalars['JSON']['output']>;
  totalRows?: Maybe<Scalars['Int']['output']>;
};

export type IntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  contains?: InputMaybe<Scalars['Int']['input']>;
  containsi?: InputMaybe<Scalars['Int']['input']>;
  endsWith?: InputMaybe<Scalars['Int']['input']>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  eqi?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  nei?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntFilterInput>;
  notContains?: InputMaybe<Scalars['Int']['input']>;
  notContainsi?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startsWith?: InputMaybe<Scalars['Int']['input']>;
};

export type InvoicePayload = {
  __typename?: 'InvoicePayload';
  account_country?: Maybe<Scalars['String']['output']>;
  account_name?: Maybe<Scalars['String']['output']>;
  account_tax_ids?: Maybe<Scalars['String']['output']>;
  amount_due?: Maybe<Scalars['Float']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  amount_remaining?: Maybe<Scalars['Float']['output']>;
  application_fee_amount?: Maybe<Scalars['Float']['output']>;
  attempt_count?: Maybe<Scalars['Int']['output']>;
  attempted?: Maybe<Scalars['Boolean']['output']>;
  auto_advance?: Maybe<Scalars['Boolean']['output']>;
  billing_reason?: Maybe<Scalars['String']['output']>;
  collection_method?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Scalars['String']['output']>;
  default_payment_method?: Maybe<Scalars['String']['output']>;
  default_source?: Maybe<Scalars['String']['output']>;
  default_tax_rates?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  discounts?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  due_date?: Maybe<Scalars['String']['output']>;
  ending_balance?: Maybe<Scalars['Float']['output']>;
  hosted_invoice_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  invoice_pdf?: Maybe<Scalars['String']['output']>;
  lines?: Maybe<Scalars['JSON']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  paid?: Maybe<Scalars['Boolean']['output']>;
  period_end?: Maybe<Scalars['String']['output']>;
  period_start?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<Scalars['String']['output']>;
};

export type IsListInUseResponse = {
  __typename?: 'IsListInUseResponse';
  amountOfUses?: Maybe<Scalars['Int']['output']>;
  foundLists?: Maybe<Array<Maybe<ComponentCustomDataFieldsDataList>>>;
  isListInUse?: Maybe<Scalars['Boolean']['output']>;
};

export type JsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  contains?: InputMaybe<Scalars['JSON']['input']>;
  containsi?: InputMaybe<Scalars['JSON']['input']>;
  endsWith?: InputMaybe<Scalars['JSON']['input']>;
  eq?: InputMaybe<Scalars['JSON']['input']>;
  eqi?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  ne?: InputMaybe<Scalars['JSON']['input']>;
  nei?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<JsonFilterInput>;
  notContains?: InputMaybe<Scalars['JSON']['input']>;
  notContainsi?: InputMaybe<Scalars['JSON']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  startsWith?: InputMaybe<Scalars['JSON']['input']>;
};

export type LongFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  contains?: InputMaybe<Scalars['Long']['input']>;
  containsi?: InputMaybe<Scalars['Long']['input']>;
  endsWith?: InputMaybe<Scalars['Long']['input']>;
  eq?: InputMaybe<Scalars['Long']['input']>;
  eqi?: InputMaybe<Scalars['Long']['input']>;
  gt?: InputMaybe<Scalars['Long']['input']>;
  gte?: InputMaybe<Scalars['Long']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  lt?: InputMaybe<Scalars['Long']['input']>;
  lte?: InputMaybe<Scalars['Long']['input']>;
  ne?: InputMaybe<Scalars['Long']['input']>;
  nei?: InputMaybe<Scalars['Long']['input']>;
  not?: InputMaybe<LongFilterInput>;
  notContains?: InputMaybe<Scalars['Long']['input']>;
  notContainsi?: InputMaybe<Scalars['Long']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  startsWith?: InputMaybe<Scalars['Long']['input']>;
};

export type Metric = {
  __typename?: 'Metric';
  chartData?: Maybe<Array<Maybe<ChartData>>>;
  last30Days: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type MigrateToAutomatedPlanInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId: Scalars['String']['input'];
  productPlanId: Scalars['ID']['input'];
};

export type MultipleBaoriderPayload = {
  __typename?: 'MultipleBaoriderPayload';
  baoriders?: Maybe<Array<Maybe<UsersPermissionsUserEntity>>>;
};

export type MultipleCommunityMembersPayload = {
  __typename?: 'MultipleCommunityMembersPayload';
  members?: Maybe<Array<Maybe<UsersPermissionsUserEntity>>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptBaoriderTask: TaskEntity;
  acceptCommunityMemberRequest: UsersPermissionsUserEntity;
  activateTaskType: TaskTypeEntity;
  addDataCollectorToProject?: Maybe<ProjectEntity>;
  cancelSubscription?: Maybe<SubscriptionCancellationPayload>;
  changeMyPassword?: Maybe<UsersPermissionsUserEntity>;
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<UsersPermissionsLoginPayload>;
  changeSubscriptionPlan?: Maybe<PlanChangePayload>;
  completeOnboardingStep?: Maybe<UsersPermissionsUserEntity>;
  createBaoleader: BaoleaderPayload;
  createBaoleaderCommunity?: Maybe<CommunityEntity>;
  createBaoleaderInsightReport: InsightReportEntity;
  createBaoleaderNotification?: Maybe<NotificationEntity>;
  createBaoleaderProject?: Maybe<ProjectEntity>;
  createBaoleaderScheduledNotification?: Maybe<ScheduledNotificationEntity>;
  createBaoleaderTask: TaskEntity;
  createBaoleaderTaskDefinition: TaskDefinitionEntity;
  createBaoleaderTaskType: TaskTypeEntity;
  createBaorider: BaoriderPayload;
  createBaoriderEvidence: EvidenceEntity;
  createBaoriders: MultipleBaoriderPayload;
  createBaoverifierFullTask: TaskAndEvidenceType;
  createBaoverifierFullTaskFromDesktop: TaskAndEvidenceType;
  createBaoverifierTask: TaskEntity;
  createCategory?: Maybe<CategoryEntityResponse>;
  createCommunity?: Maybe<CommunityEntityResponse>;
  createCommunityMember: CommunityMembersPayload;
  createCommunityMembers: Array<Maybe<CommunityMembersPayload>>;
  createCompany?: Maybe<CompanyEntityResponse>;
  createCustomDataLabel?: Maybe<CustomDataLabelEntityResponse>;
  createDataLabelType?: Maybe<DataLabelTypeEntityResponse>;
  createDataLabelValue?: Maybe<TaskDataLabelValue>;
  createDataList?: Maybe<DataListEntityResponse>;
  createDataListOption?: Maybe<DataListOptionEntityResponse>;
  createEmailOtp?: Maybe<EmailOtpEntityResponse>;
  createEvidence?: Maybe<EvidenceEntityResponse>;
  createFeatureCoupon?: Maybe<FeatureCouponEntityResponse>;
  createFeatureUnlock?: Maybe<FeatureUnlockEntityResponse>;
  createInsightReport?: Maybe<InsightReportEntityResponse>;
  createNewSubscription?: Maybe<Subscription>;
  createNotification?: Maybe<NotificationEntityResponse>;
  createProductPlan?: Maybe<ProductPlanEntityResponse>;
  createProject?: Maybe<ProjectEntityResponse>;
  createProjectDataLabelTypeOption?: Maybe<ProjectDataLabelTypeOptionEntityResponse>;
  createRequest?: Maybe<RequestEntityResponse>;
  createScheduledCronEmailStatus?: Maybe<ScheduledCronEmailStatusEntityResponse>;
  createScheduledCronJob?: Maybe<ScheduledCronJobEntityResponse>;
  createScheduledNotification?: Maybe<ScheduledNotificationEntityResponse>;
  createSetupIntent?: Maybe<SetupIntentPayload>;
  createSubscription?: Maybe<SubscriptionEntityResponse>;
  createTask?: Maybe<TaskEntityResponse>;
  createTaskDataLabelValue?: Maybe<TaskDataLabelValueEntityResponse>;
  createTaskDefinition?: Maybe<TaskDefinitionEntityResponse>;
  createTaskType?: Maybe<TaskTypeEntityResponse>;
  createUnSdg?: Maybe<UnSdgEntityResponse>;
  createUploadFile?: Maybe<UploadFileEntityResponse>;
  createUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  createVideo?: Maybe<VideoEntityResponse>;
  deactivateTaskType: TaskTypeEntity;
  deleteAnalytic?: Maybe<AnalyticEntityResponse>;
  deleteBaoleaderInsightReport?: Maybe<InsightReportEntity>;
  deleteBaoleaderNotification?: Maybe<NotificationEntity>;
  deleteBaoleaderScheduledNotification?: Maybe<ScheduledNotificationEntity>;
  deleteBaoleaderTask?: Maybe<TaskEntity>;
  deleteBaoleaderTaskDefinition?: Maybe<TaskDefinitionEntity>;
  deleteBaoverifierApp?: Maybe<BaoverifierAppEntityResponse>;
  deleteCategory?: Maybe<CategoryEntityResponse>;
  deleteCommunity?: Maybe<CommunityEntityResponse>;
  deleteCompany?: Maybe<CompanyEntityResponse>;
  deleteCustomDataLabel?: Maybe<CustomDataLabelEntityResponse>;
  deleteDataLabelType?: Maybe<DataLabelTypeEntityResponse>;
  deleteDataList?: Maybe<DataListEntityResponse>;
  deleteDataListOption?: Maybe<DataListOptionEntityResponse>;
  deleteEmailOtp?: Maybe<EmailOtpEntityResponse>;
  deleteEvidence?: Maybe<EvidenceEntityResponse>;
  deleteFeatureCoupon?: Maybe<FeatureCouponEntityResponse>;
  deleteFeatureUnlock?: Maybe<FeatureUnlockEntityResponse>;
  deleteInsightReport?: Maybe<InsightReportEntityResponse>;
  deleteNotification?: Maybe<NotificationEntityResponse>;
  deleteProductPlan?: Maybe<ProductPlanEntityResponse>;
  deleteProject?: Maybe<ProjectEntityResponse>;
  deleteProjectDataLabelTypeOption?: Maybe<ProjectDataLabelTypeOptionEntityResponse>;
  deleteRequest?: Maybe<RequestEntityResponse>;
  deleteScheduledCronEmailStatus?: Maybe<ScheduledCronEmailStatusEntityResponse>;
  deleteScheduledCronJob?: Maybe<ScheduledCronJobEntityResponse>;
  deleteScheduledNotification?: Maybe<ScheduledNotificationEntityResponse>;
  deleteSubscription?: Maybe<SubscriptionEntityResponse>;
  deleteTask?: Maybe<TaskEntityResponse>;
  deleteTaskDataLabelValue?: Maybe<TaskDataLabelValueEntityResponse>;
  deleteTaskDefinition?: Maybe<TaskDefinitionEntityResponse>;
  deleteTaskType?: Maybe<TaskTypeEntityResponse>;
  deleteTermsAndCondition?: Maybe<TermsAndConditionEntityResponse>;
  deleteTrainingVideo?: Maybe<TrainingVideoEntityResponse>;
  deleteUnSdg?: Maybe<UnSdgEntityResponse>;
  deleteUploadFile?: Maybe<UploadFileEntityResponse>;
  deleteUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  deleteVideo?: Maybe<VideoEntityResponse>;
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  executeInsightReportAgent: InsightAgentReportResult;
  exportExcel?: Maybe<Scalars['JSON']['output']>;
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
  login: UsersPermissionsLoginPayload;
  loginCustomerPortal?: Maybe<Scalars['String']['output']>;
  markDataCollectorNotificationAsRead?: Maybe<NotificationEntity>;
  markDataCollectorNotificationAsUnread?: Maybe<NotificationEntity>;
  markNotificationAsReceived?: Maybe<PushNotificationStatusEntity>;
  migrateToAutomatedPlan?: Maybe<PlanMigrationPayload>;
  multipleUpload: Array<Maybe<UploadFileEntityResponse>>;
  redeemFeatureCoupon?: Maybe<FeatureUnlockPayload>;
  /** Register a user */
  register: UsersPermissionsLoginPayload;
  rejectCommunityMemberRequest: UsersPermissionsUserEntity;
  removeBaorider: BaoriderPayload;
  removeCommunityMember: CommunityMembersPayload;
  removeCompanyMember?: Maybe<UsersPermissionsUserEntity>;
  removeFile?: Maybe<UploadFileEntityResponse>;
  removePaymentMethod: Scalars['Boolean']['output'];
  requestMoreInfo: TaskEntity;
  requestUpdateCompanyDetails?: Maybe<Company>;
  resendDataCollectorInvite?: Maybe<UsersPermissionsUserEntity>;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  resumeSubscription?: Maybe<SubscriptionCancellationPayload>;
  setDefaultPaymentMethod: Scalars['Boolean']['output'];
  skipOnboardingStep?: Maybe<UsersPermissionsUserEntity>;
  startFreeTrial?: Maybe<FreeTrialPayload>;
  suggestCommunityMember: CommunityMembersPayload;
  unarchiveCompanyMember?: Maybe<UsersPermissionsUserEntity>;
  updateAnalytic?: Maybe<AnalyticEntityResponse>;
  updateBaoleaderCommunity?: Maybe<CommunityEntity>;
  updateBaoleaderEvidence: Evidence;
  updateBaoleaderInsightReport: InsightReportEntity;
  updateBaoleaderNotification?: Maybe<NotificationEntity>;
  updateBaoleaderProject?: Maybe<ProjectEntity>;
  updateBaoleaderScheduledNotification?: Maybe<ScheduledNotificationEntity>;
  updateBaoleaderTask: TaskEntity;
  updateBaoleaderTaskDefinition: TaskDefinitionEntity;
  updateBaoleaderTaskType: TaskTypeEntity;
  updateBaorider: BaoriderPayload;
  updateBaoriderEvidence: Evidence;
  updateBaoriderTask: TaskEntity;
  updateBaoverifierApp?: Maybe<BaoverifierAppEntityResponse>;
  updateCategory?: Maybe<CategoryEntityResponse>;
  updateCommunity?: Maybe<CommunityEntityResponse>;
  updateCommunityMember: CommunityMembersPayload;
  updateCompany?: Maybe<CompanyEntityResponse>;
  updateCompanyOnboardingInformation?: Maybe<CompanyEntity>;
  updateCustomDataLabel?: Maybe<CustomDataLabelEntityResponse>;
  updateDataLabelType?: Maybe<DataLabelTypeEntityResponse>;
  updateDataList?: Maybe<DataListEntityResponse>;
  updateDataListOption?: Maybe<DataListOptionEntityResponse>;
  updateEmailOtp?: Maybe<EmailOtpEntityResponse>;
  updateEvidence?: Maybe<EvidenceEntityResponse>;
  updateFeatureCoupon?: Maybe<FeatureCouponEntityResponse>;
  updateFeatureUnlock?: Maybe<FeatureUnlockEntityResponse>;
  updateFileInfo: UploadFileEntityResponse;
  updateInsightReport?: Maybe<InsightReportEntityResponse>;
  updateMyUser?: Maybe<UsersPermissionsUserEntity>;
  updateNotification?: Maybe<NotificationEntityResponse>;
  updateProductPlan?: Maybe<ProductPlanEntityResponse>;
  updateProject?: Maybe<ProjectEntityResponse>;
  updateProjectDataLabelTypeOption?: Maybe<ProjectDataLabelTypeOptionEntityResponse>;
  updateRequest?: Maybe<RequestEntityResponse>;
  updateScheduledCronEmailStatus?: Maybe<ScheduledCronEmailStatusEntityResponse>;
  updateScheduledCronJob?: Maybe<ScheduledCronJobEntityResponse>;
  updateScheduledNotification?: Maybe<ScheduledNotificationEntityResponse>;
  updateSubscription?: Maybe<SubscriptionEntityResponse>;
  updateTask?: Maybe<TaskEntityResponse>;
  updateTaskDataLabelValue?: Maybe<TaskDataLabelValueEntityResponse>;
  updateTaskDefinition?: Maybe<TaskDefinitionEntityResponse>;
  updateTaskType?: Maybe<TaskTypeEntityResponse>;
  updateTermsAndCondition?: Maybe<TermsAndConditionEntityResponse>;
  updateTrainingVideo?: Maybe<TrainingVideoEntityResponse>;
  updateUnSdg?: Maybe<UnSdgEntityResponse>;
  updateUploadFile?: Maybe<UploadFileEntityResponse>;
  updateUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  updateVideo?: Maybe<VideoEntityResponse>;
  upload: UploadFileEntityResponse;
  useProjectTemplate?: Maybe<ProjectEntity>;
  useProjectTemplates?: Maybe<Array<Maybe<ProjectEntity>>>;
  verifyDatacollectOtp?: Maybe<CodeValid>;
};


export type MutationAcceptBaoriderTaskArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAcceptCommunityMemberRequestArgs = {
  requestId: Scalars['ID']['input'];
};


export type MutationActivateTaskTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAddDataCollectorToProjectArgs = {
  input?: InputMaybe<AddDataCollectorToProjectInput>;
};


export type MutationChangeMyPasswordArgs = {
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  passwordNew: Scalars['String']['input'];
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationChangeSubscriptionPlanArgs = {
  productPlanId: Scalars['ID']['input'];
};


export type MutationCompleteOnboardingStepArgs = {
  completeOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  index: Scalars['String']['input'];
};


export type MutationCreateBaoleaderArgs = {
  input: CreateBaoleaderInput;
};


export type MutationCreateBaoleaderCommunityArgs = {
  input?: InputMaybe<CommunityInput>;
};


export type MutationCreateBaoleaderInsightReportArgs = {
  input: InsightReportCustomInput;
};


export type MutationCreateBaoleaderNotificationArgs = {
  data: NotificationInput;
};


export type MutationCreateBaoleaderProjectArgs = {
  input?: InputMaybe<ProjectInput>;
};


export type MutationCreateBaoleaderScheduledNotificationArgs = {
  input: ScheduledNotificationInput;
};


export type MutationCreateBaoleaderTaskArgs = {
  input?: InputMaybe<TaskInput>;
};


export type MutationCreateBaoleaderTaskDefinitionArgs = {
  input?: InputMaybe<TaskDefinitionInput>;
};


export type MutationCreateBaoleaderTaskTypeArgs = {
  dataFieldsArr?: InputMaybe<Scalars['JSON']['input']>;
  input: TaskTypeInput;
};


export type MutationCreateBaoriderArgs = {
  input: CreateBaoriderInput;
  sendInvite?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateBaoriderEvidenceArgs = {
  dataLabelValuesArr?: InputMaybe<Scalars['JSON']['input']>;
  input?: InputMaybe<EvidenceInput>;
};


export type MutationCreateBaoridersArgs = {
  input: Array<InputMaybe<CreateBaoriderInput>>;
};


export type MutationCreateBaoverifierFullTaskArgs = {
  evidence?: InputMaybe<EvidenceInputType>;
  task?: InputMaybe<TaskInput>;
  taskEdited?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateBaoverifierFullTaskFromDesktopArgs = {
  evidence?: InputMaybe<EvidenceInputType>;
  task?: InputMaybe<TaskInput>;
  taskEdited?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateBaoverifierTaskArgs = {
  input?: InputMaybe<TaskInput>;
};


export type MutationCreateCategoryArgs = {
  data: CategoryInput;
};


export type MutationCreateCommunityArgs = {
  data: CommunityInput;
};


export type MutationCreateCommunityMemberArgs = {
  input?: InputMaybe<CreateCommunityMembersInput>;
  sendInvite?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateCommunityMembersArgs = {
  input?: InputMaybe<Array<InputMaybe<CreateCommunityMembersInput>>>;
};


export type MutationCreateCompanyArgs = {
  data: CompanyInput;
};


export type MutationCreateCustomDataLabelArgs = {
  data: CustomDataLabelInput;
};


export type MutationCreateDataLabelTypeArgs = {
  data: DataLabelTypeInput;
};


export type MutationCreateDataLabelValueArgs = {
  input?: InputMaybe<TaskDataLabelValueInput>;
};


export type MutationCreateDataListArgs = {
  data: DataListInput;
};


export type MutationCreateDataListOptionArgs = {
  data: DataListOptionInput;
};


export type MutationCreateEmailOtpArgs = {
  data: EmailOtpInput;
};


export type MutationCreateEvidenceArgs = {
  data: EvidenceInput;
};


export type MutationCreateFeatureCouponArgs = {
  data: FeatureCouponInput;
};


export type MutationCreateFeatureUnlockArgs = {
  data: FeatureUnlockInput;
};


export type MutationCreateInsightReportArgs = {
  data: InsightReportInput;
};


export type MutationCreateNewSubscriptionArgs = {
  input?: InputMaybe<CreateNewSubscriptionInput>;
};


export type MutationCreateNotificationArgs = {
  data: NotificationInput;
};


export type MutationCreateProductPlanArgs = {
  data: ProductPlanInput;
};


export type MutationCreateProjectArgs = {
  data: ProjectInput;
};


export type MutationCreateProjectDataLabelTypeOptionArgs = {
  data: ProjectDataLabelTypeOptionInput;
};


export type MutationCreateRequestArgs = {
  data: RequestInput;
};


export type MutationCreateScheduledCronEmailStatusArgs = {
  data: ScheduledCronEmailStatusInput;
};


export type MutationCreateScheduledCronJobArgs = {
  data: ScheduledCronJobInput;
};


export type MutationCreateScheduledNotificationArgs = {
  data: ScheduledNotificationInput;
};


export type MutationCreateSubscriptionArgs = {
  data: SubscriptionInput;
};


export type MutationCreateTaskArgs = {
  data: TaskInput;
};


export type MutationCreateTaskDataLabelValueArgs = {
  data: TaskDataLabelValueInput;
};


export type MutationCreateTaskDefinitionArgs = {
  data: TaskDefinitionInput;
};


export type MutationCreateTaskTypeArgs = {
  data: TaskTypeInput;
};


export type MutationCreateUnSdgArgs = {
  data: UnSdgInput;
};


export type MutationCreateUploadFileArgs = {
  data: UploadFileInput;
};


export type MutationCreateUploadFolderArgs = {
  data: UploadFolderInput;
};


export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};


export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
};


export type MutationCreateVideoArgs = {
  data: VideoInput;
};


export type MutationDeactivateTaskTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBaoleaderInsightReportArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBaoleaderNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBaoleaderScheduledNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBaoleaderTaskArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBaoleaderTaskDefinitionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCommunityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCustomDataLabelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDataLabelTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDataListArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDataListOptionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEmailOtpArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEvidenceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFeatureCouponArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFeatureUnlockArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInsightReportArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProductPlanArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectDataLabelTypeOptionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteScheduledCronEmailStatusArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteScheduledCronJobArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteScheduledNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSubscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTaskArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTaskDataLabelValueArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTaskDefinitionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTaskTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUnSdgArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUploadFolderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVideoArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String']['input'];
};


export type MutationExecuteInsightReportAgentArgs = {
  input: InsightAgentReportInput;
};


export type MutationExportExcelArgs = {
  filterValues?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationMarkDataCollectorNotificationAsReadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkDataCollectorNotificationAsUnreadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkNotificationAsReceivedArgs = {
  notificationId: Scalars['ID']['input'];
};


export type MutationMigrateToAutomatedPlanArgs = {
  input?: InputMaybe<MigrateToAutomatedPlanInput>;
};


export type MutationMultipleUploadArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  files: Array<InputMaybe<Scalars['Upload']['input']>>;
  ref?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRedeemFeatureCouponArgs = {
  code: Scalars['String']['input'];
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationRejectCommunityMemberRequestArgs = {
  requestId: Scalars['ID']['input'];
};


export type MutationRemoveBaoriderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveCommunityMemberArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveCompanyMemberArgs = {
  memberId: Scalars['ID']['input'];
};


export type MutationRemoveFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemovePaymentMethodArgs = {
  paymentMethodId: Scalars['ID']['input'];
};


export type MutationRequestMoreInfoArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<TaskInput>;
};


export type MutationRequestUpdateCompanyDetailsArgs = {
  data: RequestCompanyDetailsChangeInput;
};


export type MutationResendDataCollectorInviteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResetPasswordArgs = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationSetDefaultPaymentMethodArgs = {
  paymentMethodId: Scalars['ID']['input'];
};


export type MutationSkipOnboardingStepArgs = {
  completeOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  index: Scalars['String']['input'];
};


export type MutationStartFreeTrialArgs = {
  input?: InputMaybe<StartFreeTrialInput>;
};


export type MutationSuggestCommunityMemberArgs = {
  input?: InputMaybe<SuggestCommunityMembersInput>;
};


export type MutationUnarchiveCompanyMemberArgs = {
  memberId: Scalars['ID']['input'];
};


export type MutationUpdateAnalyticArgs = {
  data: AnalyticInput;
};


export type MutationUpdateBaoleaderCommunityArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<CommunityInput>;
};


export type MutationUpdateBaoleaderEvidenceArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<EvidenceInput>;
};


export type MutationUpdateBaoleaderInsightReportArgs = {
  id: Scalars['ID']['input'];
  input: InsightReportCustomInput;
};


export type MutationUpdateBaoleaderNotificationArgs = {
  data: NotificationInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateBaoleaderProjectArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<ProjectInput>;
};


export type MutationUpdateBaoleaderScheduledNotificationArgs = {
  id: Scalars['ID']['input'];
  input: ScheduledNotificationInput;
};


export type MutationUpdateBaoleaderTaskArgs = {
  id: Scalars['ID']['input'];
  input: TaskInput;
};


export type MutationUpdateBaoleaderTaskDefinitionArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<TaskDefinitionInput>;
};


export type MutationUpdateBaoleaderTaskTypeArgs = {
  dataFieldsArr?: InputMaybe<Scalars['JSON']['input']>;
  diffs?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  input: TaskTypeInput;
};


export type MutationUpdateBaoriderArgs = {
  baorider?: InputMaybe<UpdateBaoriderInput>;
  id: Scalars['ID']['input'];
};


export type MutationUpdateBaoriderEvidenceArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<EvidenceInput>;
};


export type MutationUpdateBaoriderTaskArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<TaskInput>;
};


export type MutationUpdateBaoverifierAppArgs = {
  data: BaoverifierAppInput;
};


export type MutationUpdateCategoryArgs = {
  data: CategoryInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateCommunityArgs = {
  data: CommunityInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateCommunityMemberArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateCommunityMembersInput>;
};


export type MutationUpdateCompanyArgs = {
  data: CompanyInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateCompanyOnboardingInformationArgs = {
  onboardingInformation: Scalars['JSON']['input'];
};


export type MutationUpdateCustomDataLabelArgs = {
  data: CustomDataLabelInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateDataLabelTypeArgs = {
  data: DataLabelTypeInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateDataListArgs = {
  data: DataListInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateDataListOptionArgs = {
  data: DataListOptionInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateEmailOtpArgs = {
  data: EmailOtpInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateEvidenceArgs = {
  data: EvidenceInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateFeatureCouponArgs = {
  data: FeatureCouponInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateFeatureUnlockArgs = {
  data: FeatureUnlockInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateFileInfoArgs = {
  id: Scalars['ID']['input'];
  info?: InputMaybe<FileInfoInput>;
};


export type MutationUpdateInsightReportArgs = {
  data: InsightReportInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateMyUserArgs = {
  input?: InputMaybe<UpdateMyUserInput>;
};


export type MutationUpdateNotificationArgs = {
  data: NotificationInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateProductPlanArgs = {
  data: ProductPlanInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateProjectArgs = {
  data: ProjectInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateProjectDataLabelTypeOptionArgs = {
  data: ProjectDataLabelTypeOptionInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateRequestArgs = {
  data: RequestInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateScheduledCronEmailStatusArgs = {
  data: ScheduledCronEmailStatusInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateScheduledCronJobArgs = {
  data: ScheduledCronJobInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateScheduledNotificationArgs = {
  data: ScheduledNotificationInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateSubscriptionArgs = {
  data: SubscriptionInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateTaskArgs = {
  data: TaskInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateTaskDataLabelValueArgs = {
  data: TaskDataLabelValueInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateTaskDefinitionArgs = {
  data: TaskDefinitionInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateTaskTypeArgs = {
  data: TaskTypeInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateTermsAndConditionArgs = {
  data: TermsAndConditionInput;
};


export type MutationUpdateTrainingVideoArgs = {
  data: TrainingVideoInput;
};


export type MutationUpdateUnSdgArgs = {
  data: UnSdgInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUploadFileArgs = {
  data: UploadFileInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUploadFolderArgs = {
  data: UploadFolderInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateVideoArgs = {
  data: VideoInput;
  id: Scalars['ID']['input'];
};


export type MutationUploadArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
  info?: InputMaybe<FileInfoInput>;
  ref?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUseProjectTemplateArgs = {
  templateId: Scalars['ID']['input'];
};


export type MutationUseProjectTemplatesArgs = {
  templateIds: Array<Scalars['ID']['input']>;
};


export type MutationVerifyDatacollectOtpArgs = {
  code: Scalars['String']['input'];
  otp: Scalars['String']['input'];
};

export type Notification = {
  __typename?: 'Notification';
  action?: Maybe<Scalars['JSON']['output']>;
  attachment?: Maybe<UploadFileEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateSent?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  nextScheduledNotificationDetails?: Maybe<NotificationScheduledDetails>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  read?: Maybe<Scalars['Boolean']['output']>;
  recipients?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  recur?: Maybe<Enum_Notification_Recur>;
  scheduled_notification?: Maybe<ScheduledNotificationEntityResponse>;
  status?: Maybe<Enum_Notification_Status>;
  timezone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Enum_Notification_Type>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<UsersPermissionsUserEntityResponse>;
};


export type NotificationRecipientsArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NotificationEntity = {
  __typename?: 'NotificationEntity';
  attributes?: Maybe<Notification>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type NotificationEntityResponse = {
  __typename?: 'NotificationEntityResponse';
  data?: Maybe<NotificationEntity>;
};

export type NotificationEntityResponseCollection = {
  __typename?: 'NotificationEntityResponseCollection';
  data: Array<NotificationEntity>;
  meta: ResponseCollectionMeta;
};

export type NotificationFiltersInput = {
  action?: InputMaybe<JsonFilterInput>;
  and?: InputMaybe<Array<InputMaybe<NotificationFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  dateSent?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  message?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<NotificationFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<NotificationFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  read?: InputMaybe<BooleanFilterInput>;
  recipients?: InputMaybe<UsersPermissionsUserFiltersInput>;
  recur?: InputMaybe<StringFilterInput>;
  scheduled_notification?: InputMaybe<ScheduledNotificationFiltersInput>;
  status?: InputMaybe<StringFilterInput>;
  timezone?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type NotificationInput = {
  action?: InputMaybe<Scalars['JSON']['input']>;
  attachment?: InputMaybe<Scalars['ID']['input']>;
  dateSent?: InputMaybe<Scalars['DateTime']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  recipients?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  recur?: InputMaybe<Enum_Notification_Recur>;
  scheduled_notification?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Enum_Notification_Status>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Enum_Notification_Type>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type NotificationRelationResponseCollection = {
  __typename?: 'NotificationRelationResponseCollection';
  data: Array<NotificationEntity>;
};

export type NotificationScheduledDetails = {
  __typename?: 'NotificationScheduledDetails';
  endAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  priority?: Maybe<Enum_Schedulednotification_Priority>;
  recur?: Maybe<Enum_Schedulednotification_Recur>;
  sendAt?: Maybe<Scalars['DateTime']['output']>;
  sent?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Enum_Schedulednotification_Status>;
};

export type NumberOfDataCollectorsAndAdmins = {
  __typename?: 'NumberOfDataCollectorsAndAdmins';
  admins?: Maybe<Scalars['Int']['output']>;
  dataCollectors?: Maybe<Scalars['Int']['output']>;
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginationArg = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export type PlanChangePayload = {
  __typename?: 'PlanChangePayload';
  direction?: Maybe<Scalars['String']['output']>;
  planId?: Maybe<Scalars['ID']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  priceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type PlanMigrationPayload = {
  __typename?: 'PlanMigrationPayload';
  /** When the first automatic charge falls due. */
  billingStartsAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  planId?: Maybe<Scalars['ID']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  priceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type PopularTaskDefinitionEntityWithCount = {
  __typename?: 'PopularTaskDefinitionEntityWithCount';
  count: Scalars['Int']['output'];
  taskDefinition: TaskDefinitionEntity;
};

export type Prices = {
  __typename?: 'Prices';
  active?: Maybe<Scalars['Boolean']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  recurring?: Maybe<Recurring>;
  unit_amount?: Maybe<Scalars['Float']['output']>;
  unit_amount_decimal?: Maybe<Scalars['Float']['output']>;
};

export type ProductMetaData = {
  __typename?: 'ProductMetaData';
  baoriders_allowed?: Maybe<Scalars['Int']['output']>;
  baoriders_cost?: Maybe<Scalars['Float']['output']>;
};

export type ProductPlan = {
  __typename?: 'ProductPlan';
  ProductFeature?: Maybe<ComponentProductFeatureProductFeature>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<Maybe<ComponentProductFeaturePlanFeature>>>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  isManual?: Maybe<Scalars['Boolean']['output']>;
  isPopular?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  priceId?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  subscriptions?: Maybe<SubscriptionRelationResponseCollection>;
  tagline?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ProductPlanFeaturesArgs = {
  filters?: InputMaybe<ComponentProductFeaturePlanFeatureFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProductPlanSubscriptionsArgs = {
  filters?: InputMaybe<SubscriptionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProductPlanEntity = {
  __typename?: 'ProductPlanEntity';
  attributes?: Maybe<ProductPlan>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ProductPlanEntityResponse = {
  __typename?: 'ProductPlanEntityResponse';
  data?: Maybe<ProductPlanEntity>;
};

export type ProductPlanEntityResponseCollection = {
  __typename?: 'ProductPlanEntityResponseCollection';
  data: Array<ProductPlanEntity>;
  meta: ResponseCollectionMeta;
};

export type ProductPlanFiltersInput = {
  ProductFeature?: InputMaybe<ComponentProductFeatureProductFeatureFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<ProductPlanFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  features?: InputMaybe<ComponentProductFeaturePlanFeatureFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  isDefault?: InputMaybe<BooleanFilterInput>;
  isManual?: InputMaybe<BooleanFilterInput>;
  isPopular?: InputMaybe<BooleanFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ProductPlanFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ProductPlanFiltersInput>>>;
  priceId?: InputMaybe<StringFilterInput>;
  productId?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  sortOrder?: InputMaybe<IntFilterInput>;
  subscriptions?: InputMaybe<SubscriptionFiltersInput>;
  tagline?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ProductPlanInput = {
  ProductFeature?: InputMaybe<ComponentProductFeatureProductFeatureInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<InputMaybe<ComponentProductFeaturePlanFeatureInput>>>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
  isPopular?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priceId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  subscriptions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  tagline?: InputMaybe<Scalars['String']['input']>;
};

export type Products = {
  __typename?: 'Products';
  active?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<ProductMetaData>;
  name?: Maybe<Scalars['String']['output']>;
  prices?: Maybe<Array<Maybe<Prices>>>;
  statement_descriptor?: Maybe<Scalars['String']['output']>;
};

export type Project = {
  __typename?: 'Project';
  baoleaders?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  breakdown?: Maybe<Scalars['JSON']['output']>;
  budget?: Maybe<Scalars['String']['output']>;
  collaborators?: Maybe<Scalars['JSON']['output']>;
  companies?: Maybe<CompanyRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  featured_image?: Maybe<UploadFileEntityResponse>;
  isTemplate?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  outcomes?: Maybe<Scalars['String']['output']>;
  partners?: Maybe<Enum_Project_Partners>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  reward?: Maybe<Scalars['String']['output']>;
  statement?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Enum_Project_Status>;
  tags?: Maybe<Scalars['JSON']['output']>;
  task_definitions?: Maybe<TaskDefinitionRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  verifiers?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type ProjectBaoleadersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProjectCompaniesArgs = {
  filters?: InputMaybe<CompanyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProjectTask_DefinitionsArgs = {
  filters?: InputMaybe<TaskDefinitionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProjectVerifiersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProjectDataLabelTypeOption = {
  __typename?: 'ProjectDataLabelTypeOption';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  custom_data_field?: Maybe<CustomDataLabelEntityResponse>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value: Scalars['String']['output'];
};

export type ProjectDataLabelTypeOptionEntity = {
  __typename?: 'ProjectDataLabelTypeOptionEntity';
  attributes?: Maybe<ProjectDataLabelTypeOption>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ProjectDataLabelTypeOptionEntityResponse = {
  __typename?: 'ProjectDataLabelTypeOptionEntityResponse';
  data?: Maybe<ProjectDataLabelTypeOptionEntity>;
};

export type ProjectDataLabelTypeOptionEntityResponseCollection = {
  __typename?: 'ProjectDataLabelTypeOptionEntityResponseCollection';
  data: Array<ProjectDataLabelTypeOptionEntity>;
  meta: ResponseCollectionMeta;
};

export type ProjectDataLabelTypeOptionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ProjectDataLabelTypeOptionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  custom_data_field?: InputMaybe<CustomDataLabelFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<ProjectDataLabelTypeOptionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ProjectDataLabelTypeOptionFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  value?: InputMaybe<StringFilterInput>;
};

export type ProjectDataLabelTypeOptionInput = {
  custom_data_field?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectDataLabelTypeOptionRelationResponseCollection = {
  __typename?: 'ProjectDataLabelTypeOptionRelationResponseCollection';
  data: Array<ProjectDataLabelTypeOptionEntity>;
};

export type ProjectEntity = {
  __typename?: 'ProjectEntity';
  attributes?: Maybe<Project>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ProjectEntityResponse = {
  __typename?: 'ProjectEntityResponse';
  data?: Maybe<ProjectEntity>;
};

export type ProjectEntityResponseCollection = {
  __typename?: 'ProjectEntityResponseCollection';
  data: Array<ProjectEntity>;
  meta: ResponseCollectionMeta;
};

export type ProjectFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ProjectFiltersInput>>>;
  baoleaders?: InputMaybe<UsersPermissionsUserFiltersInput>;
  breakdown?: InputMaybe<JsonFilterInput>;
  budget?: InputMaybe<StringFilterInput>;
  collaborators?: InputMaybe<JsonFilterInput>;
  companies?: InputMaybe<CompanyFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isTemplate?: InputMaybe<BooleanFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ProjectFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ProjectFiltersInput>>>;
  outcomes?: InputMaybe<StringFilterInput>;
  partners?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  reward?: InputMaybe<StringFilterInput>;
  statement?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  tags?: InputMaybe<JsonFilterInput>;
  task_definitions?: InputMaybe<TaskDefinitionFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  verifiers?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type ProjectInput = {
  baoleaders?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  breakdown?: InputMaybe<Scalars['JSON']['input']>;
  budget?: InputMaybe<Scalars['String']['input']>;
  collaborators?: InputMaybe<Scalars['JSON']['input']>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  featured_image?: InputMaybe<Scalars['ID']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  outcomes?: InputMaybe<Scalars['String']['input']>;
  partners?: InputMaybe<Enum_Project_Partners>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reward?: InputMaybe<Scalars['String']['input']>;
  statement?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Enum_Project_Status>;
  tags?: InputMaybe<Scalars['JSON']['input']>;
  task_definitions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  verifiers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ProjectRelationResponseCollection = {
  __typename?: 'ProjectRelationResponseCollection';
  data: Array<ProjectEntity>;
};

export type ProjectSet = {
  __typename?: 'ProjectSet';
  chartData?: Maybe<Array<Maybe<ChartData>>>;
  completedPercentage: Scalars['Float']['output'];
  increaseIn30days: Scalars['Int']['output'];
  project?: Maybe<ProjectEntity>;
  taskCompleted: Scalars['Int']['output'];
};

export enum PublicationState {
  Live = 'LIVE',
  Preview = 'PREVIEW'
}

export type PushNotificationStatus = {
  __typename?: 'PushNotificationStatus';
  error?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  receivedAt?: Maybe<Scalars['DateTime']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Enum_Pushnotificationstatus_Status>;
  user?: Maybe<UsersPermissionsUserEntityResponse>;
};

export type PushNotificationStatusEntity = {
  __typename?: 'PushNotificationStatusEntity';
  attributes?: Maybe<PushNotificationStatus>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type Query = {
  __typename?: 'Query';
  analytic?: Maybe<AnalyticEntityResponse>;
  baoverifierApp?: Maybe<BaoverifierAppEntityResponse>;
  canDeactivateCategory?: Maybe<Scalars['Boolean']['output']>;
  canEditTask?: Maybe<Scalars['Boolean']['output']>;
  categories?: Maybe<CategoryEntityResponseCollection>;
  category?: Maybe<CategoryEntityResponse>;
  communities?: Maybe<CommunityEntityResponseCollection>;
  community?: Maybe<CommunityEntityResponse>;
  companies?: Maybe<CompanyEntityResponseCollection>;
  company?: Maybe<CompanyEntityResponse>;
  countCommunityMembers?: Maybe<Scalars['Int']['output']>;
  countCompanyCommunities?: Maybe<Scalars['Int']['output']>;
  countCompanyMembers?: Maybe<Scalars['Int']['output']>;
  countCompanyProjects?: Maybe<Scalars['Int']['output']>;
  countRiders?: Maybe<Scalars['Int']['output']>;
  countTasks?: Maybe<Scalars['Int']['output']>;
  countTasksByStatus?: Maybe<Scalars['JSON']['output']>;
  countTasksWithTrend?: Maybe<TaskCountWithTrend>;
  customDataLabel?: Maybe<CustomDataLabelEntityResponse>;
  customDataLabels?: Maybe<CustomDataLabelEntityResponseCollection>;
  dataLabelType?: Maybe<DataLabelTypeEntityResponse>;
  dataLabelTypes?: Maybe<DataLabelTypeEntityResponseCollection>;
  dataList?: Maybe<DataListEntityResponse>;
  dataListOption?: Maybe<DataListOptionEntityResponse>;
  dataListOptions?: Maybe<DataListOptionEntityResponseCollection>;
  dataLists?: Maybe<DataListEntityResponseCollection>;
  deliveryReportCounts: DeliveryReportCounts;
  emailOtp?: Maybe<EmailOtpEntityResponse>;
  emailOtps?: Maybe<EmailOtpEntityResponseCollection>;
  evidence?: Maybe<EvidenceEntityResponse>;
  evidences?: Maybe<EvidenceEntityResponseCollection>;
  featureCoupon?: Maybe<FeatureCouponEntityResponse>;
  featureCoupons?: Maybe<FeatureCouponEntityResponseCollection>;
  featureUnlock?: Maybe<FeatureUnlockEntityResponse>;
  featureUnlocks?: Maybe<FeatureUnlockEntityResponseCollection>;
  findDataListOptionWithCount?: Maybe<DataListOptionWithCount>;
  getAdminNotification?: Maybe<NotificationEntity>;
  getAdminNotifications?: Maybe<Array<Maybe<NotificationEntity>>>;
  getAdminNotificationsCount?: Maybe<Scalars['Int']['output']>;
  getAllInvoices?: Maybe<Array<Maybe<InvoicePayload>>>;
  getAllProducts?: Maybe<Array<Maybe<Products>>>;
  getBaoleaderCommunities?: Maybe<Array<Maybe<CommunityEntity>>>;
  getBaoleaderCommunity?: Maybe<CommunityEntity>;
  getBaoleaderProject?: Maybe<ProjectEntity>;
  getBaoleaderProjects?: Maybe<Array<Maybe<ProjectEntity>>>;
  getBaoleaderProjectsCategories?: Maybe<Array<Maybe<CategorySet>>>;
  getBaoleaderTask?: Maybe<TaskEntity>;
  getBaoleaderTaskDefinition?: Maybe<TaskDefinitionEntity>;
  getBaoleaderTaskDefinitions?: Maybe<Array<Maybe<TaskDefinitionEntity>>>;
  getBaoleaderTaskDefinitionsCount?: Maybe<Scalars['Int']['output']>;
  getBaoleaderTasksWithCount?: Maybe<TasksWithCount>;
  getBaoriderCommunities?: Maybe<Array<Maybe<CommunityEntity>>>;
  getBaoriderCommunityProjects?: Maybe<Array<Maybe<ProjectEntity>>>;
  getBaoriderDashboardMetrics?: Maybe<BaoriderTaskMetrics>;
  getBaoriderEvidence?: Maybe<Evidence>;
  getBaoriderProjects?: Maybe<Array<Maybe<ProjectEntity>>>;
  getBaoriderTasks?: Maybe<TasksWithCount>;
  getBaoriders?: Maybe<Array<Maybe<UsersPermissionsUserEntity>>>;
  getBaoverifierMostPopularTaskDefinitions?: Maybe<Array<Maybe<PopularTaskDefinitionEntityWithCount>>>;
  getBaoverifierTaskDefinition?: Maybe<TaskDefinitionEntity>;
  getBaoverifierTaskDefinitions?: Maybe<Array<Maybe<TaskDefinitionEntity>>>;
  getCategories?: Maybe<Array<Maybe<CategoryEntity>>>;
  getCommunityBaoriders?: Maybe<MultipleCommunityMembersPayload>;
  getCommunityMembers?: Maybe<MultipleCommunityMembersPayload>;
  getCommunityProjects?: Maybe<Array<Maybe<ProjectEntity>>>;
  getCommunityProjectsCount?: Maybe<Scalars['Int']['output']>;
  getCommunityVerifiers?: Maybe<MultipleCommunityMembersPayload>;
  getCompanyCategories?: Maybe<Array<Maybe<CategoryEntity>>>;
  getCompanyInfo?: Maybe<Company>;
  getCompanyLeaders?: Maybe<Array<Maybe<UsersPermissionsUserEntity>>>;
  getCompanyLeadersCount?: Maybe<Scalars['Int']['output']>;
  getCompanyOnlyCategories?: Maybe<CategorysWithCount>;
  getCompanyScheduledNotification?: Maybe<ScheduledNotificationEntity>;
  getCompanyScheduledNotifications?: Maybe<Array<Maybe<ScheduledNotificationEntity>>>;
  getCompanyScheduledNotificationsCount?: Maybe<Scalars['Int']['output']>;
  getCompanyTaskTypes?: Maybe<Array<Maybe<TaskTypeEntity>>>;
  getCompanyTaskTypesCount?: Maybe<Scalars['Int']['output']>;
  getCountDataLists?: Maybe<Scalars['Int']['output']>;
  getCustomerPaymentDetails?: Maybe<Array<Maybe<CardPayload>>>;
  getDataCollectorNotification?: Maybe<NotificationEntity>;
  getDataCollectorNotifications?: Maybe<Array<Maybe<NotificationEntity>>>;
  getDataCollectorTasksLeaderBoard?: Maybe<Array<Maybe<TasksWithDataCollector>>>;
  getDataLists?: Maybe<Array<Maybe<DataListEntity>>>;
  getInsightAIAnalysis?: Maybe<InsightAiResponse>;
  getInsightReport?: Maybe<InsightReportEntity>;
  getInsightReports?: Maybe<Array<Maybe<InsightReportEntity>>>;
  getInsightReportsCount?: Maybe<Scalars['Int']['output']>;
  getInsightTaskData?: Maybe<InsightTaskData>;
  getInsightTaskDefinitions?: Maybe<Array<Maybe<TaskDefinitionEntity>>>;
  getMapTasks?: Maybe<Scalars['JSON']['output']>;
  getMyFeatureAccess?: Maybe<FeatureAccessPayload>;
  getMyFeatureUnlocks?: Maybe<Array<Maybe<FeatureUnlockPayload>>>;
  getNotificationTasks?: Maybe<Array<Maybe<TaskWithCanEdit>>>;
  getNumberDataCollectorsTasks?: Maybe<Scalars['Int']['output']>;
  getNumberOfTasksPerDataCollector?: Maybe<Array<Maybe<TaskPer>>>;
  getNumberOfTasksPerDay?: Maybe<Array<Maybe<TaskPer>>>;
  getNumberOfTasksPerMonth?: Maybe<Array<Maybe<TaskPer>>>;
  getNumberOfTasksPerProject?: Maybe<Array<Maybe<TaskPer>>>;
  getNumberOfTasksPerSDG?: Maybe<Array<Maybe<TaskPer>>>;
  getNumberOfTasksPerTag?: Maybe<Array<Maybe<TaskPer>>>;
  getNumberOfTasksPerTaskType?: Maybe<Array<Maybe<TaskPer>>>;
  getNumberOfTasksPerTaskTypeCollapsed?: Maybe<Array<Maybe<TaskPer>>>;
  getNumberOfUsers?: Maybe<NumberOfDataCollectorsAndAdmins>;
  getProjectDataCollectorsCount?: Maybe<Scalars['Int']['output']>;
  getProjectGroups?: Maybe<Array<Maybe<CommunityEntity>>>;
  getProjectMetrics?: Maybe<TaskMetrics>;
  getProjectUnsdgTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  getRecommendedTemplates?: Maybe<Array<Maybe<ProjectEntity>>>;
  getRequests?: Maybe<Array<Maybe<Request>>>;
  getSingleBaoleaderCommunity?: Maybe<CommunityEntity>;
  getSingleBaoleaderProject?: Maybe<ProjectEntity>;
  getSingleBaorider?: Maybe<BaoriderPayload>;
  getSingleBaoriderCommunity?: Maybe<BaoriderCommunityMetrics>;
  getSingleBaoriderProject?: Maybe<ProjectEntity>;
  getSingleBaoriderTask?: Maybe<TaskEntity>;
  getSingleCommunityMember?: Maybe<CommunityMembersPayload>;
  getSubscription?: Maybe<SubscriptionPayload>;
  getSubscriptionPlans?: Maybe<Array<Maybe<SubscriptionPlan>>>;
  getTaskBuilderFilterCategories?: Maybe<Array<Maybe<CategoryEntity>>>;
  getTaskBuilderFilterCreators?: Maybe<Array<Maybe<UsersPermissionsUserEntity>>>;
  getTaskFilterCommunities?: Maybe<Array<Maybe<CommunityEntity>>>;
  getTaskFilterDataCollectors?: Maybe<Array<Maybe<UsersPermissionsUserEntity>>>;
  getTaskFilterDataCollectorsCount?: Maybe<Scalars['Int']['output']>;
  getTaskFilterProjects?: Maybe<Array<Maybe<ProjectEntity>>>;
  getTaskFilterTaskTypes?: Maybe<Array<Maybe<TaskTypeEntity>>>;
  getTaskFilterUnsdgs?: Maybe<Array<Maybe<UnSdgEntity>>>;
  getTaskType?: Maybe<TaskTypeEntity>;
  getTaskTypeProjects?: Maybe<Array<Maybe<ProjectEntity>>>;
  getTaskTypeTemplates?: Maybe<Array<Maybe<TaskTypeEntity>>>;
  getTasksDashboardMetrics?: Maybe<TaskMetrics>;
  getTemplateProjects?: Maybe<Array<Maybe<ProjectEntity>>>;
  getTopPerformingUsers?: Maybe<TopPerforming>;
  getUnreadNotificationsCount?: Maybe<Scalars['Int']['output']>;
  getWholeCompanyTaskTypes?: Maybe<Array<Maybe<TaskTypeEntity>>>;
  i18NLocale?: Maybe<I18NLocaleEntityResponse>;
  i18NLocales?: Maybe<I18NLocaleEntityResponseCollection>;
  insightReport?: Maybe<InsightReportEntityResponse>;
  insightReports?: Maybe<InsightReportEntityResponseCollection>;
  isListInUse?: Maybe<IsListInUseResponse>;
  me?: Maybe<UsersPermissionsMe>;
  myUser?: Maybe<UsersPermissionsUserEntity>;
  notification?: Maybe<NotificationEntityResponse>;
  notifications?: Maybe<NotificationEntityResponseCollection>;
  productPlan?: Maybe<ProductPlanEntityResponse>;
  productPlans?: Maybe<ProductPlanEntityResponseCollection>;
  project?: Maybe<ProjectEntityResponse>;
  projectDataLabelTypeOption?: Maybe<ProjectDataLabelTypeOptionEntityResponse>;
  projectDataLabelTypeOptions?: Maybe<ProjectDataLabelTypeOptionEntityResponseCollection>;
  projects?: Maybe<ProjectEntityResponseCollection>;
  request?: Maybe<RequestEntityResponse>;
  requests?: Maybe<RequestEntityResponseCollection>;
  scheduledCronEmailStatus?: Maybe<ScheduledCronEmailStatusEntityResponse>;
  scheduledCronEmailStatuses?: Maybe<ScheduledCronEmailStatusEntityResponseCollection>;
  scheduledCronJob?: Maybe<ScheduledCronJobEntityResponse>;
  scheduledCronJobs?: Maybe<ScheduledCronJobEntityResponseCollection>;
  scheduledNotification?: Maybe<ScheduledNotificationEntityResponse>;
  scheduledNotifications?: Maybe<ScheduledNotificationEntityResponseCollection>;
  subscription?: Maybe<SubscriptionEntityResponse>;
  subscriptions?: Maybe<SubscriptionEntityResponseCollection>;
  task?: Maybe<TaskEntityResponse>;
  taskDataLabelValue?: Maybe<TaskDataLabelValueEntityResponse>;
  taskDataLabelValues?: Maybe<TaskDataLabelValueEntityResponseCollection>;
  taskDefinition?: Maybe<TaskDefinitionEntityResponse>;
  taskDefinitions?: Maybe<TaskDefinitionEntityResponseCollection>;
  taskType?: Maybe<TaskTypeEntityResponse>;
  taskTypes?: Maybe<TaskTypeEntityResponseCollection>;
  tasks?: Maybe<TaskEntityResponseCollection>;
  termsAndCondition?: Maybe<TermsAndConditionEntityResponse>;
  trainingVideo?: Maybe<TrainingVideoEntityResponse>;
  unSdg?: Maybe<UnSdgEntityResponse>;
  unSdgs?: Maybe<UnSdgEntityResponseCollection>;
  uploadFile?: Maybe<UploadFileEntityResponse>;
  uploadFiles?: Maybe<UploadFileEntityResponseCollection>;
  uploadFolder?: Maybe<UploadFolderEntityResponse>;
  uploadFolders?: Maybe<UploadFolderEntityResponseCollection>;
  usersPermissionsRole?: Maybe<UsersPermissionsRoleEntityResponse>;
  usersPermissionsRoles?: Maybe<UsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsUser?: Maybe<UsersPermissionsUserEntityResponse>;
  usersPermissionsUsers?: Maybe<UsersPermissionsUserEntityResponseCollection>;
  video?: Maybe<VideoEntityResponse>;
  videos?: Maybe<VideoEntityResponseCollection>;
};


export type QueryAnalyticArgs = {
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryBaoverifierAppArgs = {
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryCanDeactivateCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCanEditTaskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCategoriesArgs = {
  filters?: InputMaybe<CategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCategoryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCommunitiesArgs = {
  filters?: InputMaybe<CommunityFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCommunityArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCompaniesArgs = {
  filters?: InputMaybe<CompanyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCompanyArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCountCommunityMembersArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCountCompanyCommunitiesArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCountCompanyProjectsArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCountRidersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryCountTasksArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCountTasksByStatusArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryCountTasksWithTrendArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCustomDataLabelArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCustomDataLabelsArgs = {
  filters?: InputMaybe<CustomDataLabelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryDataLabelTypeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDataLabelTypesArgs = {
  filters?: InputMaybe<DataLabelTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryDataListArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDataListOptionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDataListOptionsArgs = {
  filters?: InputMaybe<DataListOptionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryDataListsArgs = {
  filters?: InputMaybe<DataListFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryDeliveryReportCountsArgs = {
  notificationId: Scalars['ID']['input'];
};


export type QueryEmailOtpArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEmailOtpsArgs = {
  filters?: InputMaybe<EmailOtpFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryEvidenceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEvidencesArgs = {
  filters?: InputMaybe<EvidenceFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryFeatureCouponArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFeatureCouponsArgs = {
  filters?: InputMaybe<FeatureCouponFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryFeatureUnlockArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFeatureUnlocksArgs = {
  filters?: InputMaybe<FeatureUnlockFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryFindDataListOptionWithCountArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  orderBy?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryGetAdminNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAdminNotificationsArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetAdminNotificationsCountArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetBaoleaderCommunitiesArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetBaoleaderProjectsArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetBaoleaderTaskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetBaoleaderTaskDefinitionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetBaoleaderTaskDefinitionsArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetBaoleaderTaskDefinitionsCountArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetBaoleaderTasksWithCountArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetBaoriderCommunityProjectsArgs = {
  community: Scalars['ID']['input'];
};


export type QueryGetBaoriderDashboardMetricsArgs = {
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetBaoriderEvidenceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetBaoriderProjectsArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetBaoriderTasksArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetBaoridersArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetBaoverifierMostPopularTaskDefinitionsArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetBaoverifierTaskDefinitionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetBaoverifierTaskDefinitionsArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetCategoriesArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetCommunityBaoridersArgs = {
  community: Scalars['ID']['input'];
};


export type QueryGetCommunityMembersArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetCommunityProjectsArgs = {
  community: Scalars['ID']['input'];
};


export type QueryGetCommunityProjectsCountArgs = {
  community: Scalars['ID']['input'];
};


export type QueryGetCommunityVerifiersArgs = {
  community: Scalars['ID']['input'];
};


export type QueryGetCompanyCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetCompanyLeadersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetCompanyOnlyCategoriesArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetCompanyScheduledNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCompanyScheduledNotificationsArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetCompanyScheduledNotificationsCountArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetCompanyTaskTypesArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetCompanyTaskTypesCountArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetCountDataListsArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetDataCollectorNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetDataCollectorNotificationsArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetDataCollectorTasksLeaderBoardArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetDataListsArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetInsightAiAnalysisArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  columns?: InputMaybe<Scalars['JSON']['input']>;
  dataSummary?: InputMaybe<Scalars['JSON']['input']>;
  dateInfo?: InputMaybe<Scalars['JSON']['input']>;
  dateRange?: InputMaybe<DateRangeInput>;
  dateSource?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Array<InputMaybe<InsightAiMessageInput>>>;
  recordCount?: InputMaybe<Scalars['Int']['input']>;
  selectedColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taskDefinitionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  timeSeries?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetInsightReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetInsightReportsArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetInsightReportsCountArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetInsightTaskDataArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  compareYears?: InputMaybe<Scalars['Boolean']['input']>;
  dateRange?: InputMaybe<DateRangeInput>;
  dateSource?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<InsightAgentFilterInput>>;
  groupBy?: InputMaybe<Scalars['String']['input']>;
  selectedColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taskDefinitionId?: InputMaybe<Scalars['ID']['input']>;
  taskDefinitionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  timeSeries?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetMapTasksArgs = {
  compact?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetMyFeatureAccessArgs = {
  feature?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetNotificationTasksArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetNumberDataCollectorsTasksArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetNumberOfTasksPerDataCollectorArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetNumberOfTasksPerDayArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetNumberOfTasksPerMonthArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetNumberOfTasksPerProjectArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetNumberOfTasksPerSdgArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetNumberOfTasksPerTagArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetNumberOfTasksPerTaskTypeArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetNumberOfTasksPerTaskTypeCollapsedArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetProjectDataCollectorsCountArgs = {
  project: Scalars['ID']['input'];
};


export type QueryGetProjectGroupsArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryGetProjectMetricsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetProjectUnsdgTagsArgs = {
  project: Scalars['ID']['input'];
};


export type QueryGetRequestsArgs = {
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetSingleBaoleaderCommunityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSingleBaoleaderProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSingleBaoriderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSingleBaoriderCommunityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSingleBaoriderProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSingleBaoriderTaskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSingleCommunityMemberArgs = {
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetTaskBuilderFilterCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetTaskBuilderFilterCreatorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetTaskFilterCommunitiesArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetTaskFilterDataCollectorsArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetTaskFilterDataCollectorsCountArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryGetTaskFilterProjectsArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetTaskFilterTaskTypesArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetTaskFilterUnsdgsArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetTaskTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetTaskTypeProjectsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetTemplateProjectsArgs = {
  partners?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetTopPerformingUsersArgs = {
  community?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  project?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryGetWholeCompanyTaskTypesArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryI18NLocaleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryI18NLocalesArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryInsightReportArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryInsightReportsArgs = {
  filters?: InputMaybe<InsightReportFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryIsListInUseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNotificationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryNotificationsArgs = {
  filters?: InputMaybe<NotificationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryProductPlanArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProductPlansArgs = {
  filters?: InputMaybe<ProductPlanFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryProjectArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProjectDataLabelTypeOptionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProjectDataLabelTypeOptionsArgs = {
  filters?: InputMaybe<ProjectDataLabelTypeOptionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryProjectsArgs = {
  filters?: InputMaybe<ProjectFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryRequestArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRequestsArgs = {
  filters?: InputMaybe<RequestFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryScheduledCronEmailStatusArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryScheduledCronEmailStatusesArgs = {
  filters?: InputMaybe<ScheduledCronEmailStatusFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryScheduledCronJobArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryScheduledCronJobsArgs = {
  filters?: InputMaybe<ScheduledCronJobFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryScheduledNotificationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryScheduledNotificationsArgs = {
  filters?: InputMaybe<ScheduledNotificationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySubscriptionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySubscriptionsArgs = {
  filters?: InputMaybe<SubscriptionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryTaskArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTaskDataLabelValueArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTaskDataLabelValuesArgs = {
  filters?: InputMaybe<TaskDataLabelValueFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryTaskDefinitionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTaskDefinitionsArgs = {
  filters?: InputMaybe<TaskDefinitionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryTaskTypeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTaskTypesArgs = {
  filters?: InputMaybe<TaskTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryTasksArgs = {
  filters?: InputMaybe<TaskFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryTermsAndConditionArgs = {
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryTrainingVideoArgs = {
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryUnSdgArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUnSdgsArgs = {
  filters?: InputMaybe<UnSdgFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUploadFileArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUploadFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUploadFolderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUploadFoldersArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUsersPermissionsRoleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUsersPermissionsRolesArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUsersPermissionsUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUsersPermissionsUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryVideoArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVideosArgs = {
  filters?: InputMaybe<VideoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Recurring = {
  __typename?: 'Recurring';
  interval?: Maybe<Scalars['String']['output']>;
  interval_count?: Maybe<Scalars['Int']['output']>;
};

export type Request = {
  __typename?: 'Request';
  baoleader?: Maybe<UsersPermissionsUserEntityResponse>;
  community?: Maybe<CommunityEntityResponse>;
  community_member?: Maybe<UsersPermissionsUserEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Enum_Request_Status>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RequestCompanyDetailsChangeInput = {
  CompanyName?: InputMaybe<Scalars['String']['input']>;
  WildlifeAssociationNumber?: InputMaybe<Scalars['String']['input']>;
  currentCompanyName?: InputMaybe<Scalars['String']['input']>;
  orgID?: InputMaybe<Scalars['String']['input']>;
  pin_registration?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type RequestEntity = {
  __typename?: 'RequestEntity';
  attributes?: Maybe<Request>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type RequestEntityResponse = {
  __typename?: 'RequestEntityResponse';
  data?: Maybe<RequestEntity>;
};

export type RequestEntityResponseCollection = {
  __typename?: 'RequestEntityResponseCollection';
  data: Array<RequestEntity>;
  meta: ResponseCollectionMeta;
};

export type RequestFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<RequestFiltersInput>>>;
  baoleader?: InputMaybe<UsersPermissionsUserFiltersInput>;
  community?: InputMaybe<CommunityFiltersInput>;
  community_member?: InputMaybe<UsersPermissionsUserFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<RequestFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<RequestFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  reason?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type RequestInput = {
  baoleader?: InputMaybe<Scalars['ID']['input']>;
  community?: InputMaybe<Scalars['ID']['input']>;
  community_member?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Enum_Request_Status>;
};

export type RequestRelationResponseCollection = {
  __typename?: 'RequestRelationResponseCollection';
  data: Array<RequestEntity>;
};

export type ResponseCollectionMeta = {
  __typename?: 'ResponseCollectionMeta';
  pagination: Pagination;
};

export type ScheduledCronEmailStatus = {
  __typename?: 'ScheduledCronEmailStatus';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email_last_added: Scalars['DateTime']['output'];
  email_sent: Scalars['Boolean']['output'];
  job_id?: Maybe<ScheduledCronJobEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user_id?: Maybe<UsersPermissionsUserEntityResponse>;
};

export type ScheduledCronEmailStatusEntity = {
  __typename?: 'ScheduledCronEmailStatusEntity';
  attributes?: Maybe<ScheduledCronEmailStatus>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ScheduledCronEmailStatusEntityResponse = {
  __typename?: 'ScheduledCronEmailStatusEntityResponse';
  data?: Maybe<ScheduledCronEmailStatusEntity>;
};

export type ScheduledCronEmailStatusEntityResponseCollection = {
  __typename?: 'ScheduledCronEmailStatusEntityResponseCollection';
  data: Array<ScheduledCronEmailStatusEntity>;
  meta: ResponseCollectionMeta;
};

export type ScheduledCronEmailStatusFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ScheduledCronEmailStatusFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  email_last_added?: InputMaybe<DateTimeFilterInput>;
  email_sent?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  job_id?: InputMaybe<ScheduledCronJobFiltersInput>;
  not?: InputMaybe<ScheduledCronEmailStatusFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ScheduledCronEmailStatusFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user_id?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type ScheduledCronEmailStatusInput = {
  email_last_added?: InputMaybe<Scalars['DateTime']['input']>;
  email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  job_id?: InputMaybe<Scalars['ID']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type ScheduledCronJob = {
  __typename?: 'ScheduledCronJob';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  jobId: Scalars['String']['output'];
  jobType: Enum_Scheduledcronjob_Jobtype;
  started_at: Scalars['DateTime']['output'];
  status: Enum_Scheduledcronjob_Status;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ScheduledCronJobEntity = {
  __typename?: 'ScheduledCronJobEntity';
  attributes?: Maybe<ScheduledCronJob>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ScheduledCronJobEntityResponse = {
  __typename?: 'ScheduledCronJobEntityResponse';
  data?: Maybe<ScheduledCronJobEntity>;
};

export type ScheduledCronJobEntityResponseCollection = {
  __typename?: 'ScheduledCronJobEntityResponseCollection';
  data: Array<ScheduledCronJobEntity>;
  meta: ResponseCollectionMeta;
};

export type ScheduledCronJobFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ScheduledCronJobFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  finished_at?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  jobId?: InputMaybe<StringFilterInput>;
  jobType?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ScheduledCronJobFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ScheduledCronJobFiltersInput>>>;
  started_at?: InputMaybe<DateTimeFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ScheduledCronJobInput = {
  finished_at?: InputMaybe<Scalars['DateTime']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  jobType?: InputMaybe<Enum_Scheduledcronjob_Jobtype>;
  started_at?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Enum_Scheduledcronjob_Status>;
};

export type ScheduledNotification = {
  __typename?: 'ScheduledNotification';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  notification?: Maybe<NotificationEntityResponse>;
  priority?: Maybe<Enum_Schedulednotification_Priority>;
  recur: Enum_Schedulednotification_Recur;
  sendAt: Scalars['DateTime']['output'];
  sent?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Enum_Schedulednotification_Status>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ScheduledNotificationEntity = {
  __typename?: 'ScheduledNotificationEntity';
  attributes?: Maybe<ScheduledNotification>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ScheduledNotificationEntityResponse = {
  __typename?: 'ScheduledNotificationEntityResponse';
  data?: Maybe<ScheduledNotificationEntity>;
};

export type ScheduledNotificationEntityResponseCollection = {
  __typename?: 'ScheduledNotificationEntityResponseCollection';
  data: Array<ScheduledNotificationEntity>;
  meta: ResponseCollectionMeta;
};

export type ScheduledNotificationFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ScheduledNotificationFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  data?: InputMaybe<JsonFilterInput>;
  endAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<ScheduledNotificationFiltersInput>;
  notification?: InputMaybe<NotificationFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ScheduledNotificationFiltersInput>>>;
  priority?: InputMaybe<StringFilterInput>;
  recur?: InputMaybe<StringFilterInput>;
  sendAt?: InputMaybe<DateTimeFilterInput>;
  sent?: InputMaybe<BooleanFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ScheduledNotificationInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  notification: Scalars['ID']['input'];
  priority?: InputMaybe<Enum_Schedulednotification_Priority>;
  recur?: InputMaybe<Enum_Schedulednotification_Recur>;
  sendAt: Scalars['DateTime']['input'];
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Enum_Schedulednotification_Status>;
};

export type SetupIntentPayload = {
  __typename?: 'SetupIntentPayload';
  clientSecret?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  publishableKey?: Maybe<Scalars['String']['output']>;
};

export type StartFreeTrialInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  productPlanId?: InputMaybe<Scalars['ID']['input']>;
};

export type StringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  containsi?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  eqi?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nei?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notContainsi?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  cancel_at?: Maybe<Scalars['DateTime']['output']>;
  cancel_at_period_end?: Maybe<Scalars['Boolean']['output']>;
  collection_method: Enum_Subscription_Collection_Method;
  company?: Maybe<CompanyEntityResponse>;
  created?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Enum_Subscription_Currency>;
  current_period_end?: Maybe<Scalars['DateTime']['output']>;
  current_period_start?: Maybe<Scalars['DateTime']['output']>;
  items?: Maybe<Scalars['JSON']['output']>;
  monthly_extra?: Maybe<Scalars['Float']['output']>;
  priceId?: Maybe<Scalars['String']['output']>;
  product_plan?: Maybe<ProductPlanEntityResponse>;
  recurring: Enum_Subscription_Recurring;
  status: Enum_Subscription_Status;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  trial_end?: Maybe<Scalars['DateTime']['output']>;
  trial_start?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SubscriptionCancellationPayload = {
  __typename?: 'SubscriptionCancellationPayload';
  cancelAtPeriodEnd?: Maybe<Scalars['Boolean']['output']>;
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionEntity = {
  __typename?: 'SubscriptionEntity';
  attributes?: Maybe<Subscription>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type SubscriptionEntityResponse = {
  __typename?: 'SubscriptionEntityResponse';
  data?: Maybe<SubscriptionEntity>;
};

export type SubscriptionEntityResponseCollection = {
  __typename?: 'SubscriptionEntityResponseCollection';
  data: Array<SubscriptionEntity>;
  meta: ResponseCollectionMeta;
};

export type SubscriptionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<SubscriptionFiltersInput>>>;
  cancel_at?: InputMaybe<DateTimeFilterInput>;
  cancel_at_period_end?: InputMaybe<BooleanFilterInput>;
  collection_method?: InputMaybe<StringFilterInput>;
  company?: InputMaybe<CompanyFiltersInput>;
  created?: InputMaybe<DateTimeFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  currency?: InputMaybe<StringFilterInput>;
  current_period_end?: InputMaybe<DateTimeFilterInput>;
  current_period_start?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  items?: InputMaybe<JsonFilterInput>;
  monthly_extra?: InputMaybe<FloatFilterInput>;
  not?: InputMaybe<SubscriptionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SubscriptionFiltersInput>>>;
  priceId?: InputMaybe<StringFilterInput>;
  product_plan?: InputMaybe<ProductPlanFiltersInput>;
  recurring?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  subscriptionId?: InputMaybe<StringFilterInput>;
  trial_end?: InputMaybe<DateTimeFilterInput>;
  trial_start?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type SubscriptionInput = {
  cancel_at?: InputMaybe<Scalars['DateTime']['input']>;
  cancel_at_period_end?: InputMaybe<Scalars['Boolean']['input']>;
  collection_method?: InputMaybe<Enum_Subscription_Collection_Method>;
  company?: InputMaybe<Scalars['ID']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Enum_Subscription_Currency>;
  current_period_end?: InputMaybe<Scalars['DateTime']['input']>;
  current_period_start?: InputMaybe<Scalars['DateTime']['input']>;
  items?: InputMaybe<Scalars['JSON']['input']>;
  monthly_extra?: InputMaybe<Scalars['Float']['input']>;
  priceId?: InputMaybe<Scalars['String']['input']>;
  product_plan?: InputMaybe<Scalars['ID']['input']>;
  recurring?: InputMaybe<Enum_Subscription_Recurring>;
  status?: InputMaybe<Enum_Subscription_Status>;
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
  trial_end?: InputMaybe<Scalars['DateTime']['input']>;
  trial_start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubscriptionPayload = {
  __typename?: 'SubscriptionPayload';
  cancel_at?: Maybe<Scalars['DateTime']['output']>;
  cancel_at_period_end?: Maybe<Scalars['Boolean']['output']>;
  collection_method?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  current_period_end?: Maybe<Scalars['DateTime']['output']>;
  current_period_start?: Maybe<Scalars['DateTime']['output']>;
  customer?: Maybe<Scalars['ID']['output']>;
  ended_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  items?: Maybe<Scalars['JSON']['output']>;
  latest_invoice?: Maybe<Scalars['ID']['output']>;
  product_plan?: Maybe<ProductPlan>;
  recurring?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  trial_end?: Maybe<Scalars['DateTime']['output']>;
  trial_start?: Maybe<Scalars['DateTime']['output']>;
};

export type SubscriptionPlan = {
  __typename?: 'SubscriptionPlan';
  description?: Maybe<Scalars['String']['output']>;
  feature?: Maybe<SubscriptionPlanFeature>;
  features?: Maybe<Array<Maybe<SubscriptionPlanFeatureItem>>>;
  id?: Maybe<Scalars['ID']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  isPopular?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  priceId?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionPlanFeature = {
  __typename?: 'SubscriptionPlanFeature';
  priceGbp?: Maybe<Scalars['Float']['output']>;
  priceUsd?: Maybe<Scalars['Float']['output']>;
  priceZar?: Maybe<Scalars['Float']['output']>;
  recurring?: Maybe<Scalars['String']['output']>;
  supportHours?: Maybe<Scalars['Float']['output']>;
  usersAllowed?: Maybe<Scalars['Int']['output']>;
};

export type SubscriptionPlanFeatureItem = {
  __typename?: 'SubscriptionPlanFeatureItem';
  description?: Maybe<Scalars['String']['output']>;
  isHighlighted?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

export type SubscriptionRelationResponseCollection = {
  __typename?: 'SubscriptionRelationResponseCollection';
  data: Array<SubscriptionEntity>;
};

export type SuggestCommunityMembersInput = {
  community: Scalars['ID']['input'];
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

export type Task = {
  __typename?: 'Task';
  ER_ID?: Maybe<Scalars['String']['output']>;
  accepted_at?: Maybe<Scalars['DateTime']['output']>;
  baoleader?: Maybe<UsersPermissionsUserEntityResponse>;
  baorider?: Maybe<UsersPermissionsUserEntityResponse>;
  community?: Maybe<CommunityEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  date_reported?: Maybe<Scalars['DateTime']['output']>;
  documents?: Maybe<UploadFileRelationResponseCollection>;
  edit_from?: Maybe<TaskEntityResponse>;
  evidences?: Maybe<EvidenceRelationResponseCollection>;
  location?: Maybe<Scalars['JSON']['output']>;
  onlyEmployeesVerify?: Maybe<Scalars['Boolean']['output']>;
  project?: Maybe<ProjectEntityResponse>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Enum_Task_Status>;
  task_definition?: Maybe<TaskDefinitionEntityResponse>;
  task_offline_id?: Maybe<Scalars['String']['output']>;
  task_origin?: Maybe<Enum_Task_Task_Origin>;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type TaskDocumentsArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type TaskEvidencesArgs = {
  filters?: InputMaybe<EvidenceFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TaskAndEvidenceType = {
  __typename?: 'TaskAndEvidenceType';
  evidence?: Maybe<EvidenceEntity>;
  task?: Maybe<TaskEntity>;
};

export type TaskCountWithTrend = {
  __typename?: 'TaskCountWithTrend';
  count?: Maybe<Scalars['Int']['output']>;
  trend?: Maybe<Trend>;
};

export type TaskDataLabelValue = {
  __typename?: 'TaskDataLabelValue';
  baorider?: Maybe<UsersPermissionsUserEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  data_field?: Maybe<CustomDataLabelEntityResponse>;
  evidence?: Maybe<EvidenceEntityResponse>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type TaskDataLabelValueEntity = {
  __typename?: 'TaskDataLabelValueEntity';
  attributes?: Maybe<TaskDataLabelValue>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type TaskDataLabelValueEntityResponse = {
  __typename?: 'TaskDataLabelValueEntityResponse';
  data?: Maybe<TaskDataLabelValueEntity>;
};

export type TaskDataLabelValueEntityResponseCollection = {
  __typename?: 'TaskDataLabelValueEntityResponseCollection';
  data: Array<TaskDataLabelValueEntity>;
  meta: ResponseCollectionMeta;
};

export type TaskDataLabelValueFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<TaskDataLabelValueFiltersInput>>>;
  baorider?: InputMaybe<UsersPermissionsUserFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  data_field?: InputMaybe<CustomDataLabelFiltersInput>;
  evidence?: InputMaybe<EvidenceFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<TaskDataLabelValueFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TaskDataLabelValueFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  value?: InputMaybe<StringFilterInput>;
};

export type TaskDataLabelValueInput = {
  baorider?: InputMaybe<Scalars['ID']['input']>;
  data_field?: InputMaybe<Scalars['ID']['input']>;
  evidence?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TaskDataLabelValueRelationResponseCollection = {
  __typename?: 'TaskDataLabelValueRelationResponseCollection';
  data: Array<TaskDataLabelValueEntity>;
};

export type TaskDefinition = {
  __typename?: 'TaskDefinition';
  baoleader?: Maybe<UsersPermissionsUserEntityResponse>;
  category?: Maybe<CategoryEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  ecoCredits?: Maybe<Scalars['Float']['output']>;
  project?: Maybe<ProjectEntityResponse>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Enum_Taskdefinition_Status>;
  task_type?: Maybe<TaskTypeEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TaskDefinitionEntity = {
  __typename?: 'TaskDefinitionEntity';
  attributes?: Maybe<TaskDefinition>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type TaskDefinitionEntityResponse = {
  __typename?: 'TaskDefinitionEntityResponse';
  data?: Maybe<TaskDefinitionEntity>;
};

export type TaskDefinitionEntityResponseCollection = {
  __typename?: 'TaskDefinitionEntityResponseCollection';
  data: Array<TaskDefinitionEntity>;
  meta: ResponseCollectionMeta;
};

export type TaskDefinitionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<TaskDefinitionFiltersInput>>>;
  baoleader?: InputMaybe<UsersPermissionsUserFiltersInput>;
  category?: InputMaybe<CategoryFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  ecoCredits?: InputMaybe<FloatFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<TaskDefinitionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TaskDefinitionFiltersInput>>>;
  project?: InputMaybe<ProjectFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  task_type?: InputMaybe<TaskTypeFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type TaskDefinitionInput = {
  baoleader?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<Scalars['ID']['input']>;
  ecoCredits?: InputMaybe<Scalars['Float']['input']>;
  project?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Enum_Taskdefinition_Status>;
  task_type?: InputMaybe<Scalars['ID']['input']>;
};

export type TaskDefinitionRelationResponseCollection = {
  __typename?: 'TaskDefinitionRelationResponseCollection';
  data: Array<TaskDefinitionEntity>;
};

export type TaskEntity = {
  __typename?: 'TaskEntity';
  attributes?: Maybe<Task>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type TaskEntityResponse = {
  __typename?: 'TaskEntityResponse';
  data?: Maybe<TaskEntity>;
};

export type TaskEntityResponseCollection = {
  __typename?: 'TaskEntityResponseCollection';
  data: Array<TaskEntity>;
  meta: ResponseCollectionMeta;
};

export type TaskFiltersInput = {
  ER_ID?: InputMaybe<StringFilterInput>;
  accepted_at?: InputMaybe<DateTimeFilterInput>;
  and?: InputMaybe<Array<InputMaybe<TaskFiltersInput>>>;
  baoleader?: InputMaybe<UsersPermissionsUserFiltersInput>;
  baorider?: InputMaybe<UsersPermissionsUserFiltersInput>;
  community?: InputMaybe<CommunityFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  date_reported?: InputMaybe<DateTimeFilterInput>;
  edit_from?: InputMaybe<TaskFiltersInput>;
  evidences?: InputMaybe<EvidenceFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  location?: InputMaybe<JsonFilterInput>;
  not?: InputMaybe<TaskFiltersInput>;
  onlyEmployeesVerify?: InputMaybe<BooleanFilterInput>;
  or?: InputMaybe<Array<InputMaybe<TaskFiltersInput>>>;
  project?: InputMaybe<ProjectFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  task_definition?: InputMaybe<TaskDefinitionFiltersInput>;
  task_offline_id?: InputMaybe<StringFilterInput>;
  task_origin?: InputMaybe<StringFilterInput>;
  timezone?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type TaskInput = {
  ER_ID?: InputMaybe<Scalars['String']['input']>;
  accepted_at?: InputMaybe<Scalars['DateTime']['input']>;
  baoleader?: InputMaybe<Scalars['ID']['input']>;
  baorider?: InputMaybe<Scalars['ID']['input']>;
  community?: InputMaybe<Scalars['ID']['input']>;
  date_reported?: InputMaybe<Scalars['DateTime']['input']>;
  documents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  edit_from?: InputMaybe<Scalars['ID']['input']>;
  evidences?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  location?: InputMaybe<Scalars['JSON']['input']>;
  onlyEmployeesVerify?: InputMaybe<Scalars['Boolean']['input']>;
  project?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Enum_Task_Status>;
  task_definition?: InputMaybe<Scalars['ID']['input']>;
  task_offline_id?: InputMaybe<Scalars['String']['input']>;
  task_origin?: InputMaybe<Enum_Task_Task_Origin>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type TaskMetrics = {
  __typename?: 'TaskMetrics';
  averageCompletionTime?: Maybe<AverageMetirc>;
  averageEvidenceTime?: Maybe<AverageMetirc>;
  completedTasks?: Maybe<Metric>;
  reportedTask?: Maybe<Metric>;
};

export type TaskPer = {
  __typename?: 'TaskPer';
  count?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TaskType = {
  __typename?: 'TaskType';
  ER_ID?: Maybe<Scalars['String']['output']>;
  category?: Maybe<CategoryEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creator?: Maybe<UsersPermissionsUserEntityResponse>;
  custom_data_fields?: Maybe<CustomDataLabelRelationResponseCollection>;
  dataFields?: Maybe<Array<Maybe<TaskTypeDataFieldsDynamicZone>>>;
  documentedEvidence?: Maybe<Scalars['String']['output']>;
  environmentalImpact?: Maybe<Scalars['String']['output']>;
  next?: Maybe<TaskTypeEntityResponse>;
  onlyEmployeesVerify?: Maybe<Scalars['Boolean']['output']>;
  photoEvidence?: Maybe<Scalars['String']['output']>;
  photoRequired?: Maybe<Scalars['Boolean']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  reportingDateField?: Maybe<Scalars['String']['output']>;
  socialImpact?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Enum_Tasktype_Status>;
  task_definitions?: Maybe<TaskDefinitionRelationResponseCollection>;
  title?: Maybe<Scalars['String']['output']>;
  un_sdg?: Maybe<UnSdgEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
  withComment?: Maybe<Scalars['Boolean']['output']>;
};


export type TaskTypeCustom_Data_FieldsArgs = {
  filters?: InputMaybe<CustomDataLabelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type TaskTypeTask_DefinitionsArgs = {
  filters?: InputMaybe<TaskDefinitionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TaskTypeDataFieldsDynamicZone = ComponentCustomDataFieldsCheckbox | ComponentCustomDataFieldsDataList | ComponentCustomDataFieldsDateTimeField | ComponentCustomDataFieldsEmailField | ComponentCustomDataFieldsImageField | ComponentCustomDataFieldsMetricsSpecific | ComponentCustomDataFieldsNumberDropDown | ComponentCustomDataFieldsNumberField | ComponentCustomDataFieldsNumberRange | ComponentCustomDataFieldsPercentage | ComponentCustomDataFieldsPhoneNumberField | ComponentCustomDataFieldsRadio | ComponentCustomDataFieldsRating | ComponentCustomDataFieldsSelect | ComponentCustomDataFieldsText | Error;

export type TaskTypeEntity = {
  __typename?: 'TaskTypeEntity';
  attributes?: Maybe<TaskType>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type TaskTypeEntityResponse = {
  __typename?: 'TaskTypeEntityResponse';
  data?: Maybe<TaskTypeEntity>;
};

export type TaskTypeEntityResponseCollection = {
  __typename?: 'TaskTypeEntityResponseCollection';
  data: Array<TaskTypeEntity>;
  meta: ResponseCollectionMeta;
};

export type TaskTypeFiltersInput = {
  ER_ID?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<TaskTypeFiltersInput>>>;
  category?: InputMaybe<CategoryFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  creator?: InputMaybe<UsersPermissionsUserFiltersInput>;
  custom_data_fields?: InputMaybe<CustomDataLabelFiltersInput>;
  documentedEvidence?: InputMaybe<StringFilterInput>;
  environmentalImpact?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isPublicTemplate?: InputMaybe<BooleanFilterInput>;
  next?: InputMaybe<TaskTypeFiltersInput>;
  not?: InputMaybe<TaskTypeFiltersInput>;
  onlyEmployeesVerify?: InputMaybe<BooleanFilterInput>;
  or?: InputMaybe<Array<InputMaybe<TaskTypeFiltersInput>>>;
  photoEvidence?: InputMaybe<StringFilterInput>;
  photoRequired?: InputMaybe<BooleanFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  reportingDateField?: InputMaybe<StringFilterInput>;
  socialImpact?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  task_definitions?: InputMaybe<TaskDefinitionFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  un_sdg?: InputMaybe<UnSdgFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  version?: InputMaybe<LongFilterInput>;
  withComment?: InputMaybe<BooleanFilterInput>;
};

export type TaskTypeInput = {
  ER_ID?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['ID']['input']>;
  creator?: InputMaybe<Scalars['ID']['input']>;
  custom_data_fields?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  dataFields?: InputMaybe<Array<Scalars['TaskTypeDataFieldsDynamicZoneInput']['input']>>;
  documentedEvidence?: InputMaybe<Scalars['String']['input']>;
  environmentalImpact?: InputMaybe<Scalars['String']['input']>;
  isPublicTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  next?: InputMaybe<Scalars['ID']['input']>;
  onlyEmployeesVerify?: InputMaybe<Scalars['Boolean']['input']>;
  photoEvidence?: InputMaybe<Scalars['String']['input']>;
  photoRequired?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reportingDateField?: InputMaybe<Scalars['String']['input']>;
  socialImpact?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Enum_Tasktype_Status>;
  task_definitions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  un_sdg?: InputMaybe<Scalars['ID']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
  withComment?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TaskTypeRelationResponseCollection = {
  __typename?: 'TaskTypeRelationResponseCollection';
  data: Array<TaskTypeEntity>;
};

export type TaskWithCanEdit = {
  __typename?: 'TaskWithCanEdit';
  canEdit?: Maybe<Scalars['Boolean']['output']>;
  task?: Maybe<TaskEntity>;
};

export type TasksWithCount = {
  __typename?: 'TasksWithCount';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<TaskEntity>>>;
};

export type TasksWithDataCollector = {
  __typename?: 'TasksWithDataCollector';
  count?: Maybe<Scalars['Int']['output']>;
  dataCollector?: Maybe<UsersPermissionsUserEntity>;
};

export type TermsAndCondition = {
  __typename?: 'TermsAndCondition';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  terms_pdf: UploadFileEntityResponse;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TermsAndConditionEntity = {
  __typename?: 'TermsAndConditionEntity';
  attributes?: Maybe<TermsAndCondition>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type TermsAndConditionEntityResponse = {
  __typename?: 'TermsAndConditionEntityResponse';
  data?: Maybe<TermsAndConditionEntity>;
};

export type TermsAndConditionInput = {
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  terms_pdf?: InputMaybe<Scalars['ID']['input']>;
};

export type TopPerforming = {
  __typename?: 'TopPerforming';
  baoriders?: Maybe<Array<Maybe<TopPerformingBaorider>>>;
  chartData?: Maybe<TopPerformingChartData>;
  communityMembers?: Maybe<Array<Maybe<TopPerformingCommunityMember>>>;
};

export type TopPerformingBaorider = {
  __typename?: 'TopPerformingBaorider';
  baorider?: Maybe<UsersPermissionsUserEntity>;
  tasksCompleted: Scalars['Int']['output'];
};

export type TopPerformingChartData = {
  __typename?: 'TopPerformingChartData';
  baoriders?: Maybe<Array<Maybe<ChartData>>>;
  communityMembers?: Maybe<Array<Maybe<ChartData>>>;
};

export type TopPerformingCommunityMember = {
  __typename?: 'TopPerformingCommunityMember';
  communityMember?: Maybe<UsersPermissionsUserEntity>;
  tasksCompleted: Scalars['Int']['output'];
};

export type TrainingVideo = {
  __typename?: 'TrainingVideo';
  FAQs?: Maybe<Array<Maybe<ComponentFaqFaq>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  training_videos?: Maybe<Array<Maybe<ComponentTrainingVideoTrainingVideo>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type TrainingVideoFaQsArgs = {
  filters?: InputMaybe<ComponentFaqFaqFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type TrainingVideoTraining_VideosArgs = {
  filters?: InputMaybe<ComponentTrainingVideoTrainingVideoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TrainingVideoEntity = {
  __typename?: 'TrainingVideoEntity';
  attributes?: Maybe<TrainingVideo>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type TrainingVideoEntityResponse = {
  __typename?: 'TrainingVideoEntityResponse';
  data?: Maybe<TrainingVideoEntity>;
};

export type TrainingVideoInput = {
  FAQs?: InputMaybe<Array<InputMaybe<ComponentFaqFaqInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  training_videos?: InputMaybe<Array<InputMaybe<ComponentTrainingVideoTrainingVideoInput>>>;
};

export type Trend = {
  __typename?: 'Trend';
  count?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  previousMonthCount?: Maybe<Scalars['Int']['output']>;
  trend?: Maybe<Scalars['Int']['output']>;
};

export type UnSdg = {
  __typename?: 'UnSdg';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  icon?: Maybe<UploadFileEntityResponse>;
  name?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  task_types?: Maybe<TaskTypeRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type UnSdgTask_TypesArgs = {
  filters?: InputMaybe<TaskTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UnSdgEntity = {
  __typename?: 'UnSdgEntity';
  attributes?: Maybe<UnSdg>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UnSdgEntityResponse = {
  __typename?: 'UnSdgEntityResponse';
  data?: Maybe<UnSdgEntity>;
};

export type UnSdgEntityResponseCollection = {
  __typename?: 'UnSdgEntityResponseCollection';
  data: Array<UnSdgEntity>;
  meta: ResponseCollectionMeta;
};

export type UnSdgFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UnSdgFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UnSdgFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UnSdgFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  task_types?: InputMaybe<TaskTypeFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UnSdgInput = {
  icon?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  task_types?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UpdateBaoriderInput = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  community?: InputMaybe<Scalars['ID']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  idNumber?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  projects?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<Enum_Userspermissionsuser_Status>;
};

export type UpdateCommunityMembersInput = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  community?: InputMaybe<Scalars['ID']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  idNumber?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Enum_Userspermissionsuser_Status>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  alternativeText?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  ext?: Maybe<Scalars['String']['output']>;
  formats?: Maybe<Scalars['JSON']['output']>;
  hash: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  provider_metadata?: Maybe<Scalars['JSON']['output']>;
  related?: Maybe<Array<Maybe<GenericMorph>>>;
  size: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type UploadFileEntity = {
  __typename?: 'UploadFileEntity';
  attributes?: Maybe<UploadFile>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UploadFileEntityResponse = {
  __typename?: 'UploadFileEntityResponse';
  data?: Maybe<UploadFileEntity>;
};

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  data: Array<UploadFileEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFileFiltersInput = {
  alternativeText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  ext?: InputMaybe<StringFilterInput>;
  folder?: InputMaybe<UploadFolderFiltersInput>;
  folderPath?: InputMaybe<StringFilterInput>;
  formats?: InputMaybe<JsonFilterInput>;
  hash?: InputMaybe<StringFilterInput>;
  height?: InputMaybe<IntFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  mime?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  previewUrl?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  provider_metadata?: InputMaybe<JsonFilterInput>;
  size?: InputMaybe<FloatFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  width?: InputMaybe<IntFilterInput>;
};

export type UploadFileInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  ext?: InputMaybe<Scalars['String']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  folderPath?: InputMaybe<Scalars['String']['input']>;
  formats?: InputMaybe<Scalars['JSON']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  previewUrl?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  provider_metadata?: InputMaybe<Scalars['JSON']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadFileRelationResponseCollection = {
  __typename?: 'UploadFileRelationResponseCollection';
  data: Array<UploadFileEntity>;
};

export type UploadFolder = {
  __typename?: 'UploadFolder';
  children?: Maybe<UploadFolderRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  files?: Maybe<UploadFileRelationResponseCollection>;
  name: Scalars['String']['output'];
  parent?: Maybe<UploadFolderEntityResponse>;
  path: Scalars['String']['output'];
  pathId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type UploadFolderChildrenArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UploadFolderFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UploadFolderEntity = {
  __typename?: 'UploadFolderEntity';
  attributes?: Maybe<UploadFolder>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UploadFolderEntityResponse = {
  __typename?: 'UploadFolderEntityResponse';
  data?: Maybe<UploadFolderEntity>;
};

export type UploadFolderEntityResponseCollection = {
  __typename?: 'UploadFolderEntityResponseCollection';
  data: Array<UploadFolderEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFolderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  children?: InputMaybe<UploadFolderFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  files?: InputMaybe<UploadFileFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFolderFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  parent?: InputMaybe<UploadFolderFiltersInput>;
  path?: InputMaybe<StringFilterInput>;
  pathId?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UploadFolderInput = {
  children?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  pathId?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadFolderRelationResponseCollection = {
  __typename?: 'UploadFolderRelationResponseCollection';
  data: Array<UploadFolderEntity>;
};

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
  provider?: Scalars['String']['input'];
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']['output']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UsersPermissionsPermissionEntity = {
  __typename?: 'UsersPermissionsPermissionEntity';
  attributes?: Maybe<UsersPermissionsPermission>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection';
  data: Array<UsersPermissionsPermissionEntity>;
};

export type UsersPermissionsRegisterInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  permissions?: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type UsersPermissionsRolePermissionsArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsRoleEntity = {
  __typename?: 'UsersPermissionsRoleEntity';
  attributes?: Maybe<UsersPermissionsRole>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsRoleEntityResponse = {
  __typename?: 'UsersPermissionsRoleEntityResponse';
  data?: Maybe<UsersPermissionsRoleEntity>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection';
  data: Array<UsersPermissionsRoleEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  permissions?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  baoleader?: Maybe<UsersPermissionsUserEntityResponse>;
  baoriders?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  camera_permission?: Maybe<Scalars['Boolean']['output']>;
  community?: Maybe<CommunityEntityResponse>;
  company?: Maybe<CompanyEntityResponse>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  gender?: Maybe<Enum_Userspermissionsuser_Gender>;
  idNumber?: Maybe<Scalars['String']['output']>;
  invitedViaSMS?: Maybe<Scalars['Boolean']['output']>;
  isVerifier?: Maybe<Scalars['Boolean']['output']>;
  lastInactivityNotificationSentDate?: Maybe<Scalars['Date']['output']>;
  lastLoggedIn?: Maybe<Scalars['Date']['output']>;
  lastLoginReminderSent?: Maybe<Scalars['Date']['output']>;
  lastName: Scalars['String']['output'];
  lastTaskReportedDate?: Maybe<Scalars['Date']['output']>;
  lastWeeklyStatusReportSentDate?: Maybe<Scalars['Date']['output']>;
  location_permission?: Maybe<Scalars['Boolean']['output']>;
  media_library_permission?: Maybe<Scalars['Boolean']['output']>;
  metabaseUserID?: Maybe<Scalars['String']['output']>;
  notifications?: Maybe<NotificationRelationResponseCollection>;
  onboarding?: Maybe<Enum_Userspermissionsuser_Onboarding>;
  onboardingInformation?: Maybe<Scalars['JSON']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<UploadFileEntityResponse>;
  projects?: Maybe<ProjectRelationResponseCollection>;
  provider?: Maybe<Scalars['String']['output']>;
  pushToken?: Maybe<Scalars['String']['output']>;
  receiveAllTimeWeeklyStatusReport?: Maybe<Scalars['Boolean']['output']>;
  receiveLoginReminder?: Maybe<Scalars['Boolean']['output']>;
  receiveProjectNotifications?: Maybe<Scalars['Boolean']['output']>;
  receivePushNotifications?: Maybe<Scalars['Boolean']['output']>;
  receiveSmsNotifications?: Maybe<Scalars['Boolean']['output']>;
  receiveWeeklyStatusReport?: Maybe<Scalars['Boolean']['output']>;
  request?: Maybe<RequestEntityResponse>;
  requests?: Maybe<RequestRelationResponseCollection>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  status?: Maybe<Enum_Userspermissionsuser_Status>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  username: Scalars['String']['output'];
};


export type UsersPermissionsUserBaoridersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserNotificationsArgs = {
  filters?: InputMaybe<NotificationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserProjectsArgs = {
  filters?: InputMaybe<ProjectFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserRequestsArgs = {
  filters?: InputMaybe<RequestFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsUserEntity = {
  __typename?: 'UsersPermissionsUserEntity';
  attributes?: Maybe<UsersPermissionsUser>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse';
  data?: Maybe<UsersPermissionsUserEntity>;
};

export type UsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  baoleader?: InputMaybe<UsersPermissionsUserFiltersInput>;
  baoriders?: InputMaybe<UsersPermissionsUserFiltersInput>;
  blocked?: InputMaybe<BooleanFilterInput>;
  camera_permission?: InputMaybe<BooleanFilterInput>;
  community?: InputMaybe<CommunityFiltersInput>;
  company?: InputMaybe<CompanyFiltersInput>;
  confirmationToken?: InputMaybe<StringFilterInput>;
  confirmed?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  customerId?: InputMaybe<StringFilterInput>;
  dateOfBirth?: InputMaybe<DateFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  firstName?: InputMaybe<StringFilterInput>;
  gender?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  idNumber?: InputMaybe<StringFilterInput>;
  invitedViaSMS?: InputMaybe<BooleanFilterInput>;
  isVerifier?: InputMaybe<BooleanFilterInput>;
  lastInactivityNotificationSentDate?: InputMaybe<DateFilterInput>;
  lastLoggedIn?: InputMaybe<DateFilterInput>;
  lastLoginReminderSent?: InputMaybe<DateFilterInput>;
  lastName?: InputMaybe<StringFilterInput>;
  lastTaskReportedDate?: InputMaybe<DateFilterInput>;
  lastWeeklyStatusReportSentDate?: InputMaybe<DateFilterInput>;
  location_permission?: InputMaybe<BooleanFilterInput>;
  media_library_permission?: InputMaybe<BooleanFilterInput>;
  metabaseUserID?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsUserFiltersInput>;
  notifications?: InputMaybe<NotificationFiltersInput>;
  onboarding?: InputMaybe<StringFilterInput>;
  onboardingInformation?: InputMaybe<JsonFilterInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  otp?: InputMaybe<StringFilterInput>;
  password?: InputMaybe<StringFilterInput>;
  phoneNumber?: InputMaybe<StringFilterInput>;
  projects?: InputMaybe<ProjectFiltersInput>;
  provider?: InputMaybe<StringFilterInput>;
  pushToken?: InputMaybe<StringFilterInput>;
  receiveAllTimeWeeklyStatusReport?: InputMaybe<BooleanFilterInput>;
  receiveLoginReminder?: InputMaybe<BooleanFilterInput>;
  receiveProjectNotifications?: InputMaybe<BooleanFilterInput>;
  receivePushNotifications?: InputMaybe<BooleanFilterInput>;
  receiveSmsNotifications?: InputMaybe<BooleanFilterInput>;
  receiveWeeklyStatusReport?: InputMaybe<BooleanFilterInput>;
  request?: InputMaybe<RequestFiltersInput>;
  requests?: InputMaybe<RequestFiltersInput>;
  resetPasswordToken?: InputMaybe<StringFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  status?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  username?: InputMaybe<StringFilterInput>;
};

export type UsersPermissionsUserInput = {
  baoleader?: InputMaybe<Scalars['ID']['input']>;
  baoriders?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  camera_permission?: InputMaybe<Scalars['Boolean']['input']>;
  community?: InputMaybe<Scalars['ID']['input']>;
  company?: InputMaybe<Scalars['ID']['input']>;
  confirmationToken?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Enum_Userspermissionsuser_Gender>;
  idNumber?: InputMaybe<Scalars['String']['input']>;
  invitedViaSMS?: InputMaybe<Scalars['Boolean']['input']>;
  isVerifier?: InputMaybe<Scalars['Boolean']['input']>;
  lastInactivityNotificationSentDate?: InputMaybe<Scalars['Date']['input']>;
  lastLoggedIn?: InputMaybe<Scalars['Date']['input']>;
  lastLoginReminderSent?: InputMaybe<Scalars['Date']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastTaskReportedDate?: InputMaybe<Scalars['Date']['input']>;
  lastWeeklyStatusReportSentDate?: InputMaybe<Scalars['Date']['input']>;
  location_permission?: InputMaybe<Scalars['Boolean']['input']>;
  media_library_permission?: InputMaybe<Scalars['Boolean']['input']>;
  metabaseUserID?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  onboarding?: InputMaybe<Enum_Userspermissionsuser_Onboarding>;
  onboardingInformation?: InputMaybe<Scalars['JSON']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Scalars['ID']['input']>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  provider?: InputMaybe<Scalars['String']['input']>;
  pushToken?: InputMaybe<Scalars['String']['input']>;
  receiveAllTimeWeeklyStatusReport?: InputMaybe<Scalars['Boolean']['input']>;
  receiveLoginReminder?: InputMaybe<Scalars['Boolean']['input']>;
  receiveProjectNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  receivePushNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  receiveSmsNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  receiveWeeklyStatusReport?: InputMaybe<Scalars['Boolean']['input']>;
  request?: InputMaybe<Scalars['ID']['input']>;
  requests?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Enum_Userspermissionsuser_Status>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
};

export type Video = {
  __typename?: 'Video';
  category?: Maybe<Enum_Video_Category>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  videoLink: UploadFileEntityResponse;
};

export type VideoEntity = {
  __typename?: 'VideoEntity';
  attributes?: Maybe<Video>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type VideoEntityResponse = {
  __typename?: 'VideoEntityResponse';
  data?: Maybe<VideoEntity>;
};

export type VideoEntityResponseCollection = {
  __typename?: 'VideoEntityResponseCollection';
  data: Array<VideoEntity>;
  meta: ResponseCollectionMeta;
};

export type VideoFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<VideoFiltersInput>>>;
  category?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<VideoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<VideoFiltersInput>>>;
  order?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type VideoInput = {
  category?: InputMaybe<Enum_Video_Category>;
  order?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  videoLink?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateMyUserInput = {
  baoriders?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  camera_permission?: InputMaybe<Scalars['Boolean']['input']>;
  community?: InputMaybe<Scalars['ID']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  idNumber?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  location_permission?: InputMaybe<Scalars['Boolean']['input']>;
  media_library_permission?: InputMaybe<Scalars['Boolean']['input']>;
  notifications?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  onboarding?: InputMaybe<Enum_Userspermissionsuser_Onboarding>;
  onboardingInformation?: InputMaybe<Scalars['JSON']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Scalars['ID']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  pushToken?: InputMaybe<Scalars['String']['input']>;
  receiveAllTimeWeeklyStatusReport?: InputMaybe<Scalars['Boolean']['input']>;
  receiveLoginReminder?: InputMaybe<Scalars['Boolean']['input']>;
  receiveProjectNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  receivePushNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  receiveSmsNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  receiveWeeklyStatusReport?: InputMaybe<Scalars['Boolean']['input']>;
  requests?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  tasks?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UnsdgFragment = { __typename?: 'UnSdg', name?: string | null, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null };

export type Analytic_FragmentFragment = { __typename?: 'Analytic', default_dashboard?: string | null };

export type CategoryFragment = { __typename?: 'Category', title?: string | null, description?: string | null, status?: Enum_Category_Status | null, createdAt?: any | null, updatedAt?: any | null };

export type CommunityFragment = { __typename?: 'Community', createdAt?: any | null, updatedAt?: any | null, name?: string | null, type?: Enum_Community_Type | null, description?: string | null, chief_name?: string | null, location?: any | null };

export type ComponentCustomDataFieldsCheckboxFragment = { __typename?: 'ComponentCustomDataFieldsCheckbox', id: string, isRequired?: boolean | null, label?: string | null, option?: Array<{ __typename?: 'ComponentComboFieldOption', id: string, option?: string | null } | null> | null };

export type ComponentCustomDataFieldsDataListFragment = { __typename?: 'ComponentCustomDataFieldsDataList', id: string, label?: string | null, isRequired?: boolean | null, listId: string, option?: Array<{ __typename?: 'ComponentComboFieldOption', id: string, option?: string | null } | null> | null };

export type ComponentCustomDataFieldsDateTimeFieldFragment = { __typename?: 'ComponentCustomDataFieldsDateTimeField', id: string, label?: string | null, isRequired?: boolean | null, datetime?: any | null };

export type ComponentCustomDataFieldsEmailFieldFragment = { __typename?: 'ComponentCustomDataFieldsEmailField', id: string, label?: string | null, isRequired?: boolean | null, email?: string | null };

export type ComponentCustomDataFieldsImageFieldFragment = { __typename?: 'ComponentCustomDataFieldsImageField', id: string, isRequired?: boolean | null, label?: string | null, upload_state?: Enum_Componentcustomdatafieldsimagefield_Upload_State | null, images?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null }> } | null };

export type ComponentCustomDataFieldsMetricsSpecificFragment = { __typename?: 'ComponentCustomDataFieldsMetricsSpecific', id: string, label?: string | null, min?: any | null, max?: any | null, isRequired?: boolean | null, metric?: string | null, number_value?: string | null };

export type ComponentCustomDataFieldsNumberDropDownFragment = { __typename?: 'ComponentCustomDataFieldsNumberDropDown', id: string, label?: string | null, value?: any | null, isRequired?: boolean | null, max?: any | null, min?: any | null };

export type ComponentCustomDataFieldsNumberFieldFragment = { __typename?: 'ComponentCustomDataFieldsNumberField', id: string, label?: string | null, min?: any | null, max?: any | null, isRequired?: boolean | null, number_field_value?: string | null };

export type ComponentCustomDataFieldsNumberRangeFragment = { __typename?: 'ComponentCustomDataFieldsNumberRange', id: string, label?: string | null, min?: any | null, isRequired?: boolean | null, max?: any | null };

export type ComponentCustomDataFieldsPercentageFragment = { __typename?: 'ComponentCustomDataFieldsPercentage', id: string, label?: string | null, isRequired?: boolean | null, value?: any | null };

export type ComponentCustomDataFieldsPhoneNumberFieldFragment = { __typename?: 'ComponentCustomDataFieldsPhoneNumberField', id: string, label?: string | null, isRequired?: boolean | null, phoneNumber?: string | null };

export type ComponentCustomDataFieldsRadioFragment = { __typename?: 'ComponentCustomDataFieldsRadio', id: string, label?: string | null, isRequired?: boolean | null, option?: Array<{ __typename?: 'ComponentComboFieldOption', id: string, option?: string | null } | null> | null };

export type ComponentCustomDataFieldsRatingFragment = { __typename?: 'ComponentCustomDataFieldsRating', id: string, label?: string | null, rating?: number | null, isRequired?: boolean | null, number_of_stars?: any | null };

export type ComponentCustomDataFieldsSelectFragment = { __typename?: 'ComponentCustomDataFieldsSelect', id: string, isRequired?: boolean | null, label?: string | null, option?: Array<{ __typename: 'ComponentComboFieldOption', id: string, option?: string | null } | null> | null };

export type ComponentCustomDataFieldsTextFragment = { __typename?: 'ComponentCustomDataFieldsText', id: string, label?: string | null, isRequired?: boolean | null, text_value?: string | null };

export type DataListOptionFragment = { __typename?: 'DataListOption', createdAt?: any | null, status?: Enum_Datalistoption_Status | null, updatedAt?: any | null, value: string, publishedAt?: any | null };

export type DataListsFragment = { __typename?: 'DataList', name: string, createdAt?: any | null, updatedAt?: any | null, status?: Enum_Datalist_Status | null, publishedAt?: any | null };

export type EvidenceFragment = { __typename?: 'Evidence', notes?: string | null, location?: string | null, createdAt?: any | null, updatedAt?: any | null, upload_state?: Enum_Evidence_Upload_State | null, cancellationReason?: string | null, requestedInfo?: string | null };

export type FaqFragment = { __typename: 'ComponentFaqFaq', id: string, question?: string | null, answer?: string | null, category?: Enum_Componentfaqfaq_Category | null, page?: Enum_Componentfaqfaq_Page | null, tags?: Array<{ __typename?: 'ComponentComboFieldOption', id: string, option?: string | null } | null> | null };

export type InsightReportFragment = { __typename?: 'InsightReport', name: string, description?: string | null, status?: Enum_Insightreport_Status | null, graphs?: any | null, createdAt?: any | null, updatedAt?: any | null };

export type MemberFragment = { __typename?: 'UsersPermissionsUser', firstName: string, lastName: string, status?: Enum_Userspermissionsuser_Status | null, phoneNumber?: string | null, createdAt?: any | null, updatedAt?: any | null, gender?: Enum_Userspermissionsuser_Gender | null, idNumber?: string | null, blocked?: boolean | null, dateOfBirth?: any | null, location_permission?: boolean | null, camera_permission?: boolean | null, media_library_permission?: boolean | null, isVerifier?: boolean | null, email: string, baoleader?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null } | null } | null, profilePicture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null, role?: { __typename?: 'UsersPermissionsRoleEntityResponse', data?: { __typename?: 'UsersPermissionsRoleEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsRole', name: string, type?: string | null } | null } | null } | null, community?: { __typename?: 'CommunityEntityResponse', data?: { __typename?: 'CommunityEntity', id?: string | null, attributes?: { __typename?: 'Community', createdAt?: any | null, updatedAt?: any | null, name?: string | null, type?: Enum_Community_Type | null, description?: string | null, chief_name?: string | null, location?: any | null, featured_image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null } | null } | null };

export type ProjectFragment = { __typename?: 'Project', breakdown?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, collaborators?: any | null, reward?: string | null, status?: Enum_Project_Status | null, statement?: string | null, description?: string | null, outcomes?: string | null, budget?: string | null };

export type TaskFragment = { __typename?: 'Task', updatedAt?: any | null, createdAt?: any | null, date_reported?: any | null, status?: Enum_Task_Status | null, location?: any | null, onlyEmployeesVerify?: boolean | null, timezone?: string | null, task_origin?: Enum_Task_Task_Origin | null };

export type TaskPerFragment = { __typename?: 'TaskPer', name?: string | null, count?: number | null };

export type TaskTypeFragment = { __typename?: 'TaskType', title?: string | null, reportingDateField?: string | null, photoEvidence?: string | null, documentedEvidence?: string | null, environmentalImpact?: string | null, socialImpact?: string | null, status?: Enum_Tasktype_Status | null, createdAt?: any | null, updatedAt?: any | null, withComment?: boolean | null, photoRequired?: boolean | null };

export type Training_VideoFragment = { __typename: 'ComponentTrainingVideoTrainingVideo', id: string, title?: string | null, url?: string | null, page?: Enum_Componenttrainingvideotrainingvideo_Page | null, category?: Enum_Componenttrainingvideotrainingvideo_Category | null, description?: string | null, tags?: Array<{ __typename?: 'ComponentComboFieldOption', id: string, option?: string | null } | null> | null };

export type UploadFileFragment = { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null };

export type AcceptCommunityMemberRequestMutationVariables = Exact<{
  requestId: Scalars['ID']['input'];
}>;


export type AcceptCommunityMemberRequestMutation = { __typename?: 'Mutation', acceptCommunityMemberRequest: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName: string, lastName: string } | null } };

export type ActivateTaskTypeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ActivateTaskTypeMutation = { __typename?: 'Mutation', activateTaskType: { __typename?: 'TaskTypeEntity', id?: string | null } };

export type AddDataCollectorToProjectMutationVariables = Exact<{
  input: AddDataCollectorToProjectInput;
}>;


export type AddDataCollectorToProjectMutation = { __typename?: 'Mutation', addDataCollectorToProject?: { __typename?: 'ProjectEntity', id?: string | null } | null };

export type ArchiveNotificationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveNotificationMutation = { __typename?: 'Mutation', deleteBaoleaderNotification?: { __typename?: 'NotificationEntity', id?: string | null, attributes?: { __typename?: 'Notification', status?: Enum_Notification_Status | null, updatedAt?: any | null } | null } | null };

export type CancelSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type CancelSubscriptionMutation = { __typename?: 'Mutation', cancelSubscription?: { __typename?: 'SubscriptionCancellationPayload', status?: string | null, cancelAtPeriodEnd?: boolean | null, endsAt?: any | null } | null };

export type ChangeSubscriptionPlanMutationVariables = Exact<{
  productPlanId: Scalars['ID']['input'];
}>;


export type ChangeSubscriptionPlanMutation = { __typename?: 'Mutation', changeSubscriptionPlan?: { __typename?: 'PlanChangePayload', status?: string | null, planId?: string | null, planName?: string | null, priceId?: string | null, direction?: string | null } | null };

export type CompleteOnboardingStepMutationVariables = Exact<{
  index: Scalars['String']['input'];
  completeOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CompleteOnboardingStepMutation = { __typename?: 'Mutation', completeOnboardingStep?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', username: string } | null } | null };

export type CreateBaoleaderMutationVariables = Exact<{
  input: CreateBaoleaderInput;
}>;


export type CreateBaoleaderMutation = { __typename?: 'Mutation', createBaoleader: { __typename?: 'BaoleaderPayload', baoleader?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', username: string, email: string } | null } | null } };

export type CreateBaoriderMutationVariables = Exact<{
  input: CreateBaoriderInput;
  sendInvite?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateBaoriderMutation = { __typename?: 'Mutation', createBaorider: { __typename?: 'BaoriderPayload', baorider?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', username: string, email: string } | null } | null } };

export type CreateBaoridersMutationVariables = Exact<{
  input: Array<InputMaybe<CreateBaoriderInput>> | InputMaybe<CreateBaoriderInput>;
}>;


export type CreateBaoridersMutation = { __typename?: 'Mutation', createBaoriders: { __typename?: 'MultipleBaoriderPayload', baoriders?: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', email: string, username: string } | null } | null> | null } };

export type CreateCategoryMutationVariables = Exact<{
  input: CategoryInput;
}>;


export type CreateCategoryMutation = { __typename?: 'Mutation', createCategory?: { __typename?: 'CategoryEntityResponse', data?: { __typename?: 'CategoryEntity', id?: string | null, attributes?: { __typename?: 'Category', title?: string | null, description?: string | null, status?: Enum_Category_Status | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null };

export type CreateCommunityMutationVariables = Exact<{
  input?: InputMaybe<CommunityInput>;
}>;


export type CreateCommunityMutation = { __typename?: 'Mutation', createBaoleaderCommunity?: { __typename?: 'CommunityEntity', id?: string | null, attributes?: { __typename?: 'Community', name?: string | null, chief_name?: string | null, description?: string | null } | null } | null };

export type CreateCommunityMemberMutationVariables = Exact<{
  input?: InputMaybe<CreateCommunityMembersInput>;
  sendInvite?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateCommunityMemberMutation = { __typename?: 'Mutation', createCommunityMember: { __typename?: 'CommunityMembersPayload', member?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', username: string } | null } | null } };

export type CreateCommunityMembersMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<CreateCommunityMembersInput>> | InputMaybe<CreateCommunityMembersInput>>;
}>;


export type CreateCommunityMembersMutation = { __typename?: 'Mutation', createCommunityMembers: Array<{ __typename?: 'CommunityMembersPayload', member?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', username: string } | null } | null } | null> };

export type CreateDataListMutationVariables = Exact<{
  input: DataListInput;
}>;


export type CreateDataListMutation = { __typename?: 'Mutation', createDataList?: { __typename?: 'DataListEntityResponse', data?: { __typename?: 'DataListEntity', id?: string | null } | null } | null };

export type CreateDataListOptionMutationVariables = Exact<{
  input: DataListOptionInput;
}>;


export type CreateDataListOptionMutation = { __typename?: 'Mutation', createDataListOption?: { __typename?: 'DataListOptionEntityResponse', data?: { __typename?: 'DataListOptionEntity', id?: string | null } | null } | null };

export type CreateBaoleaderInsightReportMutationVariables = Exact<{
  input: InsightReportCustomInput;
}>;


export type CreateBaoleaderInsightReportMutation = { __typename?: 'Mutation', createBaoleaderInsightReport: { __typename?: 'InsightReportEntity', id?: string | null, attributes?: { __typename?: 'InsightReport', name: string, description?: string | null, status?: Enum_Insightreport_Status | null, graphs?: any | null, createdAt?: any | null, updatedAt?: any | null } | null } };

export type CreateNotificationMutationVariables = Exact<{
  data: NotificationInput;
}>;


export type CreateNotificationMutation = { __typename?: 'Mutation', createBaoleaderNotification?: { __typename?: 'NotificationEntity', id?: string | null, attributes?: { __typename?: 'Notification', title?: string | null, message?: string | null, type?: Enum_Notification_Type | null, status?: Enum_Notification_Status | null, timezone?: string | null, dateSent?: any | null, recur?: Enum_Notification_Recur | null, nextScheduledNotificationDetails?: { __typename?: 'NotificationScheduledDetails', id?: string | null, sendAt?: any | null, endAt?: any | null, recur?: Enum_Schedulednotification_Recur | null, status?: Enum_Schedulednotification_Status | null, priority?: Enum_Schedulednotification_Priority | null } | null } | null } | null };

export type CreateProjectMutationVariables = Exact<{
  input?: InputMaybe<ProjectInput>;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createBaoleaderProject?: { __typename?: 'ProjectEntity', id?: string | null, attributes?: { __typename?: 'Project', name?: string | null } | null } | null };

export type CreateSetupIntentMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateSetupIntentMutation = { __typename?: 'Mutation', createSetupIntent?: { __typename?: 'SetupIntentPayload', clientSecret?: string | null, publishableKey?: string | null, customerId?: string | null } | null };

export type CreateTaskMutationVariables = Exact<{
  input?: InputMaybe<TaskInput>;
}>;


export type CreateTaskMutation = { __typename?: 'Mutation', createBaoleaderTask: { __typename?: 'TaskEntity', id?: string | null, attributes?: { __typename?: 'Task', createdAt?: any | null } | null } };

export type DeactivateTaskTypeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeactivateTaskTypeMutation = { __typename?: 'Mutation', deactivateTaskType: { __typename?: 'TaskTypeEntity', id?: string | null } };

export type DeleteBaoriderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteBaoriderMutation = { __typename?: 'Mutation', removeBaorider: { __typename?: 'BaoriderPayload', baorider?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', username: string } | null } | null } };

export type DeleteCommunityMemberMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCommunityMemberMutation = { __typename?: 'Mutation', removeCommunityMember: { __typename?: 'CommunityMembersPayload', member?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', username: string } | null } | null } };

export type DeleteBaoleaderInsightReportMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteBaoleaderInsightReportMutation = { __typename?: 'Mutation', deleteBaoleaderInsightReport?: { __typename?: 'InsightReportEntity', id?: string | null, attributes?: { __typename?: 'InsightReport', name: string, description?: string | null, status?: Enum_Insightreport_Status | null, graphs?: any | null, createdAt?: any | null, updatedAt?: any | null } | null } | null };

export type DeleteTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteTaskMutation = { __typename?: 'Mutation', deleteBaoleaderTask?: { __typename?: 'TaskEntity', id?: string | null, attributes?: { __typename?: 'Task', baorider?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null } | null } | null } | null } | null };

export type DeleteTasktypeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteTasktypeMutation = { __typename?: 'Mutation', deleteTaskType?: { __typename?: 'TaskTypeEntityResponse', data?: { __typename?: 'TaskTypeEntity', id?: string | null } | null } | null };

export type ExecuteInsightReportAgentMutationVariables = Exact<{
  input: InsightAgentReportInput;
}>;


export type ExecuteInsightReportAgentMutation = { __typename?: 'Mutation', executeInsightReportAgent: { __typename?: 'InsightAgentReportResult', preview: any, warnings: Array<string>, report?: { __typename?: 'InsightReportEntity', id?: string | null, attributes?: { __typename?: 'InsightReport', name: string, description?: string | null, status?: Enum_Insightreport_Status | null, graphs?: any | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } };

export type ExportExcelMutationVariables = Exact<{
  filterValues?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type ExportExcelMutation = { __typename?: 'Mutation', exportExcel?: any | null };

export type LoginCustomerPortalMutationVariables = Exact<{ [key: string]: never; }>;


export type LoginCustomerPortalMutation = { __typename?: 'Mutation', loginCustomerPortal?: string | null };

export type MigrateToAutomatedPlanMutationVariables = Exact<{
  input?: InputMaybe<MigrateToAutomatedPlanInput>;
}>;


export type MigrateToAutomatedPlanMutation = { __typename?: 'Mutation', migrateToAutomatedPlan?: { __typename?: 'PlanMigrationPayload', status?: string | null, planId?: string | null, planName?: string | null, priceId?: string | null, currency?: string | null, billingStartsAt?: any | null } | null };

export type RedeemFeatureCouponMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type RedeemFeatureCouponMutation = { __typename?: 'Mutation', redeemFeatureCoupon?: { __typename?: 'FeatureUnlockPayload', feature?: string | null, expiresAt?: any | null, active?: boolean | null } | null };

export type RejectCommunityMemberRequestMutationVariables = Exact<{
  requestId: Scalars['ID']['input'];
}>;


export type RejectCommunityMemberRequestMutation = { __typename?: 'Mutation', rejectCommunityMemberRequest: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName: string, lastName: string } | null } };

export type RemoveCompanyMemberMutationVariables = Exact<{
  memberId: Scalars['ID']['input'];
}>;


export type RemoveCompanyMemberMutation = { __typename?: 'Mutation', removeCompanyMember?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null } | null };

export type RemovePaymentMethodMutationVariables = Exact<{
  paymentMethodId: Scalars['ID']['input'];
}>;


export type RemovePaymentMethodMutation = { __typename?: 'Mutation', removePaymentMethod: boolean };

export type RequestMoreInfoMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input?: InputMaybe<TaskInput>;
}>;


export type RequestMoreInfoMutation = { __typename?: 'Mutation', requestMoreInfo: { __typename?: 'TaskEntity', id?: string | null } };

export type RequestUpdateCompanyDetailsMutationVariables = Exact<{
  data: RequestCompanyDetailsChangeInput;
}>;


export type RequestUpdateCompanyDetailsMutation = { __typename?: 'Mutation', requestUpdateCompanyDetails?: { __typename?: 'Company', name?: string | null } | null };

export type ResendDataCollectorInviteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ResendDataCollectorInviteMutation = { __typename?: 'Mutation', resendDataCollectorInvite?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null } | null };

export type ResumeSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type ResumeSubscriptionMutation = { __typename?: 'Mutation', resumeSubscription?: { __typename?: 'SubscriptionCancellationPayload', status?: string | null, cancelAtPeriodEnd?: boolean | null, endsAt?: any | null } | null };

export type SetDefaultPaymentMethodMutationVariables = Exact<{
  paymentMethodId: Scalars['ID']['input'];
}>;


export type SetDefaultPaymentMethodMutation = { __typename?: 'Mutation', setDefaultPaymentMethod: boolean };

export type SkipOnboardingStepMutationVariables = Exact<{
  index: Scalars['String']['input'];
  completeOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SkipOnboardingStepMutation = { __typename?: 'Mutation', skipOnboardingStep?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', username: string } | null } | null };

export type CreateTaskDefinitionMutationVariables = Exact<{
  input?: InputMaybe<TaskDefinitionInput>;
}>;


export type CreateTaskDefinitionMutation = { __typename?: 'Mutation', createBaoleaderTaskDefinition: { __typename?: 'TaskDefinitionEntity', id?: string | null, attributes?: { __typename?: 'TaskDefinition', category?: { __typename?: 'CategoryEntityResponse', data?: { __typename?: 'CategoryEntity', id?: string | null } | null } | null, task_type?: { __typename?: 'TaskTypeEntityResponse', data?: { __typename?: 'TaskTypeEntity', id?: string | null } | null } | null } | null } };

export type UpdateBaoleaderTaskDefinitionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input?: InputMaybe<TaskDefinitionInput>;
}>;


export type UpdateBaoleaderTaskDefinitionMutation = { __typename?: 'Mutation', updateBaoleaderTaskDefinition: { __typename?: 'TaskDefinitionEntity', id?: string | null, attributes?: { __typename?: 'TaskDefinition', category?: { __typename?: 'CategoryEntityResponse', data?: { __typename?: 'CategoryEntity', id?: string | null } | null } | null, task_type?: { __typename?: 'TaskTypeEntityResponse', data?: { __typename?: 'TaskTypeEntity', id?: string | null } | null } | null } | null } };

export type DeleteBaoleaderTaskDefinitionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteBaoleaderTaskDefinitionMutation = { __typename?: 'Mutation', deleteBaoleaderTaskDefinition?: { __typename?: 'TaskDefinitionEntity', id?: string | null, attributes?: { __typename?: 'TaskDefinition', category?: { __typename?: 'CategoryEntityResponse', data?: { __typename?: 'CategoryEntity', id?: string | null } | null } | null, task_type?: { __typename?: 'TaskTypeEntityResponse', data?: { __typename?: 'TaskTypeEntity', id?: string | null } | null } | null } | null } | null };

export type CreateTaskTypeMutationVariables = Exact<{
  input: TaskTypeInput;
  dataFieldsArr?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type CreateTaskTypeMutation = { __typename?: 'Mutation', createBaoleaderTaskType: { __typename?: 'TaskTypeEntity', id?: string | null, attributes?: { __typename?: 'TaskType', title?: string | null, reportingDateField?: string | null, photoEvidence?: string | null, documentedEvidence?: string | null, environmentalImpact?: string | null, socialImpact?: string | null, status?: Enum_Tasktype_Status | null, createdAt?: any | null, updatedAt?: any | null, withComment?: boolean | null, photoRequired?: boolean | null, category?: { __typename?: 'CategoryEntityResponse', data?: { __typename?: 'CategoryEntity', id?: string | null } | null } | null } | null } };

export type UnarchiveCompanyMemberMutationVariables = Exact<{
  memberId: Scalars['ID']['input'];
}>;


export type UnarchiveCompanyMemberMutation = { __typename?: 'Mutation', unarchiveCompanyMember?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null } | null };

export type UpdateBaoriderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  baorider?: InputMaybe<UpdateBaoriderInput>;
}>;


export type UpdateBaoriderMutation = { __typename?: 'Mutation', updateBaorider: { __typename?: 'BaoriderPayload', baorider?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null } | null } };

export type UpdateCategoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: CategoryInput;
}>;


export type UpdateCategoryMutation = { __typename?: 'Mutation', updateCategory?: { __typename?: 'CategoryEntityResponse', data?: { __typename?: 'CategoryEntity', id?: string | null, attributes?: { __typename?: 'Category', title?: string | null, description?: string | null, status?: Enum_Category_Status | null, createdAt?: any | null, updatedAt?: any | null } | null } | null } | null };

export type UpdateCommunityMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input?: InputMaybe<CommunityInput>;
}>;


export type UpdateCommunityMutation = { __typename?: 'Mutation', updateBaoleaderCommunity?: { __typename?: 'CommunityEntity', id?: string | null, attributes?: { __typename?: 'Community', name?: string | null } | null } | null };

export type UpdateCommunityMemberMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateCommunityMembersInput>;
}>;


export type UpdateCommunityMemberMutation = { __typename?: 'Mutation', updateCommunityMember: { __typename?: 'CommunityMembersPayload', member?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', username: string } | null } | null } };

export type UpdateCompanyOnboardingInformationMutationVariables = Exact<{
  onboardingInformation: Scalars['JSON']['input'];
}>;


export type UpdateCompanyOnboardingInformationMutation = { __typename?: 'Mutation', updateCompanyOnboardingInformation?: { __typename?: 'CompanyEntity', id?: string | null, attributes?: { __typename?: 'Company', onboardingInformation?: any | null } | null } | null };

export type UpdateDataListMutationVariables = Exact<{
  input: DataListInput;
  id: Scalars['ID']['input'];
}>;


export type UpdateDataListMutation = { __typename?: 'Mutation', updateDataList?: { __typename?: 'DataListEntityResponse', data?: { __typename?: 'DataListEntity', id?: string | null, attributes?: { __typename?: 'DataList', name: string } | null } | null } | null };

export type UpdateDataListOptionMutationVariables = Exact<{
  input: DataListOptionInput;
  id: Scalars['ID']['input'];
}>;


export type UpdateDataListOptionMutation = { __typename?: 'Mutation', updateDataListOption?: { __typename?: 'DataListOptionEntityResponse', data?: { __typename?: 'DataListOptionEntity', id?: string | null, attributes?: { __typename?: 'DataListOption', value: string } | null } | null } | null };

export type UpdateEvidenceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input?: InputMaybe<EvidenceInput>;
}>;


export type UpdateEvidenceMutation = { __typename?: 'Mutation', updateBaoleaderEvidence: { __typename?: 'Evidence', notes?: string | null } };

export type UpdateBaoleaderInsightReportMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: InsightReportCustomInput;
}>;


export type UpdateBaoleaderInsightReportMutation = { __typename?: 'Mutation', updateBaoleaderInsightReport: { __typename?: 'InsightReportEntity', id?: string | null, attributes?: { __typename?: 'InsightReport', name: string, description?: string | null, status?: Enum_Insightreport_Status | null, graphs?: any | null, createdAt?: any | null, updatedAt?: any | null } | null } };

export type UpdateMyUserMutationVariables = Exact<{
  input?: InputMaybe<UpdateMyUserInput>;
}>;


export type UpdateMyUserMutation = { __typename?: 'Mutation', updateMyUser?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null } | null };

export type UpdateNotificationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: NotificationInput;
}>;


export type UpdateNotificationMutation = { __typename?: 'Mutation', updateBaoleaderNotification?: { __typename?: 'NotificationEntity', id?: string | null, attributes?: { __typename?: 'Notification', title?: string | null, message?: string | null, type?: Enum_Notification_Type | null, status?: Enum_Notification_Status | null, dateSent?: any | null, recur?: Enum_Notification_Recur | null, timezone?: string | null, updatedAt?: any | null, nextScheduledNotificationDetails?: { __typename?: 'NotificationScheduledDetails', id?: string | null, sendAt?: any | null, endAt?: any | null, recur?: Enum_Schedulednotification_Recur | null, status?: Enum_Schedulednotification_Status | null, priority?: Enum_Schedulednotification_Priority | null } | null } | null } | null };

export type UpdateProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input?: InputMaybe<ProjectInput>;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateBaoleaderProject?: { __typename?: 'ProjectEntity', id?: string | null, attributes?: { __typename?: 'Project', name?: string | null } | null } | null };

export type UpdateTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: TaskInput;
}>;


export type UpdateTaskMutation = { __typename?: 'Mutation', updateBaoleaderTask: { __typename?: 'TaskEntity', id?: string | null, attributes?: { __typename?: 'Task', createdAt?: any | null } | null } };

export type UpdateTaskTypeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: TaskTypeInput;
  dataFieldsArr?: InputMaybe<Scalars['JSON']['input']>;
  diffs?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type UpdateTaskTypeMutation = { __typename?: 'Mutation', updateBaoleaderTaskType: { __typename?: 'TaskTypeEntity', id?: string | null, attributes?: { __typename?: 'TaskType', title?: string | null } | null } };

export type UpdateVideoMutationVariables = Exact<{
  input: VideoInput;
  id: Scalars['ID']['input'];
}>;


export type UpdateVideoMutation = { __typename?: 'Mutation', updateVideo?: { __typename?: 'VideoEntityResponse', data?: { __typename?: 'VideoEntity', id?: string | null } | null } | null };

export type AnalyticsQueryVariables = Exact<{ [key: string]: never; }>;


export type AnalyticsQuery = { __typename?: 'Query', analytic?: { __typename?: 'AnalyticEntityResponse', data?: { __typename?: 'AnalyticEntity', id?: string | null, attributes?: { __typename?: 'Analytic', default_dashboard?: string | null } | null } | null } | null };

export type BaoverifierAppQueryVariables = Exact<{ [key: string]: never; }>;


export type BaoverifierAppQuery = { __typename?: 'Query', baoverifierApp?: { __typename?: 'BaoverifierAppEntityResponse', data?: { __typename?: 'BaoverifierAppEntity', id?: string | null } | null } | null };

export type CanDeactivateCategoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CanDeactivateCategoryQuery = { __typename?: 'Query', canDeactivateCategory?: boolean | null };

export type CanEditTaskQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CanEditTaskQuery = { __typename?: 'Query', canEditTask?: boolean | null };

export type CountCommunityMembersQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type CountCommunityMembersQuery = { __typename?: 'Query', countCommunityMembers?: number | null };

export type CountCompanyCommunitiesQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type CountCompanyCommunitiesQuery = { __typename?: 'Query', countCompanyCommunities?: number | null };

export type CountCompanyMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type CountCompanyMembersQuery = { __typename?: 'Query', countCompanyMembers?: number | null };

export type CountCompanyProjectsQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type CountCompanyProjectsQuery = { __typename?: 'Query', countCompanyProjects?: number | null };

export type CountRidersQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type CountRidersQuery = { __typename?: 'Query', countRiders?: number | null };

export type CountTaskTypesQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type CountTaskTypesQuery = { __typename?: 'Query', getCompanyTaskTypesCount?: number | null };

export type CountTasksQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type CountTasksQuery = { __typename?: 'Query', countTasks?: number | null };

export type CountTasksByStatusQueryVariables = Exact<{
  filters?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type CountTasksByStatusQuery = { __typename?: 'Query', countTasksByStatus?: any | null };

export type CountTasksWithTrendQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type CountTasksWithTrendQuery = { __typename?: 'Query', countTasksWithTrend?: { __typename?: 'TaskCountWithTrend', count?: number | null, trend?: { __typename?: 'Trend', trend?: number | null, count?: number | null, previousMonthCount?: number | null, percentage?: number | null } | null } | null };

export type FindDataListOptionWithCountQueryVariables = Exact<{
  orderBy?: InputMaybe<Scalars['JSON']['input']>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type FindDataListOptionWithCountQuery = { __typename?: 'Query', findDataListOptionWithCount?: { __typename?: 'DataListOptionWithCount', count?: number | null, data?: Array<{ __typename?: 'DataListOptionEntity', id?: string | null, attributes?: { __typename?: 'DataListOption', createdAt?: any | null, status?: Enum_Datalistoption_Status | null, updatedAt?: any | null, value: string, publishedAt?: any | null, data_list?: { __typename?: 'DataListEntityResponse', data?: { __typename?: 'DataListEntity', id?: string | null, attributes?: { __typename?: 'DataList', name: string, createdAt?: any | null, updatedAt?: any | null, status?: Enum_Datalist_Status | null, publishedAt?: any | null } | null } | null } | null } | null } | null> | null } | null };

export type GetAdminNotificationsCountQueryVariables = Exact<{
  filters?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetAdminNotificationsCountQuery = { __typename?: 'Query', getAdminNotificationsCount?: number | null };

export type GetAllInvoicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllInvoicesQuery = { __typename?: 'Query', getAllInvoices?: Array<{ __typename?: 'InvoicePayload', id?: string | null, currency?: string | null, customer?: string | null, created?: any | null, ending_balance?: number | null, hosted_invoice_url?: string | null, invoice_pdf?: string | null, paid?: boolean | null, status?: string | null, subscription?: string | null, lines?: any | null, number?: string | null } | null> | null };

export type GetAllProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProductsQuery = { __typename?: 'Query', getAllProducts?: Array<{ __typename?: 'Products', id?: string | null, name?: string | null, statement_descriptor?: string | null, metadata?: { __typename?: 'ProductMetaData', baoriders_allowed?: number | null, baoriders_cost?: number | null } | null, prices?: Array<{ __typename?: 'Prices', id?: string | null, nickname?: string | null, currency?: string | null, unit_amount?: number | null, unit_amount_decimal?: number | null, recurring?: { __typename?: 'Recurring', interval?: string | null, interval_count?: number | null } | null } | null> | null } | null> | null };

export type GetCommunitiesLiteQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetCommunitiesLiteQuery = { __typename?: 'Query', getBaoleaderCommunities?: Array<{ __typename?: 'CommunityEntity', id?: string | null, attributes?: { __typename?: 'Community', name?: string | null } | null } | null> | null };

export type GetBaoleaderProjectsCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBaoleaderProjectsCategoriesQuery = { __typename?: 'Query', getBaoleaderProjectsCategories?: Array<{ __typename?: 'CategorySet', id: string, title: string } | null> | null };

export type GetBaoleaderTaskQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetBaoleaderTaskQuery = { __typename?: 'Query', getBaoleaderTask?: { __typename?: 'TaskEntity', id?: string | null, attributes?: { __typename?: 'Task', createdAt?: any | null, updatedAt?: any | null, status?: Enum_Task_Status | null, date_reported?: any | null, location?: any | null, onlyEmployeesVerify?: boolean | null, task_origin?: Enum_Task_Task_Origin | null, edit_from?: { __typename?: 'TaskEntityResponse', data?: { __typename?: 'TaskEntity', id?: string | null } | null } | null, documents?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null }> } | null, task_definition?: { __typename?: 'TaskDefinitionEntityResponse', data?: { __typename?: 'TaskDefinitionEntity', id?: string | null, attributes?: { __typename?: 'TaskDefinition', category?: { __typename?: 'CategoryEntityResponse', data?: { __typename?: 'CategoryEntity', id?: string | null, attributes?: { __typename?: 'Category', title?: string | null, description?: string | null, status?: Enum_Category_Status | null, createdAt?: any | null, updatedAt?: any | null, featureImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null } | null } | null, task_type?: { __typename?: 'TaskTypeEntityResponse', data?: { __typename?: 'TaskTypeEntity', id?: string | null, attributes?: { __typename?: 'TaskType', title?: string | null, reportingDateField?: string | null, photoEvidence?: string | null, documentedEvidence?: string | null, environmentalImpact?: string | null, socialImpact?: string | null, status?: Enum_Tasktype_Status | null, createdAt?: any | null, updatedAt?: any | null, withComment?: boolean | null, photoRequired?: boolean | null } | null } | null } | null } | null } | null } | null, community?: { __typename?: 'CommunityEntityResponse', data?: { __typename?: 'CommunityEntity', id?: string | null, attributes?: { __typename?: 'Community', createdAt?: any | null, updatedAt?: any | null, name?: string | null, type?: Enum_Community_Type | null, description?: string | null, chief_name?: string | null, location?: any | null, featured_image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null } | null } | null, project?: { __typename?: 'ProjectEntityResponse', data?: { __typename?: 'ProjectEntity', id?: string | null, attributes?: { __typename?: 'Project', breakdown?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, collaborators?: any | null, reward?: string | null, status?: Enum_Project_Status | null, statement?: string | null, description?: string | null, outcomes?: string | null, budget?: string | null, featured_image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null } | null } | null, evidences?: { __typename?: 'EvidenceRelationResponseCollection', data: Array<{ __typename?: 'EvidenceEntity', id?: string | null, attributes?: { __typename?: 'Evidence', notes?: string | null, location?: string | null, createdAt?: any | null, updatedAt?: any | null, upload_state?: Enum_Evidence_Upload_State | null, cancellationReason?: string | null, requestedInfo?: string | null, custom_data_fields?: Array<{ __typename: 'ComponentCustomDataFieldsCheckbox', id: string, isRequired?: boolean | null, label?: string | null, option?: Array<{ __typename?: 'ComponentComboFieldOption', id: string, option?: string | null } | null> | null } | { __typename: 'ComponentCustomDataFieldsDataList', id: string, label?: string | null, isRequired?: boolean | null, listId: string, option?: Array<{ __typename?: 'ComponentComboFieldOption', id: string, option?: string | null } | null> | null } | { __typename: 'ComponentCustomDataFieldsDateTimeField', id: string, label?: string | null, isRequired?: boolean | null, datetime?: any | null } | { __typename: 'ComponentCustomDataFieldsEmailField', id: string, label?: string | null, isRequired?: boolean | null, email?: string | null } | { __typename: 'ComponentCustomDataFieldsImageField', id: string, isRequired?: boolean | null, label?: string | null, upload_state?: Enum_Componentcustomdatafieldsimagefield_Upload_State | null, images?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null }> } | null } | { __typename: 'ComponentCustomDataFieldsMetricsSpecific', id: string, label?: string | null, min?: any | null, max?: any | null, isRequired?: boolean | null, metric?: string | null, number_value?: string | null } | { __typename: 'ComponentCustomDataFieldsNumberDropDown', id: string, label?: string | null, value?: any | null, isRequired?: boolean | null, max?: any | null, min?: any | null } | { __typename: 'ComponentCustomDataFieldsNumberField', id: string, label?: string | null, min?: any | null, max?: any | null, isRequired?: boolean | null, number_field_value?: string | null } | { __typename: 'ComponentCustomDataFieldsNumberRange', id: string, label?: string | null, min?: any | null, isRequired?: boolean | null, max?: any | null } | { __typename: 'ComponentCustomDataFieldsPercentage', id: string, label?: string | null, isRequired?: boolean | null, value?: any | null } | { __typename: 'ComponentCustomDataFieldsPhoneNumberField', id: string, label?: string | null, isRequired?: boolean | null, phoneNumber?: string | null } | { __typename: 'ComponentCustomDataFieldsRadio', id: string, label?: string | null, isRequired?: boolean | null, option?: Array<{ __typename?: 'ComponentComboFieldOption', id: string, option?: string | null } | null> | null } | { __typename: 'ComponentCustomDataFieldsRating', id: string, label?: string | null, rating?: number | null, isRequired?: boolean | null, number_of_stars?: any | null } | { __typename: 'ComponentCustomDataFieldsSelect', id: string, isRequired?: boolean | null, label?: string | null, option?: Array<{ __typename: 'ComponentComboFieldOption', id: string, option?: string | null } | null> | null } | { __typename: 'ComponentCustomDataFieldsText', id: string, label?: string | null, isRequired?: boolean | null, text_value?: string | null } | { __typename: 'Error' } | null> | null, photos?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null }> } | null, data_field_values?: { __typename?: 'TaskDataLabelValueRelationResponseCollection', data: Array<{ __typename?: 'TaskDataLabelValueEntity', id?: string | null, attributes?: { __typename?: 'TaskDataLabelValue', value?: string | null, data_field?: { __typename?: 'CustomDataLabelEntityResponse', data?: { __typename?: 'CustomDataLabelEntity', id?: string | null, attributes?: { __typename?: 'CustomDataLabel', label?: string | null } | null } | null } | null, baorider?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null } | null } | null } | null }> } | null, baorider?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName: string, lastName: string, status?: Enum_Userspermissionsuser_Status | null, phoneNumber?: string | null, createdAt?: any | null, updatedAt?: any | null, gender?: Enum_Userspermissionsuser_Gender | null, idNumber?: string | null, blocked?: boolean | null, dateOfBirth?: any | null, location_permission?: boolean | null, camera_permission?: boolean | null, media_library_permission?: boolean | null, isVerifier?: boolean | null, email: string, baoleader?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null } | null } | null, profilePicture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null, role?: { __typename?: 'UsersPermissionsRoleEntityResponse', data?: { __typename?: 'UsersPermissionsRoleEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsRole', name: string, type?: string | null } | null } | null } | null, community?: { __typename?: 'CommunityEntityResponse', data?: { __typename?: 'CommunityEntity', id?: string | null, attributes?: { __typename?: 'Community', createdAt?: any | null, updatedAt?: any | null, name?: string | null, type?: Enum_Community_Type | null, description?: string | null, chief_name?: string | null, location?: any | null, featured_image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null } | null } | null } | null } | null } | null } | null }> } | null } | null } | null };

export type GetBaoleaderTaskDefinitionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetBaoleaderTaskDefinitionQuery = { __typename?: 'Query', getBaoleaderTaskDefinition?: { __typename?: 'TaskDefinitionEntity', id?: string | null, attributes?: { __typename?: 'TaskDefinition', status?: Enum_Taskdefinition_Status | null, project?: { __typename?: 'ProjectEntityResponse', data?: { __typename?: 'ProjectEntity', id?: string | null, attributes?: { __typename?: 'Project', name?: string | null, featured_image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null } | null } | null, category?: { __typename?: 'CategoryEntityResponse', data?: { __typename?: 'CategoryEntity', id?: string | null, attributes?: { __typename?: 'Category', title?: string | null, description?: string | null, featureImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null } | null } | null, task_type?: { __typename?: 'TaskTypeEntityResponse', data?: { __typename?: 'TaskTypeEntity', id?: string | null, attributes?: { __typename?: 'TaskType', title?: string | null, photoEvidence?: string | null, documentedEvidence?: string | null, environmentalImpact?: string | null, socialImpact?: string | null } | null } | null } | null } | null } | null };

export type GetBaoleaderTaskDefinitionsCountQueryVariables = Exact<{
  filters?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetBaoleaderTaskDefinitionsCountQuery = { __typename?: 'Query', getBaoleaderTaskDefinitionsCount?: number | null };

export type GetBaoridersQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetBaoridersQuery = { __typename?: 'Query', getBaoriders?: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', idNumber?: string | null, phoneNumber?: string | null, firstName: string, isVerifier?: boolean | null, lastName: string, status?: Enum_Userspermissionsuser_Status | null, createdAt?: any | null, updatedAt?: any | null, profilePicture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null, projects?: { __typename?: 'ProjectRelationResponseCollection', data: Array<{ __typename?: 'ProjectEntity', id?: string | null, attributes?: { __typename?: 'Project', breakdown?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, collaborators?: any | null, reward?: string | null, status?: Enum_Project_Status | null, statement?: string | null, description?: string | null, outcomes?: string | null, budget?: string | null } | null }> } | null, community?: { __typename?: 'CommunityEntityResponse', data?: { __typename?: 'CommunityEntity', id?: string | null, attributes?: { __typename?: 'Community', createdAt?: any | null, updatedAt?: any | null, name?: string | null, type?: Enum_Community_Type | null, description?: string | null, chief_name?: string | null, location?: any | null } | null } | null } | null } | null } | null> | null };

export type GetCategoriesQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetCategoriesQuery = { __typename?: 'Query', getCategories?: Array<{ __typename?: 'CategoryEntity', id?: string | null, attributes?: { __typename?: 'Category', title?: string | null, description?: string | null, status?: Enum_Category_Status | null, createdAt?: any | null, updatedAt?: any | null, featureImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null, task_types?: { __typename?: 'TaskTypeRelationResponseCollection', data: Array<{ __typename?: 'TaskTypeEntity', id?: string | null, attributes?: { __typename?: 'TaskType', title?: string | null, reportingDateField?: string | null, photoEvidence?: string | null, documentedEvidence?: string | null, environmentalImpact?: string | null, socialImpact?: string | null, status?: Enum_Tasktype_Status | null, createdAt?: any | null, updatedAt?: any | null, withComment?: boolean | null, photoRequired?: boolean | null } | null }> } | null } | null } | null> | null };

export type GetCommunityVerifiersQueryVariables = Exact<{
  communityId: Scalars['ID']['input'];
}>;


export type GetCommunityVerifiersQuery = { __typename?: 'Query', getCommunityVerifiers?: { __typename?: 'MultipleCommunityMembersPayload', members?: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName: string, lastName: string, status?: Enum_Userspermissionsuser_Status | null, phoneNumber?: string | null, createdAt?: any | null, updatedAt?: any | null, gender?: Enum_Userspermissionsuser_Gender | null, idNumber?: string | null, blocked?: boolean | null, dateOfBirth?: any | null, location_permission?: boolean | null, camera_permission?: boolean | null, media_library_permission?: boolean | null, isVerifier?: boolean | null, email: string, baoleader?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null } | null } | null, profilePicture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null, role?: { __typename?: 'UsersPermissionsRoleEntityResponse', data?: { __typename?: 'UsersPermissionsRoleEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsRole', name: string, type?: string | null } | null } | null } | null, community?: { __typename?: 'CommunityEntityResponse', data?: { __typename?: 'CommunityEntity', id?: string | null, attributes?: { __typename?: 'Community', createdAt?: any | null, updatedAt?: any | null, name?: string | null, type?: Enum_Community_Type | null, description?: string | null, chief_name?: string | null, location?: any | null, featured_image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null } | null } | null } | null } | null> | null } | null };

export type GetCommunitiesQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetCommunitiesQuery = { __typename?: 'Query', getBaoleaderCommunities?: Array<{ __typename?: 'CommunityEntity', id?: string | null, attributes?: { __typename?: 'Community', createdAt?: any | null, updatedAt?: any | null, name?: string | null, type?: Enum_Community_Type | null, description?: string | null, chief_name?: string | null, location?: any | null, featured_image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null } | null> | null };

export type GetCommunityQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCommunityQuery = { __typename?: 'Query', getBaoleaderCommunity?: { __typename?: 'CommunityEntity', id?: string | null, attributes?: { __typename?: 'Community', name?: string | null, chief_name?: string | null, description?: string | null, location?: any | null, updatedAt?: any | null, createdAt?: any | null, featured_image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null, baoleader?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null } | null } | null } | null } | null };

export type GetCommunityBaoridersQueryVariables = Exact<{
  communityId: Scalars['ID']['input'];
}>;


export type GetCommunityBaoridersQuery = { __typename?: 'Query', getCommunityBaoriders?: { __typename?: 'MultipleCommunityMembersPayload', members?: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName: string, lastName: string, status?: Enum_Userspermissionsuser_Status | null, phoneNumber?: string | null, createdAt?: any | null, updatedAt?: any | null, gender?: Enum_Userspermissionsuser_Gender | null, idNumber?: string | null, blocked?: boolean | null, dateOfBirth?: any | null, location_permission?: boolean | null, camera_permission?: boolean | null, media_library_permission?: boolean | null, isVerifier?: boolean | null, email: string, baoleader?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null } | null } | null, profilePicture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null, role?: { __typename?: 'UsersPermissionsRoleEntityResponse', data?: { __typename?: 'UsersPermissionsRoleEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsRole', name: string, type?: string | null } | null } | null } | null, community?: { __typename?: 'CommunityEntityResponse', data?: { __typename?: 'CommunityEntity', id?: string | null, attributes?: { __typename?: 'Community', createdAt?: any | null, updatedAt?: any | null, name?: string | null, type?: Enum_Community_Type | null, description?: string | null, chief_name?: string | null, location?: any | null, featured_image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null } | null } | null } | null } | null> | null } | null };

export type GetCommunityMembersQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetCommunityMembersQuery = { __typename?: 'Query', getCommunityMembers?: { __typename?: 'MultipleCommunityMembersPayload', members?: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName: string, lastName: string, status?: Enum_Userspermissionsuser_Status | null, phoneNumber?: string | null, createdAt?: any | null, updatedAt?: any | null, gender?: Enum_Userspermissionsuser_Gender | null, idNumber?: string | null, blocked?: boolean | null, dateOfBirth?: any | null, location_permission?: boolean | null, camera_permission?: boolean | null, media_library_permission?: boolean | null, isVerifier?: boolean | null, email: string, baoleader?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null } | null } | null, profilePicture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null, role?: { __typename?: 'UsersPermissionsRoleEntityResponse', data?: { __typename?: 'UsersPermissionsRoleEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsRole', name: string, type?: string | null } | null } | null } | null, community?: { __typename?: 'CommunityEntityResponse', data?: { __typename?: 'CommunityEntity', id?: string | null, attributes?: { __typename?: 'Community', createdAt?: any | null, updatedAt?: any | null, name?: string | null, type?: Enum_Community_Type | null, description?: string | null, chief_name?: string | null, location?: any | null, featured_image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null } | null } | null } | null } | null> | null } | null };

export type GetCommunityProjectsQueryVariables = Exact<{
  community: Scalars['ID']['input'];
}>;


export type GetCommunityProjectsQuery = { __typename?: 'Query', getCommunityProjects?: Array<{ __typename?: 'ProjectEntity', id?: string | null, attributes?: { __typename?: 'Project', breakdown?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, collaborators?: any | null, reward?: string | null, status?: Enum_Project_Status | null, statement?: string | null, description?: string | null, outcomes?: string | null, budget?: string | null, featured_image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null } | null> | null };

export type GetCommunityProjectsCountQueryVariables = Exact<{
  community: Scalars['ID']['input'];
}>;


export type GetCommunityProjectsCountQuery = { __typename?: 'Query', getCommunityProjectsCount?: number | null };

export type GetCompanyCategoriesQueryVariables = Exact<{
  where?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCompanyCategoriesQuery = { __typename?: 'Query', getCompanyCategories?: Array<{ __typename?: 'CategoryEntity', id?: string | null, attributes?: { __typename?: 'Category', title?: string | null, description?: string | null, status?: Enum_Category_Status | null, createdAt?: any | null, updatedAt?: any | null, featureImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null } | null> | null };

export type GetCompanyInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyInfoQuery = { __typename?: 'Query', getCompanyInfo?: { __typename?: 'Company', name?: string | null, pin_registration?: string | null, website?: string | null, affiliates?: any | null, paymentMethod?: string | null, default_dashboard?: string | null, onboardingInformation?: any | null, id_number?: string | null, wildlife_association_number?: string | null, createdAt?: any | null, updatedAt?: any | null, subscription?: { __typename?: 'SubscriptionEntityResponse', data?: { __typename?: 'SubscriptionEntity', id?: string | null, attributes?: { __typename?: 'Subscription', createdAt?: any | null, updatedAt?: any | null, current_period_start?: any | null, current_period_end?: any | null, cancel_at?: any | null, trial_start?: any | null, collection_method: Enum_Subscription_Collection_Method, cancel_at_period_end?: boolean | null, recurring: Enum_Subscription_Recurring, trial_end?: any | null, status: Enum_Subscription_Status, product_plan?: { __typename?: 'ProductPlanEntityResponse', data?: { __typename?: 'ProductPlanEntity', id?: string | null, attributes?: { __typename?: 'ProductPlan', name?: string | null, isManual?: boolean | null, description?: string | null, ProductFeature?: { __typename?: 'ComponentProductFeatureProductFeature', id: string, baoriders_allowed?: number | null, cost_per_baorider?: number | null, price?: any | null, recurring?: Enum_Componentproductfeatureproductfeature_Recurring | null } | null } | null } | null } | null } | null } | null } | null, team_members?: { __typename?: 'UsersPermissionsUserRelationResponseCollection', data: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName: string, lastName: string, status?: Enum_Userspermissionsuser_Status | null, phoneNumber?: string | null, createdAt?: any | null, updatedAt?: any | null, gender?: Enum_Userspermissionsuser_Gender | null, idNumber?: string | null, blocked?: boolean | null, dateOfBirth?: any | null, location_permission?: boolean | null, camera_permission?: boolean | null, media_library_permission?: boolean | null, isVerifier?: boolean | null, email: string, baoleader?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null } | null } | null, profilePicture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null, role?: { __typename?: 'UsersPermissionsRoleEntityResponse', data?: { __typename?: 'UsersPermissionsRoleEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsRole', name: string, type?: string | null } | null } | null } | null, community?: { __typename?: 'CommunityEntityResponse', data?: { __typename?: 'CommunityEntity', id?: string | null, attributes?: { __typename?: 'Community', createdAt?: any | null, updatedAt?: any | null, name?: string | null, type?: Enum_Community_Type | null, description?: string | null, chief_name?: string | null, location?: any | null, featured_image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null } | null } | null } | null }> } | null } | null };

export type GetCompanyInfoLiteQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyInfoLiteQuery = { __typename?: 'Query', getCompanyInfo?: { __typename?: 'Company', name?: string | null, pin_registration?: string | null, website?: string | null, affiliates?: any | null, paymentMethod?: string | null, default_dashboard?: string | null, id_number?: string | null, wildlife_association_number?: string | null, createdAt?: any | null, updatedAt?: any | null, subscription?: { __typename?: 'SubscriptionEntityResponse', data?: { __typename?: 'SubscriptionEntity', id?: string | null, attributes?: { __typename?: 'Subscription', createdAt?: any | null, updatedAt?: any | null, current_period_start?: any | null, current_period_end?: any | null, cancel_at?: any | null, trial_start?: any | null, collection_method: Enum_Subscription_Collection_Method, cancel_at_period_end?: boolean | null, recurring: Enum_Subscription_Recurring, currency?: Enum_Subscription_Currency | null, trial_end?: any | null, status: Enum_Subscription_Status, product_plan?: { __typename?: 'ProductPlanEntityResponse', data?: { __typename?: 'ProductPlanEntity', id?: string | null, attributes?: { __typename?: 'ProductPlan', name?: string | null, isManual?: boolean | null, description?: string | null, ProductFeature?: { __typename?: 'ComponentProductFeatureProductFeature', id: string, baoriders_allowed?: number | null, cost_per_baorider?: number | null, price?: any | null, recurring?: Enum_Componentproductfeatureproductfeature_Recurring | null } | null } | null } | null } | null } | null } | null } | null } | null };

export type GetCompanyLeadersQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetCompanyLeadersQuery = { __typename?: 'Query', getCompanyLeaders?: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName: string, lastName: string, status?: Enum_Userspermissionsuser_Status | null, phoneNumber?: string | null, createdAt?: any | null, updatedAt?: any | null, gender?: Enum_Userspermissionsuser_Gender | null, idNumber?: string | null, blocked?: boolean | null, dateOfBirth?: any | null, location_permission?: boolean | null, camera_permission?: boolean | null, media_library_permission?: boolean | null, isVerifier?: boolean | null, email: string, baoleader?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null } | null } | null, profilePicture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null, role?: { __typename?: 'UsersPermissionsRoleEntityResponse', data?: { __typename?: 'UsersPermissionsRoleEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsRole', name: string, type?: string | null } | null } | null } | null, community?: { __typename?: 'CommunityEntityResponse', data?: { __typename?: 'CommunityEntity', id?: string | null, attributes?: { __typename?: 'Community', createdAt?: any | null, updatedAt?: any | null, name?: string | null, type?: Enum_Community_Type | null, description?: string | null, chief_name?: string | null, location?: any | null, featured_image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null } | null } | null } | null } | null> | null };

export type GetCompanyLeadersCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyLeadersCountQuery = { __typename?: 'Query', getCompanyLeadersCount?: number | null };

export type GetCompanyOnlyCategoriesQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetCompanyOnlyCategoriesQuery = { __typename?: 'Query', getCompanyOnlyCategories?: { __typename?: 'CategorysWithCount', count?: number | null, categories?: Array<{ __typename?: 'CategoryEntity', id?: string | null, attributes?: { __typename?: 'Category', title?: string | null, description?: string | null, status?: Enum_Category_Status | null, createdAt?: any | null, updatedAt?: any | null, featureImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null, task_types?: { __typename?: 'TaskTypeRelationResponseCollection', data: Array<{ __typename?: 'TaskTypeEntity', id?: string | null }> } | null } | null } | null> | null } | null };

export type GetCompanyTaskTypesQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetCompanyTaskTypesQuery = { __typename?: 'Query', getCompanyTaskTypes?: Array<{ __typename?: 'TaskTypeEntity', id?: string | null, attributes?: { __typename?: 'TaskType', title?: string | null, reportingDateField?: string | null, photoEvidence?: string | null, documentedEvidence?: string | null, environmentalImpact?: string | null, socialImpact?: string | null, status?: Enum_Tasktype_Status | null, createdAt?: any | null, updatedAt?: any | null, withComment?: boolean | null, photoRequired?: boolean | null, category?: { __typename?: 'CategoryEntityResponse', data?: { __typename?: 'CategoryEntity', id?: string | null, attributes?: { __typename?: 'Category', title?: string | null, description?: string | null, status?: Enum_Category_Status | null, createdAt?: any | null, updatedAt?: any | null, featureImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null } | null } | null } | null } | null> | null };

export type GetCountDataListsQueryVariables = Exact<{
  filters?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetCountDataListsQuery = { __typename?: 'Query', getCountDataLists?: number | null };

export type GetCustomerPaymentDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomerPaymentDetailsQuery = { __typename?: 'Query', getCustomerPaymentDetails?: Array<{ __typename?: 'CardPayload', id?: string | null, brand?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null, isDefault?: boolean | null } | null> | null };

export type GetDataListsQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetDataListsQuery = { __typename?: 'Query', getDataLists?: Array<{ __typename?: 'DataListEntity', id?: string | null, attributes?: { __typename?: 'DataList', name: string, createdAt?: any | null, updatedAt?: any | null, status?: Enum_Datalist_Status | null, publishedAt?: any | null } | null } | null> | null };

export type GetInsightAiAnalysisQueryVariables = Exact<{
  taskDefinitionIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  columns?: InputMaybe<Scalars['JSON']['input']>;
  aggregation?: InputMaybe<Scalars['String']['input']>;
  timeSeries?: InputMaybe<Scalars['String']['input']>;
  recordCount?: InputMaybe<Scalars['Int']['input']>;
  selectedColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  messages?: InputMaybe<Array<InputMaybe<InsightAiMessageInput>> | InputMaybe<InsightAiMessageInput>>;
  dataSummary?: InputMaybe<Scalars['JSON']['input']>;
  dateRange?: InputMaybe<DateRangeInput>;
  dateSource?: InputMaybe<Scalars['String']['input']>;
  dateInfo?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetInsightAiAnalysisQuery = { __typename?: 'Query', getInsightAIAnalysis?: { __typename?: 'InsightAIResponse', message?: string | null, suggestedChartType?: string | null, suggestedColumns?: Array<string | null> | null, reportPlan?: any | null, suggestions?: Array<{ __typename?: 'InsightAISuggestion', label?: string | null, prompt?: string | null } | null> | null } | null };

export type GetInsightReportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetInsightReportQuery = { __typename?: 'Query', getInsightReport?: { __typename?: 'InsightReportEntity', id?: string | null, attributes?: { __typename?: 'InsightReport', name: string, description?: string | null, status?: Enum_Insightreport_Status | null, graphs?: any | null, createdAt?: any | null, updatedAt?: any | null } | null } | null };

export type GetInsightReportsQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetInsightReportsQuery = { __typename?: 'Query', getInsightReports?: Array<{ __typename?: 'InsightReportEntity', id?: string | null, attributes?: { __typename?: 'InsightReport', name: string, description?: string | null, status?: Enum_Insightreport_Status | null, graphs?: any | null, createdAt?: any | null, updatedAt?: any | null } | null } | null> | null };

export type GetInsightReportsCountQueryVariables = Exact<{
  filters?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetInsightReportsCountQuery = { __typename?: 'Query', getInsightReportsCount?: number | null };

export type GetInsightTaskDataQueryVariables = Exact<{
  taskDefinitionId?: InputMaybe<Scalars['ID']['input']>;
  taskDefinitionIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  dateRange?: InputMaybe<DateRangeInput>;
  dateSource?: InputMaybe<Scalars['String']['input']>;
  timeSeries?: InputMaybe<Scalars['String']['input']>;
  aggregation?: InputMaybe<Scalars['String']['input']>;
  selectedColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Array<InsightAgentFilterInput> | InsightAgentFilterInput>;
  groupBy?: InputMaybe<Scalars['String']['input']>;
  compareYears?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetInsightTaskDataQuery = { __typename?: 'Query', getInsightTaskData?: { __typename?: 'InsightTaskData', rows?: any | null, aggregatedData?: any | null, totalRows?: number | null, dateInfo?: any | null, columns?: Array<{ __typename?: 'InsightColumn', key?: string | null, label?: string | null, type?: string | null, version?: number | null, isFromOlderVersion?: boolean | null, taskTypeName?: string | null, taskTypeId?: string | null } | null> | null } | null };

export type GetInsightTaskDefinitionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInsightTaskDefinitionsQuery = { __typename?: 'Query', getInsightTaskDefinitions?: Array<{ __typename?: 'TaskDefinitionEntity', id?: string | null, attributes?: { __typename?: 'TaskDefinition', status?: Enum_Taskdefinition_Status | null, task_type?: { __typename?: 'TaskTypeEntityResponse', data?: { __typename?: 'TaskTypeEntity', id?: string | null, attributes?: { __typename?: 'TaskType', title?: string | null } | null } | null } | null, project?: { __typename?: 'ProjectEntityResponse', data?: { __typename?: 'ProjectEntity', id?: string | null, attributes?: { __typename?: 'Project', name?: string | null } | null } | null } | null } | null } | null> | null };

export type GetMapTasksQueryVariables = Exact<{
  filters?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetMapTasksQuery = { __typename?: 'Query', getMapTasks?: any | null };

export type GetMyFeatureAccessQueryVariables = Exact<{
  feature?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMyFeatureAccessQuery = { __typename?: 'Query', getMyFeatureAccess?: { __typename?: 'FeatureAccessPayload', feature?: string | null, hasAccess?: boolean | null, source?: string | null, accessEndsAt?: any | null, showCountdown?: boolean | null, requiresMigration?: boolean | null, migrationDeadline?: any | null, isManual?: boolean | null } | null };

export type GetMyFeatureUnlocksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyFeatureUnlocksQuery = { __typename?: 'Query', getMyFeatureUnlocks?: Array<{ __typename?: 'FeatureUnlockPayload', feature?: string | null, expiresAt?: any | null, active?: boolean | null } | null> | null };

export type GetNotificationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetNotificationQuery = { __typename?: 'Query', getAdminNotification?: { __typename?: 'NotificationEntity', id?: string | null, attributes?: { __typename?: 'Notification', title?: string | null, message?: string | null, type?: Enum_Notification_Type | null, status?: Enum_Notification_Status | null, dateSent?: any | null, action?: any | null, recur?: Enum_Notification_Recur | null, timezone?: string | null, createdAt?: any | null, updatedAt?: any | null, nextScheduledNotificationDetails?: { __typename?: 'NotificationScheduledDetails', id?: string | null, sendAt?: any | null, endAt?: any | null, recur?: Enum_Schedulednotification_Recur | null, status?: Enum_Schedulednotification_Status | null, priority?: Enum_Schedulednotification_Priority | null } | null, attachment?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, recipients?: { __typename?: 'UsersPermissionsUserRelationResponseCollection', data: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null }> } | null } | null } | null };

export type GetNotificationRecipientsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetNotificationRecipientsQuery = { __typename?: 'Query', notification?: { __typename?: 'NotificationEntityResponse', data?: { __typename?: 'NotificationEntity', id?: string | null, attributes?: { __typename?: 'Notification', recipients?: { __typename?: 'UsersPermissionsUserRelationResponseCollection', data: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', username: string, email: string, phoneNumber?: string | null } | null }> } | null } | null } | null } | null };

export type GetNotificationsQueryVariables = Exact<{
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetNotificationsQuery = { __typename?: 'Query', getAdminNotifications?: Array<{ __typename?: 'NotificationEntity', id?: string | null, attributes?: { __typename?: 'Notification', title?: string | null, message?: string | null, type?: Enum_Notification_Type | null, status?: Enum_Notification_Status | null, dateSent?: any | null, recur?: Enum_Notification_Recur | null, timezone?: string | null, createdAt?: any | null, updatedAt?: any | null, attachment?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, nextScheduledNotificationDetails?: { __typename?: 'NotificationScheduledDetails', id?: string | null, sendAt?: any | null, endAt?: any | null, recur?: Enum_Schedulednotification_Recur | null, status?: Enum_Schedulednotification_Status | null, priority?: Enum_Schedulednotification_Priority | null } | null, recipients?: { __typename?: 'UsersPermissionsUserRelationResponseCollection', data: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName: string, lastName: string, email: string } | null }> } | null } | null } | null> | null };

export type GetNumberOfTasksPerDataCollectorQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetNumberOfTasksPerDataCollectorQuery = { __typename?: 'Query', getNumberOfTasksPerDataCollector?: Array<{ __typename?: 'TaskPer', name?: string | null, count?: number | null } | null> | null };

export type GetNumberOfTasksPerDayQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetNumberOfTasksPerDayQuery = { __typename?: 'Query', getNumberOfTasksPerDay?: Array<{ __typename?: 'TaskPer', name?: string | null, count?: number | null } | null> | null };

export type GetNumberOfTasksPerMonthQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetNumberOfTasksPerMonthQuery = { __typename?: 'Query', getNumberOfTasksPerMonth?: Array<{ __typename?: 'TaskPer', name?: string | null, count?: number | null } | null> | null };

export type GetNumberOfTasksPerProjectQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetNumberOfTasksPerProjectQuery = { __typename?: 'Query', getNumberOfTasksPerProject?: Array<{ __typename?: 'TaskPer', name?: string | null, count?: number | null } | null> | null };

export type GetNumberOfTasksPerSdgQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetNumberOfTasksPerSdgQuery = { __typename?: 'Query', getNumberOfTasksPerSDG?: Array<{ __typename?: 'TaskPer', name?: string | null, count?: number | null } | null> | null };

export type GetNumberOfTasksPerTagQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetNumberOfTasksPerTagQuery = { __typename?: 'Query', getNumberOfTasksPerTag?: Array<{ __typename?: 'TaskPer', name?: string | null, count?: number | null } | null> | null };

export type GetNumberOfTasksPerTaskTypeQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetNumberOfTasksPerTaskTypeQuery = { __typename?: 'Query', getNumberOfTasksPerTaskType?: Array<{ __typename?: 'TaskPer', name?: string | null, count?: number | null } | null> | null };

export type GetNumberOfTasksPerTaskTypeCollapsedQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetNumberOfTasksPerTaskTypeCollapsedQuery = { __typename?: 'Query', getNumberOfTasksPerTaskTypeCollapsed?: Array<{ __typename?: 'TaskPer', name?: string | null, count?: number | null } | null> | null };

export type GetNumberOfUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNumberOfUsersQuery = { __typename?: 'Query', getNumberOfUsers?: { __typename?: 'NumberOfDataCollectorsAndAdmins', dataCollectors?: number | null, admins?: number | null } | null };

export type GetProjectQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectQuery = { __typename?: 'Query', getBaoleaderProject?: { __typename?: 'ProjectEntity', id?: string | null, attributes?: { __typename?: 'Project', breakdown?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, collaborators?: any | null, reward?: string | null, status?: Enum_Project_Status | null, statement?: string | null, description?: string | null, outcomes?: string | null, budget?: string | null, featured_image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null } | null };

export type GetProjectDataCollectorsCountQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GetProjectDataCollectorsCountQuery = { __typename?: 'Query', getProjectDataCollectorsCount?: number | null };

export type GetProjectGroupsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GetProjectGroupsQuery = { __typename?: 'Query', getProjectGroups?: Array<{ __typename?: 'CommunityEntity', id?: string | null, attributes?: { __typename?: 'Community', name?: string | null } | null } | null> | null };

export type GetProjectMetricsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProjectMetricsQuery = { __typename?: 'Query', getProjectMetrics?: { __typename?: 'TaskMetrics', completedTasks?: { __typename?: 'Metric', total: number, last30Days: number, chartData?: Array<{ __typename?: 'ChartData', key: string, value: number } | null> | null } | null, reportedTask?: { __typename?: 'Metric', total: number, last30Days: number, chartData?: Array<{ __typename?: 'ChartData', key: string, value: number } | null> | null } | null, averageCompletionTime?: { __typename?: 'AverageMetirc', total: number, wow: number, dod: number } | null, averageEvidenceTime?: { __typename?: 'AverageMetirc', total: number, wow: number, dod: number } | null } | null };

export type GetProjectTaskTypesQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<TaskTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetProjectTaskTypesQuery = { __typename?: 'Query', taskTypes?: { __typename?: 'TaskTypeEntityResponseCollection', data: Array<{ __typename?: 'TaskTypeEntity', id?: string | null, attributes?: { __typename?: 'TaskType', title?: string | null } | null }> } | null };

export type GetProjectUnsdgTagsQueryVariables = Exact<{
  project: Scalars['ID']['input'];
}>;


export type GetProjectUnsdgTagsQuery = { __typename?: 'Query', getProjectUnsdgTags?: Array<string | null> | null };

export type GetProjectsQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetProjectsQuery = { __typename?: 'Query', getBaoleaderProjects?: Array<{ __typename?: 'ProjectEntity', id?: string | null, attributes?: { __typename?: 'Project', breakdown?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, collaborators?: any | null, reward?: string | null, status?: Enum_Project_Status | null, statement?: string | null, description?: string | null, outcomes?: string | null, budget?: string | null, featured_image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null } | null> | null };

export type GetSingleBaoriderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSingleBaoriderQuery = { __typename?: 'Query', getSingleBaorider?: { __typename?: 'BaoriderPayload', baorider?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', idNumber?: string | null, phoneNumber?: string | null, email: string, firstName: string, lastName: string, isVerifier?: boolean | null, status?: Enum_Userspermissionsuser_Status | null, createdAt?: any | null, updatedAt?: any | null, gender?: Enum_Userspermissionsuser_Gender | null, dateOfBirth?: any | null, profilePicture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null, community?: { __typename?: 'CommunityEntityResponse', data?: { __typename?: 'CommunityEntity', id?: string | null, attributes?: { __typename?: 'Community', createdAt?: any | null, updatedAt?: any | null, name?: string | null, type?: Enum_Community_Type | null, description?: string | null, chief_name?: string | null, location?: any | null } | null } | null } | null, projects?: { __typename?: 'ProjectRelationResponseCollection', data: Array<{ __typename?: 'ProjectEntity', id?: string | null, attributes?: { __typename?: 'Project', breakdown?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, collaborators?: any | null, reward?: string | null, status?: Enum_Project_Status | null, statement?: string | null, description?: string | null, outcomes?: string | null, budget?: string | null, featured_image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null }> } | null } | null } | null } | null };

export type GetSingleBaoleaderCommunityQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSingleBaoleaderCommunityQuery = { __typename?: 'Query', getSingleBaoleaderCommunity?: { __typename?: 'CommunityEntity', id?: string | null, attributes?: { __typename?: 'Community', createdAt?: any | null, updatedAt?: any | null, name?: string | null, type?: Enum_Community_Type | null, description?: string | null, chief_name?: string | null, location?: any | null, featured_image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null } | null };

export type GetSingleCommunityMemberQueryVariables = Exact<{
  where?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetSingleCommunityMemberQuery = { __typename?: 'Query', getSingleCommunityMember?: { __typename?: 'CommunityMembersPayload', member?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', idNumber?: string | null, phoneNumber?: string | null, firstName: string, lastName: string, email: string, status?: Enum_Userspermissionsuser_Status | null, createdAt?: any | null, updatedAt?: any | null, gender?: Enum_Userspermissionsuser_Gender | null, dateOfBirth?: any | null, profilePicture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null, community?: { __typename?: 'CommunityEntityResponse', data?: { __typename?: 'CommunityEntity', id?: string | null, attributes?: { __typename?: 'Community', createdAt?: any | null, updatedAt?: any | null, name?: string | null, type?: Enum_Community_Type | null, description?: string | null, chief_name?: string | null, location?: any | null, featured_image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null } | null } | null } | null } | null } | null };

export type GetSingleBaoleaderProjectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSingleBaoleaderProjectQuery = { __typename?: 'Query', getSingleBaoleaderProject?: { __typename?: 'ProjectEntity', id?: string | null, attributes?: { __typename?: 'Project', breakdown?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, collaborators?: any | null, reward?: string | null, status?: Enum_Project_Status | null, statement?: string | null, description?: string | null, outcomes?: string | null, budget?: string | null, featured_image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null } | null };

export type GetSubscriptionPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubscriptionPlansQuery = { __typename?: 'Query', getSubscriptionPlans?: Array<{ __typename?: 'SubscriptionPlan', id?: string | null, name?: string | null, description?: string | null, tagline?: string | null, isPopular?: boolean | null, isDefault?: boolean | null, sortOrder?: number | null, priceId?: string | null, feature?: { __typename?: 'SubscriptionPlanFeature', usersAllowed?: number | null, priceGbp?: number | null, priceUsd?: number | null, priceZar?: number | null, supportHours?: number | null, recurring?: string | null } | null, features?: Array<{ __typename?: 'SubscriptionPlanFeatureItem', label?: string | null, description?: string | null, isHighlighted?: boolean | null, sortOrder?: number | null } | null> | null } | null> | null };

export type GetSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubscriptionQuery = { __typename?: 'Query', getSubscription?: { __typename?: 'SubscriptionPayload', id?: string | null, recurring?: string | null, cancel_at_period_end?: boolean | null, cancel_at?: any | null, collection_method?: string | null, created?: any | null, current_period_end?: any | null, current_period_start?: any | null, customer?: string | null, ended_at?: any | null, latest_invoice?: string | null, status?: string | null, trial_end?: any | null, trial_start?: any | null, items?: any | null, product_plan?: { __typename?: 'ProductPlan', name?: string | null } | null } | null };

export type GetTaskBuilderFilterCategoriesQueryVariables = Exact<{
  where?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTaskBuilderFilterCategoriesQuery = { __typename?: 'Query', getTaskBuilderFilterCategories?: Array<{ __typename?: 'CategoryEntity', id?: string | null, attributes?: { __typename?: 'Category', title?: string | null } | null } | null> | null };

export type GetTaskBuilderFilterCreatorsQueryVariables = Exact<{
  where?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTaskBuilderFilterCreatorsQuery = { __typename?: 'Query', getTaskBuilderFilterCreators?: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName: string, lastName: string } | null } | null> | null };

export type GetTaskFilterCommunitiesQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetTaskFilterCommunitiesQuery = { __typename?: 'Query', getTaskFilterCommunities?: Array<{ __typename?: 'CommunityEntity', id?: string | null, attributes?: { __typename?: 'Community', createdAt?: any | null, updatedAt?: any | null, name?: string | null, type?: Enum_Community_Type | null, description?: string | null, chief_name?: string | null, location?: any | null } | null } | null> | null };

export type GetTaskFilterDataCollectorsQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetTaskFilterDataCollectorsQuery = { __typename?: 'Query', getTaskFilterDataCollectors?: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', idNumber?: string | null, phoneNumber?: string | null, firstName: string, isVerifier?: boolean | null, lastName: string, status?: Enum_Userspermissionsuser_Status | null, createdAt?: any | null, updatedAt?: any | null } | null } | null> | null };

export type GetTaskFilterDataCollectorsCountQueryVariables = Exact<{
  filters?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetTaskFilterDataCollectorsCountQuery = { __typename?: 'Query', getTaskFilterDataCollectorsCount?: number | null };

export type GetTaskFilterProjectsQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetTaskFilterProjectsQuery = { __typename?: 'Query', getTaskFilterProjects?: Array<{ __typename?: 'ProjectEntity', id?: string | null, attributes?: { __typename?: 'Project', breakdown?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, collaborators?: any | null, reward?: string | null, status?: Enum_Project_Status | null, statement?: string | null, description?: string | null, outcomes?: string | null, budget?: string | null } | null } | null> | null };

export type GetTaskFilterTaskTypesQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetTaskFilterTaskTypesQuery = { __typename?: 'Query', getTaskFilterTaskTypes?: Array<{ __typename?: 'TaskTypeEntity', id?: string | null, attributes?: { __typename?: 'TaskType', title?: string | null, reportingDateField?: string | null, photoEvidence?: string | null, documentedEvidence?: string | null, environmentalImpact?: string | null, socialImpact?: string | null, status?: Enum_Tasktype_Status | null, createdAt?: any | null, updatedAt?: any | null, withComment?: boolean | null, photoRequired?: boolean | null } | null } | null> | null };

export type GetTaskFilterUnsdgsQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetTaskFilterUnsdgsQuery = { __typename?: 'Query', getTaskFilterUnsdgs?: Array<{ __typename?: 'UnSdgEntity', id?: string | null, attributes?: { __typename?: 'UnSdg', name?: string | null, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null } | null> | null };

export type GetTaskTypeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTaskTypeQuery = { __typename?: 'Query', getTaskType?: { __typename?: 'TaskTypeEntity', id?: string | null, attributes?: { __typename?: 'TaskType', title?: string | null, reportingDateField?: string | null, photoEvidence?: string | null, documentedEvidence?: string | null, environmentalImpact?: string | null, socialImpact?: string | null, status?: Enum_Tasktype_Status | null, createdAt?: any | null, updatedAt?: any | null, withComment?: boolean | null, photoRequired?: boolean | null, un_sdg?: { __typename?: 'UnSdgEntityResponse', data?: { __typename?: 'UnSdgEntity', id?: string | null, attributes?: { __typename?: 'UnSdg', name?: string | null, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null } | null } | null, category?: { __typename?: 'CategoryEntityResponse', data?: { __typename?: 'CategoryEntity', id?: string | null, attributes?: { __typename?: 'Category', title?: string | null, description?: string | null, status?: Enum_Category_Status | null, createdAt?: any | null, updatedAt?: any | null, featureImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null } | null } | null, creator?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName: string, lastName: string } | null } | null } | null, dataFields?: Array<{ __typename: 'ComponentCustomDataFieldsCheckbox', id: string, isRequired?: boolean | null, label?: string | null, option?: Array<{ __typename?: 'ComponentComboFieldOption', id: string, option?: string | null } | null> | null } | { __typename: 'ComponentCustomDataFieldsDataList', id: string, label?: string | null, isRequired?: boolean | null, listId: string, option?: Array<{ __typename?: 'ComponentComboFieldOption', id: string, option?: string | null } | null> | null } | { __typename: 'ComponentCustomDataFieldsDateTimeField', id: string, label?: string | null, isRequired?: boolean | null, datetime?: any | null } | { __typename: 'ComponentCustomDataFieldsEmailField', id: string, label?: string | null, isRequired?: boolean | null, email?: string | null } | { __typename: 'ComponentCustomDataFieldsImageField', id: string, isRequired?: boolean | null, label?: string | null, upload_state?: Enum_Componentcustomdatafieldsimagefield_Upload_State | null, images?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null }> } | null } | { __typename: 'ComponentCustomDataFieldsMetricsSpecific', id: string, label?: string | null, min?: any | null, max?: any | null, isRequired?: boolean | null, metric?: string | null, number_value?: string | null } | { __typename: 'ComponentCustomDataFieldsNumberDropDown', id: string, label?: string | null, value?: any | null, isRequired?: boolean | null, max?: any | null, min?: any | null } | { __typename: 'ComponentCustomDataFieldsNumberField', id: string, label?: string | null, min?: any | null, max?: any | null, isRequired?: boolean | null, number_field_value?: string | null } | { __typename: 'ComponentCustomDataFieldsNumberRange', id: string, label?: string | null, min?: any | null, isRequired?: boolean | null, max?: any | null } | { __typename: 'ComponentCustomDataFieldsPercentage', id: string, label?: string | null, isRequired?: boolean | null, value?: any | null } | { __typename: 'ComponentCustomDataFieldsPhoneNumberField', id: string, label?: string | null, isRequired?: boolean | null, phoneNumber?: string | null } | { __typename: 'ComponentCustomDataFieldsRadio', id: string, label?: string | null, isRequired?: boolean | null, option?: Array<{ __typename?: 'ComponentComboFieldOption', id: string, option?: string | null } | null> | null } | { __typename: 'ComponentCustomDataFieldsRating', id: string, label?: string | null, rating?: number | null, isRequired?: boolean | null, number_of_stars?: any | null } | { __typename: 'ComponentCustomDataFieldsSelect', id: string, isRequired?: boolean | null, label?: string | null, option?: Array<{ __typename: 'ComponentComboFieldOption', id: string, option?: string | null } | null> | null } | { __typename: 'ComponentCustomDataFieldsText', id: string, label?: string | null, isRequired?: boolean | null, text_value?: string | null } | { __typename: 'Error' } | null> | null } | null } | null };

export type GetTaskTypeProjectsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTaskTypeProjectsQuery = { __typename?: 'Query', getTaskTypeProjects?: Array<{ __typename?: 'ProjectEntity', id?: string | null, attributes?: { __typename?: 'Project', breakdown?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, collaborators?: any | null, reward?: string | null, status?: Enum_Project_Status | null, statement?: string | null, description?: string | null, outcomes?: string | null, budget?: string | null, featured_image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null } | null> | null };

export type GetTaskTypeTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTaskTypeTemplatesQuery = { __typename?: 'Query', getTaskTypeTemplates?: Array<{ __typename?: 'TaskTypeEntity', id?: string | null, attributes?: { __typename?: 'TaskType', title?: string | null, reportingDateField?: string | null, photoEvidence?: string | null, documentedEvidence?: string | null, environmentalImpact?: string | null, socialImpact?: string | null, status?: Enum_Tasktype_Status | null, createdAt?: any | null, updatedAt?: any | null, withComment?: boolean | null, photoRequired?: boolean | null, category?: { __typename?: 'CategoryEntityResponse', data?: { __typename?: 'CategoryEntity', id?: string | null, attributes?: { __typename?: 'Category', title?: string | null, description?: string | null, status?: Enum_Category_Status | null, createdAt?: any | null, updatedAt?: any | null, featureImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null } | null } | null, un_sdg?: { __typename?: 'UnSdgEntityResponse', data?: { __typename?: 'UnSdgEntity', id?: string | null, attributes?: { __typename?: 'UnSdg', name?: string | null } | null } | null } | null, creator?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName: string, lastName: string, status?: Enum_Userspermissionsuser_Status | null, phoneNumber?: string | null, createdAt?: any | null, updatedAt?: any | null, gender?: Enum_Userspermissionsuser_Gender | null, idNumber?: string | null, blocked?: boolean | null, dateOfBirth?: any | null, location_permission?: boolean | null, camera_permission?: boolean | null, media_library_permission?: boolean | null, isVerifier?: boolean | null, email: string, baoleader?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null } | null } | null, profilePicture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null, role?: { __typename?: 'UsersPermissionsRoleEntityResponse', data?: { __typename?: 'UsersPermissionsRoleEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsRole', name: string, type?: string | null } | null } | null } | null, community?: { __typename?: 'CommunityEntityResponse', data?: { __typename?: 'CommunityEntity', id?: string | null, attributes?: { __typename?: 'Community', createdAt?: any | null, updatedAt?: any | null, name?: string | null, type?: Enum_Community_Type | null, description?: string | null, chief_name?: string | null, location?: any | null, featured_image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null } | null } | null } | null } | null } | null } | null } | null> | null };

export type GetTaskTypesQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<TaskTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetTaskTypesQuery = { __typename?: 'Query', taskTypes?: { __typename?: 'TaskTypeEntityResponseCollection', data: Array<{ __typename?: 'TaskTypeEntity', id?: string | null, attributes?: { __typename?: 'TaskType', title?: string | null, reportingDateField?: string | null, photoEvidence?: string | null, documentedEvidence?: string | null, environmentalImpact?: string | null, socialImpact?: string | null, status?: Enum_Tasktype_Status | null, createdAt?: any | null, updatedAt?: any | null, withComment?: boolean | null, photoRequired?: boolean | null, category?: { __typename?: 'CategoryEntityResponse', data?: { __typename?: 'CategoryEntity', id?: string | null, attributes?: { __typename?: 'Category', title?: string | null, description?: string | null, status?: Enum_Category_Status | null, createdAt?: any | null, updatedAt?: any | null, featureImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null } | null } | null, creator?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName: string, lastName: string, status?: Enum_Userspermissionsuser_Status | null, phoneNumber?: string | null, createdAt?: any | null, updatedAt?: any | null, gender?: Enum_Userspermissionsuser_Gender | null, idNumber?: string | null, blocked?: boolean | null, dateOfBirth?: any | null, location_permission?: boolean | null, camera_permission?: boolean | null, media_library_permission?: boolean | null, isVerifier?: boolean | null, email: string, baoleader?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null } | null } | null, profilePicture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null, role?: { __typename?: 'UsersPermissionsRoleEntityResponse', data?: { __typename?: 'UsersPermissionsRoleEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsRole', name: string, type?: string | null } | null } | null } | null, community?: { __typename?: 'CommunityEntityResponse', data?: { __typename?: 'CommunityEntity', id?: string | null, attributes?: { __typename?: 'Community', createdAt?: any | null, updatedAt?: any | null, name?: string | null, type?: Enum_Community_Type | null, description?: string | null, chief_name?: string | null, location?: any | null, featured_image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null } | null } | null } | null } | null } | null } | null }> } | null };

export type GetTasksQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetTasksQuery = { __typename?: 'Query', getBaoleaderTasksWithCount?: { __typename?: 'TasksWithCount', count?: number | null, data?: Array<{ __typename?: 'TaskEntity', id?: string | null, attributes?: { __typename?: 'Task', updatedAt?: any | null, createdAt?: any | null, date_reported?: any | null, status?: Enum_Task_Status | null, location?: any | null, onlyEmployeesVerify?: boolean | null, timezone?: string | null, task_origin?: Enum_Task_Task_Origin | null, edit_from?: { __typename?: 'TaskEntityResponse', data?: { __typename?: 'TaskEntity', id?: string | null, attributes?: { __typename?: 'Task', updatedAt?: any | null, createdAt?: any | null, date_reported?: any | null, status?: Enum_Task_Status | null, location?: any | null, onlyEmployeesVerify?: boolean | null, timezone?: string | null, task_origin?: Enum_Task_Task_Origin | null } | null } | null } | null, task_definition?: { __typename?: 'TaskDefinitionEntityResponse', data?: { __typename?: 'TaskDefinitionEntity', id?: string | null, attributes?: { __typename?: 'TaskDefinition', task_type?: { __typename?: 'TaskTypeEntityResponse', data?: { __typename?: 'TaskTypeEntity', id?: string | null, attributes?: { __typename?: 'TaskType', title?: string | null } | null } | null } | null, category?: { __typename?: 'CategoryEntityResponse', data?: { __typename?: 'CategoryEntity', id?: string | null, attributes?: { __typename?: 'Category', featureImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null } | null } | null } | null } | null } | null, community?: { __typename?: 'CommunityEntityResponse', data?: { __typename?: 'CommunityEntity', id?: string | null, attributes?: { __typename?: 'Community', name?: string | null } | null } | null } | null, project?: { __typename?: 'ProjectEntityResponse', data?: { __typename?: 'ProjectEntity', id?: string | null, attributes?: { __typename?: 'Project', name?: string | null } | null } | null } | null, evidences?: { __typename?: 'EvidenceRelationResponseCollection', data: Array<{ __typename?: 'EvidenceEntity', id?: string | null, attributes?: { __typename?: 'Evidence', custom_data_fields?: Array<{ __typename: 'ComponentCustomDataFieldsCheckbox' } | { __typename: 'ComponentCustomDataFieldsDataList' } | { __typename: 'ComponentCustomDataFieldsDateTimeField' } | { __typename: 'ComponentCustomDataFieldsEmailField' } | { __typename: 'ComponentCustomDataFieldsImageField', id: string, isRequired?: boolean | null, label?: string | null, upload_state?: Enum_Componentcustomdatafieldsimagefield_Upload_State | null, images?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null }> } | null } | { __typename: 'ComponentCustomDataFieldsMetricsSpecific' } | { __typename: 'ComponentCustomDataFieldsNumberDropDown' } | { __typename: 'ComponentCustomDataFieldsNumberField' } | { __typename: 'ComponentCustomDataFieldsNumberRange' } | { __typename: 'ComponentCustomDataFieldsPercentage' } | { __typename: 'ComponentCustomDataFieldsPhoneNumberField' } | { __typename: 'ComponentCustomDataFieldsRadio' } | { __typename: 'ComponentCustomDataFieldsRating' } | { __typename: 'ComponentCustomDataFieldsSelect' } | { __typename: 'ComponentCustomDataFieldsText' } | { __typename: 'Error' } | null> | null, photos?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null }> } | null, baorider?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName: string, lastName: string, phoneNumber?: string | null } | null } | null } | null } | null }> } | null } | null } | null> | null } | null };

export type GetTopPerformingUsersQueryVariables = Exact<{
  community?: InputMaybe<Scalars['ID']['input']>;
  project?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GetTopPerformingUsersQuery = { __typename?: 'Query', getTopPerformingUsers?: { __typename?: 'TopPerforming', baoriders?: Array<{ __typename?: 'TopPerformingBaorider', tasksCompleted: number, baorider?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName: string, lastName: string } | null } | null } | null> | null, communityMembers?: Array<{ __typename?: 'TopPerformingCommunityMember', tasksCompleted: number, communityMember?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName: string, lastName: string } | null } | null } | null> | null, chartData?: { __typename?: 'TopPerformingChartData', communityMembers?: Array<{ __typename?: 'ChartData', key: string, value: number } | null> | null, baoriders?: Array<{ __typename?: 'ChartData', key: string, value: number } | null> | null } | null } | null };

export type GetUnsdGsQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<UnSdgFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetUnsdGsQuery = { __typename?: 'Query', unSdgs?: { __typename?: 'UnSdgEntityResponseCollection', data: Array<{ __typename?: 'UnSdgEntity', id?: string | null, attributes?: { __typename?: 'UnSdg', name?: string | null, createdAt?: any | null, updatedAt?: any | null, publishedAt?: any | null, task_types?: { __typename?: 'TaskTypeRelationResponseCollection', data: Array<{ __typename?: 'TaskTypeEntity', id?: string | null, attributes?: { __typename?: 'TaskType', title?: string | null, reportingDateField?: string | null, photoEvidence?: string | null, documentedEvidence?: string | null, environmentalImpact?: string | null, socialImpact?: string | null, status?: Enum_Tasktype_Status | null, createdAt?: any | null, updatedAt?: any | null, withComment?: boolean | null, photoRequired?: boolean | null } | null }> } | null, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null }> } | null };

export type GetVideosQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<VideoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetVideosQuery = { __typename?: 'Query', videos?: { __typename?: 'VideoEntityResponseCollection', data: Array<{ __typename?: 'VideoEntity', id?: string | null, attributes?: { __typename?: 'Video', title: string, order?: number | null, category?: Enum_Video_Category | null, videoLink: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } } | null }> } | null };

export type GetWholeCompanyTaskTypesQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['JSON']['input']>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetWholeCompanyTaskTypesQuery = { __typename?: 'Query', getWholeCompanyTaskTypes?: Array<{ __typename?: 'TaskTypeEntity', id?: string | null, attributes?: { __typename?: 'TaskType', title?: string | null, reportingDateField?: string | null, photoEvidence?: string | null, documentedEvidence?: string | null, environmentalImpact?: string | null, socialImpact?: string | null, status?: Enum_Tasktype_Status | null, createdAt?: any | null, updatedAt?: any | null, withComment?: boolean | null, photoRequired?: boolean | null, category?: { __typename?: 'CategoryEntityResponse', data?: { __typename?: 'CategoryEntity', id?: string | null, attributes?: { __typename?: 'Category', title?: string | null, featureImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null } | null } | null, creator?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', firstName: string, lastName: string } | null } | null } | null } | null } | null> | null };

export type HelpQueryVariables = Exact<{ [key: string]: never; }>;


export type HelpQuery = { __typename?: 'Query', trainingVideo?: { __typename?: 'TrainingVideoEntityResponse', data?: { __typename?: 'TrainingVideoEntity', id?: string | null, attributes?: { __typename: 'TrainingVideo', training_videos?: Array<{ __typename: 'ComponentTrainingVideoTrainingVideo', id: string, title?: string | null, url?: string | null, page?: Enum_Componenttrainingvideotrainingvideo_Page | null, category?: Enum_Componenttrainingvideotrainingvideo_Category | null, description?: string | null, tags?: Array<{ __typename?: 'ComponentComboFieldOption', id: string, option?: string | null } | null> | null } | null> | null, FAQs?: Array<{ __typename: 'ComponentFaqFaq', id: string, question?: string | null, answer?: string | null, category?: Enum_Componentfaqfaq_Category | null, page?: Enum_Componentfaqfaq_Page | null, tags?: Array<{ __typename?: 'ComponentComboFieldOption', id: string, option?: string | null } | null> | null } | null> | null } | null } | null } | null };

export type IsListInUseQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IsListInUseQuery = { __typename?: 'Query', isListInUse?: { __typename?: 'IsListInUseResponse', isListInUse?: boolean | null, amountOfUses?: number | null, foundLists?: Array<{ __typename?: 'ComponentCustomDataFieldsDataList', id: string, label?: string | null, isRequired?: boolean | null, listId: string, option?: Array<{ __typename?: 'ComponentComboFieldOption', id: string, option?: string | null } | null> | null } | null> | null } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', myUser?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', username: string, firstName: string, lastName: string, email: string, confirmed?: boolean | null, blocked?: boolean | null, receiveAllTimeWeeklyStatusReport?: boolean | null, receiveLoginReminder?: boolean | null, receiveWeeklyStatusReport?: boolean | null, onboardingInformation?: any | null, company?: { __typename?: 'CompanyEntityResponse', data?: { __typename?: 'CompanyEntity', id?: string | null, attributes?: { __typename?: 'Company', name?: string | null } | null } | null } | null } | null } | null };

export type GetBaoleaderTaskDefinitionsQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetBaoleaderTaskDefinitionsQuery = { __typename?: 'Query', getBaoleaderTaskDefinitions?: Array<{ __typename?: 'TaskDefinitionEntity', id?: string | null, attributes?: { __typename?: 'TaskDefinition', status?: Enum_Taskdefinition_Status | null, category?: { __typename?: 'CategoryEntityResponse', data?: { __typename?: 'CategoryEntity', id?: string | null, attributes?: { __typename?: 'Category', title?: string | null, description?: string | null, status?: Enum_Category_Status | null, createdAt?: any | null, updatedAt?: any | null, featureImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', createdAt?: any | null, updatedAt?: any | null, name: string, alternativeText?: string | null, caption?: string | null, size: number, mime: string, url: string, provider: string, width?: number | null, height?: number | null, formats?: any | null, hash: string, ext?: string | null } | null } | null } | null } | null } | null } | null, task_type?: { __typename?: 'TaskTypeEntityResponse', data?: { __typename?: 'TaskTypeEntity', id?: string | null, attributes?: { __typename?: 'TaskType', title?: string | null, reportingDateField?: string | null, photoEvidence?: string | null, documentedEvidence?: string | null, environmentalImpact?: string | null, socialImpact?: string | null, status?: Enum_Tasktype_Status | null, createdAt?: any | null, updatedAt?: any | null, withComment?: boolean | null, photoRequired?: boolean | null } | null } | null } | null } | null } | null> | null };

export type UsersQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type UsersQuery = { __typename?: 'Query', usersPermissionsUsers?: { __typename?: 'UsersPermissionsUserEntityResponseCollection', data: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', createdAt?: any | null, updatedAt?: any | null, username: string, email: string, provider?: string | null, confirmed?: boolean | null, blocked?: boolean | null, role?: { __typename?: 'UsersPermissionsRoleEntityResponse', data?: { __typename?: 'UsersPermissionsRoleEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsRole', name: string, description?: string | null, type?: string | null } | null } | null } | null } | null }> } | null };

export const UploadFileFragmentDoc = gql`
    fragment uploadFile on UploadFileEntity {
  id
  attributes {
    createdAt
    updatedAt
    name
    alternativeText
    caption
    size
    mime
    url
    provider
    width
    height
    formats
    hash
    ext
  }
}
    `;
export const UnsdgFragmentDoc = gql`
    fragment UNSDG on UnSdg {
  name
  icon {
    data {
      ...uploadFile
    }
  }
}
    ${UploadFileFragmentDoc}`;
export const Analytic_FragmentFragmentDoc = gql`
    fragment analytic_fragment on Analytic {
  default_dashboard
}
    `;
export const CategoryFragmentDoc = gql`
    fragment category on Category {
  title
  description
  status
  createdAt
  updatedAt
}
    `;
export const ComponentCustomDataFieldsCheckboxFragmentDoc = gql`
    fragment componentCustomDataFieldsCheckbox on ComponentCustomDataFieldsCheckbox {
  id
  isRequired
  label
  option {
    id
    option
  }
}
    `;
export const ComponentCustomDataFieldsDataListFragmentDoc = gql`
    fragment componentCustomDataFieldsDataList on ComponentCustomDataFieldsDataList {
  id
  label
  isRequired
  listId
  option {
    id
    option
  }
}
    `;
export const ComponentCustomDataFieldsDateTimeFieldFragmentDoc = gql`
    fragment componentCustomDataFieldsDateTimeField on ComponentCustomDataFieldsDateTimeField {
  id
  label
  isRequired
  datetime
}
    `;
export const ComponentCustomDataFieldsEmailFieldFragmentDoc = gql`
    fragment componentCustomDataFieldsEmailField on ComponentCustomDataFieldsEmailField {
  id
  label
  isRequired
  email
}
    `;
export const ComponentCustomDataFieldsImageFieldFragmentDoc = gql`
    fragment componentCustomDataFieldsImageField on ComponentCustomDataFieldsImageField {
  id
  isRequired
  label
  upload_state
  images {
    data {
      ...uploadFile
    }
  }
}
    ${UploadFileFragmentDoc}`;
export const ComponentCustomDataFieldsMetricsSpecificFragmentDoc = gql`
    fragment componentCustomDataFieldsMetricsSpecific on ComponentCustomDataFieldsMetricsSpecific {
  id
  label
  min
  max
  isRequired
  metric
  number_value
}
    `;
export const ComponentCustomDataFieldsNumberDropDownFragmentDoc = gql`
    fragment componentCustomDataFieldsNumberDropDown on ComponentCustomDataFieldsNumberDropDown {
  id
  label
  value
  isRequired
  max
  min
}
    `;
export const ComponentCustomDataFieldsNumberFieldFragmentDoc = gql`
    fragment componentCustomDataFieldsNumberField on ComponentCustomDataFieldsNumberField {
  id
  label
  min
  max
  isRequired
  number_field_value
}
    `;
export const ComponentCustomDataFieldsNumberRangeFragmentDoc = gql`
    fragment componentCustomDataFieldsNumberRange on ComponentCustomDataFieldsNumberRange {
  id
  label
  min
  isRequired
  max
}
    `;
export const ComponentCustomDataFieldsPercentageFragmentDoc = gql`
    fragment componentCustomDataFieldsPercentage on ComponentCustomDataFieldsPercentage {
  id
  label
  isRequired
  value
}
    `;
export const ComponentCustomDataFieldsPhoneNumberFieldFragmentDoc = gql`
    fragment componentCustomDataFieldsPhoneNumberField on ComponentCustomDataFieldsPhoneNumberField {
  id
  label
  isRequired
  phoneNumber
}
    `;
export const ComponentCustomDataFieldsRadioFragmentDoc = gql`
    fragment componentCustomDataFieldsRadio on ComponentCustomDataFieldsRadio {
  id
  label
  isRequired
  option {
    id
    option
  }
}
    `;
export const ComponentCustomDataFieldsRatingFragmentDoc = gql`
    fragment componentCustomDataFieldsRating on ComponentCustomDataFieldsRating {
  id
  label
  rating
  isRequired
  number_of_stars
}
    `;
export const ComponentCustomDataFieldsSelectFragmentDoc = gql`
    fragment componentCustomDataFieldsSelect on ComponentCustomDataFieldsSelect {
  id
  isRequired
  label
  option {
    id
    option
    __typename
  }
}
    `;
export const ComponentCustomDataFieldsTextFragmentDoc = gql`
    fragment componentCustomDataFieldsText on ComponentCustomDataFieldsText {
  id
  label
  isRequired
  text_value
}
    `;
export const DataListOptionFragmentDoc = gql`
    fragment dataListOption on DataListOption {
  createdAt
  status
  updatedAt
  value
  publishedAt
}
    `;
export const DataListsFragmentDoc = gql`
    fragment dataLists on DataList {
  name
  createdAt
  updatedAt
  status
  publishedAt
}
    `;
export const EvidenceFragmentDoc = gql`
    fragment evidence on Evidence {
  notes
  location
  createdAt
  updatedAt
  upload_state
  cancellationReason
  requestedInfo
  upload_state
}
    `;
export const FaqFragmentDoc = gql`
    fragment faq on ComponentFaqFaq {
  id
  question
  answer
  category
  page
  tags {
    id
    option
  }
  __typename
}
    `;
export const InsightReportFragmentDoc = gql`
    fragment insightReport on InsightReport {
  name
  description
  status
  graphs
  createdAt
  updatedAt
}
    `;
export const CommunityFragmentDoc = gql`
    fragment community on Community {
  createdAt
  updatedAt
  name
  type
  description
  chief_name
  location
}
    `;
export const MemberFragmentDoc = gql`
    fragment member on UsersPermissionsUser {
  firstName
  lastName
  status
  phoneNumber
  createdAt
  updatedAt
  gender
  idNumber
  blocked
  dateOfBirth
  location_permission
  camera_permission
  media_library_permission
  baoleader {
    data {
      id
    }
  }
  isVerifier
  email
  profilePicture {
    data {
      ...uploadFile
    }
  }
  role {
    data {
      id
      attributes {
        name
        type
      }
    }
  }
  community {
    data {
      id
      attributes {
        ...community
        featured_image {
          data {
            ...uploadFile
          }
        }
      }
    }
  }
}
    ${UploadFileFragmentDoc}
${CommunityFragmentDoc}`;
export const ProjectFragmentDoc = gql`
    fragment project on Project {
  breakdown
  name
  createdAt
  updatedAt
  collaborators
  reward
  status
  statement
  description
  outcomes
  createdAt
  updatedAt
  budget
}
    `;
export const TaskFragmentDoc = gql`
    fragment task on Task {
  updatedAt
  createdAt
  date_reported
  status
  location
  onlyEmployeesVerify
  timezone
  task_origin
}
    `;
export const TaskPerFragmentDoc = gql`
    fragment taskPer on TaskPer {
  name
  count
}
    `;
export const TaskTypeFragmentDoc = gql`
    fragment taskType on TaskType {
  title
  reportingDateField
  photoEvidence
  documentedEvidence
  environmentalImpact
  socialImpact
  status
  createdAt
  updatedAt
  withComment
  photoRequired
}
    `;
export const Training_VideoFragmentDoc = gql`
    fragment training_video on ComponentTrainingVideoTrainingVideo {
  id
  title
  url
  page
  category
  description
  tags {
    id
    option
  }
  __typename
}
    `;
export const AcceptCommunityMemberRequestDocument = gql`
    mutation acceptCommunityMemberRequest($requestId: ID!) {
  acceptCommunityMemberRequest(requestId: $requestId) {
    id
    attributes {
      firstName
      lastName
    }
  }
}
    `;
export type AcceptCommunityMemberRequestMutationFn = Apollo.MutationFunction<AcceptCommunityMemberRequestMutation, AcceptCommunityMemberRequestMutationVariables>;

/**
 * __useAcceptCommunityMemberRequestMutation__
 *
 * To run a mutation, you first call `useAcceptCommunityMemberRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptCommunityMemberRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptCommunityMemberRequestMutation, { data, loading, error }] = useAcceptCommunityMemberRequestMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useAcceptCommunityMemberRequestMutation(baseOptions?: Apollo.MutationHookOptions<AcceptCommunityMemberRequestMutation, AcceptCommunityMemberRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptCommunityMemberRequestMutation, AcceptCommunityMemberRequestMutationVariables>(AcceptCommunityMemberRequestDocument, options);
      }
export type AcceptCommunityMemberRequestMutationHookResult = ReturnType<typeof useAcceptCommunityMemberRequestMutation>;
export type AcceptCommunityMemberRequestMutationResult = Apollo.MutationResult<AcceptCommunityMemberRequestMutation>;
export type AcceptCommunityMemberRequestMutationOptions = Apollo.BaseMutationOptions<AcceptCommunityMemberRequestMutation, AcceptCommunityMemberRequestMutationVariables>;
export const ActivateTaskTypeDocument = gql`
    mutation activateTaskType($id: ID!) {
  activateTaskType(id: $id) {
    id
  }
}
    `;
export type ActivateTaskTypeMutationFn = Apollo.MutationFunction<ActivateTaskTypeMutation, ActivateTaskTypeMutationVariables>;

/**
 * __useActivateTaskTypeMutation__
 *
 * To run a mutation, you first call `useActivateTaskTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateTaskTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateTaskTypeMutation, { data, loading, error }] = useActivateTaskTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivateTaskTypeMutation(baseOptions?: Apollo.MutationHookOptions<ActivateTaskTypeMutation, ActivateTaskTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateTaskTypeMutation, ActivateTaskTypeMutationVariables>(ActivateTaskTypeDocument, options);
      }
export type ActivateTaskTypeMutationHookResult = ReturnType<typeof useActivateTaskTypeMutation>;
export type ActivateTaskTypeMutationResult = Apollo.MutationResult<ActivateTaskTypeMutation>;
export type ActivateTaskTypeMutationOptions = Apollo.BaseMutationOptions<ActivateTaskTypeMutation, ActivateTaskTypeMutationVariables>;
export const AddDataCollectorToProjectDocument = gql`
    mutation addDataCollectorToProject($input: AddDataCollectorToProjectInput!) {
  addDataCollectorToProject(input: $input) {
    id
  }
}
    `;
export type AddDataCollectorToProjectMutationFn = Apollo.MutationFunction<AddDataCollectorToProjectMutation, AddDataCollectorToProjectMutationVariables>;

/**
 * __useAddDataCollectorToProjectMutation__
 *
 * To run a mutation, you first call `useAddDataCollectorToProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDataCollectorToProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDataCollectorToProjectMutation, { data, loading, error }] = useAddDataCollectorToProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddDataCollectorToProjectMutation(baseOptions?: Apollo.MutationHookOptions<AddDataCollectorToProjectMutation, AddDataCollectorToProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDataCollectorToProjectMutation, AddDataCollectorToProjectMutationVariables>(AddDataCollectorToProjectDocument, options);
      }
export type AddDataCollectorToProjectMutationHookResult = ReturnType<typeof useAddDataCollectorToProjectMutation>;
export type AddDataCollectorToProjectMutationResult = Apollo.MutationResult<AddDataCollectorToProjectMutation>;
export type AddDataCollectorToProjectMutationOptions = Apollo.BaseMutationOptions<AddDataCollectorToProjectMutation, AddDataCollectorToProjectMutationVariables>;
export const ArchiveNotificationDocument = gql`
    mutation archiveNotification($id: ID!) {
  deleteBaoleaderNotification(id: $id) {
    id
    attributes {
      status
      updatedAt
    }
  }
}
    `;
export type ArchiveNotificationMutationFn = Apollo.MutationFunction<ArchiveNotificationMutation, ArchiveNotificationMutationVariables>;

/**
 * __useArchiveNotificationMutation__
 *
 * To run a mutation, you first call `useArchiveNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveNotificationMutation, { data, loading, error }] = useArchiveNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveNotificationMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveNotificationMutation, ArchiveNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveNotificationMutation, ArchiveNotificationMutationVariables>(ArchiveNotificationDocument, options);
      }
export type ArchiveNotificationMutationHookResult = ReturnType<typeof useArchiveNotificationMutation>;
export type ArchiveNotificationMutationResult = Apollo.MutationResult<ArchiveNotificationMutation>;
export type ArchiveNotificationMutationOptions = Apollo.BaseMutationOptions<ArchiveNotificationMutation, ArchiveNotificationMutationVariables>;
export const CancelSubscriptionDocument = gql`
    mutation cancelSubscription {
  cancelSubscription {
    status
    cancelAtPeriodEnd
    endsAt
  }
}
    `;
export type CancelSubscriptionMutationFn = Apollo.MutationFunction<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;

/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionMutation, { data, loading, error }] = useCancelSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>(CancelSubscriptionDocument, options);
      }
export type CancelSubscriptionMutationHookResult = ReturnType<typeof useCancelSubscriptionMutation>;
export type CancelSubscriptionMutationResult = Apollo.MutationResult<CancelSubscriptionMutation>;
export type CancelSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;
export const ChangeSubscriptionPlanDocument = gql`
    mutation changeSubscriptionPlan($productPlanId: ID!) {
  changeSubscriptionPlan(productPlanId: $productPlanId) {
    status
    planId
    planName
    priceId
    direction
  }
}
    `;
export type ChangeSubscriptionPlanMutationFn = Apollo.MutationFunction<ChangeSubscriptionPlanMutation, ChangeSubscriptionPlanMutationVariables>;

/**
 * __useChangeSubscriptionPlanMutation__
 *
 * To run a mutation, you first call `useChangeSubscriptionPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeSubscriptionPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeSubscriptionPlanMutation, { data, loading, error }] = useChangeSubscriptionPlanMutation({
 *   variables: {
 *      productPlanId: // value for 'productPlanId'
 *   },
 * });
 */
export function useChangeSubscriptionPlanMutation(baseOptions?: Apollo.MutationHookOptions<ChangeSubscriptionPlanMutation, ChangeSubscriptionPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeSubscriptionPlanMutation, ChangeSubscriptionPlanMutationVariables>(ChangeSubscriptionPlanDocument, options);
      }
export type ChangeSubscriptionPlanMutationHookResult = ReturnType<typeof useChangeSubscriptionPlanMutation>;
export type ChangeSubscriptionPlanMutationResult = Apollo.MutationResult<ChangeSubscriptionPlanMutation>;
export type ChangeSubscriptionPlanMutationOptions = Apollo.BaseMutationOptions<ChangeSubscriptionPlanMutation, ChangeSubscriptionPlanMutationVariables>;
export const CompleteOnboardingStepDocument = gql`
    mutation completeOnboardingStep($index: String!, $completeOnboarding: Boolean) {
  completeOnboardingStep(index: $index, completeOnboarding: $completeOnboarding) {
    id
    attributes {
      username
    }
  }
}
    `;
export type CompleteOnboardingStepMutationFn = Apollo.MutationFunction<CompleteOnboardingStepMutation, CompleteOnboardingStepMutationVariables>;

/**
 * __useCompleteOnboardingStepMutation__
 *
 * To run a mutation, you first call `useCompleteOnboardingStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteOnboardingStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeOnboardingStepMutation, { data, loading, error }] = useCompleteOnboardingStepMutation({
 *   variables: {
 *      index: // value for 'index'
 *      completeOnboarding: // value for 'completeOnboarding'
 *   },
 * });
 */
export function useCompleteOnboardingStepMutation(baseOptions?: Apollo.MutationHookOptions<CompleteOnboardingStepMutation, CompleteOnboardingStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteOnboardingStepMutation, CompleteOnboardingStepMutationVariables>(CompleteOnboardingStepDocument, options);
      }
export type CompleteOnboardingStepMutationHookResult = ReturnType<typeof useCompleteOnboardingStepMutation>;
export type CompleteOnboardingStepMutationResult = Apollo.MutationResult<CompleteOnboardingStepMutation>;
export type CompleteOnboardingStepMutationOptions = Apollo.BaseMutationOptions<CompleteOnboardingStepMutation, CompleteOnboardingStepMutationVariables>;
export const CreateBaoleaderDocument = gql`
    mutation createBaoleader($input: CreateBaoleaderInput!) {
  createBaoleader(input: $input) {
    baoleader {
      id
      attributes {
        username
        email
      }
    }
  }
}
    `;
export type CreateBaoleaderMutationFn = Apollo.MutationFunction<CreateBaoleaderMutation, CreateBaoleaderMutationVariables>;

/**
 * __useCreateBaoleaderMutation__
 *
 * To run a mutation, you first call `useCreateBaoleaderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBaoleaderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBaoleaderMutation, { data, loading, error }] = useCreateBaoleaderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBaoleaderMutation(baseOptions?: Apollo.MutationHookOptions<CreateBaoleaderMutation, CreateBaoleaderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBaoleaderMutation, CreateBaoleaderMutationVariables>(CreateBaoleaderDocument, options);
      }
export type CreateBaoleaderMutationHookResult = ReturnType<typeof useCreateBaoleaderMutation>;
export type CreateBaoleaderMutationResult = Apollo.MutationResult<CreateBaoleaderMutation>;
export type CreateBaoleaderMutationOptions = Apollo.BaseMutationOptions<CreateBaoleaderMutation, CreateBaoleaderMutationVariables>;
export const CreateBaoriderDocument = gql`
    mutation createBaorider($input: CreateBaoriderInput!, $sendInvite: Boolean) {
  createBaorider(input: $input, sendInvite: $sendInvite) {
    baorider {
      id
      attributes {
        username
        email
      }
    }
  }
}
    `;
export type CreateBaoriderMutationFn = Apollo.MutationFunction<CreateBaoriderMutation, CreateBaoriderMutationVariables>;

/**
 * __useCreateBaoriderMutation__
 *
 * To run a mutation, you first call `useCreateBaoriderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBaoriderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBaoriderMutation, { data, loading, error }] = useCreateBaoriderMutation({
 *   variables: {
 *      input: // value for 'input'
 *      sendInvite: // value for 'sendInvite'
 *   },
 * });
 */
export function useCreateBaoriderMutation(baseOptions?: Apollo.MutationHookOptions<CreateBaoriderMutation, CreateBaoriderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBaoriderMutation, CreateBaoriderMutationVariables>(CreateBaoriderDocument, options);
      }
export type CreateBaoriderMutationHookResult = ReturnType<typeof useCreateBaoriderMutation>;
export type CreateBaoriderMutationResult = Apollo.MutationResult<CreateBaoriderMutation>;
export type CreateBaoriderMutationOptions = Apollo.BaseMutationOptions<CreateBaoriderMutation, CreateBaoriderMutationVariables>;
export const CreateBaoridersDocument = gql`
    mutation createBaoriders($input: [CreateBaoriderInput]!) {
  createBaoriders(input: $input) {
    baoriders {
      id
      attributes {
        email
        username
      }
    }
  }
}
    `;
export type CreateBaoridersMutationFn = Apollo.MutationFunction<CreateBaoridersMutation, CreateBaoridersMutationVariables>;

/**
 * __useCreateBaoridersMutation__
 *
 * To run a mutation, you first call `useCreateBaoridersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBaoridersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBaoridersMutation, { data, loading, error }] = useCreateBaoridersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBaoridersMutation(baseOptions?: Apollo.MutationHookOptions<CreateBaoridersMutation, CreateBaoridersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBaoridersMutation, CreateBaoridersMutationVariables>(CreateBaoridersDocument, options);
      }
export type CreateBaoridersMutationHookResult = ReturnType<typeof useCreateBaoridersMutation>;
export type CreateBaoridersMutationResult = Apollo.MutationResult<CreateBaoridersMutation>;
export type CreateBaoridersMutationOptions = Apollo.BaseMutationOptions<CreateBaoridersMutation, CreateBaoridersMutationVariables>;
export const CreateCategoryDocument = gql`
    mutation createCategory($input: CategoryInput!) {
  createCategory(data: $input) {
    data {
      id
      attributes {
        ...category
      }
    }
  }
}
    ${CategoryFragmentDoc}`;
export type CreateCategoryMutationFn = Apollo.MutationFunction<CreateCategoryMutation, CreateCategoryMutationVariables>;

/**
 * __useCreateCategoryMutation__
 *
 * To run a mutation, you first call `useCreateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCategoryMutation, { data, loading, error }] = useCreateCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateCategoryMutation, CreateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCategoryMutation, CreateCategoryMutationVariables>(CreateCategoryDocument, options);
      }
export type CreateCategoryMutationHookResult = ReturnType<typeof useCreateCategoryMutation>;
export type CreateCategoryMutationResult = Apollo.MutationResult<CreateCategoryMutation>;
export type CreateCategoryMutationOptions = Apollo.BaseMutationOptions<CreateCategoryMutation, CreateCategoryMutationVariables>;
export const CreateCommunityDocument = gql`
    mutation createCommunity($input: CommunityInput) {
  createBaoleaderCommunity(input: $input) {
    id
    attributes {
      name
      chief_name
      description
    }
  }
}
    `;
export type CreateCommunityMutationFn = Apollo.MutationFunction<CreateCommunityMutation, CreateCommunityMutationVariables>;

/**
 * __useCreateCommunityMutation__
 *
 * To run a mutation, you first call `useCreateCommunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommunityMutation, { data, loading, error }] = useCreateCommunityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommunityMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommunityMutation, CreateCommunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommunityMutation, CreateCommunityMutationVariables>(CreateCommunityDocument, options);
      }
export type CreateCommunityMutationHookResult = ReturnType<typeof useCreateCommunityMutation>;
export type CreateCommunityMutationResult = Apollo.MutationResult<CreateCommunityMutation>;
export type CreateCommunityMutationOptions = Apollo.BaseMutationOptions<CreateCommunityMutation, CreateCommunityMutationVariables>;
export const CreateCommunityMemberDocument = gql`
    mutation createCommunityMember($input: CreateCommunityMembersInput, $sendInvite: Boolean) {
  createCommunityMember(input: $input, sendInvite: $sendInvite) {
    member {
      id
      attributes {
        username
      }
    }
  }
}
    `;
export type CreateCommunityMemberMutationFn = Apollo.MutationFunction<CreateCommunityMemberMutation, CreateCommunityMemberMutationVariables>;

/**
 * __useCreateCommunityMemberMutation__
 *
 * To run a mutation, you first call `useCreateCommunityMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommunityMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommunityMemberMutation, { data, loading, error }] = useCreateCommunityMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *      sendInvite: // value for 'sendInvite'
 *   },
 * });
 */
export function useCreateCommunityMemberMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommunityMemberMutation, CreateCommunityMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommunityMemberMutation, CreateCommunityMemberMutationVariables>(CreateCommunityMemberDocument, options);
      }
export type CreateCommunityMemberMutationHookResult = ReturnType<typeof useCreateCommunityMemberMutation>;
export type CreateCommunityMemberMutationResult = Apollo.MutationResult<CreateCommunityMemberMutation>;
export type CreateCommunityMemberMutationOptions = Apollo.BaseMutationOptions<CreateCommunityMemberMutation, CreateCommunityMemberMutationVariables>;
export const CreateCommunityMembersDocument = gql`
    mutation createCommunityMembers($input: [CreateCommunityMembersInput]) {
  createCommunityMembers(input: $input) {
    member {
      id
      attributes {
        username
      }
    }
  }
}
    `;
export type CreateCommunityMembersMutationFn = Apollo.MutationFunction<CreateCommunityMembersMutation, CreateCommunityMembersMutationVariables>;

/**
 * __useCreateCommunityMembersMutation__
 *
 * To run a mutation, you first call `useCreateCommunityMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommunityMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommunityMembersMutation, { data, loading, error }] = useCreateCommunityMembersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommunityMembersMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommunityMembersMutation, CreateCommunityMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommunityMembersMutation, CreateCommunityMembersMutationVariables>(CreateCommunityMembersDocument, options);
      }
export type CreateCommunityMembersMutationHookResult = ReturnType<typeof useCreateCommunityMembersMutation>;
export type CreateCommunityMembersMutationResult = Apollo.MutationResult<CreateCommunityMembersMutation>;
export type CreateCommunityMembersMutationOptions = Apollo.BaseMutationOptions<CreateCommunityMembersMutation, CreateCommunityMembersMutationVariables>;
export const CreateDataListDocument = gql`
    mutation createDataList($input: DataListInput!) {
  createDataList(data: $input) {
    data {
      id
    }
  }
}
    `;
export type CreateDataListMutationFn = Apollo.MutationFunction<CreateDataListMutation, CreateDataListMutationVariables>;

/**
 * __useCreateDataListMutation__
 *
 * To run a mutation, you first call `useCreateDataListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDataListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDataListMutation, { data, loading, error }] = useCreateDataListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDataListMutation(baseOptions?: Apollo.MutationHookOptions<CreateDataListMutation, CreateDataListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDataListMutation, CreateDataListMutationVariables>(CreateDataListDocument, options);
      }
export type CreateDataListMutationHookResult = ReturnType<typeof useCreateDataListMutation>;
export type CreateDataListMutationResult = Apollo.MutationResult<CreateDataListMutation>;
export type CreateDataListMutationOptions = Apollo.BaseMutationOptions<CreateDataListMutation, CreateDataListMutationVariables>;
export const CreateDataListOptionDocument = gql`
    mutation createDataListOption($input: DataListOptionInput!) {
  createDataListOption(data: $input) {
    data {
      id
    }
  }
}
    `;
export type CreateDataListOptionMutationFn = Apollo.MutationFunction<CreateDataListOptionMutation, CreateDataListOptionMutationVariables>;

/**
 * __useCreateDataListOptionMutation__
 *
 * To run a mutation, you first call `useCreateDataListOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDataListOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDataListOptionMutation, { data, loading, error }] = useCreateDataListOptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDataListOptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateDataListOptionMutation, CreateDataListOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDataListOptionMutation, CreateDataListOptionMutationVariables>(CreateDataListOptionDocument, options);
      }
export type CreateDataListOptionMutationHookResult = ReturnType<typeof useCreateDataListOptionMutation>;
export type CreateDataListOptionMutationResult = Apollo.MutationResult<CreateDataListOptionMutation>;
export type CreateDataListOptionMutationOptions = Apollo.BaseMutationOptions<CreateDataListOptionMutation, CreateDataListOptionMutationVariables>;
export const CreateBaoleaderInsightReportDocument = gql`
    mutation createBaoleaderInsightReport($input: InsightReportCustomInput!) {
  createBaoleaderInsightReport(input: $input) {
    id
    attributes {
      ...insightReport
    }
  }
}
    ${InsightReportFragmentDoc}`;
export type CreateBaoleaderInsightReportMutationFn = Apollo.MutationFunction<CreateBaoleaderInsightReportMutation, CreateBaoleaderInsightReportMutationVariables>;

/**
 * __useCreateBaoleaderInsightReportMutation__
 *
 * To run a mutation, you first call `useCreateBaoleaderInsightReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBaoleaderInsightReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBaoleaderInsightReportMutation, { data, loading, error }] = useCreateBaoleaderInsightReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBaoleaderInsightReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateBaoleaderInsightReportMutation, CreateBaoleaderInsightReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBaoleaderInsightReportMutation, CreateBaoleaderInsightReportMutationVariables>(CreateBaoleaderInsightReportDocument, options);
      }
export type CreateBaoleaderInsightReportMutationHookResult = ReturnType<typeof useCreateBaoleaderInsightReportMutation>;
export type CreateBaoleaderInsightReportMutationResult = Apollo.MutationResult<CreateBaoleaderInsightReportMutation>;
export type CreateBaoleaderInsightReportMutationOptions = Apollo.BaseMutationOptions<CreateBaoleaderInsightReportMutation, CreateBaoleaderInsightReportMutationVariables>;
export const CreateNotificationDocument = gql`
    mutation createNotification($data: NotificationInput!) {
  createBaoleaderNotification(data: $data) {
    id
    attributes {
      title
      message
      type
      status
      timezone
      dateSent
      recur
      nextScheduledNotificationDetails {
        id
        sendAt
        endAt
        recur
        status
        priority
      }
    }
  }
}
    `;
export type CreateNotificationMutationFn = Apollo.MutationFunction<CreateNotificationMutation, CreateNotificationMutationVariables>;

/**
 * __useCreateNotificationMutation__
 *
 * To run a mutation, you first call `useCreateNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotificationMutation, { data, loading, error }] = useCreateNotificationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateNotificationMutation(baseOptions?: Apollo.MutationHookOptions<CreateNotificationMutation, CreateNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNotificationMutation, CreateNotificationMutationVariables>(CreateNotificationDocument, options);
      }
export type CreateNotificationMutationHookResult = ReturnType<typeof useCreateNotificationMutation>;
export type CreateNotificationMutationResult = Apollo.MutationResult<CreateNotificationMutation>;
export type CreateNotificationMutationOptions = Apollo.BaseMutationOptions<CreateNotificationMutation, CreateNotificationMutationVariables>;
export const CreateProjectDocument = gql`
    mutation createProject($input: ProjectInput) {
  createBaoleaderProject(input: $input) {
    id
    attributes {
      name
    }
  }
}
    `;
export type CreateProjectMutationFn = Apollo.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, options);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;
export const CreateSetupIntentDocument = gql`
    mutation createSetupIntent {
  createSetupIntent {
    clientSecret
    publishableKey
    customerId
  }
}
    `;
export type CreateSetupIntentMutationFn = Apollo.MutationFunction<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>;

/**
 * __useCreateSetupIntentMutation__
 *
 * To run a mutation, you first call `useCreateSetupIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSetupIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSetupIntentMutation, { data, loading, error }] = useCreateSetupIntentMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateSetupIntentMutation(baseOptions?: Apollo.MutationHookOptions<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>(CreateSetupIntentDocument, options);
      }
export type CreateSetupIntentMutationHookResult = ReturnType<typeof useCreateSetupIntentMutation>;
export type CreateSetupIntentMutationResult = Apollo.MutationResult<CreateSetupIntentMutation>;
export type CreateSetupIntentMutationOptions = Apollo.BaseMutationOptions<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>;
export const CreateTaskDocument = gql`
    mutation createTask($input: TaskInput) {
  createBaoleaderTask(input: $input) {
    id
    attributes {
      createdAt
    }
  }
}
    `;
export type CreateTaskMutationFn = Apollo.MutationFunction<CreateTaskMutation, CreateTaskMutationVariables>;

/**
 * __useCreateTaskMutation__
 *
 * To run a mutation, you first call `useCreateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskMutation, { data, loading, error }] = useCreateTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaskMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskMutation, CreateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskMutation, CreateTaskMutationVariables>(CreateTaskDocument, options);
      }
export type CreateTaskMutationHookResult = ReturnType<typeof useCreateTaskMutation>;
export type CreateTaskMutationResult = Apollo.MutationResult<CreateTaskMutation>;
export type CreateTaskMutationOptions = Apollo.BaseMutationOptions<CreateTaskMutation, CreateTaskMutationVariables>;
export const DeactivateTaskTypeDocument = gql`
    mutation deactivateTaskType($id: ID!) {
  deactivateTaskType(id: $id) {
    id
  }
}
    `;
export type DeactivateTaskTypeMutationFn = Apollo.MutationFunction<DeactivateTaskTypeMutation, DeactivateTaskTypeMutationVariables>;

/**
 * __useDeactivateTaskTypeMutation__
 *
 * To run a mutation, you first call `useDeactivateTaskTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateTaskTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateTaskTypeMutation, { data, loading, error }] = useDeactivateTaskTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateTaskTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateTaskTypeMutation, DeactivateTaskTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateTaskTypeMutation, DeactivateTaskTypeMutationVariables>(DeactivateTaskTypeDocument, options);
      }
export type DeactivateTaskTypeMutationHookResult = ReturnType<typeof useDeactivateTaskTypeMutation>;
export type DeactivateTaskTypeMutationResult = Apollo.MutationResult<DeactivateTaskTypeMutation>;
export type DeactivateTaskTypeMutationOptions = Apollo.BaseMutationOptions<DeactivateTaskTypeMutation, DeactivateTaskTypeMutationVariables>;
export const DeleteBaoriderDocument = gql`
    mutation deleteBaorider($id: ID!) {
  removeBaorider(id: $id) {
    baorider {
      id
      attributes {
        username
      }
    }
  }
}
    `;
export type DeleteBaoriderMutationFn = Apollo.MutationFunction<DeleteBaoriderMutation, DeleteBaoriderMutationVariables>;

/**
 * __useDeleteBaoriderMutation__
 *
 * To run a mutation, you first call `useDeleteBaoriderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBaoriderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBaoriderMutation, { data, loading, error }] = useDeleteBaoriderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBaoriderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBaoriderMutation, DeleteBaoriderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBaoriderMutation, DeleteBaoriderMutationVariables>(DeleteBaoriderDocument, options);
      }
export type DeleteBaoriderMutationHookResult = ReturnType<typeof useDeleteBaoriderMutation>;
export type DeleteBaoriderMutationResult = Apollo.MutationResult<DeleteBaoriderMutation>;
export type DeleteBaoriderMutationOptions = Apollo.BaseMutationOptions<DeleteBaoriderMutation, DeleteBaoriderMutationVariables>;
export const DeleteCommunityMemberDocument = gql`
    mutation deleteCommunityMember($id: ID!) {
  removeCommunityMember(id: $id) {
    member {
      id
      attributes {
        username
      }
    }
  }
}
    `;
export type DeleteCommunityMemberMutationFn = Apollo.MutationFunction<DeleteCommunityMemberMutation, DeleteCommunityMemberMutationVariables>;

/**
 * __useDeleteCommunityMemberMutation__
 *
 * To run a mutation, you first call `useDeleteCommunityMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommunityMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommunityMemberMutation, { data, loading, error }] = useDeleteCommunityMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCommunityMemberMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommunityMemberMutation, DeleteCommunityMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommunityMemberMutation, DeleteCommunityMemberMutationVariables>(DeleteCommunityMemberDocument, options);
      }
export type DeleteCommunityMemberMutationHookResult = ReturnType<typeof useDeleteCommunityMemberMutation>;
export type DeleteCommunityMemberMutationResult = Apollo.MutationResult<DeleteCommunityMemberMutation>;
export type DeleteCommunityMemberMutationOptions = Apollo.BaseMutationOptions<DeleteCommunityMemberMutation, DeleteCommunityMemberMutationVariables>;
export const DeleteBaoleaderInsightReportDocument = gql`
    mutation deleteBaoleaderInsightReport($id: ID!) {
  deleteBaoleaderInsightReport(id: $id) {
    id
    attributes {
      ...insightReport
    }
  }
}
    ${InsightReportFragmentDoc}`;
export type DeleteBaoleaderInsightReportMutationFn = Apollo.MutationFunction<DeleteBaoleaderInsightReportMutation, DeleteBaoleaderInsightReportMutationVariables>;

/**
 * __useDeleteBaoleaderInsightReportMutation__
 *
 * To run a mutation, you first call `useDeleteBaoleaderInsightReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBaoleaderInsightReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBaoleaderInsightReportMutation, { data, loading, error }] = useDeleteBaoleaderInsightReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBaoleaderInsightReportMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBaoleaderInsightReportMutation, DeleteBaoleaderInsightReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBaoleaderInsightReportMutation, DeleteBaoleaderInsightReportMutationVariables>(DeleteBaoleaderInsightReportDocument, options);
      }
export type DeleteBaoleaderInsightReportMutationHookResult = ReturnType<typeof useDeleteBaoleaderInsightReportMutation>;
export type DeleteBaoleaderInsightReportMutationResult = Apollo.MutationResult<DeleteBaoleaderInsightReportMutation>;
export type DeleteBaoleaderInsightReportMutationOptions = Apollo.BaseMutationOptions<DeleteBaoleaderInsightReportMutation, DeleteBaoleaderInsightReportMutationVariables>;
export const DeleteTaskDocument = gql`
    mutation deleteTask($id: ID!) {
  deleteBaoleaderTask(id: $id) {
    id
    attributes {
      baorider {
        data {
          id
        }
      }
    }
  }
}
    `;
export type DeleteTaskMutationFn = Apollo.MutationFunction<DeleteTaskMutation, DeleteTaskMutationVariables>;

/**
 * __useDeleteTaskMutation__
 *
 * To run a mutation, you first call `useDeleteTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskMutation, { data, loading, error }] = useDeleteTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTaskMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTaskMutation, DeleteTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTaskMutation, DeleteTaskMutationVariables>(DeleteTaskDocument, options);
      }
export type DeleteTaskMutationHookResult = ReturnType<typeof useDeleteTaskMutation>;
export type DeleteTaskMutationResult = Apollo.MutationResult<DeleteTaskMutation>;
export type DeleteTaskMutationOptions = Apollo.BaseMutationOptions<DeleteTaskMutation, DeleteTaskMutationVariables>;
export const DeleteTasktypeDocument = gql`
    mutation deleteTasktype($id: ID!) {
  deleteTaskType(id: $id) {
    data {
      id
    }
  }
}
    `;
export type DeleteTasktypeMutationFn = Apollo.MutationFunction<DeleteTasktypeMutation, DeleteTasktypeMutationVariables>;

/**
 * __useDeleteTasktypeMutation__
 *
 * To run a mutation, you first call `useDeleteTasktypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTasktypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTasktypeMutation, { data, loading, error }] = useDeleteTasktypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTasktypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTasktypeMutation, DeleteTasktypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTasktypeMutation, DeleteTasktypeMutationVariables>(DeleteTasktypeDocument, options);
      }
export type DeleteTasktypeMutationHookResult = ReturnType<typeof useDeleteTasktypeMutation>;
export type DeleteTasktypeMutationResult = Apollo.MutationResult<DeleteTasktypeMutation>;
export type DeleteTasktypeMutationOptions = Apollo.BaseMutationOptions<DeleteTasktypeMutation, DeleteTasktypeMutationVariables>;
export const ExecuteInsightReportAgentDocument = gql`
    mutation executeInsightReportAgent($input: InsightAgentReportInput!) {
  executeInsightReportAgent(input: $input) {
    preview
    warnings
    report {
      id
      attributes {
        ...insightReport
      }
    }
  }
}
    ${InsightReportFragmentDoc}`;
export type ExecuteInsightReportAgentMutationFn = Apollo.MutationFunction<ExecuteInsightReportAgentMutation, ExecuteInsightReportAgentMutationVariables>;

/**
 * __useExecuteInsightReportAgentMutation__
 *
 * To run a mutation, you first call `useExecuteInsightReportAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteInsightReportAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeInsightReportAgentMutation, { data, loading, error }] = useExecuteInsightReportAgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExecuteInsightReportAgentMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteInsightReportAgentMutation, ExecuteInsightReportAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteInsightReportAgentMutation, ExecuteInsightReportAgentMutationVariables>(ExecuteInsightReportAgentDocument, options);
      }
export type ExecuteInsightReportAgentMutationHookResult = ReturnType<typeof useExecuteInsightReportAgentMutation>;
export type ExecuteInsightReportAgentMutationResult = Apollo.MutationResult<ExecuteInsightReportAgentMutation>;
export type ExecuteInsightReportAgentMutationOptions = Apollo.BaseMutationOptions<ExecuteInsightReportAgentMutation, ExecuteInsightReportAgentMutationVariables>;
export const ExportExcelDocument = gql`
    mutation exportExcel($filterValues: JSON, $pagination: PaginationArg) {
  exportExcel(filterValues: $filterValues, pagination: $pagination)
}
    `;
export type ExportExcelMutationFn = Apollo.MutationFunction<ExportExcelMutation, ExportExcelMutationVariables>;

/**
 * __useExportExcelMutation__
 *
 * To run a mutation, you first call `useExportExcelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportExcelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportExcelMutation, { data, loading, error }] = useExportExcelMutation({
 *   variables: {
 *      filterValues: // value for 'filterValues'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useExportExcelMutation(baseOptions?: Apollo.MutationHookOptions<ExportExcelMutation, ExportExcelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportExcelMutation, ExportExcelMutationVariables>(ExportExcelDocument, options);
      }
export type ExportExcelMutationHookResult = ReturnType<typeof useExportExcelMutation>;
export type ExportExcelMutationResult = Apollo.MutationResult<ExportExcelMutation>;
export type ExportExcelMutationOptions = Apollo.BaseMutationOptions<ExportExcelMutation, ExportExcelMutationVariables>;
export const LoginCustomerPortalDocument = gql`
    mutation loginCustomerPortal {
  loginCustomerPortal
}
    `;
export type LoginCustomerPortalMutationFn = Apollo.MutationFunction<LoginCustomerPortalMutation, LoginCustomerPortalMutationVariables>;

/**
 * __useLoginCustomerPortalMutation__
 *
 * To run a mutation, you first call `useLoginCustomerPortalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginCustomerPortalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginCustomerPortalMutation, { data, loading, error }] = useLoginCustomerPortalMutation({
 *   variables: {
 *   },
 * });
 */
export function useLoginCustomerPortalMutation(baseOptions?: Apollo.MutationHookOptions<LoginCustomerPortalMutation, LoginCustomerPortalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginCustomerPortalMutation, LoginCustomerPortalMutationVariables>(LoginCustomerPortalDocument, options);
      }
export type LoginCustomerPortalMutationHookResult = ReturnType<typeof useLoginCustomerPortalMutation>;
export type LoginCustomerPortalMutationResult = Apollo.MutationResult<LoginCustomerPortalMutation>;
export type LoginCustomerPortalMutationOptions = Apollo.BaseMutationOptions<LoginCustomerPortalMutation, LoginCustomerPortalMutationVariables>;
export const MigrateToAutomatedPlanDocument = gql`
    mutation migrateToAutomatedPlan($input: MigrateToAutomatedPlanInput) {
  migrateToAutomatedPlan(input: $input) {
    status
    planId
    planName
    priceId
    currency
    billingStartsAt
  }
}
    `;
export type MigrateToAutomatedPlanMutationFn = Apollo.MutationFunction<MigrateToAutomatedPlanMutation, MigrateToAutomatedPlanMutationVariables>;

/**
 * __useMigrateToAutomatedPlanMutation__
 *
 * To run a mutation, you first call `useMigrateToAutomatedPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMigrateToAutomatedPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [migrateToAutomatedPlanMutation, { data, loading, error }] = useMigrateToAutomatedPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMigrateToAutomatedPlanMutation(baseOptions?: Apollo.MutationHookOptions<MigrateToAutomatedPlanMutation, MigrateToAutomatedPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MigrateToAutomatedPlanMutation, MigrateToAutomatedPlanMutationVariables>(MigrateToAutomatedPlanDocument, options);
      }
export type MigrateToAutomatedPlanMutationHookResult = ReturnType<typeof useMigrateToAutomatedPlanMutation>;
export type MigrateToAutomatedPlanMutationResult = Apollo.MutationResult<MigrateToAutomatedPlanMutation>;
export type MigrateToAutomatedPlanMutationOptions = Apollo.BaseMutationOptions<MigrateToAutomatedPlanMutation, MigrateToAutomatedPlanMutationVariables>;
export const RedeemFeatureCouponDocument = gql`
    mutation redeemFeatureCoupon($code: String!) {
  redeemFeatureCoupon(code: $code) {
    feature
    expiresAt
    active
  }
}
    `;
export type RedeemFeatureCouponMutationFn = Apollo.MutationFunction<RedeemFeatureCouponMutation, RedeemFeatureCouponMutationVariables>;

/**
 * __useRedeemFeatureCouponMutation__
 *
 * To run a mutation, you first call `useRedeemFeatureCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemFeatureCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemFeatureCouponMutation, { data, loading, error }] = useRedeemFeatureCouponMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useRedeemFeatureCouponMutation(baseOptions?: Apollo.MutationHookOptions<RedeemFeatureCouponMutation, RedeemFeatureCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedeemFeatureCouponMutation, RedeemFeatureCouponMutationVariables>(RedeemFeatureCouponDocument, options);
      }
export type RedeemFeatureCouponMutationHookResult = ReturnType<typeof useRedeemFeatureCouponMutation>;
export type RedeemFeatureCouponMutationResult = Apollo.MutationResult<RedeemFeatureCouponMutation>;
export type RedeemFeatureCouponMutationOptions = Apollo.BaseMutationOptions<RedeemFeatureCouponMutation, RedeemFeatureCouponMutationVariables>;
export const RejectCommunityMemberRequestDocument = gql`
    mutation rejectCommunityMemberRequest($requestId: ID!) {
  rejectCommunityMemberRequest(requestId: $requestId) {
    id
    attributes {
      firstName
      lastName
    }
  }
}
    `;
export type RejectCommunityMemberRequestMutationFn = Apollo.MutationFunction<RejectCommunityMemberRequestMutation, RejectCommunityMemberRequestMutationVariables>;

/**
 * __useRejectCommunityMemberRequestMutation__
 *
 * To run a mutation, you first call `useRejectCommunityMemberRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectCommunityMemberRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectCommunityMemberRequestMutation, { data, loading, error }] = useRejectCommunityMemberRequestMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useRejectCommunityMemberRequestMutation(baseOptions?: Apollo.MutationHookOptions<RejectCommunityMemberRequestMutation, RejectCommunityMemberRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectCommunityMemberRequestMutation, RejectCommunityMemberRequestMutationVariables>(RejectCommunityMemberRequestDocument, options);
      }
export type RejectCommunityMemberRequestMutationHookResult = ReturnType<typeof useRejectCommunityMemberRequestMutation>;
export type RejectCommunityMemberRequestMutationResult = Apollo.MutationResult<RejectCommunityMemberRequestMutation>;
export type RejectCommunityMemberRequestMutationOptions = Apollo.BaseMutationOptions<RejectCommunityMemberRequestMutation, RejectCommunityMemberRequestMutationVariables>;
export const RemoveCompanyMemberDocument = gql`
    mutation removeCompanyMember($memberId: ID!) {
  removeCompanyMember(memberId: $memberId) {
    id
  }
}
    `;
export type RemoveCompanyMemberMutationFn = Apollo.MutationFunction<RemoveCompanyMemberMutation, RemoveCompanyMemberMutationVariables>;

/**
 * __useRemoveCompanyMemberMutation__
 *
 * To run a mutation, you first call `useRemoveCompanyMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCompanyMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCompanyMemberMutation, { data, loading, error }] = useRemoveCompanyMemberMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useRemoveCompanyMemberMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCompanyMemberMutation, RemoveCompanyMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCompanyMemberMutation, RemoveCompanyMemberMutationVariables>(RemoveCompanyMemberDocument, options);
      }
export type RemoveCompanyMemberMutationHookResult = ReturnType<typeof useRemoveCompanyMemberMutation>;
export type RemoveCompanyMemberMutationResult = Apollo.MutationResult<RemoveCompanyMemberMutation>;
export type RemoveCompanyMemberMutationOptions = Apollo.BaseMutationOptions<RemoveCompanyMemberMutation, RemoveCompanyMemberMutationVariables>;
export const RemovePaymentMethodDocument = gql`
    mutation removePaymentMethod($paymentMethodId: ID!) {
  removePaymentMethod(paymentMethodId: $paymentMethodId)
}
    `;
export type RemovePaymentMethodMutationFn = Apollo.MutationFunction<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>;

/**
 * __useRemovePaymentMethodMutation__
 *
 * To run a mutation, you first call `useRemovePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePaymentMethodMutation, { data, loading, error }] = useRemovePaymentMethodMutation({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useRemovePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>(RemovePaymentMethodDocument, options);
      }
export type RemovePaymentMethodMutationHookResult = ReturnType<typeof useRemovePaymentMethodMutation>;
export type RemovePaymentMethodMutationResult = Apollo.MutationResult<RemovePaymentMethodMutation>;
export type RemovePaymentMethodMutationOptions = Apollo.BaseMutationOptions<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>;
export const RequestMoreInfoDocument = gql`
    mutation requestMoreInfo($id: ID!, $input: TaskInput) {
  requestMoreInfo(id: $id, input: $input) {
    id
  }
}
    `;
export type RequestMoreInfoMutationFn = Apollo.MutationFunction<RequestMoreInfoMutation, RequestMoreInfoMutationVariables>;

/**
 * __useRequestMoreInfoMutation__
 *
 * To run a mutation, you first call `useRequestMoreInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestMoreInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestMoreInfoMutation, { data, loading, error }] = useRequestMoreInfoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestMoreInfoMutation(baseOptions?: Apollo.MutationHookOptions<RequestMoreInfoMutation, RequestMoreInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestMoreInfoMutation, RequestMoreInfoMutationVariables>(RequestMoreInfoDocument, options);
      }
export type RequestMoreInfoMutationHookResult = ReturnType<typeof useRequestMoreInfoMutation>;
export type RequestMoreInfoMutationResult = Apollo.MutationResult<RequestMoreInfoMutation>;
export type RequestMoreInfoMutationOptions = Apollo.BaseMutationOptions<RequestMoreInfoMutation, RequestMoreInfoMutationVariables>;
export const RequestUpdateCompanyDetailsDocument = gql`
    mutation requestUpdateCompanyDetails($data: RequestCompanyDetailsChangeInput!) {
  requestUpdateCompanyDetails(data: $data) {
    name
  }
}
    `;
export type RequestUpdateCompanyDetailsMutationFn = Apollo.MutationFunction<RequestUpdateCompanyDetailsMutation, RequestUpdateCompanyDetailsMutationVariables>;

/**
 * __useRequestUpdateCompanyDetailsMutation__
 *
 * To run a mutation, you first call `useRequestUpdateCompanyDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestUpdateCompanyDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestUpdateCompanyDetailsMutation, { data, loading, error }] = useRequestUpdateCompanyDetailsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRequestUpdateCompanyDetailsMutation(baseOptions?: Apollo.MutationHookOptions<RequestUpdateCompanyDetailsMutation, RequestUpdateCompanyDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestUpdateCompanyDetailsMutation, RequestUpdateCompanyDetailsMutationVariables>(RequestUpdateCompanyDetailsDocument, options);
      }
export type RequestUpdateCompanyDetailsMutationHookResult = ReturnType<typeof useRequestUpdateCompanyDetailsMutation>;
export type RequestUpdateCompanyDetailsMutationResult = Apollo.MutationResult<RequestUpdateCompanyDetailsMutation>;
export type RequestUpdateCompanyDetailsMutationOptions = Apollo.BaseMutationOptions<RequestUpdateCompanyDetailsMutation, RequestUpdateCompanyDetailsMutationVariables>;
export const ResendDataCollectorInviteDocument = gql`
    mutation ResendDataCollectorInvite($id: ID!) {
  resendDataCollectorInvite(id: $id) {
    id
  }
}
    `;
export type ResendDataCollectorInviteMutationFn = Apollo.MutationFunction<ResendDataCollectorInviteMutation, ResendDataCollectorInviteMutationVariables>;

/**
 * __useResendDataCollectorInviteMutation__
 *
 * To run a mutation, you first call `useResendDataCollectorInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendDataCollectorInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendDataCollectorInviteMutation, { data, loading, error }] = useResendDataCollectorInviteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendDataCollectorInviteMutation(baseOptions?: Apollo.MutationHookOptions<ResendDataCollectorInviteMutation, ResendDataCollectorInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendDataCollectorInviteMutation, ResendDataCollectorInviteMutationVariables>(ResendDataCollectorInviteDocument, options);
      }
export type ResendDataCollectorInviteMutationHookResult = ReturnType<typeof useResendDataCollectorInviteMutation>;
export type ResendDataCollectorInviteMutationResult = Apollo.MutationResult<ResendDataCollectorInviteMutation>;
export type ResendDataCollectorInviteMutationOptions = Apollo.BaseMutationOptions<ResendDataCollectorInviteMutation, ResendDataCollectorInviteMutationVariables>;
export const ResumeSubscriptionDocument = gql`
    mutation resumeSubscription {
  resumeSubscription {
    status
    cancelAtPeriodEnd
    endsAt
  }
}
    `;
export type ResumeSubscriptionMutationFn = Apollo.MutationFunction<ResumeSubscriptionMutation, ResumeSubscriptionMutationVariables>;

/**
 * __useResumeSubscriptionMutation__
 *
 * To run a mutation, you first call `useResumeSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeSubscriptionMutation, { data, loading, error }] = useResumeSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useResumeSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<ResumeSubscriptionMutation, ResumeSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResumeSubscriptionMutation, ResumeSubscriptionMutationVariables>(ResumeSubscriptionDocument, options);
      }
export type ResumeSubscriptionMutationHookResult = ReturnType<typeof useResumeSubscriptionMutation>;
export type ResumeSubscriptionMutationResult = Apollo.MutationResult<ResumeSubscriptionMutation>;
export type ResumeSubscriptionMutationOptions = Apollo.BaseMutationOptions<ResumeSubscriptionMutation, ResumeSubscriptionMutationVariables>;
export const SetDefaultPaymentMethodDocument = gql`
    mutation setDefaultPaymentMethod($paymentMethodId: ID!) {
  setDefaultPaymentMethod(paymentMethodId: $paymentMethodId)
}
    `;
export type SetDefaultPaymentMethodMutationFn = Apollo.MutationFunction<SetDefaultPaymentMethodMutation, SetDefaultPaymentMethodMutationVariables>;

/**
 * __useSetDefaultPaymentMethodMutation__
 *
 * To run a mutation, you first call `useSetDefaultPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultPaymentMethodMutation, { data, loading, error }] = useSetDefaultPaymentMethodMutation({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useSetDefaultPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultPaymentMethodMutation, SetDefaultPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultPaymentMethodMutation, SetDefaultPaymentMethodMutationVariables>(SetDefaultPaymentMethodDocument, options);
      }
export type SetDefaultPaymentMethodMutationHookResult = ReturnType<typeof useSetDefaultPaymentMethodMutation>;
export type SetDefaultPaymentMethodMutationResult = Apollo.MutationResult<SetDefaultPaymentMethodMutation>;
export type SetDefaultPaymentMethodMutationOptions = Apollo.BaseMutationOptions<SetDefaultPaymentMethodMutation, SetDefaultPaymentMethodMutationVariables>;
export const SkipOnboardingStepDocument = gql`
    mutation skipOnboardingStep($index: String!, $completeOnboarding: Boolean) {
  skipOnboardingStep(index: $index, completeOnboarding: $completeOnboarding) {
    id
    attributes {
      username
    }
  }
}
    `;
export type SkipOnboardingStepMutationFn = Apollo.MutationFunction<SkipOnboardingStepMutation, SkipOnboardingStepMutationVariables>;

/**
 * __useSkipOnboardingStepMutation__
 *
 * To run a mutation, you first call `useSkipOnboardingStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipOnboardingStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipOnboardingStepMutation, { data, loading, error }] = useSkipOnboardingStepMutation({
 *   variables: {
 *      index: // value for 'index'
 *      completeOnboarding: // value for 'completeOnboarding'
 *   },
 * });
 */
export function useSkipOnboardingStepMutation(baseOptions?: Apollo.MutationHookOptions<SkipOnboardingStepMutation, SkipOnboardingStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SkipOnboardingStepMutation, SkipOnboardingStepMutationVariables>(SkipOnboardingStepDocument, options);
      }
export type SkipOnboardingStepMutationHookResult = ReturnType<typeof useSkipOnboardingStepMutation>;
export type SkipOnboardingStepMutationResult = Apollo.MutationResult<SkipOnboardingStepMutation>;
export type SkipOnboardingStepMutationOptions = Apollo.BaseMutationOptions<SkipOnboardingStepMutation, SkipOnboardingStepMutationVariables>;
export const CreateTaskDefinitionDocument = gql`
    mutation createTaskDefinition($input: TaskDefinitionInput) {
  createBaoleaderTaskDefinition(input: $input) {
    id
    attributes {
      category {
        data {
          id
        }
      }
      task_type {
        data {
          id
        }
      }
    }
  }
}
    `;
export type CreateTaskDefinitionMutationFn = Apollo.MutationFunction<CreateTaskDefinitionMutation, CreateTaskDefinitionMutationVariables>;

/**
 * __useCreateTaskDefinitionMutation__
 *
 * To run a mutation, you first call `useCreateTaskDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskDefinitionMutation, { data, loading, error }] = useCreateTaskDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaskDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskDefinitionMutation, CreateTaskDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskDefinitionMutation, CreateTaskDefinitionMutationVariables>(CreateTaskDefinitionDocument, options);
      }
export type CreateTaskDefinitionMutationHookResult = ReturnType<typeof useCreateTaskDefinitionMutation>;
export type CreateTaskDefinitionMutationResult = Apollo.MutationResult<CreateTaskDefinitionMutation>;
export type CreateTaskDefinitionMutationOptions = Apollo.BaseMutationOptions<CreateTaskDefinitionMutation, CreateTaskDefinitionMutationVariables>;
export const UpdateBaoleaderTaskDefinitionDocument = gql`
    mutation updateBaoleaderTaskDefinition($id: ID!, $input: TaskDefinitionInput) {
  updateBaoleaderTaskDefinition(id: $id, input: $input) {
    id
    attributes {
      category {
        data {
          id
        }
      }
      task_type {
        data {
          id
        }
      }
    }
  }
}
    `;
export type UpdateBaoleaderTaskDefinitionMutationFn = Apollo.MutationFunction<UpdateBaoleaderTaskDefinitionMutation, UpdateBaoleaderTaskDefinitionMutationVariables>;

/**
 * __useUpdateBaoleaderTaskDefinitionMutation__
 *
 * To run a mutation, you first call `useUpdateBaoleaderTaskDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBaoleaderTaskDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBaoleaderTaskDefinitionMutation, { data, loading, error }] = useUpdateBaoleaderTaskDefinitionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBaoleaderTaskDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBaoleaderTaskDefinitionMutation, UpdateBaoleaderTaskDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBaoleaderTaskDefinitionMutation, UpdateBaoleaderTaskDefinitionMutationVariables>(UpdateBaoleaderTaskDefinitionDocument, options);
      }
export type UpdateBaoleaderTaskDefinitionMutationHookResult = ReturnType<typeof useUpdateBaoleaderTaskDefinitionMutation>;
export type UpdateBaoleaderTaskDefinitionMutationResult = Apollo.MutationResult<UpdateBaoleaderTaskDefinitionMutation>;
export type UpdateBaoleaderTaskDefinitionMutationOptions = Apollo.BaseMutationOptions<UpdateBaoleaderTaskDefinitionMutation, UpdateBaoleaderTaskDefinitionMutationVariables>;
export const DeleteBaoleaderTaskDefinitionDocument = gql`
    mutation deleteBaoleaderTaskDefinition($id: ID!) {
  deleteBaoleaderTaskDefinition(id: $id) {
    id
    attributes {
      category {
        data {
          id
        }
      }
      task_type {
        data {
          id
        }
      }
    }
  }
}
    `;
export type DeleteBaoleaderTaskDefinitionMutationFn = Apollo.MutationFunction<DeleteBaoleaderTaskDefinitionMutation, DeleteBaoleaderTaskDefinitionMutationVariables>;

/**
 * __useDeleteBaoleaderTaskDefinitionMutation__
 *
 * To run a mutation, you first call `useDeleteBaoleaderTaskDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBaoleaderTaskDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBaoleaderTaskDefinitionMutation, { data, loading, error }] = useDeleteBaoleaderTaskDefinitionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBaoleaderTaskDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBaoleaderTaskDefinitionMutation, DeleteBaoleaderTaskDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBaoleaderTaskDefinitionMutation, DeleteBaoleaderTaskDefinitionMutationVariables>(DeleteBaoleaderTaskDefinitionDocument, options);
      }
export type DeleteBaoleaderTaskDefinitionMutationHookResult = ReturnType<typeof useDeleteBaoleaderTaskDefinitionMutation>;
export type DeleteBaoleaderTaskDefinitionMutationResult = Apollo.MutationResult<DeleteBaoleaderTaskDefinitionMutation>;
export type DeleteBaoleaderTaskDefinitionMutationOptions = Apollo.BaseMutationOptions<DeleteBaoleaderTaskDefinitionMutation, DeleteBaoleaderTaskDefinitionMutationVariables>;
export const CreateTaskTypeDocument = gql`
    mutation createTaskType($input: TaskTypeInput!, $dataFieldsArr: JSON) {
  createBaoleaderTaskType(input: $input, dataFieldsArr: $dataFieldsArr) {
    id
    attributes {
      ...taskType
      category {
        data {
          id
        }
      }
    }
  }
}
    ${TaskTypeFragmentDoc}`;
export type CreateTaskTypeMutationFn = Apollo.MutationFunction<CreateTaskTypeMutation, CreateTaskTypeMutationVariables>;

/**
 * __useCreateTaskTypeMutation__
 *
 * To run a mutation, you first call `useCreateTaskTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskTypeMutation, { data, loading, error }] = useCreateTaskTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *      dataFieldsArr: // value for 'dataFieldsArr'
 *   },
 * });
 */
export function useCreateTaskTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskTypeMutation, CreateTaskTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskTypeMutation, CreateTaskTypeMutationVariables>(CreateTaskTypeDocument, options);
      }
export type CreateTaskTypeMutationHookResult = ReturnType<typeof useCreateTaskTypeMutation>;
export type CreateTaskTypeMutationResult = Apollo.MutationResult<CreateTaskTypeMutation>;
export type CreateTaskTypeMutationOptions = Apollo.BaseMutationOptions<CreateTaskTypeMutation, CreateTaskTypeMutationVariables>;
export const UnarchiveCompanyMemberDocument = gql`
    mutation unarchiveCompanyMember($memberId: ID!) {
  unarchiveCompanyMember(memberId: $memberId) {
    id
  }
}
    `;
export type UnarchiveCompanyMemberMutationFn = Apollo.MutationFunction<UnarchiveCompanyMemberMutation, UnarchiveCompanyMemberMutationVariables>;

/**
 * __useUnarchiveCompanyMemberMutation__
 *
 * To run a mutation, you first call `useUnarchiveCompanyMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveCompanyMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveCompanyMemberMutation, { data, loading, error }] = useUnarchiveCompanyMemberMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useUnarchiveCompanyMemberMutation(baseOptions?: Apollo.MutationHookOptions<UnarchiveCompanyMemberMutation, UnarchiveCompanyMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnarchiveCompanyMemberMutation, UnarchiveCompanyMemberMutationVariables>(UnarchiveCompanyMemberDocument, options);
      }
export type UnarchiveCompanyMemberMutationHookResult = ReturnType<typeof useUnarchiveCompanyMemberMutation>;
export type UnarchiveCompanyMemberMutationResult = Apollo.MutationResult<UnarchiveCompanyMemberMutation>;
export type UnarchiveCompanyMemberMutationOptions = Apollo.BaseMutationOptions<UnarchiveCompanyMemberMutation, UnarchiveCompanyMemberMutationVariables>;
export const UpdateBaoriderDocument = gql`
    mutation updateBaorider($id: ID!, $baorider: UpdateBaoriderInput) {
  updateBaorider(id: $id, baorider: $baorider) {
    baorider {
      id
    }
  }
}
    `;
export type UpdateBaoriderMutationFn = Apollo.MutationFunction<UpdateBaoriderMutation, UpdateBaoriderMutationVariables>;

/**
 * __useUpdateBaoriderMutation__
 *
 * To run a mutation, you first call `useUpdateBaoriderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBaoriderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBaoriderMutation, { data, loading, error }] = useUpdateBaoriderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      baorider: // value for 'baorider'
 *   },
 * });
 */
export function useUpdateBaoriderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBaoriderMutation, UpdateBaoriderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBaoriderMutation, UpdateBaoriderMutationVariables>(UpdateBaoriderDocument, options);
      }
export type UpdateBaoriderMutationHookResult = ReturnType<typeof useUpdateBaoriderMutation>;
export type UpdateBaoriderMutationResult = Apollo.MutationResult<UpdateBaoriderMutation>;
export type UpdateBaoriderMutationOptions = Apollo.BaseMutationOptions<UpdateBaoriderMutation, UpdateBaoriderMutationVariables>;
export const UpdateCategoryDocument = gql`
    mutation updateCategory($id: ID!, $input: CategoryInput!) {
  updateCategory(id: $id, data: $input) {
    data {
      id
      attributes {
        ...category
      }
    }
  }
}
    ${CategoryFragmentDoc}`;
export type UpdateCategoryMutationFn = Apollo.MutationFunction<UpdateCategoryMutation, UpdateCategoryMutationVariables>;

/**
 * __useUpdateCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCategoryMutation, { data, loading, error }] = useUpdateCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCategoryMutation, UpdateCategoryMutationVariables>(UpdateCategoryDocument, options);
      }
export type UpdateCategoryMutationHookResult = ReturnType<typeof useUpdateCategoryMutation>;
export type UpdateCategoryMutationResult = Apollo.MutationResult<UpdateCategoryMutation>;
export type UpdateCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>;
export const UpdateCommunityDocument = gql`
    mutation updateCommunity($id: ID!, $input: CommunityInput) {
  updateBaoleaderCommunity(id: $id, input: $input) {
    id
    attributes {
      name
    }
  }
}
    `;
export type UpdateCommunityMutationFn = Apollo.MutationFunction<UpdateCommunityMutation, UpdateCommunityMutationVariables>;

/**
 * __useUpdateCommunityMutation__
 *
 * To run a mutation, you first call `useUpdateCommunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommunityMutation, { data, loading, error }] = useUpdateCommunityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCommunityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommunityMutation, UpdateCommunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommunityMutation, UpdateCommunityMutationVariables>(UpdateCommunityDocument, options);
      }
export type UpdateCommunityMutationHookResult = ReturnType<typeof useUpdateCommunityMutation>;
export type UpdateCommunityMutationResult = Apollo.MutationResult<UpdateCommunityMutation>;
export type UpdateCommunityMutationOptions = Apollo.BaseMutationOptions<UpdateCommunityMutation, UpdateCommunityMutationVariables>;
export const UpdateCommunityMemberDocument = gql`
    mutation updateCommunityMember($id: ID!, $input: UpdateCommunityMembersInput) {
  updateCommunityMember(id: $id, input: $input) {
    member {
      id
      attributes {
        username
      }
    }
  }
}
    `;
export type UpdateCommunityMemberMutationFn = Apollo.MutationFunction<UpdateCommunityMemberMutation, UpdateCommunityMemberMutationVariables>;

/**
 * __useUpdateCommunityMemberMutation__
 *
 * To run a mutation, you first call `useUpdateCommunityMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommunityMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommunityMemberMutation, { data, loading, error }] = useUpdateCommunityMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCommunityMemberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommunityMemberMutation, UpdateCommunityMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommunityMemberMutation, UpdateCommunityMemberMutationVariables>(UpdateCommunityMemberDocument, options);
      }
export type UpdateCommunityMemberMutationHookResult = ReturnType<typeof useUpdateCommunityMemberMutation>;
export type UpdateCommunityMemberMutationResult = Apollo.MutationResult<UpdateCommunityMemberMutation>;
export type UpdateCommunityMemberMutationOptions = Apollo.BaseMutationOptions<UpdateCommunityMemberMutation, UpdateCommunityMemberMutationVariables>;
export const UpdateCompanyOnboardingInformationDocument = gql`
    mutation updateCompanyOnboardingInformation($onboardingInformation: JSON!) {
  updateCompanyOnboardingInformation(
    onboardingInformation: $onboardingInformation
  ) {
    id
    attributes {
      onboardingInformation
    }
  }
}
    `;
export type UpdateCompanyOnboardingInformationMutationFn = Apollo.MutationFunction<UpdateCompanyOnboardingInformationMutation, UpdateCompanyOnboardingInformationMutationVariables>;

/**
 * __useUpdateCompanyOnboardingInformationMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyOnboardingInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyOnboardingInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyOnboardingInformationMutation, { data, loading, error }] = useUpdateCompanyOnboardingInformationMutation({
 *   variables: {
 *      onboardingInformation: // value for 'onboardingInformation'
 *   },
 * });
 */
export function useUpdateCompanyOnboardingInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyOnboardingInformationMutation, UpdateCompanyOnboardingInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyOnboardingInformationMutation, UpdateCompanyOnboardingInformationMutationVariables>(UpdateCompanyOnboardingInformationDocument, options);
      }
export type UpdateCompanyOnboardingInformationMutationHookResult = ReturnType<typeof useUpdateCompanyOnboardingInformationMutation>;
export type UpdateCompanyOnboardingInformationMutationResult = Apollo.MutationResult<UpdateCompanyOnboardingInformationMutation>;
export type UpdateCompanyOnboardingInformationMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyOnboardingInformationMutation, UpdateCompanyOnboardingInformationMutationVariables>;
export const UpdateDataListDocument = gql`
    mutation updateDataList($input: DataListInput!, $id: ID!) {
  updateDataList(data: $input, id: $id) {
    data {
      id
      attributes {
        name
      }
    }
  }
}
    `;
export type UpdateDataListMutationFn = Apollo.MutationFunction<UpdateDataListMutation, UpdateDataListMutationVariables>;

/**
 * __useUpdateDataListMutation__
 *
 * To run a mutation, you first call `useUpdateDataListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDataListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDataListMutation, { data, loading, error }] = useUpdateDataListMutation({
 *   variables: {
 *      input: // value for 'input'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateDataListMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDataListMutation, UpdateDataListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDataListMutation, UpdateDataListMutationVariables>(UpdateDataListDocument, options);
      }
export type UpdateDataListMutationHookResult = ReturnType<typeof useUpdateDataListMutation>;
export type UpdateDataListMutationResult = Apollo.MutationResult<UpdateDataListMutation>;
export type UpdateDataListMutationOptions = Apollo.BaseMutationOptions<UpdateDataListMutation, UpdateDataListMutationVariables>;
export const UpdateDataListOptionDocument = gql`
    mutation updateDataListOption($input: DataListOptionInput!, $id: ID!) {
  updateDataListOption(data: $input, id: $id) {
    data {
      id
      attributes {
        value
      }
    }
  }
}
    `;
export type UpdateDataListOptionMutationFn = Apollo.MutationFunction<UpdateDataListOptionMutation, UpdateDataListOptionMutationVariables>;

/**
 * __useUpdateDataListOptionMutation__
 *
 * To run a mutation, you first call `useUpdateDataListOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDataListOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDataListOptionMutation, { data, loading, error }] = useUpdateDataListOptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateDataListOptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDataListOptionMutation, UpdateDataListOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDataListOptionMutation, UpdateDataListOptionMutationVariables>(UpdateDataListOptionDocument, options);
      }
export type UpdateDataListOptionMutationHookResult = ReturnType<typeof useUpdateDataListOptionMutation>;
export type UpdateDataListOptionMutationResult = Apollo.MutationResult<UpdateDataListOptionMutation>;
export type UpdateDataListOptionMutationOptions = Apollo.BaseMutationOptions<UpdateDataListOptionMutation, UpdateDataListOptionMutationVariables>;
export const UpdateEvidenceDocument = gql`
    mutation updateEvidence($id: ID!, $input: EvidenceInput) {
  updateBaoleaderEvidence(id: $id, input: $input) {
    notes
  }
}
    `;
export type UpdateEvidenceMutationFn = Apollo.MutationFunction<UpdateEvidenceMutation, UpdateEvidenceMutationVariables>;

/**
 * __useUpdateEvidenceMutation__
 *
 * To run a mutation, you first call `useUpdateEvidenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEvidenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEvidenceMutation, { data, loading, error }] = useUpdateEvidenceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEvidenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEvidenceMutation, UpdateEvidenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEvidenceMutation, UpdateEvidenceMutationVariables>(UpdateEvidenceDocument, options);
      }
export type UpdateEvidenceMutationHookResult = ReturnType<typeof useUpdateEvidenceMutation>;
export type UpdateEvidenceMutationResult = Apollo.MutationResult<UpdateEvidenceMutation>;
export type UpdateEvidenceMutationOptions = Apollo.BaseMutationOptions<UpdateEvidenceMutation, UpdateEvidenceMutationVariables>;
export const UpdateBaoleaderInsightReportDocument = gql`
    mutation updateBaoleaderInsightReport($id: ID!, $input: InsightReportCustomInput!) {
  updateBaoleaderInsightReport(id: $id, input: $input) {
    id
    attributes {
      ...insightReport
    }
  }
}
    ${InsightReportFragmentDoc}`;
export type UpdateBaoleaderInsightReportMutationFn = Apollo.MutationFunction<UpdateBaoleaderInsightReportMutation, UpdateBaoleaderInsightReportMutationVariables>;

/**
 * __useUpdateBaoleaderInsightReportMutation__
 *
 * To run a mutation, you first call `useUpdateBaoleaderInsightReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBaoleaderInsightReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBaoleaderInsightReportMutation, { data, loading, error }] = useUpdateBaoleaderInsightReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBaoleaderInsightReportMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBaoleaderInsightReportMutation, UpdateBaoleaderInsightReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBaoleaderInsightReportMutation, UpdateBaoleaderInsightReportMutationVariables>(UpdateBaoleaderInsightReportDocument, options);
      }
export type UpdateBaoleaderInsightReportMutationHookResult = ReturnType<typeof useUpdateBaoleaderInsightReportMutation>;
export type UpdateBaoleaderInsightReportMutationResult = Apollo.MutationResult<UpdateBaoleaderInsightReportMutation>;
export type UpdateBaoleaderInsightReportMutationOptions = Apollo.BaseMutationOptions<UpdateBaoleaderInsightReportMutation, UpdateBaoleaderInsightReportMutationVariables>;
export const UpdateMyUserDocument = gql`
    mutation updateMyUser($input: updateMyUserInput) {
  updateMyUser(input: $input) {
    id
  }
}
    `;
export type UpdateMyUserMutationFn = Apollo.MutationFunction<UpdateMyUserMutation, UpdateMyUserMutationVariables>;

/**
 * __useUpdateMyUserMutation__
 *
 * To run a mutation, you first call `useUpdateMyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyUserMutation, { data, loading, error }] = useUpdateMyUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMyUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMyUserMutation, UpdateMyUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMyUserMutation, UpdateMyUserMutationVariables>(UpdateMyUserDocument, options);
      }
export type UpdateMyUserMutationHookResult = ReturnType<typeof useUpdateMyUserMutation>;
export type UpdateMyUserMutationResult = Apollo.MutationResult<UpdateMyUserMutation>;
export type UpdateMyUserMutationOptions = Apollo.BaseMutationOptions<UpdateMyUserMutation, UpdateMyUserMutationVariables>;
export const UpdateNotificationDocument = gql`
    mutation updateNotification($id: ID!, $data: NotificationInput!) {
  updateBaoleaderNotification(id: $id, data: $data) {
    id
    attributes {
      title
      message
      type
      status
      dateSent
      recur
      timezone
      updatedAt
      nextScheduledNotificationDetails {
        id
        sendAt
        endAt
        recur
        status
        priority
      }
    }
  }
}
    `;
export type UpdateNotificationMutationFn = Apollo.MutationFunction<UpdateNotificationMutation, UpdateNotificationMutationVariables>;

/**
 * __useUpdateNotificationMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationMutation, { data, loading, error }] = useUpdateNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateNotificationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationMutation, UpdateNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationMutation, UpdateNotificationMutationVariables>(UpdateNotificationDocument, options);
      }
export type UpdateNotificationMutationHookResult = ReturnType<typeof useUpdateNotificationMutation>;
export type UpdateNotificationMutationResult = Apollo.MutationResult<UpdateNotificationMutation>;
export type UpdateNotificationMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationMutation, UpdateNotificationMutationVariables>;
export const UpdateProjectDocument = gql`
    mutation updateProject($id: ID!, $input: ProjectInput) {
  updateBaoleaderProject(id: $id, input: $input) {
    id
    attributes {
      name
    }
  }
}
    `;
export type UpdateProjectMutationFn = Apollo.MutationFunction<UpdateProjectMutation, UpdateProjectMutationVariables>;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, options);
      }
export type UpdateProjectMutationHookResult = ReturnType<typeof useUpdateProjectMutation>;
export type UpdateProjectMutationResult = Apollo.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const UpdateTaskDocument = gql`
    mutation updateTask($id: ID!, $input: TaskInput!) {
  updateBaoleaderTask(id: $id, input: $input) {
    id
    attributes {
      createdAt
    }
  }
}
    `;
export type UpdateTaskMutationFn = Apollo.MutationFunction<UpdateTaskMutation, UpdateTaskMutationVariables>;

/**
 * __useUpdateTaskMutation__
 *
 * To run a mutation, you first call `useUpdateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskMutation, { data, loading, error }] = useUpdateTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskMutation, UpdateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskMutation, UpdateTaskMutationVariables>(UpdateTaskDocument, options);
      }
export type UpdateTaskMutationHookResult = ReturnType<typeof useUpdateTaskMutation>;
export type UpdateTaskMutationResult = Apollo.MutationResult<UpdateTaskMutation>;
export type UpdateTaskMutationOptions = Apollo.BaseMutationOptions<UpdateTaskMutation, UpdateTaskMutationVariables>;
export const UpdateTaskTypeDocument = gql`
    mutation updateTaskType($id: ID!, $input: TaskTypeInput!, $dataFieldsArr: JSON, $diffs: JSON) {
  updateBaoleaderTaskType(
    id: $id
    input: $input
    dataFieldsArr: $dataFieldsArr
    diffs: $diffs
  ) {
    id
    attributes {
      title
    }
  }
}
    `;
export type UpdateTaskTypeMutationFn = Apollo.MutationFunction<UpdateTaskTypeMutation, UpdateTaskTypeMutationVariables>;

/**
 * __useUpdateTaskTypeMutation__
 *
 * To run a mutation, you first call `useUpdateTaskTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskTypeMutation, { data, loading, error }] = useUpdateTaskTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      dataFieldsArr: // value for 'dataFieldsArr'
 *      diffs: // value for 'diffs'
 *   },
 * });
 */
export function useUpdateTaskTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskTypeMutation, UpdateTaskTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskTypeMutation, UpdateTaskTypeMutationVariables>(UpdateTaskTypeDocument, options);
      }
export type UpdateTaskTypeMutationHookResult = ReturnType<typeof useUpdateTaskTypeMutation>;
export type UpdateTaskTypeMutationResult = Apollo.MutationResult<UpdateTaskTypeMutation>;
export type UpdateTaskTypeMutationOptions = Apollo.BaseMutationOptions<UpdateTaskTypeMutation, UpdateTaskTypeMutationVariables>;
export const UpdateVideoDocument = gql`
    mutation updateVideo($input: VideoInput!, $id: ID!) {
  updateVideo(data: $input, id: $id) {
    data {
      id
    }
  }
}
    `;
export type UpdateVideoMutationFn = Apollo.MutationFunction<UpdateVideoMutation, UpdateVideoMutationVariables>;

/**
 * __useUpdateVideoMutation__
 *
 * To run a mutation, you first call `useUpdateVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVideoMutation, { data, loading, error }] = useUpdateVideoMutation({
 *   variables: {
 *      input: // value for 'input'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateVideoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVideoMutation, UpdateVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVideoMutation, UpdateVideoMutationVariables>(UpdateVideoDocument, options);
      }
export type UpdateVideoMutationHookResult = ReturnType<typeof useUpdateVideoMutation>;
export type UpdateVideoMutationResult = Apollo.MutationResult<UpdateVideoMutation>;
export type UpdateVideoMutationOptions = Apollo.BaseMutationOptions<UpdateVideoMutation, UpdateVideoMutationVariables>;
export const AnalyticsDocument = gql`
    query Analytics {
  analytic {
    data {
      id
      attributes {
        ...analytic_fragment
      }
    }
  }
}
    ${Analytic_FragmentFragmentDoc}`;

/**
 * __useAnalyticsQuery__
 *
 * To run a query within a React component, call `useAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAnalyticsQuery(baseOptions?: Apollo.QueryHookOptions<AnalyticsQuery, AnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsQuery, AnalyticsQueryVariables>(AnalyticsDocument, options);
      }
export function useAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsQuery, AnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsQuery, AnalyticsQueryVariables>(AnalyticsDocument, options);
        }
// @ts-ignore
export function useAnalyticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AnalyticsQuery, AnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<AnalyticsQuery, AnalyticsQueryVariables>;
export function useAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsQuery, AnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<AnalyticsQuery | undefined, AnalyticsQueryVariables>;
export function useAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsQuery, AnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsQuery, AnalyticsQueryVariables>(AnalyticsDocument, options);
        }
export type AnalyticsQueryHookResult = ReturnType<typeof useAnalyticsQuery>;
export type AnalyticsLazyQueryHookResult = ReturnType<typeof useAnalyticsLazyQuery>;
export type AnalyticsSuspenseQueryHookResult = ReturnType<typeof useAnalyticsSuspenseQuery>;
export type AnalyticsQueryResult = Apollo.QueryResult<AnalyticsQuery, AnalyticsQueryVariables>;
export const BaoverifierAppDocument = gql`
    query BaoverifierApp {
  baoverifierApp {
    data {
      id
    }
  }
}
    `;

/**
 * __useBaoverifierAppQuery__
 *
 * To run a query within a React component, call `useBaoverifierAppQuery` and pass it any options that fit your needs.
 * When your component renders, `useBaoverifierAppQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBaoverifierAppQuery({
 *   variables: {
 *   },
 * });
 */
export function useBaoverifierAppQuery(baseOptions?: Apollo.QueryHookOptions<BaoverifierAppQuery, BaoverifierAppQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BaoverifierAppQuery, BaoverifierAppQueryVariables>(BaoverifierAppDocument, options);
      }
export function useBaoverifierAppLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BaoverifierAppQuery, BaoverifierAppQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BaoverifierAppQuery, BaoverifierAppQueryVariables>(BaoverifierAppDocument, options);
        }
// @ts-ignore
export function useBaoverifierAppSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BaoverifierAppQuery, BaoverifierAppQueryVariables>): Apollo.UseSuspenseQueryResult<BaoverifierAppQuery, BaoverifierAppQueryVariables>;
export function useBaoverifierAppSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BaoverifierAppQuery, BaoverifierAppQueryVariables>): Apollo.UseSuspenseQueryResult<BaoverifierAppQuery | undefined, BaoverifierAppQueryVariables>;
export function useBaoverifierAppSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BaoverifierAppQuery, BaoverifierAppQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BaoverifierAppQuery, BaoverifierAppQueryVariables>(BaoverifierAppDocument, options);
        }
export type BaoverifierAppQueryHookResult = ReturnType<typeof useBaoverifierAppQuery>;
export type BaoverifierAppLazyQueryHookResult = ReturnType<typeof useBaoverifierAppLazyQuery>;
export type BaoverifierAppSuspenseQueryHookResult = ReturnType<typeof useBaoverifierAppSuspenseQuery>;
export type BaoverifierAppQueryResult = Apollo.QueryResult<BaoverifierAppQuery, BaoverifierAppQueryVariables>;
export const CanDeactivateCategoryDocument = gql`
    query canDeactivateCategory($id: ID!) {
  canDeactivateCategory(id: $id)
}
    `;

/**
 * __useCanDeactivateCategoryQuery__
 *
 * To run a query within a React component, call `useCanDeactivateCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanDeactivateCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanDeactivateCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCanDeactivateCategoryQuery(baseOptions: Apollo.QueryHookOptions<CanDeactivateCategoryQuery, CanDeactivateCategoryQueryVariables> & ({ variables: CanDeactivateCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanDeactivateCategoryQuery, CanDeactivateCategoryQueryVariables>(CanDeactivateCategoryDocument, options);
      }
export function useCanDeactivateCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanDeactivateCategoryQuery, CanDeactivateCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanDeactivateCategoryQuery, CanDeactivateCategoryQueryVariables>(CanDeactivateCategoryDocument, options);
        }
// @ts-ignore
export function useCanDeactivateCategorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CanDeactivateCategoryQuery, CanDeactivateCategoryQueryVariables>): Apollo.UseSuspenseQueryResult<CanDeactivateCategoryQuery, CanDeactivateCategoryQueryVariables>;
export function useCanDeactivateCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CanDeactivateCategoryQuery, CanDeactivateCategoryQueryVariables>): Apollo.UseSuspenseQueryResult<CanDeactivateCategoryQuery | undefined, CanDeactivateCategoryQueryVariables>;
export function useCanDeactivateCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CanDeactivateCategoryQuery, CanDeactivateCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CanDeactivateCategoryQuery, CanDeactivateCategoryQueryVariables>(CanDeactivateCategoryDocument, options);
        }
export type CanDeactivateCategoryQueryHookResult = ReturnType<typeof useCanDeactivateCategoryQuery>;
export type CanDeactivateCategoryLazyQueryHookResult = ReturnType<typeof useCanDeactivateCategoryLazyQuery>;
export type CanDeactivateCategorySuspenseQueryHookResult = ReturnType<typeof useCanDeactivateCategorySuspenseQuery>;
export type CanDeactivateCategoryQueryResult = Apollo.QueryResult<CanDeactivateCategoryQuery, CanDeactivateCategoryQueryVariables>;
export const CanEditTaskDocument = gql`
    query canEditTask($id: ID!) {
  canEditTask(id: $id)
}
    `;

/**
 * __useCanEditTaskQuery__
 *
 * To run a query within a React component, call `useCanEditTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanEditTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanEditTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCanEditTaskQuery(baseOptions: Apollo.QueryHookOptions<CanEditTaskQuery, CanEditTaskQueryVariables> & ({ variables: CanEditTaskQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanEditTaskQuery, CanEditTaskQueryVariables>(CanEditTaskDocument, options);
      }
export function useCanEditTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanEditTaskQuery, CanEditTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanEditTaskQuery, CanEditTaskQueryVariables>(CanEditTaskDocument, options);
        }
// @ts-ignore
export function useCanEditTaskSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CanEditTaskQuery, CanEditTaskQueryVariables>): Apollo.UseSuspenseQueryResult<CanEditTaskQuery, CanEditTaskQueryVariables>;
export function useCanEditTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CanEditTaskQuery, CanEditTaskQueryVariables>): Apollo.UseSuspenseQueryResult<CanEditTaskQuery | undefined, CanEditTaskQueryVariables>;
export function useCanEditTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CanEditTaskQuery, CanEditTaskQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CanEditTaskQuery, CanEditTaskQueryVariables>(CanEditTaskDocument, options);
        }
export type CanEditTaskQueryHookResult = ReturnType<typeof useCanEditTaskQuery>;
export type CanEditTaskLazyQueryHookResult = ReturnType<typeof useCanEditTaskLazyQuery>;
export type CanEditTaskSuspenseQueryHookResult = ReturnType<typeof useCanEditTaskSuspenseQuery>;
export type CanEditTaskQueryResult = Apollo.QueryResult<CanEditTaskQuery, CanEditTaskQueryVariables>;
export const CountCommunityMembersDocument = gql`
    query countCommunityMembers($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  countCommunityMembers(sort: $sort, filters: $filters, pagination: $pagination)
}
    `;

/**
 * __useCountCommunityMembersQuery__
 *
 * To run a query within a React component, call `useCountCommunityMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountCommunityMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountCommunityMembersQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useCountCommunityMembersQuery(baseOptions?: Apollo.QueryHookOptions<CountCommunityMembersQuery, CountCommunityMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountCommunityMembersQuery, CountCommunityMembersQueryVariables>(CountCommunityMembersDocument, options);
      }
export function useCountCommunityMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountCommunityMembersQuery, CountCommunityMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountCommunityMembersQuery, CountCommunityMembersQueryVariables>(CountCommunityMembersDocument, options);
        }
// @ts-ignore
export function useCountCommunityMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountCommunityMembersQuery, CountCommunityMembersQueryVariables>): Apollo.UseSuspenseQueryResult<CountCommunityMembersQuery, CountCommunityMembersQueryVariables>;
export function useCountCommunityMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountCommunityMembersQuery, CountCommunityMembersQueryVariables>): Apollo.UseSuspenseQueryResult<CountCommunityMembersQuery | undefined, CountCommunityMembersQueryVariables>;
export function useCountCommunityMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountCommunityMembersQuery, CountCommunityMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountCommunityMembersQuery, CountCommunityMembersQueryVariables>(CountCommunityMembersDocument, options);
        }
export type CountCommunityMembersQueryHookResult = ReturnType<typeof useCountCommunityMembersQuery>;
export type CountCommunityMembersLazyQueryHookResult = ReturnType<typeof useCountCommunityMembersLazyQuery>;
export type CountCommunityMembersSuspenseQueryHookResult = ReturnType<typeof useCountCommunityMembersSuspenseQuery>;
export type CountCommunityMembersQueryResult = Apollo.QueryResult<CountCommunityMembersQuery, CountCommunityMembersQueryVariables>;
export const CountCompanyCommunitiesDocument = gql`
    query countCompanyCommunities($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  countCompanyCommunities(
    sort: $sort
    filters: $filters
    publicationState: LIVE
    pagination: $pagination
  )
}
    `;

/**
 * __useCountCompanyCommunitiesQuery__
 *
 * To run a query within a React component, call `useCountCompanyCommunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountCompanyCommunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountCompanyCommunitiesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useCountCompanyCommunitiesQuery(baseOptions?: Apollo.QueryHookOptions<CountCompanyCommunitiesQuery, CountCompanyCommunitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountCompanyCommunitiesQuery, CountCompanyCommunitiesQueryVariables>(CountCompanyCommunitiesDocument, options);
      }
export function useCountCompanyCommunitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountCompanyCommunitiesQuery, CountCompanyCommunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountCompanyCommunitiesQuery, CountCompanyCommunitiesQueryVariables>(CountCompanyCommunitiesDocument, options);
        }
// @ts-ignore
export function useCountCompanyCommunitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountCompanyCommunitiesQuery, CountCompanyCommunitiesQueryVariables>): Apollo.UseSuspenseQueryResult<CountCompanyCommunitiesQuery, CountCompanyCommunitiesQueryVariables>;
export function useCountCompanyCommunitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountCompanyCommunitiesQuery, CountCompanyCommunitiesQueryVariables>): Apollo.UseSuspenseQueryResult<CountCompanyCommunitiesQuery | undefined, CountCompanyCommunitiesQueryVariables>;
export function useCountCompanyCommunitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountCompanyCommunitiesQuery, CountCompanyCommunitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountCompanyCommunitiesQuery, CountCompanyCommunitiesQueryVariables>(CountCompanyCommunitiesDocument, options);
        }
export type CountCompanyCommunitiesQueryHookResult = ReturnType<typeof useCountCompanyCommunitiesQuery>;
export type CountCompanyCommunitiesLazyQueryHookResult = ReturnType<typeof useCountCompanyCommunitiesLazyQuery>;
export type CountCompanyCommunitiesSuspenseQueryHookResult = ReturnType<typeof useCountCompanyCommunitiesSuspenseQuery>;
export type CountCompanyCommunitiesQueryResult = Apollo.QueryResult<CountCompanyCommunitiesQuery, CountCompanyCommunitiesQueryVariables>;
export const CountCompanyMembersDocument = gql`
    query countCompanyMembers {
  countCompanyMembers
}
    `;

/**
 * __useCountCompanyMembersQuery__
 *
 * To run a query within a React component, call `useCountCompanyMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountCompanyMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountCompanyMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountCompanyMembersQuery(baseOptions?: Apollo.QueryHookOptions<CountCompanyMembersQuery, CountCompanyMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountCompanyMembersQuery, CountCompanyMembersQueryVariables>(CountCompanyMembersDocument, options);
      }
export function useCountCompanyMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountCompanyMembersQuery, CountCompanyMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountCompanyMembersQuery, CountCompanyMembersQueryVariables>(CountCompanyMembersDocument, options);
        }
// @ts-ignore
export function useCountCompanyMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountCompanyMembersQuery, CountCompanyMembersQueryVariables>): Apollo.UseSuspenseQueryResult<CountCompanyMembersQuery, CountCompanyMembersQueryVariables>;
export function useCountCompanyMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountCompanyMembersQuery, CountCompanyMembersQueryVariables>): Apollo.UseSuspenseQueryResult<CountCompanyMembersQuery | undefined, CountCompanyMembersQueryVariables>;
export function useCountCompanyMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountCompanyMembersQuery, CountCompanyMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountCompanyMembersQuery, CountCompanyMembersQueryVariables>(CountCompanyMembersDocument, options);
        }
export type CountCompanyMembersQueryHookResult = ReturnType<typeof useCountCompanyMembersQuery>;
export type CountCompanyMembersLazyQueryHookResult = ReturnType<typeof useCountCompanyMembersLazyQuery>;
export type CountCompanyMembersSuspenseQueryHookResult = ReturnType<typeof useCountCompanyMembersSuspenseQuery>;
export type CountCompanyMembersQueryResult = Apollo.QueryResult<CountCompanyMembersQuery, CountCompanyMembersQueryVariables>;
export const CountCompanyProjectsDocument = gql`
    query countCompanyProjects($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  countCompanyProjects(
    sort: $sort
    filters: $filters
    publicationState: LIVE
    pagination: $pagination
  )
}
    `;

/**
 * __useCountCompanyProjectsQuery__
 *
 * To run a query within a React component, call `useCountCompanyProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountCompanyProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountCompanyProjectsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useCountCompanyProjectsQuery(baseOptions?: Apollo.QueryHookOptions<CountCompanyProjectsQuery, CountCompanyProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountCompanyProjectsQuery, CountCompanyProjectsQueryVariables>(CountCompanyProjectsDocument, options);
      }
export function useCountCompanyProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountCompanyProjectsQuery, CountCompanyProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountCompanyProjectsQuery, CountCompanyProjectsQueryVariables>(CountCompanyProjectsDocument, options);
        }
// @ts-ignore
export function useCountCompanyProjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountCompanyProjectsQuery, CountCompanyProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<CountCompanyProjectsQuery, CountCompanyProjectsQueryVariables>;
export function useCountCompanyProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountCompanyProjectsQuery, CountCompanyProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<CountCompanyProjectsQuery | undefined, CountCompanyProjectsQueryVariables>;
export function useCountCompanyProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountCompanyProjectsQuery, CountCompanyProjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountCompanyProjectsQuery, CountCompanyProjectsQueryVariables>(CountCompanyProjectsDocument, options);
        }
export type CountCompanyProjectsQueryHookResult = ReturnType<typeof useCountCompanyProjectsQuery>;
export type CountCompanyProjectsLazyQueryHookResult = ReturnType<typeof useCountCompanyProjectsLazyQuery>;
export type CountCompanyProjectsSuspenseQueryHookResult = ReturnType<typeof useCountCompanyProjectsSuspenseQuery>;
export type CountCompanyProjectsQueryResult = Apollo.QueryResult<CountCompanyProjectsQuery, CountCompanyProjectsQueryVariables>;
export const CountRidersDocument = gql`
    query countRiders($sort: String, $limit: Int, $start: Int, $where: JSON) {
  countRiders(sort: $sort, limit: $limit, start: $start, where: $where)
}
    `;

/**
 * __useCountRidersQuery__
 *
 * To run a query within a React component, call `useCountRidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountRidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountRidersQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountRidersQuery(baseOptions?: Apollo.QueryHookOptions<CountRidersQuery, CountRidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountRidersQuery, CountRidersQueryVariables>(CountRidersDocument, options);
      }
export function useCountRidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountRidersQuery, CountRidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountRidersQuery, CountRidersQueryVariables>(CountRidersDocument, options);
        }
// @ts-ignore
export function useCountRidersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountRidersQuery, CountRidersQueryVariables>): Apollo.UseSuspenseQueryResult<CountRidersQuery, CountRidersQueryVariables>;
export function useCountRidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountRidersQuery, CountRidersQueryVariables>): Apollo.UseSuspenseQueryResult<CountRidersQuery | undefined, CountRidersQueryVariables>;
export function useCountRidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountRidersQuery, CountRidersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountRidersQuery, CountRidersQueryVariables>(CountRidersDocument, options);
        }
export type CountRidersQueryHookResult = ReturnType<typeof useCountRidersQuery>;
export type CountRidersLazyQueryHookResult = ReturnType<typeof useCountRidersLazyQuery>;
export type CountRidersSuspenseQueryHookResult = ReturnType<typeof useCountRidersSuspenseQuery>;
export type CountRidersQueryResult = Apollo.QueryResult<CountRidersQuery, CountRidersQueryVariables>;
export const CountTaskTypesDocument = gql`
    query countTaskTypes($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  getCompanyTaskTypesCount(
    sort: $sort
    filters: $filters
    publicationState: LIVE
    pagination: $pagination
  )
}
    `;

/**
 * __useCountTaskTypesQuery__
 *
 * To run a query within a React component, call `useCountTaskTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountTaskTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountTaskTypesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useCountTaskTypesQuery(baseOptions?: Apollo.QueryHookOptions<CountTaskTypesQuery, CountTaskTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountTaskTypesQuery, CountTaskTypesQueryVariables>(CountTaskTypesDocument, options);
      }
export function useCountTaskTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountTaskTypesQuery, CountTaskTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountTaskTypesQuery, CountTaskTypesQueryVariables>(CountTaskTypesDocument, options);
        }
// @ts-ignore
export function useCountTaskTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountTaskTypesQuery, CountTaskTypesQueryVariables>): Apollo.UseSuspenseQueryResult<CountTaskTypesQuery, CountTaskTypesQueryVariables>;
export function useCountTaskTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountTaskTypesQuery, CountTaskTypesQueryVariables>): Apollo.UseSuspenseQueryResult<CountTaskTypesQuery | undefined, CountTaskTypesQueryVariables>;
export function useCountTaskTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountTaskTypesQuery, CountTaskTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountTaskTypesQuery, CountTaskTypesQueryVariables>(CountTaskTypesDocument, options);
        }
export type CountTaskTypesQueryHookResult = ReturnType<typeof useCountTaskTypesQuery>;
export type CountTaskTypesLazyQueryHookResult = ReturnType<typeof useCountTaskTypesLazyQuery>;
export type CountTaskTypesSuspenseQueryHookResult = ReturnType<typeof useCountTaskTypesSuspenseQuery>;
export type CountTaskTypesQueryResult = Apollo.QueryResult<CountTaskTypesQuery, CountTaskTypesQueryVariables>;
export const CountTasksDocument = gql`
    query countTasks($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  countTasks(
    sort: $sort
    filters: $filters
    publicationState: LIVE
    pagination: $pagination
  )
}
    `;

/**
 * __useCountTasksQuery__
 *
 * To run a query within a React component, call `useCountTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountTasksQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useCountTasksQuery(baseOptions?: Apollo.QueryHookOptions<CountTasksQuery, CountTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountTasksQuery, CountTasksQueryVariables>(CountTasksDocument, options);
      }
export function useCountTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountTasksQuery, CountTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountTasksQuery, CountTasksQueryVariables>(CountTasksDocument, options);
        }
// @ts-ignore
export function useCountTasksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountTasksQuery, CountTasksQueryVariables>): Apollo.UseSuspenseQueryResult<CountTasksQuery, CountTasksQueryVariables>;
export function useCountTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountTasksQuery, CountTasksQueryVariables>): Apollo.UseSuspenseQueryResult<CountTasksQuery | undefined, CountTasksQueryVariables>;
export function useCountTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountTasksQuery, CountTasksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountTasksQuery, CountTasksQueryVariables>(CountTasksDocument, options);
        }
export type CountTasksQueryHookResult = ReturnType<typeof useCountTasksQuery>;
export type CountTasksLazyQueryHookResult = ReturnType<typeof useCountTasksLazyQuery>;
export type CountTasksSuspenseQueryHookResult = ReturnType<typeof useCountTasksSuspenseQuery>;
export type CountTasksQueryResult = Apollo.QueryResult<CountTasksQuery, CountTasksQueryVariables>;
export const CountTasksByStatusDocument = gql`
    query countTasksByStatus($filters: JSON) {
  countTasksByStatus(filters: $filters)
}
    `;

/**
 * __useCountTasksByStatusQuery__
 *
 * To run a query within a React component, call `useCountTasksByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountTasksByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountTasksByStatusQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCountTasksByStatusQuery(baseOptions?: Apollo.QueryHookOptions<CountTasksByStatusQuery, CountTasksByStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountTasksByStatusQuery, CountTasksByStatusQueryVariables>(CountTasksByStatusDocument, options);
      }
export function useCountTasksByStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountTasksByStatusQuery, CountTasksByStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountTasksByStatusQuery, CountTasksByStatusQueryVariables>(CountTasksByStatusDocument, options);
        }
// @ts-ignore
export function useCountTasksByStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountTasksByStatusQuery, CountTasksByStatusQueryVariables>): Apollo.UseSuspenseQueryResult<CountTasksByStatusQuery, CountTasksByStatusQueryVariables>;
export function useCountTasksByStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountTasksByStatusQuery, CountTasksByStatusQueryVariables>): Apollo.UseSuspenseQueryResult<CountTasksByStatusQuery | undefined, CountTasksByStatusQueryVariables>;
export function useCountTasksByStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountTasksByStatusQuery, CountTasksByStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountTasksByStatusQuery, CountTasksByStatusQueryVariables>(CountTasksByStatusDocument, options);
        }
export type CountTasksByStatusQueryHookResult = ReturnType<typeof useCountTasksByStatusQuery>;
export type CountTasksByStatusLazyQueryHookResult = ReturnType<typeof useCountTasksByStatusLazyQuery>;
export type CountTasksByStatusSuspenseQueryHookResult = ReturnType<typeof useCountTasksByStatusSuspenseQuery>;
export type CountTasksByStatusQueryResult = Apollo.QueryResult<CountTasksByStatusQuery, CountTasksByStatusQueryVariables>;
export const CountTasksWithTrendDocument = gql`
    query countTasksWithTrend($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  countTasksWithTrend(
    sort: $sort
    filters: $filters
    publicationState: LIVE
    pagination: $pagination
  ) {
    count
    trend {
      trend
      count
      previousMonthCount
      percentage
    }
  }
}
    `;

/**
 * __useCountTasksWithTrendQuery__
 *
 * To run a query within a React component, call `useCountTasksWithTrendQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountTasksWithTrendQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountTasksWithTrendQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useCountTasksWithTrendQuery(baseOptions?: Apollo.QueryHookOptions<CountTasksWithTrendQuery, CountTasksWithTrendQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountTasksWithTrendQuery, CountTasksWithTrendQueryVariables>(CountTasksWithTrendDocument, options);
      }
export function useCountTasksWithTrendLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountTasksWithTrendQuery, CountTasksWithTrendQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountTasksWithTrendQuery, CountTasksWithTrendQueryVariables>(CountTasksWithTrendDocument, options);
        }
// @ts-ignore
export function useCountTasksWithTrendSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountTasksWithTrendQuery, CountTasksWithTrendQueryVariables>): Apollo.UseSuspenseQueryResult<CountTasksWithTrendQuery, CountTasksWithTrendQueryVariables>;
export function useCountTasksWithTrendSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountTasksWithTrendQuery, CountTasksWithTrendQueryVariables>): Apollo.UseSuspenseQueryResult<CountTasksWithTrendQuery | undefined, CountTasksWithTrendQueryVariables>;
export function useCountTasksWithTrendSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountTasksWithTrendQuery, CountTasksWithTrendQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountTasksWithTrendQuery, CountTasksWithTrendQueryVariables>(CountTasksWithTrendDocument, options);
        }
export type CountTasksWithTrendQueryHookResult = ReturnType<typeof useCountTasksWithTrendQuery>;
export type CountTasksWithTrendLazyQueryHookResult = ReturnType<typeof useCountTasksWithTrendLazyQuery>;
export type CountTasksWithTrendSuspenseQueryHookResult = ReturnType<typeof useCountTasksWithTrendSuspenseQuery>;
export type CountTasksWithTrendQueryResult = Apollo.QueryResult<CountTasksWithTrendQuery, CountTasksWithTrendQueryVariables>;
export const FindDataListOptionWithCountDocument = gql`
    query findDataListOptionWithCount($orderBy: JSON, $filters: JSON, $pagination: PaginationArg) {
  findDataListOptionWithCount(
    orderBy: $orderBy
    filters: $filters
    publicationState: LIVE
    pagination: $pagination
  ) {
    count
    data {
      id
      attributes {
        ...dataListOption
        data_list {
          data {
            id
            attributes {
              ...dataLists
            }
          }
        }
      }
    }
  }
}
    ${DataListOptionFragmentDoc}
${DataListsFragmentDoc}`;

/**
 * __useFindDataListOptionWithCountQuery__
 *
 * To run a query within a React component, call `useFindDataListOptionWithCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindDataListOptionWithCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindDataListOptionWithCountQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useFindDataListOptionWithCountQuery(baseOptions?: Apollo.QueryHookOptions<FindDataListOptionWithCountQuery, FindDataListOptionWithCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindDataListOptionWithCountQuery, FindDataListOptionWithCountQueryVariables>(FindDataListOptionWithCountDocument, options);
      }
export function useFindDataListOptionWithCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindDataListOptionWithCountQuery, FindDataListOptionWithCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindDataListOptionWithCountQuery, FindDataListOptionWithCountQueryVariables>(FindDataListOptionWithCountDocument, options);
        }
// @ts-ignore
export function useFindDataListOptionWithCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindDataListOptionWithCountQuery, FindDataListOptionWithCountQueryVariables>): Apollo.UseSuspenseQueryResult<FindDataListOptionWithCountQuery, FindDataListOptionWithCountQueryVariables>;
export function useFindDataListOptionWithCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindDataListOptionWithCountQuery, FindDataListOptionWithCountQueryVariables>): Apollo.UseSuspenseQueryResult<FindDataListOptionWithCountQuery | undefined, FindDataListOptionWithCountQueryVariables>;
export function useFindDataListOptionWithCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindDataListOptionWithCountQuery, FindDataListOptionWithCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindDataListOptionWithCountQuery, FindDataListOptionWithCountQueryVariables>(FindDataListOptionWithCountDocument, options);
        }
export type FindDataListOptionWithCountQueryHookResult = ReturnType<typeof useFindDataListOptionWithCountQuery>;
export type FindDataListOptionWithCountLazyQueryHookResult = ReturnType<typeof useFindDataListOptionWithCountLazyQuery>;
export type FindDataListOptionWithCountSuspenseQueryHookResult = ReturnType<typeof useFindDataListOptionWithCountSuspenseQuery>;
export type FindDataListOptionWithCountQueryResult = Apollo.QueryResult<FindDataListOptionWithCountQuery, FindDataListOptionWithCountQueryVariables>;
export const GetAdminNotificationsCountDocument = gql`
    query getAdminNotificationsCount($filters: JSON) {
  getAdminNotificationsCount(filters: $filters)
}
    `;

/**
 * __useGetAdminNotificationsCountQuery__
 *
 * To run a query within a React component, call `useGetAdminNotificationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminNotificationsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminNotificationsCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetAdminNotificationsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminNotificationsCountQuery, GetAdminNotificationsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminNotificationsCountQuery, GetAdminNotificationsCountQueryVariables>(GetAdminNotificationsCountDocument, options);
      }
export function useGetAdminNotificationsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminNotificationsCountQuery, GetAdminNotificationsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminNotificationsCountQuery, GetAdminNotificationsCountQueryVariables>(GetAdminNotificationsCountDocument, options);
        }
// @ts-ignore
export function useGetAdminNotificationsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminNotificationsCountQuery, GetAdminNotificationsCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetAdminNotificationsCountQuery, GetAdminNotificationsCountQueryVariables>;
export function useGetAdminNotificationsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminNotificationsCountQuery, GetAdminNotificationsCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetAdminNotificationsCountQuery | undefined, GetAdminNotificationsCountQueryVariables>;
export function useGetAdminNotificationsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminNotificationsCountQuery, GetAdminNotificationsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminNotificationsCountQuery, GetAdminNotificationsCountQueryVariables>(GetAdminNotificationsCountDocument, options);
        }
export type GetAdminNotificationsCountQueryHookResult = ReturnType<typeof useGetAdminNotificationsCountQuery>;
export type GetAdminNotificationsCountLazyQueryHookResult = ReturnType<typeof useGetAdminNotificationsCountLazyQuery>;
export type GetAdminNotificationsCountSuspenseQueryHookResult = ReturnType<typeof useGetAdminNotificationsCountSuspenseQuery>;
export type GetAdminNotificationsCountQueryResult = Apollo.QueryResult<GetAdminNotificationsCountQuery, GetAdminNotificationsCountQueryVariables>;
export const GetAllInvoicesDocument = gql`
    query getAllInvoices {
  getAllInvoices {
    id
    currency
    customer
    created
    ending_balance
    hosted_invoice_url
    invoice_pdf
    paid
    status
    subscription
    lines
    number
  }
}
    `;

/**
 * __useGetAllInvoicesQuery__
 *
 * To run a query within a React component, call `useGetAllInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllInvoicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllInvoicesQuery, GetAllInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllInvoicesQuery, GetAllInvoicesQueryVariables>(GetAllInvoicesDocument, options);
      }
export function useGetAllInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllInvoicesQuery, GetAllInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllInvoicesQuery, GetAllInvoicesQueryVariables>(GetAllInvoicesDocument, options);
        }
// @ts-ignore
export function useGetAllInvoicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllInvoicesQuery, GetAllInvoicesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllInvoicesQuery, GetAllInvoicesQueryVariables>;
export function useGetAllInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllInvoicesQuery, GetAllInvoicesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllInvoicesQuery | undefined, GetAllInvoicesQueryVariables>;
export function useGetAllInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllInvoicesQuery, GetAllInvoicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllInvoicesQuery, GetAllInvoicesQueryVariables>(GetAllInvoicesDocument, options);
        }
export type GetAllInvoicesQueryHookResult = ReturnType<typeof useGetAllInvoicesQuery>;
export type GetAllInvoicesLazyQueryHookResult = ReturnType<typeof useGetAllInvoicesLazyQuery>;
export type GetAllInvoicesSuspenseQueryHookResult = ReturnType<typeof useGetAllInvoicesSuspenseQuery>;
export type GetAllInvoicesQueryResult = Apollo.QueryResult<GetAllInvoicesQuery, GetAllInvoicesQueryVariables>;
export const GetAllProductsDocument = gql`
    query getAllProducts {
  getAllProducts {
    id
    name
    statement_descriptor
    metadata {
      baoriders_allowed
      baoriders_cost
    }
    prices {
      id
      nickname
      currency
      recurring {
        interval
        interval_count
      }
      unit_amount
      unit_amount_decimal
    }
  }
}
    `;

/**
 * __useGetAllProductsQuery__
 *
 * To run a query within a React component, call `useGetAllProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProductsQuery, GetAllProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProductsQuery, GetAllProductsQueryVariables>(GetAllProductsDocument, options);
      }
export function useGetAllProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProductsQuery, GetAllProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProductsQuery, GetAllProductsQueryVariables>(GetAllProductsDocument, options);
        }
// @ts-ignore
export function useGetAllProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllProductsQuery, GetAllProductsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllProductsQuery, GetAllProductsQueryVariables>;
export function useGetAllProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllProductsQuery, GetAllProductsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllProductsQuery | undefined, GetAllProductsQueryVariables>;
export function useGetAllProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllProductsQuery, GetAllProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllProductsQuery, GetAllProductsQueryVariables>(GetAllProductsDocument, options);
        }
export type GetAllProductsQueryHookResult = ReturnType<typeof useGetAllProductsQuery>;
export type GetAllProductsLazyQueryHookResult = ReturnType<typeof useGetAllProductsLazyQuery>;
export type GetAllProductsSuspenseQueryHookResult = ReturnType<typeof useGetAllProductsSuspenseQuery>;
export type GetAllProductsQueryResult = Apollo.QueryResult<GetAllProductsQuery, GetAllProductsQueryVariables>;
export const GetCommunitiesLiteDocument = gql`
    query getCommunitiesLite($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  getBaoleaderCommunities(
    sort: $sort
    filters: $filters
    publicationState: LIVE
    pagination: $pagination
  ) {
    id
    attributes {
      name
    }
  }
}
    `;

/**
 * __useGetCommunitiesLiteQuery__
 *
 * To run a query within a React component, call `useGetCommunitiesLiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunitiesLiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunitiesLiteQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetCommunitiesLiteQuery(baseOptions?: Apollo.QueryHookOptions<GetCommunitiesLiteQuery, GetCommunitiesLiteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommunitiesLiteQuery, GetCommunitiesLiteQueryVariables>(GetCommunitiesLiteDocument, options);
      }
export function useGetCommunitiesLiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommunitiesLiteQuery, GetCommunitiesLiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommunitiesLiteQuery, GetCommunitiesLiteQueryVariables>(GetCommunitiesLiteDocument, options);
        }
// @ts-ignore
export function useGetCommunitiesLiteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommunitiesLiteQuery, GetCommunitiesLiteQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommunitiesLiteQuery, GetCommunitiesLiteQueryVariables>;
export function useGetCommunitiesLiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommunitiesLiteQuery, GetCommunitiesLiteQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommunitiesLiteQuery | undefined, GetCommunitiesLiteQueryVariables>;
export function useGetCommunitiesLiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommunitiesLiteQuery, GetCommunitiesLiteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommunitiesLiteQuery, GetCommunitiesLiteQueryVariables>(GetCommunitiesLiteDocument, options);
        }
export type GetCommunitiesLiteQueryHookResult = ReturnType<typeof useGetCommunitiesLiteQuery>;
export type GetCommunitiesLiteLazyQueryHookResult = ReturnType<typeof useGetCommunitiesLiteLazyQuery>;
export type GetCommunitiesLiteSuspenseQueryHookResult = ReturnType<typeof useGetCommunitiesLiteSuspenseQuery>;
export type GetCommunitiesLiteQueryResult = Apollo.QueryResult<GetCommunitiesLiteQuery, GetCommunitiesLiteQueryVariables>;
export const GetBaoleaderProjectsCategoriesDocument = gql`
    query getBaoleaderProjectsCategories {
  getBaoleaderProjectsCategories {
    id
    title
  }
}
    `;

/**
 * __useGetBaoleaderProjectsCategoriesQuery__
 *
 * To run a query within a React component, call `useGetBaoleaderProjectsCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBaoleaderProjectsCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBaoleaderProjectsCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBaoleaderProjectsCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetBaoleaderProjectsCategoriesQuery, GetBaoleaderProjectsCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBaoleaderProjectsCategoriesQuery, GetBaoleaderProjectsCategoriesQueryVariables>(GetBaoleaderProjectsCategoriesDocument, options);
      }
export function useGetBaoleaderProjectsCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBaoleaderProjectsCategoriesQuery, GetBaoleaderProjectsCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBaoleaderProjectsCategoriesQuery, GetBaoleaderProjectsCategoriesQueryVariables>(GetBaoleaderProjectsCategoriesDocument, options);
        }
// @ts-ignore
export function useGetBaoleaderProjectsCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBaoleaderProjectsCategoriesQuery, GetBaoleaderProjectsCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetBaoleaderProjectsCategoriesQuery, GetBaoleaderProjectsCategoriesQueryVariables>;
export function useGetBaoleaderProjectsCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBaoleaderProjectsCategoriesQuery, GetBaoleaderProjectsCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetBaoleaderProjectsCategoriesQuery | undefined, GetBaoleaderProjectsCategoriesQueryVariables>;
export function useGetBaoleaderProjectsCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBaoleaderProjectsCategoriesQuery, GetBaoleaderProjectsCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBaoleaderProjectsCategoriesQuery, GetBaoleaderProjectsCategoriesQueryVariables>(GetBaoleaderProjectsCategoriesDocument, options);
        }
export type GetBaoleaderProjectsCategoriesQueryHookResult = ReturnType<typeof useGetBaoleaderProjectsCategoriesQuery>;
export type GetBaoleaderProjectsCategoriesLazyQueryHookResult = ReturnType<typeof useGetBaoleaderProjectsCategoriesLazyQuery>;
export type GetBaoleaderProjectsCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetBaoleaderProjectsCategoriesSuspenseQuery>;
export type GetBaoleaderProjectsCategoriesQueryResult = Apollo.QueryResult<GetBaoleaderProjectsCategoriesQuery, GetBaoleaderProjectsCategoriesQueryVariables>;
export const GetBaoleaderTaskDocument = gql`
    query getBaoleaderTask($id: ID!) {
  getBaoleaderTask(id: $id) {
    id
    attributes {
      createdAt
      updatedAt
      status
      date_reported
      edit_from {
        data {
          id
        }
      }
      documents {
        data {
          ...uploadFile
        }
      }
      location
      onlyEmployeesVerify
      task_origin
      task_definition {
        data {
          id
          attributes {
            category {
              data {
                id
                attributes {
                  ...category
                  featureImage {
                    data {
                      ...uploadFile
                    }
                  }
                }
              }
            }
            task_type {
              data {
                id
                attributes {
                  ...taskType
                }
              }
            }
          }
        }
      }
      community {
        data {
          id
          attributes {
            ...community
            featured_image {
              data {
                ...uploadFile
              }
            }
          }
        }
      }
      project {
        data {
          id
          attributes {
            ...project
            featured_image {
              data {
                ...uploadFile
              }
            }
          }
        }
      }
      evidences {
        data {
          id
          attributes {
            ...evidence
            custom_data_fields {
              ...componentCustomDataFieldsMetricsSpecific
              ...componentCustomDataFieldsNumberRange
              ...componentCustomDataFieldsNumberDropDown
              ...componentCustomDataFieldsPercentage
              ...componentCustomDataFieldsRadio
              ...componentCustomDataFieldsText
              ...componentCustomDataFieldsCheckbox
              ...componentCustomDataFieldsImageField
              ...componentCustomDataFieldsDateTimeField
              ...componentCustomDataFieldsSelect
              ...componentCustomDataFieldsNumberField
              ...componentCustomDataFieldsPercentage
              ...componentCustomDataFieldsRating
              ...componentCustomDataFieldsDataList
              ...componentCustomDataFieldsPhoneNumberField
              ...componentCustomDataFieldsEmailField
              __typename
            }
            photos {
              data {
                ...uploadFile
              }
            }
            data_field_values {
              data {
                id
                attributes {
                  value
                  data_field {
                    data {
                      id
                      attributes {
                        label
                      }
                    }
                  }
                  baorider {
                    data {
                      id
                    }
                  }
                }
              }
            }
            baorider {
              data {
                id
                attributes {
                  ...member
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${UploadFileFragmentDoc}
${CategoryFragmentDoc}
${TaskTypeFragmentDoc}
${CommunityFragmentDoc}
${ProjectFragmentDoc}
${EvidenceFragmentDoc}
${ComponentCustomDataFieldsMetricsSpecificFragmentDoc}
${ComponentCustomDataFieldsNumberRangeFragmentDoc}
${ComponentCustomDataFieldsNumberDropDownFragmentDoc}
${ComponentCustomDataFieldsPercentageFragmentDoc}
${ComponentCustomDataFieldsRadioFragmentDoc}
${ComponentCustomDataFieldsTextFragmentDoc}
${ComponentCustomDataFieldsCheckboxFragmentDoc}
${ComponentCustomDataFieldsImageFieldFragmentDoc}
${ComponentCustomDataFieldsDateTimeFieldFragmentDoc}
${ComponentCustomDataFieldsSelectFragmentDoc}
${ComponentCustomDataFieldsNumberFieldFragmentDoc}
${ComponentCustomDataFieldsRatingFragmentDoc}
${ComponentCustomDataFieldsDataListFragmentDoc}
${ComponentCustomDataFieldsPhoneNumberFieldFragmentDoc}
${ComponentCustomDataFieldsEmailFieldFragmentDoc}
${MemberFragmentDoc}`;

/**
 * __useGetBaoleaderTaskQuery__
 *
 * To run a query within a React component, call `useGetBaoleaderTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBaoleaderTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBaoleaderTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBaoleaderTaskQuery(baseOptions: Apollo.QueryHookOptions<GetBaoleaderTaskQuery, GetBaoleaderTaskQueryVariables> & ({ variables: GetBaoleaderTaskQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBaoleaderTaskQuery, GetBaoleaderTaskQueryVariables>(GetBaoleaderTaskDocument, options);
      }
export function useGetBaoleaderTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBaoleaderTaskQuery, GetBaoleaderTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBaoleaderTaskQuery, GetBaoleaderTaskQueryVariables>(GetBaoleaderTaskDocument, options);
        }
// @ts-ignore
export function useGetBaoleaderTaskSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBaoleaderTaskQuery, GetBaoleaderTaskQueryVariables>): Apollo.UseSuspenseQueryResult<GetBaoleaderTaskQuery, GetBaoleaderTaskQueryVariables>;
export function useGetBaoleaderTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBaoleaderTaskQuery, GetBaoleaderTaskQueryVariables>): Apollo.UseSuspenseQueryResult<GetBaoleaderTaskQuery | undefined, GetBaoleaderTaskQueryVariables>;
export function useGetBaoleaderTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBaoleaderTaskQuery, GetBaoleaderTaskQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBaoleaderTaskQuery, GetBaoleaderTaskQueryVariables>(GetBaoleaderTaskDocument, options);
        }
export type GetBaoleaderTaskQueryHookResult = ReturnType<typeof useGetBaoleaderTaskQuery>;
export type GetBaoleaderTaskLazyQueryHookResult = ReturnType<typeof useGetBaoleaderTaskLazyQuery>;
export type GetBaoleaderTaskSuspenseQueryHookResult = ReturnType<typeof useGetBaoleaderTaskSuspenseQuery>;
export type GetBaoleaderTaskQueryResult = Apollo.QueryResult<GetBaoleaderTaskQuery, GetBaoleaderTaskQueryVariables>;
export const GetBaoleaderTaskDefinitionDocument = gql`
    query getBaoleaderTaskDefinition($id: ID!) {
  getBaoleaderTaskDefinition(id: $id) {
    id
    attributes {
      project {
        data {
          id
          attributes {
            name
            featured_image {
              data {
                ...uploadFile
              }
            }
          }
        }
      }
      category {
        data {
          id
          attributes {
            title
            description
            featureImage {
              data {
                ...uploadFile
              }
            }
          }
        }
      }
      status
      task_type {
        data {
          id
          attributes {
            title
            photoEvidence
            documentedEvidence
            environmentalImpact
            socialImpact
          }
        }
      }
    }
  }
}
    ${UploadFileFragmentDoc}`;

/**
 * __useGetBaoleaderTaskDefinitionQuery__
 *
 * To run a query within a React component, call `useGetBaoleaderTaskDefinitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBaoleaderTaskDefinitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBaoleaderTaskDefinitionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBaoleaderTaskDefinitionQuery(baseOptions: Apollo.QueryHookOptions<GetBaoleaderTaskDefinitionQuery, GetBaoleaderTaskDefinitionQueryVariables> & ({ variables: GetBaoleaderTaskDefinitionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBaoleaderTaskDefinitionQuery, GetBaoleaderTaskDefinitionQueryVariables>(GetBaoleaderTaskDefinitionDocument, options);
      }
export function useGetBaoleaderTaskDefinitionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBaoleaderTaskDefinitionQuery, GetBaoleaderTaskDefinitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBaoleaderTaskDefinitionQuery, GetBaoleaderTaskDefinitionQueryVariables>(GetBaoleaderTaskDefinitionDocument, options);
        }
// @ts-ignore
export function useGetBaoleaderTaskDefinitionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBaoleaderTaskDefinitionQuery, GetBaoleaderTaskDefinitionQueryVariables>): Apollo.UseSuspenseQueryResult<GetBaoleaderTaskDefinitionQuery, GetBaoleaderTaskDefinitionQueryVariables>;
export function useGetBaoleaderTaskDefinitionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBaoleaderTaskDefinitionQuery, GetBaoleaderTaskDefinitionQueryVariables>): Apollo.UseSuspenseQueryResult<GetBaoleaderTaskDefinitionQuery | undefined, GetBaoleaderTaskDefinitionQueryVariables>;
export function useGetBaoleaderTaskDefinitionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBaoleaderTaskDefinitionQuery, GetBaoleaderTaskDefinitionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBaoleaderTaskDefinitionQuery, GetBaoleaderTaskDefinitionQueryVariables>(GetBaoleaderTaskDefinitionDocument, options);
        }
export type GetBaoleaderTaskDefinitionQueryHookResult = ReturnType<typeof useGetBaoleaderTaskDefinitionQuery>;
export type GetBaoleaderTaskDefinitionLazyQueryHookResult = ReturnType<typeof useGetBaoleaderTaskDefinitionLazyQuery>;
export type GetBaoleaderTaskDefinitionSuspenseQueryHookResult = ReturnType<typeof useGetBaoleaderTaskDefinitionSuspenseQuery>;
export type GetBaoleaderTaskDefinitionQueryResult = Apollo.QueryResult<GetBaoleaderTaskDefinitionQuery, GetBaoleaderTaskDefinitionQueryVariables>;
export const GetBaoleaderTaskDefinitionsCountDocument = gql`
    query getBaoleaderTaskDefinitionsCount($filters: JSON) {
  getBaoleaderTaskDefinitionsCount(filters: $filters)
}
    `;

/**
 * __useGetBaoleaderTaskDefinitionsCountQuery__
 *
 * To run a query within a React component, call `useGetBaoleaderTaskDefinitionsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBaoleaderTaskDefinitionsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBaoleaderTaskDefinitionsCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetBaoleaderTaskDefinitionsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetBaoleaderTaskDefinitionsCountQuery, GetBaoleaderTaskDefinitionsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBaoleaderTaskDefinitionsCountQuery, GetBaoleaderTaskDefinitionsCountQueryVariables>(GetBaoleaderTaskDefinitionsCountDocument, options);
      }
export function useGetBaoleaderTaskDefinitionsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBaoleaderTaskDefinitionsCountQuery, GetBaoleaderTaskDefinitionsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBaoleaderTaskDefinitionsCountQuery, GetBaoleaderTaskDefinitionsCountQueryVariables>(GetBaoleaderTaskDefinitionsCountDocument, options);
        }
// @ts-ignore
export function useGetBaoleaderTaskDefinitionsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBaoleaderTaskDefinitionsCountQuery, GetBaoleaderTaskDefinitionsCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetBaoleaderTaskDefinitionsCountQuery, GetBaoleaderTaskDefinitionsCountQueryVariables>;
export function useGetBaoleaderTaskDefinitionsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBaoleaderTaskDefinitionsCountQuery, GetBaoleaderTaskDefinitionsCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetBaoleaderTaskDefinitionsCountQuery | undefined, GetBaoleaderTaskDefinitionsCountQueryVariables>;
export function useGetBaoleaderTaskDefinitionsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBaoleaderTaskDefinitionsCountQuery, GetBaoleaderTaskDefinitionsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBaoleaderTaskDefinitionsCountQuery, GetBaoleaderTaskDefinitionsCountQueryVariables>(GetBaoleaderTaskDefinitionsCountDocument, options);
        }
export type GetBaoleaderTaskDefinitionsCountQueryHookResult = ReturnType<typeof useGetBaoleaderTaskDefinitionsCountQuery>;
export type GetBaoleaderTaskDefinitionsCountLazyQueryHookResult = ReturnType<typeof useGetBaoleaderTaskDefinitionsCountLazyQuery>;
export type GetBaoleaderTaskDefinitionsCountSuspenseQueryHookResult = ReturnType<typeof useGetBaoleaderTaskDefinitionsCountSuspenseQuery>;
export type GetBaoleaderTaskDefinitionsCountQueryResult = Apollo.QueryResult<GetBaoleaderTaskDefinitionsCountQuery, GetBaoleaderTaskDefinitionsCountQueryVariables>;
export const GetBaoridersDocument = gql`
    query getBaoriders($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  getBaoriders(
    sort: $sort
    filters: $filters
    publicationState: LIVE
    pagination: $pagination
  ) {
    id
    attributes {
      idNumber
      phoneNumber
      firstName
      isVerifier
      lastName
      profilePicture {
        data {
          ...uploadFile
        }
      }
      projects {
        data {
          id
          attributes {
            ...project
          }
        }
      }
      community {
        data {
          id
          attributes {
            ...community
          }
        }
      }
      status
      createdAt
      updatedAt
    }
  }
}
    ${UploadFileFragmentDoc}
${ProjectFragmentDoc}
${CommunityFragmentDoc}`;

/**
 * __useGetBaoridersQuery__
 *
 * To run a query within a React component, call `useGetBaoridersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBaoridersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBaoridersQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetBaoridersQuery(baseOptions?: Apollo.QueryHookOptions<GetBaoridersQuery, GetBaoridersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBaoridersQuery, GetBaoridersQueryVariables>(GetBaoridersDocument, options);
      }
export function useGetBaoridersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBaoridersQuery, GetBaoridersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBaoridersQuery, GetBaoridersQueryVariables>(GetBaoridersDocument, options);
        }
// @ts-ignore
export function useGetBaoridersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBaoridersQuery, GetBaoridersQueryVariables>): Apollo.UseSuspenseQueryResult<GetBaoridersQuery, GetBaoridersQueryVariables>;
export function useGetBaoridersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBaoridersQuery, GetBaoridersQueryVariables>): Apollo.UseSuspenseQueryResult<GetBaoridersQuery | undefined, GetBaoridersQueryVariables>;
export function useGetBaoridersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBaoridersQuery, GetBaoridersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBaoridersQuery, GetBaoridersQueryVariables>(GetBaoridersDocument, options);
        }
export type GetBaoridersQueryHookResult = ReturnType<typeof useGetBaoridersQuery>;
export type GetBaoridersLazyQueryHookResult = ReturnType<typeof useGetBaoridersLazyQuery>;
export type GetBaoridersSuspenseQueryHookResult = ReturnType<typeof useGetBaoridersSuspenseQuery>;
export type GetBaoridersQueryResult = Apollo.QueryResult<GetBaoridersQuery, GetBaoridersQueryVariables>;
export const GetCategoriesDocument = gql`
    query getCategories($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  getCategories(
    sort: $sort
    filters: $filters
    publicationState: LIVE
    pagination: $pagination
  ) {
    id
    attributes {
      ...category
      featureImage {
        data {
          ...uploadFile
        }
      }
      task_types {
        data {
          id
          attributes {
            ...taskType
          }
        }
      }
    }
  }
}
    ${CategoryFragmentDoc}
${UploadFileFragmentDoc}
${TaskTypeFragmentDoc}`;

/**
 * __useGetCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
      }
export function useGetCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
// @ts-ignore
export function useGetCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCategoriesQuery, GetCategoriesQueryVariables>;
export function useGetCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCategoriesQuery | undefined, GetCategoriesQueryVariables>;
export function useGetCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export type GetCategoriesQueryHookResult = ReturnType<typeof useGetCategoriesQuery>;
export type GetCategoriesLazyQueryHookResult = ReturnType<typeof useGetCategoriesLazyQuery>;
export type GetCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetCategoriesSuspenseQuery>;
export type GetCategoriesQueryResult = Apollo.QueryResult<GetCategoriesQuery, GetCategoriesQueryVariables>;
export const GetCommunityVerifiersDocument = gql`
    query getCommunityVerifiers($communityId: ID!) {
  getCommunityVerifiers(community: $communityId) {
    members {
      id
      attributes {
        ...member
      }
    }
  }
}
    ${MemberFragmentDoc}`;

/**
 * __useGetCommunityVerifiersQuery__
 *
 * To run a query within a React component, call `useGetCommunityVerifiersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityVerifiersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityVerifiersQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useGetCommunityVerifiersQuery(baseOptions: Apollo.QueryHookOptions<GetCommunityVerifiersQuery, GetCommunityVerifiersQueryVariables> & ({ variables: GetCommunityVerifiersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommunityVerifiersQuery, GetCommunityVerifiersQueryVariables>(GetCommunityVerifiersDocument, options);
      }
export function useGetCommunityVerifiersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommunityVerifiersQuery, GetCommunityVerifiersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommunityVerifiersQuery, GetCommunityVerifiersQueryVariables>(GetCommunityVerifiersDocument, options);
        }
// @ts-ignore
export function useGetCommunityVerifiersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommunityVerifiersQuery, GetCommunityVerifiersQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommunityVerifiersQuery, GetCommunityVerifiersQueryVariables>;
export function useGetCommunityVerifiersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommunityVerifiersQuery, GetCommunityVerifiersQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommunityVerifiersQuery | undefined, GetCommunityVerifiersQueryVariables>;
export function useGetCommunityVerifiersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommunityVerifiersQuery, GetCommunityVerifiersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommunityVerifiersQuery, GetCommunityVerifiersQueryVariables>(GetCommunityVerifiersDocument, options);
        }
export type GetCommunityVerifiersQueryHookResult = ReturnType<typeof useGetCommunityVerifiersQuery>;
export type GetCommunityVerifiersLazyQueryHookResult = ReturnType<typeof useGetCommunityVerifiersLazyQuery>;
export type GetCommunityVerifiersSuspenseQueryHookResult = ReturnType<typeof useGetCommunityVerifiersSuspenseQuery>;
export type GetCommunityVerifiersQueryResult = Apollo.QueryResult<GetCommunityVerifiersQuery, GetCommunityVerifiersQueryVariables>;
export const GetCommunitiesDocument = gql`
    query getCommunities($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  getBaoleaderCommunities(
    sort: $sort
    filters: $filters
    publicationState: LIVE
    pagination: $pagination
  ) {
    id
    attributes {
      ...community
      featured_image {
        data {
          ...uploadFile
        }
      }
    }
  }
}
    ${CommunityFragmentDoc}
${UploadFileFragmentDoc}`;

/**
 * __useGetCommunitiesQuery__
 *
 * To run a query within a React component, call `useGetCommunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunitiesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetCommunitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetCommunitiesQuery, GetCommunitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommunitiesQuery, GetCommunitiesQueryVariables>(GetCommunitiesDocument, options);
      }
export function useGetCommunitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommunitiesQuery, GetCommunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommunitiesQuery, GetCommunitiesQueryVariables>(GetCommunitiesDocument, options);
        }
// @ts-ignore
export function useGetCommunitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommunitiesQuery, GetCommunitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommunitiesQuery, GetCommunitiesQueryVariables>;
export function useGetCommunitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommunitiesQuery, GetCommunitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommunitiesQuery | undefined, GetCommunitiesQueryVariables>;
export function useGetCommunitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommunitiesQuery, GetCommunitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommunitiesQuery, GetCommunitiesQueryVariables>(GetCommunitiesDocument, options);
        }
export type GetCommunitiesQueryHookResult = ReturnType<typeof useGetCommunitiesQuery>;
export type GetCommunitiesLazyQueryHookResult = ReturnType<typeof useGetCommunitiesLazyQuery>;
export type GetCommunitiesSuspenseQueryHookResult = ReturnType<typeof useGetCommunitiesSuspenseQuery>;
export type GetCommunitiesQueryResult = Apollo.QueryResult<GetCommunitiesQuery, GetCommunitiesQueryVariables>;
export const GetCommunityDocument = gql`
    query getCommunity {
  getBaoleaderCommunity {
    id
    attributes {
      name
      chief_name
      description
      location
      updatedAt
      createdAt
      featured_image {
        data {
          ...uploadFile
        }
      }
      baoleader {
        data {
          id
        }
      }
    }
  }
}
    ${UploadFileFragmentDoc}`;

/**
 * __useGetCommunityQuery__
 *
 * To run a query within a React component, call `useGetCommunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCommunityQuery(baseOptions?: Apollo.QueryHookOptions<GetCommunityQuery, GetCommunityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommunityQuery, GetCommunityQueryVariables>(GetCommunityDocument, options);
      }
export function useGetCommunityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommunityQuery, GetCommunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommunityQuery, GetCommunityQueryVariables>(GetCommunityDocument, options);
        }
// @ts-ignore
export function useGetCommunitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommunityQuery, GetCommunityQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommunityQuery, GetCommunityQueryVariables>;
export function useGetCommunitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommunityQuery, GetCommunityQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommunityQuery | undefined, GetCommunityQueryVariables>;
export function useGetCommunitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommunityQuery, GetCommunityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommunityQuery, GetCommunityQueryVariables>(GetCommunityDocument, options);
        }
export type GetCommunityQueryHookResult = ReturnType<typeof useGetCommunityQuery>;
export type GetCommunityLazyQueryHookResult = ReturnType<typeof useGetCommunityLazyQuery>;
export type GetCommunitySuspenseQueryHookResult = ReturnType<typeof useGetCommunitySuspenseQuery>;
export type GetCommunityQueryResult = Apollo.QueryResult<GetCommunityQuery, GetCommunityQueryVariables>;
export const GetCommunityBaoridersDocument = gql`
    query getCommunityBaoriders($communityId: ID!) {
  getCommunityBaoriders(community: $communityId) {
    members {
      id
      attributes {
        ...member
      }
    }
  }
}
    ${MemberFragmentDoc}`;

/**
 * __useGetCommunityBaoridersQuery__
 *
 * To run a query within a React component, call `useGetCommunityBaoridersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityBaoridersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityBaoridersQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useGetCommunityBaoridersQuery(baseOptions: Apollo.QueryHookOptions<GetCommunityBaoridersQuery, GetCommunityBaoridersQueryVariables> & ({ variables: GetCommunityBaoridersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommunityBaoridersQuery, GetCommunityBaoridersQueryVariables>(GetCommunityBaoridersDocument, options);
      }
export function useGetCommunityBaoridersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommunityBaoridersQuery, GetCommunityBaoridersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommunityBaoridersQuery, GetCommunityBaoridersQueryVariables>(GetCommunityBaoridersDocument, options);
        }
// @ts-ignore
export function useGetCommunityBaoridersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommunityBaoridersQuery, GetCommunityBaoridersQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommunityBaoridersQuery, GetCommunityBaoridersQueryVariables>;
export function useGetCommunityBaoridersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommunityBaoridersQuery, GetCommunityBaoridersQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommunityBaoridersQuery | undefined, GetCommunityBaoridersQueryVariables>;
export function useGetCommunityBaoridersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommunityBaoridersQuery, GetCommunityBaoridersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommunityBaoridersQuery, GetCommunityBaoridersQueryVariables>(GetCommunityBaoridersDocument, options);
        }
export type GetCommunityBaoridersQueryHookResult = ReturnType<typeof useGetCommunityBaoridersQuery>;
export type GetCommunityBaoridersLazyQueryHookResult = ReturnType<typeof useGetCommunityBaoridersLazyQuery>;
export type GetCommunityBaoridersSuspenseQueryHookResult = ReturnType<typeof useGetCommunityBaoridersSuspenseQuery>;
export type GetCommunityBaoridersQueryResult = Apollo.QueryResult<GetCommunityBaoridersQuery, GetCommunityBaoridersQueryVariables>;
export const GetCommunityMembersDocument = gql`
    query getCommunityMembers($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  getCommunityMembers(
    sort: $sort
    filters: $filters
    publicationState: LIVE
    pagination: $pagination
  ) {
    members {
      id
      attributes {
        ...member
      }
    }
  }
}
    ${MemberFragmentDoc}`;

/**
 * __useGetCommunityMembersQuery__
 *
 * To run a query within a React component, call `useGetCommunityMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityMembersQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetCommunityMembersQuery(baseOptions?: Apollo.QueryHookOptions<GetCommunityMembersQuery, GetCommunityMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommunityMembersQuery, GetCommunityMembersQueryVariables>(GetCommunityMembersDocument, options);
      }
export function useGetCommunityMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommunityMembersQuery, GetCommunityMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommunityMembersQuery, GetCommunityMembersQueryVariables>(GetCommunityMembersDocument, options);
        }
// @ts-ignore
export function useGetCommunityMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommunityMembersQuery, GetCommunityMembersQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommunityMembersQuery, GetCommunityMembersQueryVariables>;
export function useGetCommunityMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommunityMembersQuery, GetCommunityMembersQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommunityMembersQuery | undefined, GetCommunityMembersQueryVariables>;
export function useGetCommunityMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommunityMembersQuery, GetCommunityMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommunityMembersQuery, GetCommunityMembersQueryVariables>(GetCommunityMembersDocument, options);
        }
export type GetCommunityMembersQueryHookResult = ReturnType<typeof useGetCommunityMembersQuery>;
export type GetCommunityMembersLazyQueryHookResult = ReturnType<typeof useGetCommunityMembersLazyQuery>;
export type GetCommunityMembersSuspenseQueryHookResult = ReturnType<typeof useGetCommunityMembersSuspenseQuery>;
export type GetCommunityMembersQueryResult = Apollo.QueryResult<GetCommunityMembersQuery, GetCommunityMembersQueryVariables>;
export const GetCommunityProjectsDocument = gql`
    query getCommunityProjects($community: ID!) {
  getCommunityProjects(community: $community) {
    id
    attributes {
      ...project
      featured_image {
        data {
          ...uploadFile
        }
      }
    }
  }
}
    ${ProjectFragmentDoc}
${UploadFileFragmentDoc}`;

/**
 * __useGetCommunityProjectsQuery__
 *
 * To run a query within a React component, call `useGetCommunityProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityProjectsQuery({
 *   variables: {
 *      community: // value for 'community'
 *   },
 * });
 */
export function useGetCommunityProjectsQuery(baseOptions: Apollo.QueryHookOptions<GetCommunityProjectsQuery, GetCommunityProjectsQueryVariables> & ({ variables: GetCommunityProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommunityProjectsQuery, GetCommunityProjectsQueryVariables>(GetCommunityProjectsDocument, options);
      }
export function useGetCommunityProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommunityProjectsQuery, GetCommunityProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommunityProjectsQuery, GetCommunityProjectsQueryVariables>(GetCommunityProjectsDocument, options);
        }
// @ts-ignore
export function useGetCommunityProjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommunityProjectsQuery, GetCommunityProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommunityProjectsQuery, GetCommunityProjectsQueryVariables>;
export function useGetCommunityProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommunityProjectsQuery, GetCommunityProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommunityProjectsQuery | undefined, GetCommunityProjectsQueryVariables>;
export function useGetCommunityProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommunityProjectsQuery, GetCommunityProjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommunityProjectsQuery, GetCommunityProjectsQueryVariables>(GetCommunityProjectsDocument, options);
        }
export type GetCommunityProjectsQueryHookResult = ReturnType<typeof useGetCommunityProjectsQuery>;
export type GetCommunityProjectsLazyQueryHookResult = ReturnType<typeof useGetCommunityProjectsLazyQuery>;
export type GetCommunityProjectsSuspenseQueryHookResult = ReturnType<typeof useGetCommunityProjectsSuspenseQuery>;
export type GetCommunityProjectsQueryResult = Apollo.QueryResult<GetCommunityProjectsQuery, GetCommunityProjectsQueryVariables>;
export const GetCommunityProjectsCountDocument = gql`
    query getCommunityProjectsCount($community: ID!) {
  getCommunityProjectsCount(community: $community)
}
    `;

/**
 * __useGetCommunityProjectsCountQuery__
 *
 * To run a query within a React component, call `useGetCommunityProjectsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityProjectsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityProjectsCountQuery({
 *   variables: {
 *      community: // value for 'community'
 *   },
 * });
 */
export function useGetCommunityProjectsCountQuery(baseOptions: Apollo.QueryHookOptions<GetCommunityProjectsCountQuery, GetCommunityProjectsCountQueryVariables> & ({ variables: GetCommunityProjectsCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommunityProjectsCountQuery, GetCommunityProjectsCountQueryVariables>(GetCommunityProjectsCountDocument, options);
      }
export function useGetCommunityProjectsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommunityProjectsCountQuery, GetCommunityProjectsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommunityProjectsCountQuery, GetCommunityProjectsCountQueryVariables>(GetCommunityProjectsCountDocument, options);
        }
// @ts-ignore
export function useGetCommunityProjectsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommunityProjectsCountQuery, GetCommunityProjectsCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommunityProjectsCountQuery, GetCommunityProjectsCountQueryVariables>;
export function useGetCommunityProjectsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommunityProjectsCountQuery, GetCommunityProjectsCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommunityProjectsCountQuery | undefined, GetCommunityProjectsCountQueryVariables>;
export function useGetCommunityProjectsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommunityProjectsCountQuery, GetCommunityProjectsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommunityProjectsCountQuery, GetCommunityProjectsCountQueryVariables>(GetCommunityProjectsCountDocument, options);
        }
export type GetCommunityProjectsCountQueryHookResult = ReturnType<typeof useGetCommunityProjectsCountQuery>;
export type GetCommunityProjectsCountLazyQueryHookResult = ReturnType<typeof useGetCommunityProjectsCountLazyQuery>;
export type GetCommunityProjectsCountSuspenseQueryHookResult = ReturnType<typeof useGetCommunityProjectsCountSuspenseQuery>;
export type GetCommunityProjectsCountQueryResult = Apollo.QueryResult<GetCommunityProjectsCountQuery, GetCommunityProjectsCountQueryVariables>;
export const GetCompanyCategoriesDocument = gql`
    query GetCompanyCategories($where: JSON, $limit: Int, $start: Int, $sort: String) {
  getCompanyCategories(where: $where, limit: $limit, start: $start, sort: $sort) {
    id
    attributes {
      ...category
      featureImage {
        data {
          ...uploadFile
        }
      }
    }
  }
}
    ${CategoryFragmentDoc}
${UploadFileFragmentDoc}`;

/**
 * __useGetCompanyCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCompanyCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyCategoriesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetCompanyCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanyCategoriesQuery, GetCompanyCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyCategoriesQuery, GetCompanyCategoriesQueryVariables>(GetCompanyCategoriesDocument, options);
      }
export function useGetCompanyCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyCategoriesQuery, GetCompanyCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyCategoriesQuery, GetCompanyCategoriesQueryVariables>(GetCompanyCategoriesDocument, options);
        }
// @ts-ignore
export function useGetCompanyCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyCategoriesQuery, GetCompanyCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyCategoriesQuery, GetCompanyCategoriesQueryVariables>;
export function useGetCompanyCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyCategoriesQuery, GetCompanyCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyCategoriesQuery | undefined, GetCompanyCategoriesQueryVariables>;
export function useGetCompanyCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyCategoriesQuery, GetCompanyCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyCategoriesQuery, GetCompanyCategoriesQueryVariables>(GetCompanyCategoriesDocument, options);
        }
export type GetCompanyCategoriesQueryHookResult = ReturnType<typeof useGetCompanyCategoriesQuery>;
export type GetCompanyCategoriesLazyQueryHookResult = ReturnType<typeof useGetCompanyCategoriesLazyQuery>;
export type GetCompanyCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetCompanyCategoriesSuspenseQuery>;
export type GetCompanyCategoriesQueryResult = Apollo.QueryResult<GetCompanyCategoriesQuery, GetCompanyCategoriesQueryVariables>;
export const GetCompanyInfoDocument = gql`
    query getCompanyInfo {
  getCompanyInfo {
    name
    pin_registration
    website
    affiliates
    paymentMethod
    default_dashboard
    onboardingInformation
    subscription {
      data {
        id
        attributes {
          createdAt
          updatedAt
          current_period_start
          current_period_end
          cancel_at
          trial_start
          collection_method
          cancel_at_period_end
          recurring
          trial_end
          status
          product_plan {
            data {
              id
              attributes {
                name
                isManual
                description
                ProductFeature {
                  id
                  baoriders_allowed
                  cost_per_baorider
                  price
                  recurring
                }
              }
            }
          }
        }
      }
    }
    team_members {
      data {
        id
        attributes {
          ...member
        }
      }
    }
    id_number
    wildlife_association_number
    createdAt
    updatedAt
  }
}
    ${MemberFragmentDoc}`;

/**
 * __useGetCompanyInfoQuery__
 *
 * To run a query within a React component, call `useGetCompanyInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>(GetCompanyInfoDocument, options);
      }
export function useGetCompanyInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>(GetCompanyInfoDocument, options);
        }
// @ts-ignore
export function useGetCompanyInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>;
export function useGetCompanyInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyInfoQuery | undefined, GetCompanyInfoQueryVariables>;
export function useGetCompanyInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>(GetCompanyInfoDocument, options);
        }
export type GetCompanyInfoQueryHookResult = ReturnType<typeof useGetCompanyInfoQuery>;
export type GetCompanyInfoLazyQueryHookResult = ReturnType<typeof useGetCompanyInfoLazyQuery>;
export type GetCompanyInfoSuspenseQueryHookResult = ReturnType<typeof useGetCompanyInfoSuspenseQuery>;
export type GetCompanyInfoQueryResult = Apollo.QueryResult<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>;
export const GetCompanyInfoLiteDocument = gql`
    query getCompanyInfoLite {
  getCompanyInfo {
    name
    pin_registration
    website
    affiliates
    paymentMethod
    default_dashboard
    subscription {
      data {
        id
        attributes {
          createdAt
          updatedAt
          current_period_start
          current_period_end
          cancel_at
          trial_start
          collection_method
          cancel_at_period_end
          recurring
          currency
          trial_end
          status
          product_plan {
            data {
              id
              attributes {
                name
                isManual
                description
                ProductFeature {
                  id
                  baoriders_allowed
                  cost_per_baorider
                  price
                  recurring
                }
              }
            }
          }
        }
      }
    }
    id_number
    wildlife_association_number
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetCompanyInfoLiteQuery__
 *
 * To run a query within a React component, call `useGetCompanyInfoLiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyInfoLiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyInfoLiteQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyInfoLiteQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanyInfoLiteQuery, GetCompanyInfoLiteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyInfoLiteQuery, GetCompanyInfoLiteQueryVariables>(GetCompanyInfoLiteDocument, options);
      }
export function useGetCompanyInfoLiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyInfoLiteQuery, GetCompanyInfoLiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyInfoLiteQuery, GetCompanyInfoLiteQueryVariables>(GetCompanyInfoLiteDocument, options);
        }
// @ts-ignore
export function useGetCompanyInfoLiteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyInfoLiteQuery, GetCompanyInfoLiteQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyInfoLiteQuery, GetCompanyInfoLiteQueryVariables>;
export function useGetCompanyInfoLiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyInfoLiteQuery, GetCompanyInfoLiteQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyInfoLiteQuery | undefined, GetCompanyInfoLiteQueryVariables>;
export function useGetCompanyInfoLiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyInfoLiteQuery, GetCompanyInfoLiteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyInfoLiteQuery, GetCompanyInfoLiteQueryVariables>(GetCompanyInfoLiteDocument, options);
        }
export type GetCompanyInfoLiteQueryHookResult = ReturnType<typeof useGetCompanyInfoLiteQuery>;
export type GetCompanyInfoLiteLazyQueryHookResult = ReturnType<typeof useGetCompanyInfoLiteLazyQuery>;
export type GetCompanyInfoLiteSuspenseQueryHookResult = ReturnType<typeof useGetCompanyInfoLiteSuspenseQuery>;
export type GetCompanyInfoLiteQueryResult = Apollo.QueryResult<GetCompanyInfoLiteQuery, GetCompanyInfoLiteQueryVariables>;
export const GetCompanyLeadersDocument = gql`
    query getCompanyLeaders($sort: [String], $filters: UsersPermissionsUserFiltersInput, $pagination: PaginationArg) {
  getCompanyLeaders(
    sort: $sort
    filters: $filters
    publicationState: LIVE
    pagination: $pagination
  ) {
    id
    attributes {
      ...member
    }
  }
}
    ${MemberFragmentDoc}`;

/**
 * __useGetCompanyLeadersQuery__
 *
 * To run a query within a React component, call `useGetCompanyLeadersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyLeadersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyLeadersQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetCompanyLeadersQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanyLeadersQuery, GetCompanyLeadersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyLeadersQuery, GetCompanyLeadersQueryVariables>(GetCompanyLeadersDocument, options);
      }
export function useGetCompanyLeadersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyLeadersQuery, GetCompanyLeadersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyLeadersQuery, GetCompanyLeadersQueryVariables>(GetCompanyLeadersDocument, options);
        }
// @ts-ignore
export function useGetCompanyLeadersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyLeadersQuery, GetCompanyLeadersQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyLeadersQuery, GetCompanyLeadersQueryVariables>;
export function useGetCompanyLeadersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyLeadersQuery, GetCompanyLeadersQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyLeadersQuery | undefined, GetCompanyLeadersQueryVariables>;
export function useGetCompanyLeadersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyLeadersQuery, GetCompanyLeadersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyLeadersQuery, GetCompanyLeadersQueryVariables>(GetCompanyLeadersDocument, options);
        }
export type GetCompanyLeadersQueryHookResult = ReturnType<typeof useGetCompanyLeadersQuery>;
export type GetCompanyLeadersLazyQueryHookResult = ReturnType<typeof useGetCompanyLeadersLazyQuery>;
export type GetCompanyLeadersSuspenseQueryHookResult = ReturnType<typeof useGetCompanyLeadersSuspenseQuery>;
export type GetCompanyLeadersQueryResult = Apollo.QueryResult<GetCompanyLeadersQuery, GetCompanyLeadersQueryVariables>;
export const GetCompanyLeadersCountDocument = gql`
    query getCompanyLeadersCount {
  getCompanyLeadersCount
}
    `;

/**
 * __useGetCompanyLeadersCountQuery__
 *
 * To run a query within a React component, call `useGetCompanyLeadersCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyLeadersCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyLeadersCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyLeadersCountQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanyLeadersCountQuery, GetCompanyLeadersCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyLeadersCountQuery, GetCompanyLeadersCountQueryVariables>(GetCompanyLeadersCountDocument, options);
      }
export function useGetCompanyLeadersCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyLeadersCountQuery, GetCompanyLeadersCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyLeadersCountQuery, GetCompanyLeadersCountQueryVariables>(GetCompanyLeadersCountDocument, options);
        }
// @ts-ignore
export function useGetCompanyLeadersCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyLeadersCountQuery, GetCompanyLeadersCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyLeadersCountQuery, GetCompanyLeadersCountQueryVariables>;
export function useGetCompanyLeadersCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyLeadersCountQuery, GetCompanyLeadersCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyLeadersCountQuery | undefined, GetCompanyLeadersCountQueryVariables>;
export function useGetCompanyLeadersCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyLeadersCountQuery, GetCompanyLeadersCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyLeadersCountQuery, GetCompanyLeadersCountQueryVariables>(GetCompanyLeadersCountDocument, options);
        }
export type GetCompanyLeadersCountQueryHookResult = ReturnType<typeof useGetCompanyLeadersCountQuery>;
export type GetCompanyLeadersCountLazyQueryHookResult = ReturnType<typeof useGetCompanyLeadersCountLazyQuery>;
export type GetCompanyLeadersCountSuspenseQueryHookResult = ReturnType<typeof useGetCompanyLeadersCountSuspenseQuery>;
export type GetCompanyLeadersCountQueryResult = Apollo.QueryResult<GetCompanyLeadersCountQuery, GetCompanyLeadersCountQueryVariables>;
export const GetCompanyOnlyCategoriesDocument = gql`
    query getCompanyOnlyCategories($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  getCompanyOnlyCategories(
    sort: $sort
    filters: $filters
    publicationState: LIVE
    pagination: $pagination
  ) {
    categories {
      id
      attributes {
        ...category
        featureImage {
          data {
            ...uploadFile
          }
        }
        task_types {
          data {
            id
          }
        }
      }
    }
    count
  }
}
    ${CategoryFragmentDoc}
${UploadFileFragmentDoc}`;

/**
 * __useGetCompanyOnlyCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCompanyOnlyCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyOnlyCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyOnlyCategoriesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetCompanyOnlyCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanyOnlyCategoriesQuery, GetCompanyOnlyCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyOnlyCategoriesQuery, GetCompanyOnlyCategoriesQueryVariables>(GetCompanyOnlyCategoriesDocument, options);
      }
export function useGetCompanyOnlyCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyOnlyCategoriesQuery, GetCompanyOnlyCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyOnlyCategoriesQuery, GetCompanyOnlyCategoriesQueryVariables>(GetCompanyOnlyCategoriesDocument, options);
        }
// @ts-ignore
export function useGetCompanyOnlyCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyOnlyCategoriesQuery, GetCompanyOnlyCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyOnlyCategoriesQuery, GetCompanyOnlyCategoriesQueryVariables>;
export function useGetCompanyOnlyCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyOnlyCategoriesQuery, GetCompanyOnlyCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyOnlyCategoriesQuery | undefined, GetCompanyOnlyCategoriesQueryVariables>;
export function useGetCompanyOnlyCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyOnlyCategoriesQuery, GetCompanyOnlyCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyOnlyCategoriesQuery, GetCompanyOnlyCategoriesQueryVariables>(GetCompanyOnlyCategoriesDocument, options);
        }
export type GetCompanyOnlyCategoriesQueryHookResult = ReturnType<typeof useGetCompanyOnlyCategoriesQuery>;
export type GetCompanyOnlyCategoriesLazyQueryHookResult = ReturnType<typeof useGetCompanyOnlyCategoriesLazyQuery>;
export type GetCompanyOnlyCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetCompanyOnlyCategoriesSuspenseQuery>;
export type GetCompanyOnlyCategoriesQueryResult = Apollo.QueryResult<GetCompanyOnlyCategoriesQuery, GetCompanyOnlyCategoriesQueryVariables>;
export const GetCompanyTaskTypesDocument = gql`
    query GetCompanyTaskTypes($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  getCompanyTaskTypes(
    sort: $sort
    filters: $filters
    publicationState: LIVE
    pagination: $pagination
  ) {
    id
    attributes {
      ...taskType
      category {
        data {
          id
          attributes {
            ...category
            featureImage {
              data {
                ...uploadFile
              }
            }
          }
        }
      }
    }
  }
}
    ${TaskTypeFragmentDoc}
${CategoryFragmentDoc}
${UploadFileFragmentDoc}`;

/**
 * __useGetCompanyTaskTypesQuery__
 *
 * To run a query within a React component, call `useGetCompanyTaskTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyTaskTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyTaskTypesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetCompanyTaskTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanyTaskTypesQuery, GetCompanyTaskTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyTaskTypesQuery, GetCompanyTaskTypesQueryVariables>(GetCompanyTaskTypesDocument, options);
      }
export function useGetCompanyTaskTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyTaskTypesQuery, GetCompanyTaskTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyTaskTypesQuery, GetCompanyTaskTypesQueryVariables>(GetCompanyTaskTypesDocument, options);
        }
// @ts-ignore
export function useGetCompanyTaskTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyTaskTypesQuery, GetCompanyTaskTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyTaskTypesQuery, GetCompanyTaskTypesQueryVariables>;
export function useGetCompanyTaskTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyTaskTypesQuery, GetCompanyTaskTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyTaskTypesQuery | undefined, GetCompanyTaskTypesQueryVariables>;
export function useGetCompanyTaskTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyTaskTypesQuery, GetCompanyTaskTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyTaskTypesQuery, GetCompanyTaskTypesQueryVariables>(GetCompanyTaskTypesDocument, options);
        }
export type GetCompanyTaskTypesQueryHookResult = ReturnType<typeof useGetCompanyTaskTypesQuery>;
export type GetCompanyTaskTypesLazyQueryHookResult = ReturnType<typeof useGetCompanyTaskTypesLazyQuery>;
export type GetCompanyTaskTypesSuspenseQueryHookResult = ReturnType<typeof useGetCompanyTaskTypesSuspenseQuery>;
export type GetCompanyTaskTypesQueryResult = Apollo.QueryResult<GetCompanyTaskTypesQuery, GetCompanyTaskTypesQueryVariables>;
export const GetCountDataListsDocument = gql`
    query getCountDataLists($filters: JSON) {
  getCountDataLists(filters: $filters)
}
    `;

/**
 * __useGetCountDataListsQuery__
 *
 * To run a query within a React component, call `useGetCountDataListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountDataListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountDataListsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetCountDataListsQuery(baseOptions?: Apollo.QueryHookOptions<GetCountDataListsQuery, GetCountDataListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountDataListsQuery, GetCountDataListsQueryVariables>(GetCountDataListsDocument, options);
      }
export function useGetCountDataListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountDataListsQuery, GetCountDataListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountDataListsQuery, GetCountDataListsQueryVariables>(GetCountDataListsDocument, options);
        }
// @ts-ignore
export function useGetCountDataListsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCountDataListsQuery, GetCountDataListsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCountDataListsQuery, GetCountDataListsQueryVariables>;
export function useGetCountDataListsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountDataListsQuery, GetCountDataListsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCountDataListsQuery | undefined, GetCountDataListsQueryVariables>;
export function useGetCountDataListsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountDataListsQuery, GetCountDataListsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCountDataListsQuery, GetCountDataListsQueryVariables>(GetCountDataListsDocument, options);
        }
export type GetCountDataListsQueryHookResult = ReturnType<typeof useGetCountDataListsQuery>;
export type GetCountDataListsLazyQueryHookResult = ReturnType<typeof useGetCountDataListsLazyQuery>;
export type GetCountDataListsSuspenseQueryHookResult = ReturnType<typeof useGetCountDataListsSuspenseQuery>;
export type GetCountDataListsQueryResult = Apollo.QueryResult<GetCountDataListsQuery, GetCountDataListsQueryVariables>;
export const GetCustomerPaymentDetailsDocument = gql`
    query getCustomerPaymentDetails {
  getCustomerPaymentDetails {
    id
    brand
    exp_month
    exp_year
    last4
    isDefault
  }
}
    `;

/**
 * __useGetCustomerPaymentDetailsQuery__
 *
 * To run a query within a React component, call `useGetCustomerPaymentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerPaymentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerPaymentDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomerPaymentDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomerPaymentDetailsQuery, GetCustomerPaymentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerPaymentDetailsQuery, GetCustomerPaymentDetailsQueryVariables>(GetCustomerPaymentDetailsDocument, options);
      }
export function useGetCustomerPaymentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerPaymentDetailsQuery, GetCustomerPaymentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerPaymentDetailsQuery, GetCustomerPaymentDetailsQueryVariables>(GetCustomerPaymentDetailsDocument, options);
        }
// @ts-ignore
export function useGetCustomerPaymentDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerPaymentDetailsQuery, GetCustomerPaymentDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerPaymentDetailsQuery, GetCustomerPaymentDetailsQueryVariables>;
export function useGetCustomerPaymentDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerPaymentDetailsQuery, GetCustomerPaymentDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerPaymentDetailsQuery | undefined, GetCustomerPaymentDetailsQueryVariables>;
export function useGetCustomerPaymentDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerPaymentDetailsQuery, GetCustomerPaymentDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerPaymentDetailsQuery, GetCustomerPaymentDetailsQueryVariables>(GetCustomerPaymentDetailsDocument, options);
        }
export type GetCustomerPaymentDetailsQueryHookResult = ReturnType<typeof useGetCustomerPaymentDetailsQuery>;
export type GetCustomerPaymentDetailsLazyQueryHookResult = ReturnType<typeof useGetCustomerPaymentDetailsLazyQuery>;
export type GetCustomerPaymentDetailsSuspenseQueryHookResult = ReturnType<typeof useGetCustomerPaymentDetailsSuspenseQuery>;
export type GetCustomerPaymentDetailsQueryResult = Apollo.QueryResult<GetCustomerPaymentDetailsQuery, GetCustomerPaymentDetailsQueryVariables>;
export const GetDataListsDocument = gql`
    query getDataLists($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  getDataLists(
    sort: $sort
    filters: $filters
    publicationState: LIVE
    pagination: $pagination
  ) {
    id
    attributes {
      ...dataLists
    }
  }
}
    ${DataListsFragmentDoc}`;

/**
 * __useGetDataListsQuery__
 *
 * To run a query within a React component, call `useGetDataListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataListsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetDataListsQuery(baseOptions?: Apollo.QueryHookOptions<GetDataListsQuery, GetDataListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataListsQuery, GetDataListsQueryVariables>(GetDataListsDocument, options);
      }
export function useGetDataListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataListsQuery, GetDataListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataListsQuery, GetDataListsQueryVariables>(GetDataListsDocument, options);
        }
// @ts-ignore
export function useGetDataListsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDataListsQuery, GetDataListsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDataListsQuery, GetDataListsQueryVariables>;
export function useGetDataListsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDataListsQuery, GetDataListsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDataListsQuery | undefined, GetDataListsQueryVariables>;
export function useGetDataListsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDataListsQuery, GetDataListsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDataListsQuery, GetDataListsQueryVariables>(GetDataListsDocument, options);
        }
export type GetDataListsQueryHookResult = ReturnType<typeof useGetDataListsQuery>;
export type GetDataListsLazyQueryHookResult = ReturnType<typeof useGetDataListsLazyQuery>;
export type GetDataListsSuspenseQueryHookResult = ReturnType<typeof useGetDataListsSuspenseQuery>;
export type GetDataListsQueryResult = Apollo.QueryResult<GetDataListsQuery, GetDataListsQueryVariables>;
export const GetInsightAiAnalysisDocument = gql`
    query getInsightAIAnalysis($taskDefinitionIds: [ID!], $columns: JSON, $aggregation: String, $timeSeries: String, $recordCount: Int, $selectedColumns: [String], $messages: [InsightAIMessageInput], $dataSummary: JSON, $dateRange: DateRangeInput, $dateSource: String, $dateInfo: JSON) {
  getInsightAIAnalysis(
    taskDefinitionIds: $taskDefinitionIds
    columns: $columns
    aggregation: $aggregation
    timeSeries: $timeSeries
    recordCount: $recordCount
    selectedColumns: $selectedColumns
    messages: $messages
    dataSummary: $dataSummary
    dateRange: $dateRange
    dateSource: $dateSource
    dateInfo: $dateInfo
  ) {
    message
    suggestions {
      label
      prompt
    }
    suggestedChartType
    suggestedColumns
    reportPlan
  }
}
    `;

/**
 * __useGetInsightAiAnalysisQuery__
 *
 * To run a query within a React component, call `useGetInsightAiAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsightAiAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsightAiAnalysisQuery({
 *   variables: {
 *      taskDefinitionIds: // value for 'taskDefinitionIds'
 *      columns: // value for 'columns'
 *      aggregation: // value for 'aggregation'
 *      timeSeries: // value for 'timeSeries'
 *      recordCount: // value for 'recordCount'
 *      selectedColumns: // value for 'selectedColumns'
 *      messages: // value for 'messages'
 *      dataSummary: // value for 'dataSummary'
 *      dateRange: // value for 'dateRange'
 *      dateSource: // value for 'dateSource'
 *      dateInfo: // value for 'dateInfo'
 *   },
 * });
 */
export function useGetInsightAiAnalysisQuery(baseOptions?: Apollo.QueryHookOptions<GetInsightAiAnalysisQuery, GetInsightAiAnalysisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsightAiAnalysisQuery, GetInsightAiAnalysisQueryVariables>(GetInsightAiAnalysisDocument, options);
      }
export function useGetInsightAiAnalysisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsightAiAnalysisQuery, GetInsightAiAnalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsightAiAnalysisQuery, GetInsightAiAnalysisQueryVariables>(GetInsightAiAnalysisDocument, options);
        }
// @ts-ignore
export function useGetInsightAiAnalysisSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInsightAiAnalysisQuery, GetInsightAiAnalysisQueryVariables>): Apollo.UseSuspenseQueryResult<GetInsightAiAnalysisQuery, GetInsightAiAnalysisQueryVariables>;
export function useGetInsightAiAnalysisSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInsightAiAnalysisQuery, GetInsightAiAnalysisQueryVariables>): Apollo.UseSuspenseQueryResult<GetInsightAiAnalysisQuery | undefined, GetInsightAiAnalysisQueryVariables>;
export function useGetInsightAiAnalysisSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInsightAiAnalysisQuery, GetInsightAiAnalysisQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInsightAiAnalysisQuery, GetInsightAiAnalysisQueryVariables>(GetInsightAiAnalysisDocument, options);
        }
export type GetInsightAiAnalysisQueryHookResult = ReturnType<typeof useGetInsightAiAnalysisQuery>;
export type GetInsightAiAnalysisLazyQueryHookResult = ReturnType<typeof useGetInsightAiAnalysisLazyQuery>;
export type GetInsightAiAnalysisSuspenseQueryHookResult = ReturnType<typeof useGetInsightAiAnalysisSuspenseQuery>;
export type GetInsightAiAnalysisQueryResult = Apollo.QueryResult<GetInsightAiAnalysisQuery, GetInsightAiAnalysisQueryVariables>;
export const GetInsightReportDocument = gql`
    query getInsightReport($id: ID!) {
  getInsightReport(id: $id) {
    id
    attributes {
      ...insightReport
    }
  }
}
    ${InsightReportFragmentDoc}`;

/**
 * __useGetInsightReportQuery__
 *
 * To run a query within a React component, call `useGetInsightReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsightReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsightReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInsightReportQuery(baseOptions: Apollo.QueryHookOptions<GetInsightReportQuery, GetInsightReportQueryVariables> & ({ variables: GetInsightReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsightReportQuery, GetInsightReportQueryVariables>(GetInsightReportDocument, options);
      }
export function useGetInsightReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsightReportQuery, GetInsightReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsightReportQuery, GetInsightReportQueryVariables>(GetInsightReportDocument, options);
        }
// @ts-ignore
export function useGetInsightReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInsightReportQuery, GetInsightReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetInsightReportQuery, GetInsightReportQueryVariables>;
export function useGetInsightReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInsightReportQuery, GetInsightReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetInsightReportQuery | undefined, GetInsightReportQueryVariables>;
export function useGetInsightReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInsightReportQuery, GetInsightReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInsightReportQuery, GetInsightReportQueryVariables>(GetInsightReportDocument, options);
        }
export type GetInsightReportQueryHookResult = ReturnType<typeof useGetInsightReportQuery>;
export type GetInsightReportLazyQueryHookResult = ReturnType<typeof useGetInsightReportLazyQuery>;
export type GetInsightReportSuspenseQueryHookResult = ReturnType<typeof useGetInsightReportSuspenseQuery>;
export type GetInsightReportQueryResult = Apollo.QueryResult<GetInsightReportQuery, GetInsightReportQueryVariables>;
export const GetInsightReportsDocument = gql`
    query getInsightReports($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  getInsightReports(sort: $sort, filters: $filters, pagination: $pagination) {
    id
    attributes {
      ...insightReport
    }
  }
}
    ${InsightReportFragmentDoc}`;

/**
 * __useGetInsightReportsQuery__
 *
 * To run a query within a React component, call `useGetInsightReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsightReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsightReportsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetInsightReportsQuery(baseOptions?: Apollo.QueryHookOptions<GetInsightReportsQuery, GetInsightReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsightReportsQuery, GetInsightReportsQueryVariables>(GetInsightReportsDocument, options);
      }
export function useGetInsightReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsightReportsQuery, GetInsightReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsightReportsQuery, GetInsightReportsQueryVariables>(GetInsightReportsDocument, options);
        }
// @ts-ignore
export function useGetInsightReportsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInsightReportsQuery, GetInsightReportsQueryVariables>): Apollo.UseSuspenseQueryResult<GetInsightReportsQuery, GetInsightReportsQueryVariables>;
export function useGetInsightReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInsightReportsQuery, GetInsightReportsQueryVariables>): Apollo.UseSuspenseQueryResult<GetInsightReportsQuery | undefined, GetInsightReportsQueryVariables>;
export function useGetInsightReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInsightReportsQuery, GetInsightReportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInsightReportsQuery, GetInsightReportsQueryVariables>(GetInsightReportsDocument, options);
        }
export type GetInsightReportsQueryHookResult = ReturnType<typeof useGetInsightReportsQuery>;
export type GetInsightReportsLazyQueryHookResult = ReturnType<typeof useGetInsightReportsLazyQuery>;
export type GetInsightReportsSuspenseQueryHookResult = ReturnType<typeof useGetInsightReportsSuspenseQuery>;
export type GetInsightReportsQueryResult = Apollo.QueryResult<GetInsightReportsQuery, GetInsightReportsQueryVariables>;
export const GetInsightReportsCountDocument = gql`
    query getInsightReportsCount($filters: JSON) {
  getInsightReportsCount(filters: $filters)
}
    `;

/**
 * __useGetInsightReportsCountQuery__
 *
 * To run a query within a React component, call `useGetInsightReportsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsightReportsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsightReportsCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetInsightReportsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetInsightReportsCountQuery, GetInsightReportsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsightReportsCountQuery, GetInsightReportsCountQueryVariables>(GetInsightReportsCountDocument, options);
      }
export function useGetInsightReportsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsightReportsCountQuery, GetInsightReportsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsightReportsCountQuery, GetInsightReportsCountQueryVariables>(GetInsightReportsCountDocument, options);
        }
// @ts-ignore
export function useGetInsightReportsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInsightReportsCountQuery, GetInsightReportsCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetInsightReportsCountQuery, GetInsightReportsCountQueryVariables>;
export function useGetInsightReportsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInsightReportsCountQuery, GetInsightReportsCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetInsightReportsCountQuery | undefined, GetInsightReportsCountQueryVariables>;
export function useGetInsightReportsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInsightReportsCountQuery, GetInsightReportsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInsightReportsCountQuery, GetInsightReportsCountQueryVariables>(GetInsightReportsCountDocument, options);
        }
export type GetInsightReportsCountQueryHookResult = ReturnType<typeof useGetInsightReportsCountQuery>;
export type GetInsightReportsCountLazyQueryHookResult = ReturnType<typeof useGetInsightReportsCountLazyQuery>;
export type GetInsightReportsCountSuspenseQueryHookResult = ReturnType<typeof useGetInsightReportsCountSuspenseQuery>;
export type GetInsightReportsCountQueryResult = Apollo.QueryResult<GetInsightReportsCountQuery, GetInsightReportsCountQueryVariables>;
export const GetInsightTaskDataDocument = gql`
    query getInsightTaskData($taskDefinitionId: ID, $taskDefinitionIds: [ID!], $dateRange: DateRangeInput, $dateSource: String, $timeSeries: String, $aggregation: String, $selectedColumns: [String], $statuses: [String], $filters: [InsightAgentFilterInput!], $groupBy: String, $compareYears: Boolean) {
  getInsightTaskData(
    taskDefinitionId: $taskDefinitionId
    taskDefinitionIds: $taskDefinitionIds
    dateRange: $dateRange
    dateSource: $dateSource
    timeSeries: $timeSeries
    aggregation: $aggregation
    selectedColumns: $selectedColumns
    statuses: $statuses
    filters: $filters
    groupBy: $groupBy
    compareYears: $compareYears
  ) {
    columns {
      key
      label
      type
      version
      isFromOlderVersion
      taskTypeName
      taskTypeId
    }
    rows
    aggregatedData
    totalRows
    dateInfo
  }
}
    `;

/**
 * __useGetInsightTaskDataQuery__
 *
 * To run a query within a React component, call `useGetInsightTaskDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsightTaskDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsightTaskDataQuery({
 *   variables: {
 *      taskDefinitionId: // value for 'taskDefinitionId'
 *      taskDefinitionIds: // value for 'taskDefinitionIds'
 *      dateRange: // value for 'dateRange'
 *      dateSource: // value for 'dateSource'
 *      timeSeries: // value for 'timeSeries'
 *      aggregation: // value for 'aggregation'
 *      selectedColumns: // value for 'selectedColumns'
 *      statuses: // value for 'statuses'
 *      filters: // value for 'filters'
 *      groupBy: // value for 'groupBy'
 *      compareYears: // value for 'compareYears'
 *   },
 * });
 */
export function useGetInsightTaskDataQuery(baseOptions?: Apollo.QueryHookOptions<GetInsightTaskDataQuery, GetInsightTaskDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsightTaskDataQuery, GetInsightTaskDataQueryVariables>(GetInsightTaskDataDocument, options);
      }
export function useGetInsightTaskDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsightTaskDataQuery, GetInsightTaskDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsightTaskDataQuery, GetInsightTaskDataQueryVariables>(GetInsightTaskDataDocument, options);
        }
// @ts-ignore
export function useGetInsightTaskDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInsightTaskDataQuery, GetInsightTaskDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetInsightTaskDataQuery, GetInsightTaskDataQueryVariables>;
export function useGetInsightTaskDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInsightTaskDataQuery, GetInsightTaskDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetInsightTaskDataQuery | undefined, GetInsightTaskDataQueryVariables>;
export function useGetInsightTaskDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInsightTaskDataQuery, GetInsightTaskDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInsightTaskDataQuery, GetInsightTaskDataQueryVariables>(GetInsightTaskDataDocument, options);
        }
export type GetInsightTaskDataQueryHookResult = ReturnType<typeof useGetInsightTaskDataQuery>;
export type GetInsightTaskDataLazyQueryHookResult = ReturnType<typeof useGetInsightTaskDataLazyQuery>;
export type GetInsightTaskDataSuspenseQueryHookResult = ReturnType<typeof useGetInsightTaskDataSuspenseQuery>;
export type GetInsightTaskDataQueryResult = Apollo.QueryResult<GetInsightTaskDataQuery, GetInsightTaskDataQueryVariables>;
export const GetInsightTaskDefinitionsDocument = gql`
    query getInsightTaskDefinitions {
  getInsightTaskDefinitions {
    id
    attributes {
      status
      task_type {
        data {
          id
          attributes {
            title
          }
        }
      }
      project {
        data {
          id
          attributes {
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetInsightTaskDefinitionsQuery__
 *
 * To run a query within a React component, call `useGetInsightTaskDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsightTaskDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsightTaskDefinitionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInsightTaskDefinitionsQuery(baseOptions?: Apollo.QueryHookOptions<GetInsightTaskDefinitionsQuery, GetInsightTaskDefinitionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsightTaskDefinitionsQuery, GetInsightTaskDefinitionsQueryVariables>(GetInsightTaskDefinitionsDocument, options);
      }
export function useGetInsightTaskDefinitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsightTaskDefinitionsQuery, GetInsightTaskDefinitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsightTaskDefinitionsQuery, GetInsightTaskDefinitionsQueryVariables>(GetInsightTaskDefinitionsDocument, options);
        }
// @ts-ignore
export function useGetInsightTaskDefinitionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInsightTaskDefinitionsQuery, GetInsightTaskDefinitionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetInsightTaskDefinitionsQuery, GetInsightTaskDefinitionsQueryVariables>;
export function useGetInsightTaskDefinitionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInsightTaskDefinitionsQuery, GetInsightTaskDefinitionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetInsightTaskDefinitionsQuery | undefined, GetInsightTaskDefinitionsQueryVariables>;
export function useGetInsightTaskDefinitionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInsightTaskDefinitionsQuery, GetInsightTaskDefinitionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInsightTaskDefinitionsQuery, GetInsightTaskDefinitionsQueryVariables>(GetInsightTaskDefinitionsDocument, options);
        }
export type GetInsightTaskDefinitionsQueryHookResult = ReturnType<typeof useGetInsightTaskDefinitionsQuery>;
export type GetInsightTaskDefinitionsLazyQueryHookResult = ReturnType<typeof useGetInsightTaskDefinitionsLazyQuery>;
export type GetInsightTaskDefinitionsSuspenseQueryHookResult = ReturnType<typeof useGetInsightTaskDefinitionsSuspenseQuery>;
export type GetInsightTaskDefinitionsQueryResult = Apollo.QueryResult<GetInsightTaskDefinitionsQuery, GetInsightTaskDefinitionsQueryVariables>;
export const GetMapTasksDocument = gql`
    query getMapTasks($filters: JSON) {
  getMapTasks(filters: $filters)
}
    `;

/**
 * __useGetMapTasksQuery__
 *
 * To run a query within a React component, call `useGetMapTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMapTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMapTasksQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetMapTasksQuery(baseOptions?: Apollo.QueryHookOptions<GetMapTasksQuery, GetMapTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMapTasksQuery, GetMapTasksQueryVariables>(GetMapTasksDocument, options);
      }
export function useGetMapTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMapTasksQuery, GetMapTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMapTasksQuery, GetMapTasksQueryVariables>(GetMapTasksDocument, options);
        }
// @ts-ignore
export function useGetMapTasksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMapTasksQuery, GetMapTasksQueryVariables>): Apollo.UseSuspenseQueryResult<GetMapTasksQuery, GetMapTasksQueryVariables>;
export function useGetMapTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMapTasksQuery, GetMapTasksQueryVariables>): Apollo.UseSuspenseQueryResult<GetMapTasksQuery | undefined, GetMapTasksQueryVariables>;
export function useGetMapTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMapTasksQuery, GetMapTasksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMapTasksQuery, GetMapTasksQueryVariables>(GetMapTasksDocument, options);
        }
export type GetMapTasksQueryHookResult = ReturnType<typeof useGetMapTasksQuery>;
export type GetMapTasksLazyQueryHookResult = ReturnType<typeof useGetMapTasksLazyQuery>;
export type GetMapTasksSuspenseQueryHookResult = ReturnType<typeof useGetMapTasksSuspenseQuery>;
export type GetMapTasksQueryResult = Apollo.QueryResult<GetMapTasksQuery, GetMapTasksQueryVariables>;
export const GetMyFeatureAccessDocument = gql`
    query getMyFeatureAccess($feature: String) {
  getMyFeatureAccess(feature: $feature) {
    feature
    hasAccess
    source
    accessEndsAt
    showCountdown
    requiresMigration
    migrationDeadline
    isManual
  }
}
    `;

/**
 * __useGetMyFeatureAccessQuery__
 *
 * To run a query within a React component, call `useGetMyFeatureAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyFeatureAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyFeatureAccessQuery({
 *   variables: {
 *      feature: // value for 'feature'
 *   },
 * });
 */
export function useGetMyFeatureAccessQuery(baseOptions?: Apollo.QueryHookOptions<GetMyFeatureAccessQuery, GetMyFeatureAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyFeatureAccessQuery, GetMyFeatureAccessQueryVariables>(GetMyFeatureAccessDocument, options);
      }
export function useGetMyFeatureAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyFeatureAccessQuery, GetMyFeatureAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyFeatureAccessQuery, GetMyFeatureAccessQueryVariables>(GetMyFeatureAccessDocument, options);
        }
// @ts-ignore
export function useGetMyFeatureAccessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyFeatureAccessQuery, GetMyFeatureAccessQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyFeatureAccessQuery, GetMyFeatureAccessQueryVariables>;
export function useGetMyFeatureAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyFeatureAccessQuery, GetMyFeatureAccessQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyFeatureAccessQuery | undefined, GetMyFeatureAccessQueryVariables>;
export function useGetMyFeatureAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyFeatureAccessQuery, GetMyFeatureAccessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyFeatureAccessQuery, GetMyFeatureAccessQueryVariables>(GetMyFeatureAccessDocument, options);
        }
export type GetMyFeatureAccessQueryHookResult = ReturnType<typeof useGetMyFeatureAccessQuery>;
export type GetMyFeatureAccessLazyQueryHookResult = ReturnType<typeof useGetMyFeatureAccessLazyQuery>;
export type GetMyFeatureAccessSuspenseQueryHookResult = ReturnType<typeof useGetMyFeatureAccessSuspenseQuery>;
export type GetMyFeatureAccessQueryResult = Apollo.QueryResult<GetMyFeatureAccessQuery, GetMyFeatureAccessQueryVariables>;
export const GetMyFeatureUnlocksDocument = gql`
    query getMyFeatureUnlocks {
  getMyFeatureUnlocks {
    feature
    expiresAt
    active
  }
}
    `;

/**
 * __useGetMyFeatureUnlocksQuery__
 *
 * To run a query within a React component, call `useGetMyFeatureUnlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyFeatureUnlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyFeatureUnlocksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyFeatureUnlocksQuery(baseOptions?: Apollo.QueryHookOptions<GetMyFeatureUnlocksQuery, GetMyFeatureUnlocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyFeatureUnlocksQuery, GetMyFeatureUnlocksQueryVariables>(GetMyFeatureUnlocksDocument, options);
      }
export function useGetMyFeatureUnlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyFeatureUnlocksQuery, GetMyFeatureUnlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyFeatureUnlocksQuery, GetMyFeatureUnlocksQueryVariables>(GetMyFeatureUnlocksDocument, options);
        }
// @ts-ignore
export function useGetMyFeatureUnlocksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyFeatureUnlocksQuery, GetMyFeatureUnlocksQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyFeatureUnlocksQuery, GetMyFeatureUnlocksQueryVariables>;
export function useGetMyFeatureUnlocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyFeatureUnlocksQuery, GetMyFeatureUnlocksQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyFeatureUnlocksQuery | undefined, GetMyFeatureUnlocksQueryVariables>;
export function useGetMyFeatureUnlocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyFeatureUnlocksQuery, GetMyFeatureUnlocksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyFeatureUnlocksQuery, GetMyFeatureUnlocksQueryVariables>(GetMyFeatureUnlocksDocument, options);
        }
export type GetMyFeatureUnlocksQueryHookResult = ReturnType<typeof useGetMyFeatureUnlocksQuery>;
export type GetMyFeatureUnlocksLazyQueryHookResult = ReturnType<typeof useGetMyFeatureUnlocksLazyQuery>;
export type GetMyFeatureUnlocksSuspenseQueryHookResult = ReturnType<typeof useGetMyFeatureUnlocksSuspenseQuery>;
export type GetMyFeatureUnlocksQueryResult = Apollo.QueryResult<GetMyFeatureUnlocksQuery, GetMyFeatureUnlocksQueryVariables>;
export const GetNotificationDocument = gql`
    query getNotification($id: ID!) {
  getAdminNotification(id: $id) {
    id
    attributes {
      title
      message
      type
      status
      dateSent
      action
      nextScheduledNotificationDetails {
        id
        sendAt
        endAt
        recur
        status
        priority
      }
      recur
      timezone
      createdAt
      updatedAt
      attachment {
        data {
          id
          attributes {
            url
          }
        }
      }
      recipients {
        data {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetNotificationQuery__
 *
 * To run a query within a React component, call `useGetNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNotificationQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationQuery, GetNotificationQueryVariables> & ({ variables: GetNotificationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationQuery, GetNotificationQueryVariables>(GetNotificationDocument, options);
      }
export function useGetNotificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationQuery, GetNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationQuery, GetNotificationQueryVariables>(GetNotificationDocument, options);
        }
// @ts-ignore
export function useGetNotificationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNotificationQuery, GetNotificationQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotificationQuery, GetNotificationQueryVariables>;
export function useGetNotificationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationQuery, GetNotificationQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotificationQuery | undefined, GetNotificationQueryVariables>;
export function useGetNotificationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationQuery, GetNotificationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNotificationQuery, GetNotificationQueryVariables>(GetNotificationDocument, options);
        }
export type GetNotificationQueryHookResult = ReturnType<typeof useGetNotificationQuery>;
export type GetNotificationLazyQueryHookResult = ReturnType<typeof useGetNotificationLazyQuery>;
export type GetNotificationSuspenseQueryHookResult = ReturnType<typeof useGetNotificationSuspenseQuery>;
export type GetNotificationQueryResult = Apollo.QueryResult<GetNotificationQuery, GetNotificationQueryVariables>;
export const GetNotificationRecipientsDocument = gql`
    query GetNotificationRecipients($id: ID!) {
  notification(id: $id) {
    data {
      id
      attributes {
        recipients {
          data {
            id
            attributes {
              username
              email
              phoneNumber
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetNotificationRecipientsQuery__
 *
 * To run a query within a React component, call `useGetNotificationRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationRecipientsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNotificationRecipientsQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationRecipientsQuery, GetNotificationRecipientsQueryVariables> & ({ variables: GetNotificationRecipientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationRecipientsQuery, GetNotificationRecipientsQueryVariables>(GetNotificationRecipientsDocument, options);
      }
export function useGetNotificationRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationRecipientsQuery, GetNotificationRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationRecipientsQuery, GetNotificationRecipientsQueryVariables>(GetNotificationRecipientsDocument, options);
        }
// @ts-ignore
export function useGetNotificationRecipientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNotificationRecipientsQuery, GetNotificationRecipientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotificationRecipientsQuery, GetNotificationRecipientsQueryVariables>;
export function useGetNotificationRecipientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationRecipientsQuery, GetNotificationRecipientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotificationRecipientsQuery | undefined, GetNotificationRecipientsQueryVariables>;
export function useGetNotificationRecipientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationRecipientsQuery, GetNotificationRecipientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNotificationRecipientsQuery, GetNotificationRecipientsQueryVariables>(GetNotificationRecipientsDocument, options);
        }
export type GetNotificationRecipientsQueryHookResult = ReturnType<typeof useGetNotificationRecipientsQuery>;
export type GetNotificationRecipientsLazyQueryHookResult = ReturnType<typeof useGetNotificationRecipientsLazyQuery>;
export type GetNotificationRecipientsSuspenseQueryHookResult = ReturnType<typeof useGetNotificationRecipientsSuspenseQuery>;
export type GetNotificationRecipientsQueryResult = Apollo.QueryResult<GetNotificationRecipientsQuery, GetNotificationRecipientsQueryVariables>;
export const GetNotificationsDocument = gql`
    query getNotifications($filters: JSON, $pagination: PaginationArg, $sort: [String]) {
  getAdminNotifications(filters: $filters, pagination: $pagination, sort: $sort) {
    id
    attributes {
      title
      message
      type
      status
      dateSent
      recur
      timezone
      createdAt
      updatedAt
      attachment {
        data {
          id
          attributes {
            url
          }
        }
      }
      nextScheduledNotificationDetails {
        id
        sendAt
        endAt
        recur
        status
        priority
      }
      recipients {
        data {
          id
          attributes {
            firstName
            lastName
            email
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
      }
export function useGetNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
// @ts-ignore
export function useGetNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export function useGetNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotificationsQuery | undefined, GetNotificationsQueryVariables>;
export function useGetNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsSuspenseQueryHookResult = ReturnType<typeof useGetNotificationsSuspenseQuery>;
export type GetNotificationsQueryResult = Apollo.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const GetNumberOfTasksPerDataCollectorDocument = gql`
    query getNumberOfTasksPerDataCollector($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  getNumberOfTasksPerDataCollector(
    sort: $sort
    filters: $filters
    pagination: $pagination
  ) {
    ...taskPer
  }
}
    ${TaskPerFragmentDoc}`;

/**
 * __useGetNumberOfTasksPerDataCollectorQuery__
 *
 * To run a query within a React component, call `useGetNumberOfTasksPerDataCollectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNumberOfTasksPerDataCollectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNumberOfTasksPerDataCollectorQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetNumberOfTasksPerDataCollectorQuery(baseOptions?: Apollo.QueryHookOptions<GetNumberOfTasksPerDataCollectorQuery, GetNumberOfTasksPerDataCollectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNumberOfTasksPerDataCollectorQuery, GetNumberOfTasksPerDataCollectorQueryVariables>(GetNumberOfTasksPerDataCollectorDocument, options);
      }
export function useGetNumberOfTasksPerDataCollectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNumberOfTasksPerDataCollectorQuery, GetNumberOfTasksPerDataCollectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNumberOfTasksPerDataCollectorQuery, GetNumberOfTasksPerDataCollectorQueryVariables>(GetNumberOfTasksPerDataCollectorDocument, options);
        }
// @ts-ignore
export function useGetNumberOfTasksPerDataCollectorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNumberOfTasksPerDataCollectorQuery, GetNumberOfTasksPerDataCollectorQueryVariables>): Apollo.UseSuspenseQueryResult<GetNumberOfTasksPerDataCollectorQuery, GetNumberOfTasksPerDataCollectorQueryVariables>;
export function useGetNumberOfTasksPerDataCollectorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNumberOfTasksPerDataCollectorQuery, GetNumberOfTasksPerDataCollectorQueryVariables>): Apollo.UseSuspenseQueryResult<GetNumberOfTasksPerDataCollectorQuery | undefined, GetNumberOfTasksPerDataCollectorQueryVariables>;
export function useGetNumberOfTasksPerDataCollectorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNumberOfTasksPerDataCollectorQuery, GetNumberOfTasksPerDataCollectorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNumberOfTasksPerDataCollectorQuery, GetNumberOfTasksPerDataCollectorQueryVariables>(GetNumberOfTasksPerDataCollectorDocument, options);
        }
export type GetNumberOfTasksPerDataCollectorQueryHookResult = ReturnType<typeof useGetNumberOfTasksPerDataCollectorQuery>;
export type GetNumberOfTasksPerDataCollectorLazyQueryHookResult = ReturnType<typeof useGetNumberOfTasksPerDataCollectorLazyQuery>;
export type GetNumberOfTasksPerDataCollectorSuspenseQueryHookResult = ReturnType<typeof useGetNumberOfTasksPerDataCollectorSuspenseQuery>;
export type GetNumberOfTasksPerDataCollectorQueryResult = Apollo.QueryResult<GetNumberOfTasksPerDataCollectorQuery, GetNumberOfTasksPerDataCollectorQueryVariables>;
export const GetNumberOfTasksPerDayDocument = gql`
    query getNumberOfTasksPerDay($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  getNumberOfTasksPerDay(sort: $sort, filters: $filters, pagination: $pagination) {
    ...taskPer
  }
}
    ${TaskPerFragmentDoc}`;

/**
 * __useGetNumberOfTasksPerDayQuery__
 *
 * To run a query within a React component, call `useGetNumberOfTasksPerDayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNumberOfTasksPerDayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNumberOfTasksPerDayQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetNumberOfTasksPerDayQuery(baseOptions?: Apollo.QueryHookOptions<GetNumberOfTasksPerDayQuery, GetNumberOfTasksPerDayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNumberOfTasksPerDayQuery, GetNumberOfTasksPerDayQueryVariables>(GetNumberOfTasksPerDayDocument, options);
      }
export function useGetNumberOfTasksPerDayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNumberOfTasksPerDayQuery, GetNumberOfTasksPerDayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNumberOfTasksPerDayQuery, GetNumberOfTasksPerDayQueryVariables>(GetNumberOfTasksPerDayDocument, options);
        }
// @ts-ignore
export function useGetNumberOfTasksPerDaySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNumberOfTasksPerDayQuery, GetNumberOfTasksPerDayQueryVariables>): Apollo.UseSuspenseQueryResult<GetNumberOfTasksPerDayQuery, GetNumberOfTasksPerDayQueryVariables>;
export function useGetNumberOfTasksPerDaySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNumberOfTasksPerDayQuery, GetNumberOfTasksPerDayQueryVariables>): Apollo.UseSuspenseQueryResult<GetNumberOfTasksPerDayQuery | undefined, GetNumberOfTasksPerDayQueryVariables>;
export function useGetNumberOfTasksPerDaySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNumberOfTasksPerDayQuery, GetNumberOfTasksPerDayQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNumberOfTasksPerDayQuery, GetNumberOfTasksPerDayQueryVariables>(GetNumberOfTasksPerDayDocument, options);
        }
export type GetNumberOfTasksPerDayQueryHookResult = ReturnType<typeof useGetNumberOfTasksPerDayQuery>;
export type GetNumberOfTasksPerDayLazyQueryHookResult = ReturnType<typeof useGetNumberOfTasksPerDayLazyQuery>;
export type GetNumberOfTasksPerDaySuspenseQueryHookResult = ReturnType<typeof useGetNumberOfTasksPerDaySuspenseQuery>;
export type GetNumberOfTasksPerDayQueryResult = Apollo.QueryResult<GetNumberOfTasksPerDayQuery, GetNumberOfTasksPerDayQueryVariables>;
export const GetNumberOfTasksPerMonthDocument = gql`
    query getNumberOfTasksPerMonth($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  getNumberOfTasksPerMonth(
    sort: $sort
    filters: $filters
    pagination: $pagination
  ) {
    ...taskPer
  }
}
    ${TaskPerFragmentDoc}`;

/**
 * __useGetNumberOfTasksPerMonthQuery__
 *
 * To run a query within a React component, call `useGetNumberOfTasksPerMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNumberOfTasksPerMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNumberOfTasksPerMonthQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetNumberOfTasksPerMonthQuery(baseOptions?: Apollo.QueryHookOptions<GetNumberOfTasksPerMonthQuery, GetNumberOfTasksPerMonthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNumberOfTasksPerMonthQuery, GetNumberOfTasksPerMonthQueryVariables>(GetNumberOfTasksPerMonthDocument, options);
      }
export function useGetNumberOfTasksPerMonthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNumberOfTasksPerMonthQuery, GetNumberOfTasksPerMonthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNumberOfTasksPerMonthQuery, GetNumberOfTasksPerMonthQueryVariables>(GetNumberOfTasksPerMonthDocument, options);
        }
// @ts-ignore
export function useGetNumberOfTasksPerMonthSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNumberOfTasksPerMonthQuery, GetNumberOfTasksPerMonthQueryVariables>): Apollo.UseSuspenseQueryResult<GetNumberOfTasksPerMonthQuery, GetNumberOfTasksPerMonthQueryVariables>;
export function useGetNumberOfTasksPerMonthSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNumberOfTasksPerMonthQuery, GetNumberOfTasksPerMonthQueryVariables>): Apollo.UseSuspenseQueryResult<GetNumberOfTasksPerMonthQuery | undefined, GetNumberOfTasksPerMonthQueryVariables>;
export function useGetNumberOfTasksPerMonthSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNumberOfTasksPerMonthQuery, GetNumberOfTasksPerMonthQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNumberOfTasksPerMonthQuery, GetNumberOfTasksPerMonthQueryVariables>(GetNumberOfTasksPerMonthDocument, options);
        }
export type GetNumberOfTasksPerMonthQueryHookResult = ReturnType<typeof useGetNumberOfTasksPerMonthQuery>;
export type GetNumberOfTasksPerMonthLazyQueryHookResult = ReturnType<typeof useGetNumberOfTasksPerMonthLazyQuery>;
export type GetNumberOfTasksPerMonthSuspenseQueryHookResult = ReturnType<typeof useGetNumberOfTasksPerMonthSuspenseQuery>;
export type GetNumberOfTasksPerMonthQueryResult = Apollo.QueryResult<GetNumberOfTasksPerMonthQuery, GetNumberOfTasksPerMonthQueryVariables>;
export const GetNumberOfTasksPerProjectDocument = gql`
    query getNumberOfTasksPerProject($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  getNumberOfTasksPerProject(
    sort: $sort
    filters: $filters
    pagination: $pagination
  ) {
    ...taskPer
  }
}
    ${TaskPerFragmentDoc}`;

/**
 * __useGetNumberOfTasksPerProjectQuery__
 *
 * To run a query within a React component, call `useGetNumberOfTasksPerProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNumberOfTasksPerProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNumberOfTasksPerProjectQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetNumberOfTasksPerProjectQuery(baseOptions?: Apollo.QueryHookOptions<GetNumberOfTasksPerProjectQuery, GetNumberOfTasksPerProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNumberOfTasksPerProjectQuery, GetNumberOfTasksPerProjectQueryVariables>(GetNumberOfTasksPerProjectDocument, options);
      }
export function useGetNumberOfTasksPerProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNumberOfTasksPerProjectQuery, GetNumberOfTasksPerProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNumberOfTasksPerProjectQuery, GetNumberOfTasksPerProjectQueryVariables>(GetNumberOfTasksPerProjectDocument, options);
        }
// @ts-ignore
export function useGetNumberOfTasksPerProjectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNumberOfTasksPerProjectQuery, GetNumberOfTasksPerProjectQueryVariables>): Apollo.UseSuspenseQueryResult<GetNumberOfTasksPerProjectQuery, GetNumberOfTasksPerProjectQueryVariables>;
export function useGetNumberOfTasksPerProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNumberOfTasksPerProjectQuery, GetNumberOfTasksPerProjectQueryVariables>): Apollo.UseSuspenseQueryResult<GetNumberOfTasksPerProjectQuery | undefined, GetNumberOfTasksPerProjectQueryVariables>;
export function useGetNumberOfTasksPerProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNumberOfTasksPerProjectQuery, GetNumberOfTasksPerProjectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNumberOfTasksPerProjectQuery, GetNumberOfTasksPerProjectQueryVariables>(GetNumberOfTasksPerProjectDocument, options);
        }
export type GetNumberOfTasksPerProjectQueryHookResult = ReturnType<typeof useGetNumberOfTasksPerProjectQuery>;
export type GetNumberOfTasksPerProjectLazyQueryHookResult = ReturnType<typeof useGetNumberOfTasksPerProjectLazyQuery>;
export type GetNumberOfTasksPerProjectSuspenseQueryHookResult = ReturnType<typeof useGetNumberOfTasksPerProjectSuspenseQuery>;
export type GetNumberOfTasksPerProjectQueryResult = Apollo.QueryResult<GetNumberOfTasksPerProjectQuery, GetNumberOfTasksPerProjectQueryVariables>;
export const GetNumberOfTasksPerSdgDocument = gql`
    query getNumberOfTasksPerSDG($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  getNumberOfTasksPerSDG(sort: $sort, filters: $filters, pagination: $pagination) {
    ...taskPer
  }
}
    ${TaskPerFragmentDoc}`;

/**
 * __useGetNumberOfTasksPerSdgQuery__
 *
 * To run a query within a React component, call `useGetNumberOfTasksPerSdgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNumberOfTasksPerSdgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNumberOfTasksPerSdgQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetNumberOfTasksPerSdgQuery(baseOptions?: Apollo.QueryHookOptions<GetNumberOfTasksPerSdgQuery, GetNumberOfTasksPerSdgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNumberOfTasksPerSdgQuery, GetNumberOfTasksPerSdgQueryVariables>(GetNumberOfTasksPerSdgDocument, options);
      }
export function useGetNumberOfTasksPerSdgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNumberOfTasksPerSdgQuery, GetNumberOfTasksPerSdgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNumberOfTasksPerSdgQuery, GetNumberOfTasksPerSdgQueryVariables>(GetNumberOfTasksPerSdgDocument, options);
        }
// @ts-ignore
export function useGetNumberOfTasksPerSdgSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNumberOfTasksPerSdgQuery, GetNumberOfTasksPerSdgQueryVariables>): Apollo.UseSuspenseQueryResult<GetNumberOfTasksPerSdgQuery, GetNumberOfTasksPerSdgQueryVariables>;
export function useGetNumberOfTasksPerSdgSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNumberOfTasksPerSdgQuery, GetNumberOfTasksPerSdgQueryVariables>): Apollo.UseSuspenseQueryResult<GetNumberOfTasksPerSdgQuery | undefined, GetNumberOfTasksPerSdgQueryVariables>;
export function useGetNumberOfTasksPerSdgSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNumberOfTasksPerSdgQuery, GetNumberOfTasksPerSdgQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNumberOfTasksPerSdgQuery, GetNumberOfTasksPerSdgQueryVariables>(GetNumberOfTasksPerSdgDocument, options);
        }
export type GetNumberOfTasksPerSdgQueryHookResult = ReturnType<typeof useGetNumberOfTasksPerSdgQuery>;
export type GetNumberOfTasksPerSdgLazyQueryHookResult = ReturnType<typeof useGetNumberOfTasksPerSdgLazyQuery>;
export type GetNumberOfTasksPerSdgSuspenseQueryHookResult = ReturnType<typeof useGetNumberOfTasksPerSdgSuspenseQuery>;
export type GetNumberOfTasksPerSdgQueryResult = Apollo.QueryResult<GetNumberOfTasksPerSdgQuery, GetNumberOfTasksPerSdgQueryVariables>;
export const GetNumberOfTasksPerTagDocument = gql`
    query getNumberOfTasksPerTag($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  getNumberOfTasksPerTag(sort: $sort, filters: $filters, pagination: $pagination) {
    ...taskPer
  }
}
    ${TaskPerFragmentDoc}`;

/**
 * __useGetNumberOfTasksPerTagQuery__
 *
 * To run a query within a React component, call `useGetNumberOfTasksPerTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNumberOfTasksPerTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNumberOfTasksPerTagQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetNumberOfTasksPerTagQuery(baseOptions?: Apollo.QueryHookOptions<GetNumberOfTasksPerTagQuery, GetNumberOfTasksPerTagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNumberOfTasksPerTagQuery, GetNumberOfTasksPerTagQueryVariables>(GetNumberOfTasksPerTagDocument, options);
      }
export function useGetNumberOfTasksPerTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNumberOfTasksPerTagQuery, GetNumberOfTasksPerTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNumberOfTasksPerTagQuery, GetNumberOfTasksPerTagQueryVariables>(GetNumberOfTasksPerTagDocument, options);
        }
// @ts-ignore
export function useGetNumberOfTasksPerTagSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNumberOfTasksPerTagQuery, GetNumberOfTasksPerTagQueryVariables>): Apollo.UseSuspenseQueryResult<GetNumberOfTasksPerTagQuery, GetNumberOfTasksPerTagQueryVariables>;
export function useGetNumberOfTasksPerTagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNumberOfTasksPerTagQuery, GetNumberOfTasksPerTagQueryVariables>): Apollo.UseSuspenseQueryResult<GetNumberOfTasksPerTagQuery | undefined, GetNumberOfTasksPerTagQueryVariables>;
export function useGetNumberOfTasksPerTagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNumberOfTasksPerTagQuery, GetNumberOfTasksPerTagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNumberOfTasksPerTagQuery, GetNumberOfTasksPerTagQueryVariables>(GetNumberOfTasksPerTagDocument, options);
        }
export type GetNumberOfTasksPerTagQueryHookResult = ReturnType<typeof useGetNumberOfTasksPerTagQuery>;
export type GetNumberOfTasksPerTagLazyQueryHookResult = ReturnType<typeof useGetNumberOfTasksPerTagLazyQuery>;
export type GetNumberOfTasksPerTagSuspenseQueryHookResult = ReturnType<typeof useGetNumberOfTasksPerTagSuspenseQuery>;
export type GetNumberOfTasksPerTagQueryResult = Apollo.QueryResult<GetNumberOfTasksPerTagQuery, GetNumberOfTasksPerTagQueryVariables>;
export const GetNumberOfTasksPerTaskTypeDocument = gql`
    query getNumberOfTasksPerTaskType($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  getNumberOfTasksPerTaskType(
    sort: $sort
    filters: $filters
    pagination: $pagination
  ) {
    ...taskPer
  }
}
    ${TaskPerFragmentDoc}`;

/**
 * __useGetNumberOfTasksPerTaskTypeQuery__
 *
 * To run a query within a React component, call `useGetNumberOfTasksPerTaskTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNumberOfTasksPerTaskTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNumberOfTasksPerTaskTypeQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetNumberOfTasksPerTaskTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetNumberOfTasksPerTaskTypeQuery, GetNumberOfTasksPerTaskTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNumberOfTasksPerTaskTypeQuery, GetNumberOfTasksPerTaskTypeQueryVariables>(GetNumberOfTasksPerTaskTypeDocument, options);
      }
export function useGetNumberOfTasksPerTaskTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNumberOfTasksPerTaskTypeQuery, GetNumberOfTasksPerTaskTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNumberOfTasksPerTaskTypeQuery, GetNumberOfTasksPerTaskTypeQueryVariables>(GetNumberOfTasksPerTaskTypeDocument, options);
        }
// @ts-ignore
export function useGetNumberOfTasksPerTaskTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNumberOfTasksPerTaskTypeQuery, GetNumberOfTasksPerTaskTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetNumberOfTasksPerTaskTypeQuery, GetNumberOfTasksPerTaskTypeQueryVariables>;
export function useGetNumberOfTasksPerTaskTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNumberOfTasksPerTaskTypeQuery, GetNumberOfTasksPerTaskTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetNumberOfTasksPerTaskTypeQuery | undefined, GetNumberOfTasksPerTaskTypeQueryVariables>;
export function useGetNumberOfTasksPerTaskTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNumberOfTasksPerTaskTypeQuery, GetNumberOfTasksPerTaskTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNumberOfTasksPerTaskTypeQuery, GetNumberOfTasksPerTaskTypeQueryVariables>(GetNumberOfTasksPerTaskTypeDocument, options);
        }
export type GetNumberOfTasksPerTaskTypeQueryHookResult = ReturnType<typeof useGetNumberOfTasksPerTaskTypeQuery>;
export type GetNumberOfTasksPerTaskTypeLazyQueryHookResult = ReturnType<typeof useGetNumberOfTasksPerTaskTypeLazyQuery>;
export type GetNumberOfTasksPerTaskTypeSuspenseQueryHookResult = ReturnType<typeof useGetNumberOfTasksPerTaskTypeSuspenseQuery>;
export type GetNumberOfTasksPerTaskTypeQueryResult = Apollo.QueryResult<GetNumberOfTasksPerTaskTypeQuery, GetNumberOfTasksPerTaskTypeQueryVariables>;
export const GetNumberOfTasksPerTaskTypeCollapsedDocument = gql`
    query getNumberOfTasksPerTaskTypeCollapsed($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  getNumberOfTasksPerTaskTypeCollapsed(
    sort: $sort
    filters: $filters
    pagination: $pagination
  ) {
    ...taskPer
  }
}
    ${TaskPerFragmentDoc}`;

/**
 * __useGetNumberOfTasksPerTaskTypeCollapsedQuery__
 *
 * To run a query within a React component, call `useGetNumberOfTasksPerTaskTypeCollapsedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNumberOfTasksPerTaskTypeCollapsedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNumberOfTasksPerTaskTypeCollapsedQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetNumberOfTasksPerTaskTypeCollapsedQuery(baseOptions?: Apollo.QueryHookOptions<GetNumberOfTasksPerTaskTypeCollapsedQuery, GetNumberOfTasksPerTaskTypeCollapsedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNumberOfTasksPerTaskTypeCollapsedQuery, GetNumberOfTasksPerTaskTypeCollapsedQueryVariables>(GetNumberOfTasksPerTaskTypeCollapsedDocument, options);
      }
export function useGetNumberOfTasksPerTaskTypeCollapsedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNumberOfTasksPerTaskTypeCollapsedQuery, GetNumberOfTasksPerTaskTypeCollapsedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNumberOfTasksPerTaskTypeCollapsedQuery, GetNumberOfTasksPerTaskTypeCollapsedQueryVariables>(GetNumberOfTasksPerTaskTypeCollapsedDocument, options);
        }
// @ts-ignore
export function useGetNumberOfTasksPerTaskTypeCollapsedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNumberOfTasksPerTaskTypeCollapsedQuery, GetNumberOfTasksPerTaskTypeCollapsedQueryVariables>): Apollo.UseSuspenseQueryResult<GetNumberOfTasksPerTaskTypeCollapsedQuery, GetNumberOfTasksPerTaskTypeCollapsedQueryVariables>;
export function useGetNumberOfTasksPerTaskTypeCollapsedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNumberOfTasksPerTaskTypeCollapsedQuery, GetNumberOfTasksPerTaskTypeCollapsedQueryVariables>): Apollo.UseSuspenseQueryResult<GetNumberOfTasksPerTaskTypeCollapsedQuery | undefined, GetNumberOfTasksPerTaskTypeCollapsedQueryVariables>;
export function useGetNumberOfTasksPerTaskTypeCollapsedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNumberOfTasksPerTaskTypeCollapsedQuery, GetNumberOfTasksPerTaskTypeCollapsedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNumberOfTasksPerTaskTypeCollapsedQuery, GetNumberOfTasksPerTaskTypeCollapsedQueryVariables>(GetNumberOfTasksPerTaskTypeCollapsedDocument, options);
        }
export type GetNumberOfTasksPerTaskTypeCollapsedQueryHookResult = ReturnType<typeof useGetNumberOfTasksPerTaskTypeCollapsedQuery>;
export type GetNumberOfTasksPerTaskTypeCollapsedLazyQueryHookResult = ReturnType<typeof useGetNumberOfTasksPerTaskTypeCollapsedLazyQuery>;
export type GetNumberOfTasksPerTaskTypeCollapsedSuspenseQueryHookResult = ReturnType<typeof useGetNumberOfTasksPerTaskTypeCollapsedSuspenseQuery>;
export type GetNumberOfTasksPerTaskTypeCollapsedQueryResult = Apollo.QueryResult<GetNumberOfTasksPerTaskTypeCollapsedQuery, GetNumberOfTasksPerTaskTypeCollapsedQueryVariables>;
export const GetNumberOfUsersDocument = gql`
    query getNumberOfUsers {
  getNumberOfUsers {
    dataCollectors
    admins
  }
}
    `;

/**
 * __useGetNumberOfUsersQuery__
 *
 * To run a query within a React component, call `useGetNumberOfUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNumberOfUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNumberOfUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNumberOfUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetNumberOfUsersQuery, GetNumberOfUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNumberOfUsersQuery, GetNumberOfUsersQueryVariables>(GetNumberOfUsersDocument, options);
      }
export function useGetNumberOfUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNumberOfUsersQuery, GetNumberOfUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNumberOfUsersQuery, GetNumberOfUsersQueryVariables>(GetNumberOfUsersDocument, options);
        }
// @ts-ignore
export function useGetNumberOfUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNumberOfUsersQuery, GetNumberOfUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetNumberOfUsersQuery, GetNumberOfUsersQueryVariables>;
export function useGetNumberOfUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNumberOfUsersQuery, GetNumberOfUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetNumberOfUsersQuery | undefined, GetNumberOfUsersQueryVariables>;
export function useGetNumberOfUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNumberOfUsersQuery, GetNumberOfUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNumberOfUsersQuery, GetNumberOfUsersQueryVariables>(GetNumberOfUsersDocument, options);
        }
export type GetNumberOfUsersQueryHookResult = ReturnType<typeof useGetNumberOfUsersQuery>;
export type GetNumberOfUsersLazyQueryHookResult = ReturnType<typeof useGetNumberOfUsersLazyQuery>;
export type GetNumberOfUsersSuspenseQueryHookResult = ReturnType<typeof useGetNumberOfUsersSuspenseQuery>;
export type GetNumberOfUsersQueryResult = Apollo.QueryResult<GetNumberOfUsersQuery, GetNumberOfUsersQueryVariables>;
export const GetProjectDocument = gql`
    query getProject {
  getBaoleaderProject {
    id
    attributes {
      ...project
      featured_image {
        data {
          ...uploadFile
        }
      }
    }
  }
}
    ${ProjectFragmentDoc}
${UploadFileFragmentDoc}`;

/**
 * __useGetProjectQuery__
 *
 * To run a query within a React component, call `useGetProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProjectQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
      }
export function useGetProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
        }
// @ts-ignore
export function useGetProjectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectQuery, GetProjectQueryVariables>;
export function useGetProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectQuery | undefined, GetProjectQueryVariables>;
export function useGetProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
        }
export type GetProjectQueryHookResult = ReturnType<typeof useGetProjectQuery>;
export type GetProjectLazyQueryHookResult = ReturnType<typeof useGetProjectLazyQuery>;
export type GetProjectSuspenseQueryHookResult = ReturnType<typeof useGetProjectSuspenseQuery>;
export type GetProjectQueryResult = Apollo.QueryResult<GetProjectQuery, GetProjectQueryVariables>;
export const GetProjectDataCollectorsCountDocument = gql`
    query getProjectDataCollectorsCount($projectId: ID!) {
  getProjectDataCollectorsCount(project: $projectId)
}
    `;

/**
 * __useGetProjectDataCollectorsCountQuery__
 *
 * To run a query within a React component, call `useGetProjectDataCollectorsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectDataCollectorsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectDataCollectorsCountQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectDataCollectorsCountQuery(baseOptions: Apollo.QueryHookOptions<GetProjectDataCollectorsCountQuery, GetProjectDataCollectorsCountQueryVariables> & ({ variables: GetProjectDataCollectorsCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectDataCollectorsCountQuery, GetProjectDataCollectorsCountQueryVariables>(GetProjectDataCollectorsCountDocument, options);
      }
export function useGetProjectDataCollectorsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectDataCollectorsCountQuery, GetProjectDataCollectorsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectDataCollectorsCountQuery, GetProjectDataCollectorsCountQueryVariables>(GetProjectDataCollectorsCountDocument, options);
        }
// @ts-ignore
export function useGetProjectDataCollectorsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectDataCollectorsCountQuery, GetProjectDataCollectorsCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectDataCollectorsCountQuery, GetProjectDataCollectorsCountQueryVariables>;
export function useGetProjectDataCollectorsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectDataCollectorsCountQuery, GetProjectDataCollectorsCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectDataCollectorsCountQuery | undefined, GetProjectDataCollectorsCountQueryVariables>;
export function useGetProjectDataCollectorsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectDataCollectorsCountQuery, GetProjectDataCollectorsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectDataCollectorsCountQuery, GetProjectDataCollectorsCountQueryVariables>(GetProjectDataCollectorsCountDocument, options);
        }
export type GetProjectDataCollectorsCountQueryHookResult = ReturnType<typeof useGetProjectDataCollectorsCountQuery>;
export type GetProjectDataCollectorsCountLazyQueryHookResult = ReturnType<typeof useGetProjectDataCollectorsCountLazyQuery>;
export type GetProjectDataCollectorsCountSuspenseQueryHookResult = ReturnType<typeof useGetProjectDataCollectorsCountSuspenseQuery>;
export type GetProjectDataCollectorsCountQueryResult = Apollo.QueryResult<GetProjectDataCollectorsCountQuery, GetProjectDataCollectorsCountQueryVariables>;
export const GetProjectGroupsDocument = gql`
    query getProjectGroups($projectId: ID!) {
  getProjectGroups(projectId: $projectId) {
    id
    attributes {
      name
    }
  }
}
    `;

/**
 * __useGetProjectGroupsQuery__
 *
 * To run a query within a React component, call `useGetProjectGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectGroupsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetProjectGroupsQuery, GetProjectGroupsQueryVariables> & ({ variables: GetProjectGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectGroupsQuery, GetProjectGroupsQueryVariables>(GetProjectGroupsDocument, options);
      }
export function useGetProjectGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectGroupsQuery, GetProjectGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectGroupsQuery, GetProjectGroupsQueryVariables>(GetProjectGroupsDocument, options);
        }
// @ts-ignore
export function useGetProjectGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectGroupsQuery, GetProjectGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectGroupsQuery, GetProjectGroupsQueryVariables>;
export function useGetProjectGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectGroupsQuery, GetProjectGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectGroupsQuery | undefined, GetProjectGroupsQueryVariables>;
export function useGetProjectGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectGroupsQuery, GetProjectGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectGroupsQuery, GetProjectGroupsQueryVariables>(GetProjectGroupsDocument, options);
        }
export type GetProjectGroupsQueryHookResult = ReturnType<typeof useGetProjectGroupsQuery>;
export type GetProjectGroupsLazyQueryHookResult = ReturnType<typeof useGetProjectGroupsLazyQuery>;
export type GetProjectGroupsSuspenseQueryHookResult = ReturnType<typeof useGetProjectGroupsSuspenseQuery>;
export type GetProjectGroupsQueryResult = Apollo.QueryResult<GetProjectGroupsQuery, GetProjectGroupsQueryVariables>;
export const GetProjectMetricsDocument = gql`
    query getProjectMetrics($id: ID!) {
  getProjectMetrics(id: $id) {
    completedTasks {
      total
      last30Days
      chartData {
        key
        value
      }
    }
    reportedTask {
      total
      last30Days
      chartData {
        key
        value
      }
    }
    averageCompletionTime {
      total
      wow
      dod
    }
    averageEvidenceTime {
      total
      wow
      dod
    }
  }
}
    `;

/**
 * __useGetProjectMetricsQuery__
 *
 * To run a query within a React component, call `useGetProjectMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectMetricsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetProjectMetricsQuery, GetProjectMetricsQueryVariables> & ({ variables: GetProjectMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectMetricsQuery, GetProjectMetricsQueryVariables>(GetProjectMetricsDocument, options);
      }
export function useGetProjectMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectMetricsQuery, GetProjectMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectMetricsQuery, GetProjectMetricsQueryVariables>(GetProjectMetricsDocument, options);
        }
// @ts-ignore
export function useGetProjectMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectMetricsQuery, GetProjectMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectMetricsQuery, GetProjectMetricsQueryVariables>;
export function useGetProjectMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectMetricsQuery, GetProjectMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectMetricsQuery | undefined, GetProjectMetricsQueryVariables>;
export function useGetProjectMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectMetricsQuery, GetProjectMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectMetricsQuery, GetProjectMetricsQueryVariables>(GetProjectMetricsDocument, options);
        }
export type GetProjectMetricsQueryHookResult = ReturnType<typeof useGetProjectMetricsQuery>;
export type GetProjectMetricsLazyQueryHookResult = ReturnType<typeof useGetProjectMetricsLazyQuery>;
export type GetProjectMetricsSuspenseQueryHookResult = ReturnType<typeof useGetProjectMetricsSuspenseQuery>;
export type GetProjectMetricsQueryResult = Apollo.QueryResult<GetProjectMetricsQuery, GetProjectMetricsQueryVariables>;
export const GetProjectTaskTypesDocument = gql`
    query getProjectTaskTypes($sort: [String], $filters: TaskTypeFiltersInput, $pagination: PaginationArg) {
  taskTypes(
    sort: $sort
    filters: $filters
    publicationState: LIVE
    pagination: $pagination
  ) {
    data {
      id
      attributes {
        title
      }
    }
  }
}
    `;

/**
 * __useGetProjectTaskTypesQuery__
 *
 * To run a query within a React component, call `useGetProjectTaskTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectTaskTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectTaskTypesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetProjectTaskTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectTaskTypesQuery, GetProjectTaskTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectTaskTypesQuery, GetProjectTaskTypesQueryVariables>(GetProjectTaskTypesDocument, options);
      }
export function useGetProjectTaskTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectTaskTypesQuery, GetProjectTaskTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectTaskTypesQuery, GetProjectTaskTypesQueryVariables>(GetProjectTaskTypesDocument, options);
        }
// @ts-ignore
export function useGetProjectTaskTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectTaskTypesQuery, GetProjectTaskTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectTaskTypesQuery, GetProjectTaskTypesQueryVariables>;
export function useGetProjectTaskTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectTaskTypesQuery, GetProjectTaskTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectTaskTypesQuery | undefined, GetProjectTaskTypesQueryVariables>;
export function useGetProjectTaskTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectTaskTypesQuery, GetProjectTaskTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectTaskTypesQuery, GetProjectTaskTypesQueryVariables>(GetProjectTaskTypesDocument, options);
        }
export type GetProjectTaskTypesQueryHookResult = ReturnType<typeof useGetProjectTaskTypesQuery>;
export type GetProjectTaskTypesLazyQueryHookResult = ReturnType<typeof useGetProjectTaskTypesLazyQuery>;
export type GetProjectTaskTypesSuspenseQueryHookResult = ReturnType<typeof useGetProjectTaskTypesSuspenseQuery>;
export type GetProjectTaskTypesQueryResult = Apollo.QueryResult<GetProjectTaskTypesQuery, GetProjectTaskTypesQueryVariables>;
export const GetProjectUnsdgTagsDocument = gql`
    query getProjectUnsdgTags($project: ID!) {
  getProjectUnsdgTags(project: $project)
}
    `;

/**
 * __useGetProjectUnsdgTagsQuery__
 *
 * To run a query within a React component, call `useGetProjectUnsdgTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectUnsdgTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectUnsdgTagsQuery({
 *   variables: {
 *      project: // value for 'project'
 *   },
 * });
 */
export function useGetProjectUnsdgTagsQuery(baseOptions: Apollo.QueryHookOptions<GetProjectUnsdgTagsQuery, GetProjectUnsdgTagsQueryVariables> & ({ variables: GetProjectUnsdgTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectUnsdgTagsQuery, GetProjectUnsdgTagsQueryVariables>(GetProjectUnsdgTagsDocument, options);
      }
export function useGetProjectUnsdgTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectUnsdgTagsQuery, GetProjectUnsdgTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectUnsdgTagsQuery, GetProjectUnsdgTagsQueryVariables>(GetProjectUnsdgTagsDocument, options);
        }
// @ts-ignore
export function useGetProjectUnsdgTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectUnsdgTagsQuery, GetProjectUnsdgTagsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectUnsdgTagsQuery, GetProjectUnsdgTagsQueryVariables>;
export function useGetProjectUnsdgTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectUnsdgTagsQuery, GetProjectUnsdgTagsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectUnsdgTagsQuery | undefined, GetProjectUnsdgTagsQueryVariables>;
export function useGetProjectUnsdgTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectUnsdgTagsQuery, GetProjectUnsdgTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectUnsdgTagsQuery, GetProjectUnsdgTagsQueryVariables>(GetProjectUnsdgTagsDocument, options);
        }
export type GetProjectUnsdgTagsQueryHookResult = ReturnType<typeof useGetProjectUnsdgTagsQuery>;
export type GetProjectUnsdgTagsLazyQueryHookResult = ReturnType<typeof useGetProjectUnsdgTagsLazyQuery>;
export type GetProjectUnsdgTagsSuspenseQueryHookResult = ReturnType<typeof useGetProjectUnsdgTagsSuspenseQuery>;
export type GetProjectUnsdgTagsQueryResult = Apollo.QueryResult<GetProjectUnsdgTagsQuery, GetProjectUnsdgTagsQueryVariables>;
export const GetProjectsDocument = gql`
    query getProjects($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  getBaoleaderProjects(
    sort: $sort
    filters: $filters
    publicationState: LIVE
    pagination: $pagination
  ) {
    id
    attributes {
      ...project
      featured_image {
        data {
          ...uploadFile
        }
      }
    }
  }
}
    ${ProjectFragmentDoc}
${UploadFileFragmentDoc}`;

/**
 * __useGetProjectsQuery__
 *
 * To run a query within a React component, call `useGetProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetProjectsQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectsQuery, GetProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectsQuery, GetProjectsQueryVariables>(GetProjectsDocument, options);
      }
export function useGetProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectsQuery, GetProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectsQuery, GetProjectsQueryVariables>(GetProjectsDocument, options);
        }
// @ts-ignore
export function useGetProjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectsQuery, GetProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectsQuery, GetProjectsQueryVariables>;
export function useGetProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectsQuery, GetProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectsQuery | undefined, GetProjectsQueryVariables>;
export function useGetProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectsQuery, GetProjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectsQuery, GetProjectsQueryVariables>(GetProjectsDocument, options);
        }
export type GetProjectsQueryHookResult = ReturnType<typeof useGetProjectsQuery>;
export type GetProjectsLazyQueryHookResult = ReturnType<typeof useGetProjectsLazyQuery>;
export type GetProjectsSuspenseQueryHookResult = ReturnType<typeof useGetProjectsSuspenseQuery>;
export type GetProjectsQueryResult = Apollo.QueryResult<GetProjectsQuery, GetProjectsQueryVariables>;
export const GetSingleBaoriderDocument = gql`
    query getSingleBaorider($id: ID!) {
  getSingleBaorider(id: $id) {
    baorider {
      id
      attributes {
        idNumber
        phoneNumber
        email
        profilePicture {
          data {
            ...uploadFile
          }
        }
        firstName
        lastName
        isVerifier
        community {
          data {
            id
            attributes {
              ...community
            }
          }
        }
        projects {
          data {
            id
            attributes {
              ...project
              featured_image {
                data {
                  ...uploadFile
                }
              }
            }
          }
        }
        status
        createdAt
        updatedAt
        gender
        dateOfBirth
      }
    }
  }
}
    ${UploadFileFragmentDoc}
${CommunityFragmentDoc}
${ProjectFragmentDoc}`;

/**
 * __useGetSingleBaoriderQuery__
 *
 * To run a query within a React component, call `useGetSingleBaoriderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleBaoriderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleBaoriderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSingleBaoriderQuery(baseOptions: Apollo.QueryHookOptions<GetSingleBaoriderQuery, GetSingleBaoriderQueryVariables> & ({ variables: GetSingleBaoriderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleBaoriderQuery, GetSingleBaoriderQueryVariables>(GetSingleBaoriderDocument, options);
      }
export function useGetSingleBaoriderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleBaoriderQuery, GetSingleBaoriderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleBaoriderQuery, GetSingleBaoriderQueryVariables>(GetSingleBaoriderDocument, options);
        }
// @ts-ignore
export function useGetSingleBaoriderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSingleBaoriderQuery, GetSingleBaoriderQueryVariables>): Apollo.UseSuspenseQueryResult<GetSingleBaoriderQuery, GetSingleBaoriderQueryVariables>;
export function useGetSingleBaoriderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleBaoriderQuery, GetSingleBaoriderQueryVariables>): Apollo.UseSuspenseQueryResult<GetSingleBaoriderQuery | undefined, GetSingleBaoriderQueryVariables>;
export function useGetSingleBaoriderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleBaoriderQuery, GetSingleBaoriderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSingleBaoriderQuery, GetSingleBaoriderQueryVariables>(GetSingleBaoriderDocument, options);
        }
export type GetSingleBaoriderQueryHookResult = ReturnType<typeof useGetSingleBaoriderQuery>;
export type GetSingleBaoriderLazyQueryHookResult = ReturnType<typeof useGetSingleBaoriderLazyQuery>;
export type GetSingleBaoriderSuspenseQueryHookResult = ReturnType<typeof useGetSingleBaoriderSuspenseQuery>;
export type GetSingleBaoriderQueryResult = Apollo.QueryResult<GetSingleBaoriderQuery, GetSingleBaoriderQueryVariables>;
export const GetSingleBaoleaderCommunityDocument = gql`
    query getSingleBaoleaderCommunity($id: ID!) {
  getSingleBaoleaderCommunity(id: $id) {
    id
    attributes {
      ...community
      featured_image {
        data {
          ...uploadFile
        }
      }
    }
  }
}
    ${CommunityFragmentDoc}
${UploadFileFragmentDoc}`;

/**
 * __useGetSingleBaoleaderCommunityQuery__
 *
 * To run a query within a React component, call `useGetSingleBaoleaderCommunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleBaoleaderCommunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleBaoleaderCommunityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSingleBaoleaderCommunityQuery(baseOptions: Apollo.QueryHookOptions<GetSingleBaoleaderCommunityQuery, GetSingleBaoleaderCommunityQueryVariables> & ({ variables: GetSingleBaoleaderCommunityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleBaoleaderCommunityQuery, GetSingleBaoleaderCommunityQueryVariables>(GetSingleBaoleaderCommunityDocument, options);
      }
export function useGetSingleBaoleaderCommunityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleBaoleaderCommunityQuery, GetSingleBaoleaderCommunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleBaoleaderCommunityQuery, GetSingleBaoleaderCommunityQueryVariables>(GetSingleBaoleaderCommunityDocument, options);
        }
// @ts-ignore
export function useGetSingleBaoleaderCommunitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSingleBaoleaderCommunityQuery, GetSingleBaoleaderCommunityQueryVariables>): Apollo.UseSuspenseQueryResult<GetSingleBaoleaderCommunityQuery, GetSingleBaoleaderCommunityQueryVariables>;
export function useGetSingleBaoleaderCommunitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleBaoleaderCommunityQuery, GetSingleBaoleaderCommunityQueryVariables>): Apollo.UseSuspenseQueryResult<GetSingleBaoleaderCommunityQuery | undefined, GetSingleBaoleaderCommunityQueryVariables>;
export function useGetSingleBaoleaderCommunitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleBaoleaderCommunityQuery, GetSingleBaoleaderCommunityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSingleBaoleaderCommunityQuery, GetSingleBaoleaderCommunityQueryVariables>(GetSingleBaoleaderCommunityDocument, options);
        }
export type GetSingleBaoleaderCommunityQueryHookResult = ReturnType<typeof useGetSingleBaoleaderCommunityQuery>;
export type GetSingleBaoleaderCommunityLazyQueryHookResult = ReturnType<typeof useGetSingleBaoleaderCommunityLazyQuery>;
export type GetSingleBaoleaderCommunitySuspenseQueryHookResult = ReturnType<typeof useGetSingleBaoleaderCommunitySuspenseQuery>;
export type GetSingleBaoleaderCommunityQueryResult = Apollo.QueryResult<GetSingleBaoleaderCommunityQuery, GetSingleBaoleaderCommunityQueryVariables>;
export const GetSingleCommunityMemberDocument = gql`
    query getSingleCommunityMember($where: JSON) {
  getSingleCommunityMember(where: $where) {
    member {
      id
      attributes {
        idNumber
        phoneNumber
        firstName
        lastName
        email
        profilePicture {
          data {
            ...uploadFile
          }
        }
        community {
          data {
            id
            attributes {
              ...community
              featured_image {
                data {
                  ...uploadFile
                }
              }
            }
          }
        }
        status
        createdAt
        updatedAt
        gender
        dateOfBirth
      }
    }
  }
}
    ${UploadFileFragmentDoc}
${CommunityFragmentDoc}`;

/**
 * __useGetSingleCommunityMemberQuery__
 *
 * To run a query within a React component, call `useGetSingleCommunityMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleCommunityMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleCommunityMemberQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetSingleCommunityMemberQuery(baseOptions?: Apollo.QueryHookOptions<GetSingleCommunityMemberQuery, GetSingleCommunityMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleCommunityMemberQuery, GetSingleCommunityMemberQueryVariables>(GetSingleCommunityMemberDocument, options);
      }
export function useGetSingleCommunityMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleCommunityMemberQuery, GetSingleCommunityMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleCommunityMemberQuery, GetSingleCommunityMemberQueryVariables>(GetSingleCommunityMemberDocument, options);
        }
// @ts-ignore
export function useGetSingleCommunityMemberSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSingleCommunityMemberQuery, GetSingleCommunityMemberQueryVariables>): Apollo.UseSuspenseQueryResult<GetSingleCommunityMemberQuery, GetSingleCommunityMemberQueryVariables>;
export function useGetSingleCommunityMemberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleCommunityMemberQuery, GetSingleCommunityMemberQueryVariables>): Apollo.UseSuspenseQueryResult<GetSingleCommunityMemberQuery | undefined, GetSingleCommunityMemberQueryVariables>;
export function useGetSingleCommunityMemberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleCommunityMemberQuery, GetSingleCommunityMemberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSingleCommunityMemberQuery, GetSingleCommunityMemberQueryVariables>(GetSingleCommunityMemberDocument, options);
        }
export type GetSingleCommunityMemberQueryHookResult = ReturnType<typeof useGetSingleCommunityMemberQuery>;
export type GetSingleCommunityMemberLazyQueryHookResult = ReturnType<typeof useGetSingleCommunityMemberLazyQuery>;
export type GetSingleCommunityMemberSuspenseQueryHookResult = ReturnType<typeof useGetSingleCommunityMemberSuspenseQuery>;
export type GetSingleCommunityMemberQueryResult = Apollo.QueryResult<GetSingleCommunityMemberQuery, GetSingleCommunityMemberQueryVariables>;
export const GetSingleBaoleaderProjectDocument = gql`
    query getSingleBaoleaderProject($id: ID!) {
  getSingleBaoleaderProject(id: $id) {
    id
    attributes {
      ...project
      featured_image {
        data {
          ...uploadFile
        }
      }
    }
  }
}
    ${ProjectFragmentDoc}
${UploadFileFragmentDoc}`;

/**
 * __useGetSingleBaoleaderProjectQuery__
 *
 * To run a query within a React component, call `useGetSingleBaoleaderProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleBaoleaderProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleBaoleaderProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSingleBaoleaderProjectQuery(baseOptions: Apollo.QueryHookOptions<GetSingleBaoleaderProjectQuery, GetSingleBaoleaderProjectQueryVariables> & ({ variables: GetSingleBaoleaderProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleBaoleaderProjectQuery, GetSingleBaoleaderProjectQueryVariables>(GetSingleBaoleaderProjectDocument, options);
      }
export function useGetSingleBaoleaderProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleBaoleaderProjectQuery, GetSingleBaoleaderProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleBaoleaderProjectQuery, GetSingleBaoleaderProjectQueryVariables>(GetSingleBaoleaderProjectDocument, options);
        }
// @ts-ignore
export function useGetSingleBaoleaderProjectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSingleBaoleaderProjectQuery, GetSingleBaoleaderProjectQueryVariables>): Apollo.UseSuspenseQueryResult<GetSingleBaoleaderProjectQuery, GetSingleBaoleaderProjectQueryVariables>;
export function useGetSingleBaoleaderProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleBaoleaderProjectQuery, GetSingleBaoleaderProjectQueryVariables>): Apollo.UseSuspenseQueryResult<GetSingleBaoleaderProjectQuery | undefined, GetSingleBaoleaderProjectQueryVariables>;
export function useGetSingleBaoleaderProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleBaoleaderProjectQuery, GetSingleBaoleaderProjectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSingleBaoleaderProjectQuery, GetSingleBaoleaderProjectQueryVariables>(GetSingleBaoleaderProjectDocument, options);
        }
export type GetSingleBaoleaderProjectQueryHookResult = ReturnType<typeof useGetSingleBaoleaderProjectQuery>;
export type GetSingleBaoleaderProjectLazyQueryHookResult = ReturnType<typeof useGetSingleBaoleaderProjectLazyQuery>;
export type GetSingleBaoleaderProjectSuspenseQueryHookResult = ReturnType<typeof useGetSingleBaoleaderProjectSuspenseQuery>;
export type GetSingleBaoleaderProjectQueryResult = Apollo.QueryResult<GetSingleBaoleaderProjectQuery, GetSingleBaoleaderProjectQueryVariables>;
export const GetSubscriptionPlansDocument = gql`
    query GetSubscriptionPlans {
  getSubscriptionPlans {
    id
    name
    description
    tagline
    isPopular
    isDefault
    sortOrder
    priceId
    feature {
      usersAllowed
      priceGbp
      priceUsd
      priceZar
      supportHours
      recurring
    }
    features {
      label
      description
      isHighlighted
      sortOrder
    }
  }
}
    `;

/**
 * __useGetSubscriptionPlansQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionPlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubscriptionPlansQuery(baseOptions?: Apollo.QueryHookOptions<GetSubscriptionPlansQuery, GetSubscriptionPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionPlansQuery, GetSubscriptionPlansQueryVariables>(GetSubscriptionPlansDocument, options);
      }
export function useGetSubscriptionPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionPlansQuery, GetSubscriptionPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionPlansQuery, GetSubscriptionPlansQueryVariables>(GetSubscriptionPlansDocument, options);
        }
// @ts-ignore
export function useGetSubscriptionPlansSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSubscriptionPlansQuery, GetSubscriptionPlansQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubscriptionPlansQuery, GetSubscriptionPlansQueryVariables>;
export function useGetSubscriptionPlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubscriptionPlansQuery, GetSubscriptionPlansQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubscriptionPlansQuery | undefined, GetSubscriptionPlansQueryVariables>;
export function useGetSubscriptionPlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubscriptionPlansQuery, GetSubscriptionPlansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubscriptionPlansQuery, GetSubscriptionPlansQueryVariables>(GetSubscriptionPlansDocument, options);
        }
export type GetSubscriptionPlansQueryHookResult = ReturnType<typeof useGetSubscriptionPlansQuery>;
export type GetSubscriptionPlansLazyQueryHookResult = ReturnType<typeof useGetSubscriptionPlansLazyQuery>;
export type GetSubscriptionPlansSuspenseQueryHookResult = ReturnType<typeof useGetSubscriptionPlansSuspenseQuery>;
export type GetSubscriptionPlansQueryResult = Apollo.QueryResult<GetSubscriptionPlansQuery, GetSubscriptionPlansQueryVariables>;
export const GetSubscriptionDocument = gql`
    query getSubscription {
  getSubscription {
    id
    product_plan {
      name
    }
    recurring
    cancel_at_period_end
    cancel_at
    collection_method
    created
    current_period_end
    current_period_start
    customer
    ended_at
    latest_invoice
    status
    trial_end
    trial_start
    items
  }
}
    `;

/**
 * __useGetSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubscriptionQuery(baseOptions?: Apollo.QueryHookOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionQuery, GetSubscriptionQueryVariables>(GetSubscriptionDocument, options);
      }
export function useGetSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionQuery, GetSubscriptionQueryVariables>(GetSubscriptionDocument, options);
        }
// @ts-ignore
export function useGetSubscriptionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubscriptionQuery, GetSubscriptionQueryVariables>;
export function useGetSubscriptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubscriptionQuery | undefined, GetSubscriptionQueryVariables>;
export function useGetSubscriptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubscriptionQuery, GetSubscriptionQueryVariables>(GetSubscriptionDocument, options);
        }
export type GetSubscriptionQueryHookResult = ReturnType<typeof useGetSubscriptionQuery>;
export type GetSubscriptionLazyQueryHookResult = ReturnType<typeof useGetSubscriptionLazyQuery>;
export type GetSubscriptionSuspenseQueryHookResult = ReturnType<typeof useGetSubscriptionSuspenseQuery>;
export type GetSubscriptionQueryResult = Apollo.QueryResult<GetSubscriptionQuery, GetSubscriptionQueryVariables>;
export const GetTaskBuilderFilterCategoriesDocument = gql`
    query GetTaskBuilderFilterCategories($where: JSON, $limit: Int, $start: Int, $sort: String) {
  getTaskBuilderFilterCategories(
    where: $where
    limit: $limit
    start: $start
    sort: $sort
  ) {
    id
    attributes {
      title
    }
  }
}
    `;

/**
 * __useGetTaskBuilderFilterCategoriesQuery__
 *
 * To run a query within a React component, call `useGetTaskBuilderFilterCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskBuilderFilterCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskBuilderFilterCategoriesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetTaskBuilderFilterCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetTaskBuilderFilterCategoriesQuery, GetTaskBuilderFilterCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskBuilderFilterCategoriesQuery, GetTaskBuilderFilterCategoriesQueryVariables>(GetTaskBuilderFilterCategoriesDocument, options);
      }
export function useGetTaskBuilderFilterCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskBuilderFilterCategoriesQuery, GetTaskBuilderFilterCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskBuilderFilterCategoriesQuery, GetTaskBuilderFilterCategoriesQueryVariables>(GetTaskBuilderFilterCategoriesDocument, options);
        }
// @ts-ignore
export function useGetTaskBuilderFilterCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskBuilderFilterCategoriesQuery, GetTaskBuilderFilterCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskBuilderFilterCategoriesQuery, GetTaskBuilderFilterCategoriesQueryVariables>;
export function useGetTaskBuilderFilterCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskBuilderFilterCategoriesQuery, GetTaskBuilderFilterCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskBuilderFilterCategoriesQuery | undefined, GetTaskBuilderFilterCategoriesQueryVariables>;
export function useGetTaskBuilderFilterCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskBuilderFilterCategoriesQuery, GetTaskBuilderFilterCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskBuilderFilterCategoriesQuery, GetTaskBuilderFilterCategoriesQueryVariables>(GetTaskBuilderFilterCategoriesDocument, options);
        }
export type GetTaskBuilderFilterCategoriesQueryHookResult = ReturnType<typeof useGetTaskBuilderFilterCategoriesQuery>;
export type GetTaskBuilderFilterCategoriesLazyQueryHookResult = ReturnType<typeof useGetTaskBuilderFilterCategoriesLazyQuery>;
export type GetTaskBuilderFilterCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetTaskBuilderFilterCategoriesSuspenseQuery>;
export type GetTaskBuilderFilterCategoriesQueryResult = Apollo.QueryResult<GetTaskBuilderFilterCategoriesQuery, GetTaskBuilderFilterCategoriesQueryVariables>;
export const GetTaskBuilderFilterCreatorsDocument = gql`
    query GetTaskBuilderFilterCreators($where: JSON, $limit: Int, $start: Int, $sort: String) {
  getTaskBuilderFilterCreators(
    where: $where
    limit: $limit
    start: $start
    sort: $sort
  ) {
    id
    attributes {
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useGetTaskBuilderFilterCreatorsQuery__
 *
 * To run a query within a React component, call `useGetTaskBuilderFilterCreatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskBuilderFilterCreatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskBuilderFilterCreatorsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetTaskBuilderFilterCreatorsQuery(baseOptions?: Apollo.QueryHookOptions<GetTaskBuilderFilterCreatorsQuery, GetTaskBuilderFilterCreatorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskBuilderFilterCreatorsQuery, GetTaskBuilderFilterCreatorsQueryVariables>(GetTaskBuilderFilterCreatorsDocument, options);
      }
export function useGetTaskBuilderFilterCreatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskBuilderFilterCreatorsQuery, GetTaskBuilderFilterCreatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskBuilderFilterCreatorsQuery, GetTaskBuilderFilterCreatorsQueryVariables>(GetTaskBuilderFilterCreatorsDocument, options);
        }
// @ts-ignore
export function useGetTaskBuilderFilterCreatorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskBuilderFilterCreatorsQuery, GetTaskBuilderFilterCreatorsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskBuilderFilterCreatorsQuery, GetTaskBuilderFilterCreatorsQueryVariables>;
export function useGetTaskBuilderFilterCreatorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskBuilderFilterCreatorsQuery, GetTaskBuilderFilterCreatorsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskBuilderFilterCreatorsQuery | undefined, GetTaskBuilderFilterCreatorsQueryVariables>;
export function useGetTaskBuilderFilterCreatorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskBuilderFilterCreatorsQuery, GetTaskBuilderFilterCreatorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskBuilderFilterCreatorsQuery, GetTaskBuilderFilterCreatorsQueryVariables>(GetTaskBuilderFilterCreatorsDocument, options);
        }
export type GetTaskBuilderFilterCreatorsQueryHookResult = ReturnType<typeof useGetTaskBuilderFilterCreatorsQuery>;
export type GetTaskBuilderFilterCreatorsLazyQueryHookResult = ReturnType<typeof useGetTaskBuilderFilterCreatorsLazyQuery>;
export type GetTaskBuilderFilterCreatorsSuspenseQueryHookResult = ReturnType<typeof useGetTaskBuilderFilterCreatorsSuspenseQuery>;
export type GetTaskBuilderFilterCreatorsQueryResult = Apollo.QueryResult<GetTaskBuilderFilterCreatorsQuery, GetTaskBuilderFilterCreatorsQueryVariables>;
export const GetTaskFilterCommunitiesDocument = gql`
    query getTaskFilterCommunities($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  getTaskFilterCommunities(
    sort: $sort
    filters: $filters
    publicationState: LIVE
    pagination: $pagination
  ) {
    id
    attributes {
      ...community
    }
  }
}
    ${CommunityFragmentDoc}`;

/**
 * __useGetTaskFilterCommunitiesQuery__
 *
 * To run a query within a React component, call `useGetTaskFilterCommunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskFilterCommunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskFilterCommunitiesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetTaskFilterCommunitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetTaskFilterCommunitiesQuery, GetTaskFilterCommunitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskFilterCommunitiesQuery, GetTaskFilterCommunitiesQueryVariables>(GetTaskFilterCommunitiesDocument, options);
      }
export function useGetTaskFilterCommunitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskFilterCommunitiesQuery, GetTaskFilterCommunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskFilterCommunitiesQuery, GetTaskFilterCommunitiesQueryVariables>(GetTaskFilterCommunitiesDocument, options);
        }
// @ts-ignore
export function useGetTaskFilterCommunitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskFilterCommunitiesQuery, GetTaskFilterCommunitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskFilterCommunitiesQuery, GetTaskFilterCommunitiesQueryVariables>;
export function useGetTaskFilterCommunitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskFilterCommunitiesQuery, GetTaskFilterCommunitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskFilterCommunitiesQuery | undefined, GetTaskFilterCommunitiesQueryVariables>;
export function useGetTaskFilterCommunitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskFilterCommunitiesQuery, GetTaskFilterCommunitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskFilterCommunitiesQuery, GetTaskFilterCommunitiesQueryVariables>(GetTaskFilterCommunitiesDocument, options);
        }
export type GetTaskFilterCommunitiesQueryHookResult = ReturnType<typeof useGetTaskFilterCommunitiesQuery>;
export type GetTaskFilterCommunitiesLazyQueryHookResult = ReturnType<typeof useGetTaskFilterCommunitiesLazyQuery>;
export type GetTaskFilterCommunitiesSuspenseQueryHookResult = ReturnType<typeof useGetTaskFilterCommunitiesSuspenseQuery>;
export type GetTaskFilterCommunitiesQueryResult = Apollo.QueryResult<GetTaskFilterCommunitiesQuery, GetTaskFilterCommunitiesQueryVariables>;
export const GetTaskFilterDataCollectorsDocument = gql`
    query getTaskFilterDataCollectors($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  getTaskFilterDataCollectors(
    sort: $sort
    filters: $filters
    publicationState: LIVE
    pagination: $pagination
  ) {
    id
    attributes {
      idNumber
      phoneNumber
      firstName
      isVerifier
      lastName
      status
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetTaskFilterDataCollectorsQuery__
 *
 * To run a query within a React component, call `useGetTaskFilterDataCollectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskFilterDataCollectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskFilterDataCollectorsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetTaskFilterDataCollectorsQuery(baseOptions?: Apollo.QueryHookOptions<GetTaskFilterDataCollectorsQuery, GetTaskFilterDataCollectorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskFilterDataCollectorsQuery, GetTaskFilterDataCollectorsQueryVariables>(GetTaskFilterDataCollectorsDocument, options);
      }
export function useGetTaskFilterDataCollectorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskFilterDataCollectorsQuery, GetTaskFilterDataCollectorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskFilterDataCollectorsQuery, GetTaskFilterDataCollectorsQueryVariables>(GetTaskFilterDataCollectorsDocument, options);
        }
// @ts-ignore
export function useGetTaskFilterDataCollectorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskFilterDataCollectorsQuery, GetTaskFilterDataCollectorsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskFilterDataCollectorsQuery, GetTaskFilterDataCollectorsQueryVariables>;
export function useGetTaskFilterDataCollectorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskFilterDataCollectorsQuery, GetTaskFilterDataCollectorsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskFilterDataCollectorsQuery | undefined, GetTaskFilterDataCollectorsQueryVariables>;
export function useGetTaskFilterDataCollectorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskFilterDataCollectorsQuery, GetTaskFilterDataCollectorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskFilterDataCollectorsQuery, GetTaskFilterDataCollectorsQueryVariables>(GetTaskFilterDataCollectorsDocument, options);
        }
export type GetTaskFilterDataCollectorsQueryHookResult = ReturnType<typeof useGetTaskFilterDataCollectorsQuery>;
export type GetTaskFilterDataCollectorsLazyQueryHookResult = ReturnType<typeof useGetTaskFilterDataCollectorsLazyQuery>;
export type GetTaskFilterDataCollectorsSuspenseQueryHookResult = ReturnType<typeof useGetTaskFilterDataCollectorsSuspenseQuery>;
export type GetTaskFilterDataCollectorsQueryResult = Apollo.QueryResult<GetTaskFilterDataCollectorsQuery, GetTaskFilterDataCollectorsQueryVariables>;
export const GetTaskFilterDataCollectorsCountDocument = gql`
    query getTaskFilterDataCollectorsCount($filters: JSON) {
  getTaskFilterDataCollectorsCount(filters: $filters, publicationState: LIVE)
}
    `;

/**
 * __useGetTaskFilterDataCollectorsCountQuery__
 *
 * To run a query within a React component, call `useGetTaskFilterDataCollectorsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskFilterDataCollectorsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskFilterDataCollectorsCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetTaskFilterDataCollectorsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetTaskFilterDataCollectorsCountQuery, GetTaskFilterDataCollectorsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskFilterDataCollectorsCountQuery, GetTaskFilterDataCollectorsCountQueryVariables>(GetTaskFilterDataCollectorsCountDocument, options);
      }
export function useGetTaskFilterDataCollectorsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskFilterDataCollectorsCountQuery, GetTaskFilterDataCollectorsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskFilterDataCollectorsCountQuery, GetTaskFilterDataCollectorsCountQueryVariables>(GetTaskFilterDataCollectorsCountDocument, options);
        }
// @ts-ignore
export function useGetTaskFilterDataCollectorsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskFilterDataCollectorsCountQuery, GetTaskFilterDataCollectorsCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskFilterDataCollectorsCountQuery, GetTaskFilterDataCollectorsCountQueryVariables>;
export function useGetTaskFilterDataCollectorsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskFilterDataCollectorsCountQuery, GetTaskFilterDataCollectorsCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskFilterDataCollectorsCountQuery | undefined, GetTaskFilterDataCollectorsCountQueryVariables>;
export function useGetTaskFilterDataCollectorsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskFilterDataCollectorsCountQuery, GetTaskFilterDataCollectorsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskFilterDataCollectorsCountQuery, GetTaskFilterDataCollectorsCountQueryVariables>(GetTaskFilterDataCollectorsCountDocument, options);
        }
export type GetTaskFilterDataCollectorsCountQueryHookResult = ReturnType<typeof useGetTaskFilterDataCollectorsCountQuery>;
export type GetTaskFilterDataCollectorsCountLazyQueryHookResult = ReturnType<typeof useGetTaskFilterDataCollectorsCountLazyQuery>;
export type GetTaskFilterDataCollectorsCountSuspenseQueryHookResult = ReturnType<typeof useGetTaskFilterDataCollectorsCountSuspenseQuery>;
export type GetTaskFilterDataCollectorsCountQueryResult = Apollo.QueryResult<GetTaskFilterDataCollectorsCountQuery, GetTaskFilterDataCollectorsCountQueryVariables>;
export const GetTaskFilterProjectsDocument = gql`
    query getTaskFilterProjects($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  getTaskFilterProjects(
    sort: $sort
    filters: $filters
    publicationState: LIVE
    pagination: $pagination
  ) {
    id
    attributes {
      ...project
    }
  }
}
    ${ProjectFragmentDoc}`;

/**
 * __useGetTaskFilterProjectsQuery__
 *
 * To run a query within a React component, call `useGetTaskFilterProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskFilterProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskFilterProjectsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetTaskFilterProjectsQuery(baseOptions?: Apollo.QueryHookOptions<GetTaskFilterProjectsQuery, GetTaskFilterProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskFilterProjectsQuery, GetTaskFilterProjectsQueryVariables>(GetTaskFilterProjectsDocument, options);
      }
export function useGetTaskFilterProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskFilterProjectsQuery, GetTaskFilterProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskFilterProjectsQuery, GetTaskFilterProjectsQueryVariables>(GetTaskFilterProjectsDocument, options);
        }
// @ts-ignore
export function useGetTaskFilterProjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskFilterProjectsQuery, GetTaskFilterProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskFilterProjectsQuery, GetTaskFilterProjectsQueryVariables>;
export function useGetTaskFilterProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskFilterProjectsQuery, GetTaskFilterProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskFilterProjectsQuery | undefined, GetTaskFilterProjectsQueryVariables>;
export function useGetTaskFilterProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskFilterProjectsQuery, GetTaskFilterProjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskFilterProjectsQuery, GetTaskFilterProjectsQueryVariables>(GetTaskFilterProjectsDocument, options);
        }
export type GetTaskFilterProjectsQueryHookResult = ReturnType<typeof useGetTaskFilterProjectsQuery>;
export type GetTaskFilterProjectsLazyQueryHookResult = ReturnType<typeof useGetTaskFilterProjectsLazyQuery>;
export type GetTaskFilterProjectsSuspenseQueryHookResult = ReturnType<typeof useGetTaskFilterProjectsSuspenseQuery>;
export type GetTaskFilterProjectsQueryResult = Apollo.QueryResult<GetTaskFilterProjectsQuery, GetTaskFilterProjectsQueryVariables>;
export const GetTaskFilterTaskTypesDocument = gql`
    query getTaskFilterTaskTypes($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  getTaskFilterTaskTypes(
    sort: $sort
    filters: $filters
    publicationState: LIVE
    pagination: $pagination
  ) {
    id
    attributes {
      ...taskType
    }
  }
}
    ${TaskTypeFragmentDoc}`;

/**
 * __useGetTaskFilterTaskTypesQuery__
 *
 * To run a query within a React component, call `useGetTaskFilterTaskTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskFilterTaskTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskFilterTaskTypesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetTaskFilterTaskTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetTaskFilterTaskTypesQuery, GetTaskFilterTaskTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskFilterTaskTypesQuery, GetTaskFilterTaskTypesQueryVariables>(GetTaskFilterTaskTypesDocument, options);
      }
export function useGetTaskFilterTaskTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskFilterTaskTypesQuery, GetTaskFilterTaskTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskFilterTaskTypesQuery, GetTaskFilterTaskTypesQueryVariables>(GetTaskFilterTaskTypesDocument, options);
        }
// @ts-ignore
export function useGetTaskFilterTaskTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskFilterTaskTypesQuery, GetTaskFilterTaskTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskFilterTaskTypesQuery, GetTaskFilterTaskTypesQueryVariables>;
export function useGetTaskFilterTaskTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskFilterTaskTypesQuery, GetTaskFilterTaskTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskFilterTaskTypesQuery | undefined, GetTaskFilterTaskTypesQueryVariables>;
export function useGetTaskFilterTaskTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskFilterTaskTypesQuery, GetTaskFilterTaskTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskFilterTaskTypesQuery, GetTaskFilterTaskTypesQueryVariables>(GetTaskFilterTaskTypesDocument, options);
        }
export type GetTaskFilterTaskTypesQueryHookResult = ReturnType<typeof useGetTaskFilterTaskTypesQuery>;
export type GetTaskFilterTaskTypesLazyQueryHookResult = ReturnType<typeof useGetTaskFilterTaskTypesLazyQuery>;
export type GetTaskFilterTaskTypesSuspenseQueryHookResult = ReturnType<typeof useGetTaskFilterTaskTypesSuspenseQuery>;
export type GetTaskFilterTaskTypesQueryResult = Apollo.QueryResult<GetTaskFilterTaskTypesQuery, GetTaskFilterTaskTypesQueryVariables>;
export const GetTaskFilterUnsdgsDocument = gql`
    query getTaskFilterUnsdgs($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  getTaskFilterUnsdgs(
    sort: $sort
    filters: $filters
    publicationState: LIVE
    pagination: $pagination
  ) {
    id
    attributes {
      ...UNSDG
    }
  }
}
    ${UnsdgFragmentDoc}`;

/**
 * __useGetTaskFilterUnsdgsQuery__
 *
 * To run a query within a React component, call `useGetTaskFilterUnsdgsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskFilterUnsdgsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskFilterUnsdgsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetTaskFilterUnsdgsQuery(baseOptions?: Apollo.QueryHookOptions<GetTaskFilterUnsdgsQuery, GetTaskFilterUnsdgsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskFilterUnsdgsQuery, GetTaskFilterUnsdgsQueryVariables>(GetTaskFilterUnsdgsDocument, options);
      }
export function useGetTaskFilterUnsdgsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskFilterUnsdgsQuery, GetTaskFilterUnsdgsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskFilterUnsdgsQuery, GetTaskFilterUnsdgsQueryVariables>(GetTaskFilterUnsdgsDocument, options);
        }
// @ts-ignore
export function useGetTaskFilterUnsdgsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskFilterUnsdgsQuery, GetTaskFilterUnsdgsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskFilterUnsdgsQuery, GetTaskFilterUnsdgsQueryVariables>;
export function useGetTaskFilterUnsdgsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskFilterUnsdgsQuery, GetTaskFilterUnsdgsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskFilterUnsdgsQuery | undefined, GetTaskFilterUnsdgsQueryVariables>;
export function useGetTaskFilterUnsdgsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskFilterUnsdgsQuery, GetTaskFilterUnsdgsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskFilterUnsdgsQuery, GetTaskFilterUnsdgsQueryVariables>(GetTaskFilterUnsdgsDocument, options);
        }
export type GetTaskFilterUnsdgsQueryHookResult = ReturnType<typeof useGetTaskFilterUnsdgsQuery>;
export type GetTaskFilterUnsdgsLazyQueryHookResult = ReturnType<typeof useGetTaskFilterUnsdgsLazyQuery>;
export type GetTaskFilterUnsdgsSuspenseQueryHookResult = ReturnType<typeof useGetTaskFilterUnsdgsSuspenseQuery>;
export type GetTaskFilterUnsdgsQueryResult = Apollo.QueryResult<GetTaskFilterUnsdgsQuery, GetTaskFilterUnsdgsQueryVariables>;
export const GetTaskTypeDocument = gql`
    query getTaskType($id: ID!) {
  getTaskType(id: $id) {
    id
    attributes {
      ...taskType
      un_sdg {
        data {
          id
          attributes {
            ...UNSDG
          }
        }
      }
      category {
        data {
          id
          attributes {
            ...category
            featureImage {
              data {
                ...uploadFile
              }
            }
          }
        }
      }
      creator {
        data {
          id
          attributes {
            firstName
            lastName
          }
        }
      }
      dataFields {
        ...componentCustomDataFieldsMetricsSpecific
        ...componentCustomDataFieldsNumberRange
        ...componentCustomDataFieldsNumberDropDown
        ...componentCustomDataFieldsPercentage
        ...componentCustomDataFieldsRadio
        ...componentCustomDataFieldsText
        ...componentCustomDataFieldsCheckbox
        ...componentCustomDataFieldsDataList
        ...componentCustomDataFieldsDateTimeField
        ...componentCustomDataFieldsImageField
        ...componentCustomDataFieldsSelect
        ...componentCustomDataFieldsNumberField
        ...componentCustomDataFieldsPercentage
        ...componentCustomDataFieldsRating
        ...componentCustomDataFieldsPhoneNumberField
        ...componentCustomDataFieldsEmailField
        __typename
      }
    }
  }
}
    ${TaskTypeFragmentDoc}
${UnsdgFragmentDoc}
${CategoryFragmentDoc}
${UploadFileFragmentDoc}
${ComponentCustomDataFieldsMetricsSpecificFragmentDoc}
${ComponentCustomDataFieldsNumberRangeFragmentDoc}
${ComponentCustomDataFieldsNumberDropDownFragmentDoc}
${ComponentCustomDataFieldsPercentageFragmentDoc}
${ComponentCustomDataFieldsRadioFragmentDoc}
${ComponentCustomDataFieldsTextFragmentDoc}
${ComponentCustomDataFieldsCheckboxFragmentDoc}
${ComponentCustomDataFieldsDataListFragmentDoc}
${ComponentCustomDataFieldsDateTimeFieldFragmentDoc}
${ComponentCustomDataFieldsImageFieldFragmentDoc}
${ComponentCustomDataFieldsSelectFragmentDoc}
${ComponentCustomDataFieldsNumberFieldFragmentDoc}
${ComponentCustomDataFieldsRatingFragmentDoc}
${ComponentCustomDataFieldsPhoneNumberFieldFragmentDoc}
${ComponentCustomDataFieldsEmailFieldFragmentDoc}`;

/**
 * __useGetTaskTypeQuery__
 *
 * To run a query within a React component, call `useGetTaskTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskTypeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskTypeQuery(baseOptions: Apollo.QueryHookOptions<GetTaskTypeQuery, GetTaskTypeQueryVariables> & ({ variables: GetTaskTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskTypeQuery, GetTaskTypeQueryVariables>(GetTaskTypeDocument, options);
      }
export function useGetTaskTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskTypeQuery, GetTaskTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskTypeQuery, GetTaskTypeQueryVariables>(GetTaskTypeDocument, options);
        }
// @ts-ignore
export function useGetTaskTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskTypeQuery, GetTaskTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskTypeQuery, GetTaskTypeQueryVariables>;
export function useGetTaskTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskTypeQuery, GetTaskTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskTypeQuery | undefined, GetTaskTypeQueryVariables>;
export function useGetTaskTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskTypeQuery, GetTaskTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskTypeQuery, GetTaskTypeQueryVariables>(GetTaskTypeDocument, options);
        }
export type GetTaskTypeQueryHookResult = ReturnType<typeof useGetTaskTypeQuery>;
export type GetTaskTypeLazyQueryHookResult = ReturnType<typeof useGetTaskTypeLazyQuery>;
export type GetTaskTypeSuspenseQueryHookResult = ReturnType<typeof useGetTaskTypeSuspenseQuery>;
export type GetTaskTypeQueryResult = Apollo.QueryResult<GetTaskTypeQuery, GetTaskTypeQueryVariables>;
export const GetTaskTypeProjectsDocument = gql`
    query getTaskTypeProjects($id: ID!) {
  getTaskTypeProjects(id: $id) {
    id
    attributes {
      ...project
      featured_image {
        data {
          ...uploadFile
        }
      }
    }
  }
}
    ${ProjectFragmentDoc}
${UploadFileFragmentDoc}`;

/**
 * __useGetTaskTypeProjectsQuery__
 *
 * To run a query within a React component, call `useGetTaskTypeProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskTypeProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskTypeProjectsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskTypeProjectsQuery(baseOptions: Apollo.QueryHookOptions<GetTaskTypeProjectsQuery, GetTaskTypeProjectsQueryVariables> & ({ variables: GetTaskTypeProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskTypeProjectsQuery, GetTaskTypeProjectsQueryVariables>(GetTaskTypeProjectsDocument, options);
      }
export function useGetTaskTypeProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskTypeProjectsQuery, GetTaskTypeProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskTypeProjectsQuery, GetTaskTypeProjectsQueryVariables>(GetTaskTypeProjectsDocument, options);
        }
// @ts-ignore
export function useGetTaskTypeProjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskTypeProjectsQuery, GetTaskTypeProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskTypeProjectsQuery, GetTaskTypeProjectsQueryVariables>;
export function useGetTaskTypeProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskTypeProjectsQuery, GetTaskTypeProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskTypeProjectsQuery | undefined, GetTaskTypeProjectsQueryVariables>;
export function useGetTaskTypeProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskTypeProjectsQuery, GetTaskTypeProjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskTypeProjectsQuery, GetTaskTypeProjectsQueryVariables>(GetTaskTypeProjectsDocument, options);
        }
export type GetTaskTypeProjectsQueryHookResult = ReturnType<typeof useGetTaskTypeProjectsQuery>;
export type GetTaskTypeProjectsLazyQueryHookResult = ReturnType<typeof useGetTaskTypeProjectsLazyQuery>;
export type GetTaskTypeProjectsSuspenseQueryHookResult = ReturnType<typeof useGetTaskTypeProjectsSuspenseQuery>;
export type GetTaskTypeProjectsQueryResult = Apollo.QueryResult<GetTaskTypeProjectsQuery, GetTaskTypeProjectsQueryVariables>;
export const GetTaskTypeTemplatesDocument = gql`
    query getTaskTypeTemplates {
  getTaskTypeTemplates {
    id
    attributes {
      ...taskType
      category {
        data {
          id
          attributes {
            ...category
            featureImage {
              data {
                ...uploadFile
              }
            }
          }
        }
      }
      un_sdg {
        data {
          id
          attributes {
            name
          }
        }
      }
      creator {
        data {
          id
          attributes {
            ...member
          }
        }
      }
    }
  }
}
    ${TaskTypeFragmentDoc}
${CategoryFragmentDoc}
${UploadFileFragmentDoc}
${MemberFragmentDoc}`;

/**
 * __useGetTaskTypeTemplatesQuery__
 *
 * To run a query within a React component, call `useGetTaskTypeTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskTypeTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskTypeTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTaskTypeTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetTaskTypeTemplatesQuery, GetTaskTypeTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskTypeTemplatesQuery, GetTaskTypeTemplatesQueryVariables>(GetTaskTypeTemplatesDocument, options);
      }
export function useGetTaskTypeTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskTypeTemplatesQuery, GetTaskTypeTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskTypeTemplatesQuery, GetTaskTypeTemplatesQueryVariables>(GetTaskTypeTemplatesDocument, options);
        }
// @ts-ignore
export function useGetTaskTypeTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskTypeTemplatesQuery, GetTaskTypeTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskTypeTemplatesQuery, GetTaskTypeTemplatesQueryVariables>;
export function useGetTaskTypeTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskTypeTemplatesQuery, GetTaskTypeTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskTypeTemplatesQuery | undefined, GetTaskTypeTemplatesQueryVariables>;
export function useGetTaskTypeTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskTypeTemplatesQuery, GetTaskTypeTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskTypeTemplatesQuery, GetTaskTypeTemplatesQueryVariables>(GetTaskTypeTemplatesDocument, options);
        }
export type GetTaskTypeTemplatesQueryHookResult = ReturnType<typeof useGetTaskTypeTemplatesQuery>;
export type GetTaskTypeTemplatesLazyQueryHookResult = ReturnType<typeof useGetTaskTypeTemplatesLazyQuery>;
export type GetTaskTypeTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetTaskTypeTemplatesSuspenseQuery>;
export type GetTaskTypeTemplatesQueryResult = Apollo.QueryResult<GetTaskTypeTemplatesQuery, GetTaskTypeTemplatesQueryVariables>;
export const GetTaskTypesDocument = gql`
    query getTaskTypes($sort: [String], $filters: TaskTypeFiltersInput, $pagination: PaginationArg) {
  taskTypes(
    sort: $sort
    filters: $filters
    publicationState: LIVE
    pagination: $pagination
  ) {
    data {
      id
      attributes {
        ...taskType
        category {
          data {
            id
            attributes {
              ...category
              featureImage {
                data {
                  ...uploadFile
                }
              }
            }
          }
        }
        creator {
          data {
            id
            attributes {
              ...member
            }
          }
        }
      }
    }
  }
}
    ${TaskTypeFragmentDoc}
${CategoryFragmentDoc}
${UploadFileFragmentDoc}
${MemberFragmentDoc}`;

/**
 * __useGetTaskTypesQuery__
 *
 * To run a query within a React component, call `useGetTaskTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskTypesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetTaskTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetTaskTypesQuery, GetTaskTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskTypesQuery, GetTaskTypesQueryVariables>(GetTaskTypesDocument, options);
      }
export function useGetTaskTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskTypesQuery, GetTaskTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskTypesQuery, GetTaskTypesQueryVariables>(GetTaskTypesDocument, options);
        }
// @ts-ignore
export function useGetTaskTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskTypesQuery, GetTaskTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskTypesQuery, GetTaskTypesQueryVariables>;
export function useGetTaskTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskTypesQuery, GetTaskTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskTypesQuery | undefined, GetTaskTypesQueryVariables>;
export function useGetTaskTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskTypesQuery, GetTaskTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskTypesQuery, GetTaskTypesQueryVariables>(GetTaskTypesDocument, options);
        }
export type GetTaskTypesQueryHookResult = ReturnType<typeof useGetTaskTypesQuery>;
export type GetTaskTypesLazyQueryHookResult = ReturnType<typeof useGetTaskTypesLazyQuery>;
export type GetTaskTypesSuspenseQueryHookResult = ReturnType<typeof useGetTaskTypesSuspenseQuery>;
export type GetTaskTypesQueryResult = Apollo.QueryResult<GetTaskTypesQuery, GetTaskTypesQueryVariables>;
export const GetTasksDocument = gql`
    query getTasks($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  getBaoleaderTasksWithCount(
    sort: $sort
    filters: $filters
    publicationState: LIVE
    pagination: $pagination
  ) {
    count
    data {
      id
      attributes {
        ...task
        edit_from {
          data {
            id
            attributes {
              ...task
            }
          }
        }
        task_definition {
          data {
            id
            attributes {
              task_type {
                data {
                  id
                  attributes {
                    title
                  }
                }
              }
              category {
                data {
                  id
                  attributes {
                    featureImage {
                      data {
                        ...uploadFile
                      }
                    }
                  }
                }
              }
            }
          }
        }
        community {
          data {
            id
            attributes {
              name
            }
          }
        }
        project {
          data {
            id
            attributes {
              name
            }
          }
        }
        evidences {
          data {
            id
            attributes {
              custom_data_fields {
                ...componentCustomDataFieldsImageField
                __typename
              }
              photos {
                data {
                  ...uploadFile
                }
              }
              baorider {
                data {
                  id
                  attributes {
                    firstName
                    lastName
                    phoneNumber
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${TaskFragmentDoc}
${UploadFileFragmentDoc}
${ComponentCustomDataFieldsImageFieldFragmentDoc}`;

/**
 * __useGetTasksQuery__
 *
 * To run a query within a React component, call `useGetTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetTasksQuery(baseOptions?: Apollo.QueryHookOptions<GetTasksQuery, GetTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTasksQuery, GetTasksQueryVariables>(GetTasksDocument, options);
      }
export function useGetTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTasksQuery, GetTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTasksQuery, GetTasksQueryVariables>(GetTasksDocument, options);
        }
// @ts-ignore
export function useGetTasksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTasksQuery, GetTasksQueryVariables>): Apollo.UseSuspenseQueryResult<GetTasksQuery, GetTasksQueryVariables>;
export function useGetTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTasksQuery, GetTasksQueryVariables>): Apollo.UseSuspenseQueryResult<GetTasksQuery | undefined, GetTasksQueryVariables>;
export function useGetTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTasksQuery, GetTasksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTasksQuery, GetTasksQueryVariables>(GetTasksDocument, options);
        }
export type GetTasksQueryHookResult = ReturnType<typeof useGetTasksQuery>;
export type GetTasksLazyQueryHookResult = ReturnType<typeof useGetTasksLazyQuery>;
export type GetTasksSuspenseQueryHookResult = ReturnType<typeof useGetTasksSuspenseQuery>;
export type GetTasksQueryResult = Apollo.QueryResult<GetTasksQuery, GetTasksQueryVariables>;
export const GetTopPerformingUsersDocument = gql`
    query getTopPerformingUsers($community: ID, $project: ID, $startDate: DateTime, $endDate: DateTime) {
  getTopPerformingUsers(
    community: $community
    project: $project
    startDate: $startDate
    endDate: $endDate
  ) {
    baoriders {
      baorider {
        id
        attributes {
          firstName
          lastName
        }
      }
      tasksCompleted
    }
    communityMembers {
      communityMember {
        id
        attributes {
          firstName
          lastName
        }
      }
      tasksCompleted
    }
    chartData {
      communityMembers {
        key
        value
      }
      baoriders {
        key
        value
      }
    }
  }
}
    `;

/**
 * __useGetTopPerformingUsersQuery__
 *
 * To run a query within a React component, call `useGetTopPerformingUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopPerformingUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopPerformingUsersQuery({
 *   variables: {
 *      community: // value for 'community'
 *      project: // value for 'project'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetTopPerformingUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetTopPerformingUsersQuery, GetTopPerformingUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopPerformingUsersQuery, GetTopPerformingUsersQueryVariables>(GetTopPerformingUsersDocument, options);
      }
export function useGetTopPerformingUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopPerformingUsersQuery, GetTopPerformingUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopPerformingUsersQuery, GetTopPerformingUsersQueryVariables>(GetTopPerformingUsersDocument, options);
        }
// @ts-ignore
export function useGetTopPerformingUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTopPerformingUsersQuery, GetTopPerformingUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetTopPerformingUsersQuery, GetTopPerformingUsersQueryVariables>;
export function useGetTopPerformingUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTopPerformingUsersQuery, GetTopPerformingUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetTopPerformingUsersQuery | undefined, GetTopPerformingUsersQueryVariables>;
export function useGetTopPerformingUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTopPerformingUsersQuery, GetTopPerformingUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTopPerformingUsersQuery, GetTopPerformingUsersQueryVariables>(GetTopPerformingUsersDocument, options);
        }
export type GetTopPerformingUsersQueryHookResult = ReturnType<typeof useGetTopPerformingUsersQuery>;
export type GetTopPerformingUsersLazyQueryHookResult = ReturnType<typeof useGetTopPerformingUsersLazyQuery>;
export type GetTopPerformingUsersSuspenseQueryHookResult = ReturnType<typeof useGetTopPerformingUsersSuspenseQuery>;
export type GetTopPerformingUsersQueryResult = Apollo.QueryResult<GetTopPerformingUsersQuery, GetTopPerformingUsersQueryVariables>;
export const GetUnsdGsDocument = gql`
    query getUNSDGs($sort: [String], $filters: UnSdgFiltersInput, $pagination: PaginationArg) {
  unSdgs(
    sort: $sort
    filters: $filters
    publicationState: LIVE
    pagination: $pagination
  ) {
    data {
      id
      attributes {
        name
        task_types {
          data {
            id
            attributes {
              ...taskType
            }
          }
        }
        icon {
          data {
            ...uploadFile
          }
        }
        createdAt
        updatedAt
        publishedAt
      }
    }
  }
}
    ${TaskTypeFragmentDoc}
${UploadFileFragmentDoc}`;

/**
 * __useGetUnsdGsQuery__
 *
 * To run a query within a React component, call `useGetUnsdGsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnsdGsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnsdGsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetUnsdGsQuery(baseOptions?: Apollo.QueryHookOptions<GetUnsdGsQuery, GetUnsdGsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnsdGsQuery, GetUnsdGsQueryVariables>(GetUnsdGsDocument, options);
      }
export function useGetUnsdGsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnsdGsQuery, GetUnsdGsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnsdGsQuery, GetUnsdGsQueryVariables>(GetUnsdGsDocument, options);
        }
// @ts-ignore
export function useGetUnsdGsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUnsdGsQuery, GetUnsdGsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnsdGsQuery, GetUnsdGsQueryVariables>;
export function useGetUnsdGsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnsdGsQuery, GetUnsdGsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnsdGsQuery | undefined, GetUnsdGsQueryVariables>;
export function useGetUnsdGsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnsdGsQuery, GetUnsdGsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnsdGsQuery, GetUnsdGsQueryVariables>(GetUnsdGsDocument, options);
        }
export type GetUnsdGsQueryHookResult = ReturnType<typeof useGetUnsdGsQuery>;
export type GetUnsdGsLazyQueryHookResult = ReturnType<typeof useGetUnsdGsLazyQuery>;
export type GetUnsdGsSuspenseQueryHookResult = ReturnType<typeof useGetUnsdGsSuspenseQuery>;
export type GetUnsdGsQueryResult = Apollo.QueryResult<GetUnsdGsQuery, GetUnsdGsQueryVariables>;
export const GetVideosDocument = gql`
    query getVideos($sort: [String], $filters: VideoFiltersInput, $pagination: PaginationArg) {
  videos(
    sort: $sort
    filters: $filters
    publicationState: LIVE
    pagination: $pagination
  ) {
    data {
      id
      attributes {
        title
        order
        category
        videoLink {
          data {
            ...uploadFile
          }
        }
      }
    }
  }
}
    ${UploadFileFragmentDoc}`;

/**
 * __useGetVideosQuery__
 *
 * To run a query within a React component, call `useGetVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideosQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetVideosQuery(baseOptions?: Apollo.QueryHookOptions<GetVideosQuery, GetVideosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVideosQuery, GetVideosQueryVariables>(GetVideosDocument, options);
      }
export function useGetVideosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVideosQuery, GetVideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVideosQuery, GetVideosQueryVariables>(GetVideosDocument, options);
        }
// @ts-ignore
export function useGetVideosSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVideosQuery, GetVideosQueryVariables>): Apollo.UseSuspenseQueryResult<GetVideosQuery, GetVideosQueryVariables>;
export function useGetVideosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVideosQuery, GetVideosQueryVariables>): Apollo.UseSuspenseQueryResult<GetVideosQuery | undefined, GetVideosQueryVariables>;
export function useGetVideosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVideosQuery, GetVideosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVideosQuery, GetVideosQueryVariables>(GetVideosDocument, options);
        }
export type GetVideosQueryHookResult = ReturnType<typeof useGetVideosQuery>;
export type GetVideosLazyQueryHookResult = ReturnType<typeof useGetVideosLazyQuery>;
export type GetVideosSuspenseQueryHookResult = ReturnType<typeof useGetVideosSuspenseQuery>;
export type GetVideosQueryResult = Apollo.QueryResult<GetVideosQuery, GetVideosQueryVariables>;
export const GetWholeCompanyTaskTypesDocument = gql`
    query getWholeCompanyTaskTypes($sort: JSON, $filters: JSON, $pagination: PaginationArg) {
  getWholeCompanyTaskTypes(
    sort: $sort
    filters: $filters
    publicationState: LIVE
    pagination: $pagination
  ) {
    id
    attributes {
      ...taskType
      category {
        data {
          id
          attributes {
            title
            featureImage {
              data {
                ...uploadFile
              }
            }
          }
        }
      }
      creator {
        data {
          id
          attributes {
            firstName
            lastName
          }
        }
      }
    }
  }
}
    ${TaskTypeFragmentDoc}
${UploadFileFragmentDoc}`;

/**
 * __useGetWholeCompanyTaskTypesQuery__
 *
 * To run a query within a React component, call `useGetWholeCompanyTaskTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWholeCompanyTaskTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWholeCompanyTaskTypesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetWholeCompanyTaskTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetWholeCompanyTaskTypesQuery, GetWholeCompanyTaskTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWholeCompanyTaskTypesQuery, GetWholeCompanyTaskTypesQueryVariables>(GetWholeCompanyTaskTypesDocument, options);
      }
export function useGetWholeCompanyTaskTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWholeCompanyTaskTypesQuery, GetWholeCompanyTaskTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWholeCompanyTaskTypesQuery, GetWholeCompanyTaskTypesQueryVariables>(GetWholeCompanyTaskTypesDocument, options);
        }
// @ts-ignore
export function useGetWholeCompanyTaskTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWholeCompanyTaskTypesQuery, GetWholeCompanyTaskTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetWholeCompanyTaskTypesQuery, GetWholeCompanyTaskTypesQueryVariables>;
export function useGetWholeCompanyTaskTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWholeCompanyTaskTypesQuery, GetWholeCompanyTaskTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetWholeCompanyTaskTypesQuery | undefined, GetWholeCompanyTaskTypesQueryVariables>;
export function useGetWholeCompanyTaskTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWholeCompanyTaskTypesQuery, GetWholeCompanyTaskTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWholeCompanyTaskTypesQuery, GetWholeCompanyTaskTypesQueryVariables>(GetWholeCompanyTaskTypesDocument, options);
        }
export type GetWholeCompanyTaskTypesQueryHookResult = ReturnType<typeof useGetWholeCompanyTaskTypesQuery>;
export type GetWholeCompanyTaskTypesLazyQueryHookResult = ReturnType<typeof useGetWholeCompanyTaskTypesLazyQuery>;
export type GetWholeCompanyTaskTypesSuspenseQueryHookResult = ReturnType<typeof useGetWholeCompanyTaskTypesSuspenseQuery>;
export type GetWholeCompanyTaskTypesQueryResult = Apollo.QueryResult<GetWholeCompanyTaskTypesQuery, GetWholeCompanyTaskTypesQueryVariables>;
export const HelpDocument = gql`
    query help {
  trainingVideo(publicationState: LIVE) {
    data {
      id
      attributes {
        training_videos {
          ...training_video
        }
        FAQs {
          ...faq
        }
        __typename
      }
    }
  }
}
    ${Training_VideoFragmentDoc}
${FaqFragmentDoc}`;

/**
 * __useHelpQuery__
 *
 * To run a query within a React component, call `useHelpQuery` and pass it any options that fit your needs.
 * When your component renders, `useHelpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHelpQuery({
 *   variables: {
 *   },
 * });
 */
export function useHelpQuery(baseOptions?: Apollo.QueryHookOptions<HelpQuery, HelpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HelpQuery, HelpQueryVariables>(HelpDocument, options);
      }
export function useHelpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HelpQuery, HelpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HelpQuery, HelpQueryVariables>(HelpDocument, options);
        }
// @ts-ignore
export function useHelpSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HelpQuery, HelpQueryVariables>): Apollo.UseSuspenseQueryResult<HelpQuery, HelpQueryVariables>;
export function useHelpSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HelpQuery, HelpQueryVariables>): Apollo.UseSuspenseQueryResult<HelpQuery | undefined, HelpQueryVariables>;
export function useHelpSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HelpQuery, HelpQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HelpQuery, HelpQueryVariables>(HelpDocument, options);
        }
export type HelpQueryHookResult = ReturnType<typeof useHelpQuery>;
export type HelpLazyQueryHookResult = ReturnType<typeof useHelpLazyQuery>;
export type HelpSuspenseQueryHookResult = ReturnType<typeof useHelpSuspenseQuery>;
export type HelpQueryResult = Apollo.QueryResult<HelpQuery, HelpQueryVariables>;
export const IsListInUseDocument = gql`
    query isListInUse($id: ID!) {
  isListInUse(id: $id) {
    isListInUse
    amountOfUses
    foundLists {
      ...componentCustomDataFieldsDataList
    }
  }
}
    ${ComponentCustomDataFieldsDataListFragmentDoc}`;

/**
 * __useIsListInUseQuery__
 *
 * To run a query within a React component, call `useIsListInUseQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsListInUseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsListInUseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIsListInUseQuery(baseOptions: Apollo.QueryHookOptions<IsListInUseQuery, IsListInUseQueryVariables> & ({ variables: IsListInUseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsListInUseQuery, IsListInUseQueryVariables>(IsListInUseDocument, options);
      }
export function useIsListInUseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsListInUseQuery, IsListInUseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsListInUseQuery, IsListInUseQueryVariables>(IsListInUseDocument, options);
        }
// @ts-ignore
export function useIsListInUseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IsListInUseQuery, IsListInUseQueryVariables>): Apollo.UseSuspenseQueryResult<IsListInUseQuery, IsListInUseQueryVariables>;
export function useIsListInUseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsListInUseQuery, IsListInUseQueryVariables>): Apollo.UseSuspenseQueryResult<IsListInUseQuery | undefined, IsListInUseQueryVariables>;
export function useIsListInUseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsListInUseQuery, IsListInUseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsListInUseQuery, IsListInUseQueryVariables>(IsListInUseDocument, options);
        }
export type IsListInUseQueryHookResult = ReturnType<typeof useIsListInUseQuery>;
export type IsListInUseLazyQueryHookResult = ReturnType<typeof useIsListInUseLazyQuery>;
export type IsListInUseSuspenseQueryHookResult = ReturnType<typeof useIsListInUseSuspenseQuery>;
export type IsListInUseQueryResult = Apollo.QueryResult<IsListInUseQuery, IsListInUseQueryVariables>;
export const MeDocument = gql`
    query Me {
  myUser {
    id
    attributes {
      username
      firstName
      lastName
      email
      confirmed
      blocked
      receiveAllTimeWeeklyStatusReport
      receiveLoginReminder
      receiveWeeklyStatusReport
      onboardingInformation
      company {
        data {
          id
          attributes {
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
// @ts-ignore
export function useMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>): Apollo.UseSuspenseQueryResult<MeQuery, MeQueryVariables>;
export function useMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>): Apollo.UseSuspenseQueryResult<MeQuery | undefined, MeQueryVariables>;
export function useMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const GetBaoleaderTaskDefinitionsDocument = gql`
    query getBaoleaderTaskDefinitions($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  getBaoleaderTaskDefinitions(
    sort: $sort
    filters: $filters
    publicationState: LIVE
    pagination: $pagination
  ) {
    id
    attributes {
      category {
        data {
          id
          attributes {
            ...category
            featureImage {
              data {
                ...uploadFile
              }
            }
          }
        }
      }
      status
      task_type {
        data {
          id
          attributes {
            ...taskType
          }
        }
      }
    }
  }
}
    ${CategoryFragmentDoc}
${UploadFileFragmentDoc}
${TaskTypeFragmentDoc}`;

/**
 * __useGetBaoleaderTaskDefinitionsQuery__
 *
 * To run a query within a React component, call `useGetBaoleaderTaskDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBaoleaderTaskDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBaoleaderTaskDefinitionsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetBaoleaderTaskDefinitionsQuery(baseOptions?: Apollo.QueryHookOptions<GetBaoleaderTaskDefinitionsQuery, GetBaoleaderTaskDefinitionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBaoleaderTaskDefinitionsQuery, GetBaoleaderTaskDefinitionsQueryVariables>(GetBaoleaderTaskDefinitionsDocument, options);
      }
export function useGetBaoleaderTaskDefinitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBaoleaderTaskDefinitionsQuery, GetBaoleaderTaskDefinitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBaoleaderTaskDefinitionsQuery, GetBaoleaderTaskDefinitionsQueryVariables>(GetBaoleaderTaskDefinitionsDocument, options);
        }
// @ts-ignore
export function useGetBaoleaderTaskDefinitionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBaoleaderTaskDefinitionsQuery, GetBaoleaderTaskDefinitionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetBaoleaderTaskDefinitionsQuery, GetBaoleaderTaskDefinitionsQueryVariables>;
export function useGetBaoleaderTaskDefinitionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBaoleaderTaskDefinitionsQuery, GetBaoleaderTaskDefinitionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetBaoleaderTaskDefinitionsQuery | undefined, GetBaoleaderTaskDefinitionsQueryVariables>;
export function useGetBaoleaderTaskDefinitionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBaoleaderTaskDefinitionsQuery, GetBaoleaderTaskDefinitionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBaoleaderTaskDefinitionsQuery, GetBaoleaderTaskDefinitionsQueryVariables>(GetBaoleaderTaskDefinitionsDocument, options);
        }
export type GetBaoleaderTaskDefinitionsQueryHookResult = ReturnType<typeof useGetBaoleaderTaskDefinitionsQuery>;
export type GetBaoleaderTaskDefinitionsLazyQueryHookResult = ReturnType<typeof useGetBaoleaderTaskDefinitionsLazyQuery>;
export type GetBaoleaderTaskDefinitionsSuspenseQueryHookResult = ReturnType<typeof useGetBaoleaderTaskDefinitionsSuspenseQuery>;
export type GetBaoleaderTaskDefinitionsQueryResult = Apollo.QueryResult<GetBaoleaderTaskDefinitionsQuery, GetBaoleaderTaskDefinitionsQueryVariables>;
export const UsersDocument = gql`
    query Users($sort: [String], $filters: UsersPermissionsUserFiltersInput, $pagination: PaginationArg) {
  usersPermissionsUsers(sort: $sort, filters: $filters, pagination: $pagination) {
    data {
      id
      attributes {
        createdAt
        updatedAt
        username
        email
        provider
        confirmed
        blocked
        role {
          data {
            id
            attributes {
              name
              description
              type
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
// @ts-ignore
export function useUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>): Apollo.UseSuspenseQueryResult<UsersQuery, UsersQueryVariables>;
export function useUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>): Apollo.UseSuspenseQueryResult<UsersQuery | undefined, UsersQueryVariables>;
export function useUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersSuspenseQueryHookResult = ReturnType<typeof useUsersSuspenseQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;